<template>
	<div>
		<div class="home" :class="isPc ? '' : 'home-mobile'">
			<div>
				<NavM v-if="!isPc"></NavM>

				<!-- 新增交易界面 -->
				<div class="trading-interface" v-if="isPc && showTradingInterface">
		<!-- 顶部导航栏组件 -->
		<TradingTopNav 
			:showSubmitOrder="showSubmitOrder"
			:selectedPeriod="selectedPeriod"
			:showIndicators="showIndicators"
			:isUserLoggedIn="isUserLoggedIn"
			@toggle-submit-order="toggleSubmitOrder"
			@select-period="selectPeriod"
			@toggle-indicators="toggleIndicators"
			@chart-screenshot="handleChartScreenshot"
		@chart-zoom-in="handleChartZoomIn"
		@chart-zoom-out="handleChartZoomOut"
		@chart-move-left="handleChartMoveLeft"
		@chart-move-right="handleChartMoveRight"
		@chart-fullscreen="handleChartFullscreen"
		@toggle-dark-mode="togglePcDarkMode"
			@finance-click="showFinancePopup"
			@loan-click="showLoanPopup"
			@transfer-click="showTransferPopup"
			@about-click="showAboutPopup"
			@account-click="showAccountPopup"
			@login-click="showLoginModal"
			@register-click="showRegisterModal"
			/>

					<div :class="['trading-container', { 'with-trading-panel': showSubmitOrder }]">
					<!-- 左侧绘图工具栏组件 -->
					<DrawingToolbar
						:selectedDrawingTool="selectedDrawingTool"
						:magnetMode="magnetMode"
						:drawingsVisible="drawingsVisible"
						@select-drawing-tool="selectDrawingTool"
						@select-magnet-mode="selectMagnetMode"
						@toggle-drawing-visibility="toggleDrawingVisibility"
						@clear-all-drawings="clearAllDrawings"
					/>
					<!-- 币种列表组件 -->
				<MarketList 
					:marketList="marketList"
					:selectedStock="selectedStock"
					:getMarkTypeList="getMarkTypeList"
					:tradingStatuses="tradingStatuses"
					@select-stock="selectStock"
				/>

				<!-- K线图组件 -->
				<KLineChart
					ref="klineChart"
					:selectedStock="selectedStock"
					:showIndicators="showIndicators"
					:mainIndicators="mainIndicators"
					:subIndicators="subIndicators"
					:currentOHLC="currentOHLC"
					:isDrawingMode="isDrawingMode"
					:selectedDrawingTool="selectedDrawingTool"
					@close-indicators="showIndicators = false"
					@toggle-indicator="toggleIndicator"
				/>

				<!-- 右侧交易面板组件 -->
				<TradingPanel
					ref="tradingPanel"
					:showPanel="showSubmitOrder"
					:isUserLoggedIn="isUserLoggedIn"
						:userInfo="getUserInfo"
						:selectedStock="selectedStock"
						:mainTradeType.sync="mainTradeType"
						:contractSubType.sync="contractSubType"
						:multiplier.sync="multiplier"
						:stopLoss.sync="stopLoss"
						:takeProfit.sync="takeProfit"
						:quantity.sync="quantity"
						:stopLossEnabled.sync="stopLossEnabled"
						:takeProfitEnabled.sync="takeProfitEnabled"
						:pendingPrice.sync="pendingPrice"
						:pendingMultiplier.sync="pendingMultiplier"
						:pendingStopLoss.sync="pendingStopLoss"
						:pendingTakeProfit.sync="pendingTakeProfit"
						:pendingQuantity.sync="pendingQuantity"
						:pendingStopLossEnabled.sync="pendingStopLossEnabled"
						:pendingTakeProfitEnabled.sync="pendingTakeProfitEnabled"
						:estimatedMarketCommission="estimatedMarketCommission"
						:contractsInfoMargin="contractsInfoMargin"
						:estimatedCommission="estimatedCommission"
						:estimatedMargin="estimatedMargin"
						:users="users"
						:optionsInfo="optionsInfo"
						:optionsIndex.sync="optionsIndex"
						:currentOptionsRate="currentOptionsRate"
						:optionsMoney.sync="optionsMoney"
						:optionsLoading="optionsLoading"
						:optionsPop="optionsPop"
						:optionsTime="optionsTime"
						:optionsOrderInfo="optionsOrderInfo"
						:optionsBuyPrice="optionsBuyPrice"
						:optionsCurrentPrice="optionsCurrentPrice"
						:optionsBuyType="optionsBuyType"
						:orderId="orderId"
						@account-click="showAccountPopup"
						@login-click="showLoginModal"
						@place-trade="placeTrade"
						@place-pending-order="placePendingOrder"
						@place-options-order="placeOptionsContract"
						@select-options-time="selectOptionsTime"
					@close-options-popup="closeOptionsPopup"
							/>
						</div>
						
	<!-- 订单管理组件 -->
	<OrderManagement
		ref="orderManagement"
		:isUserLoggedIn="isUserLoggedIn"
		:mainOrderType.sync="mainOrderType"
			:tabIndex.sync="tabIndex"
			:currentNavsList="currentNavsList"
		:hylist="hylist"
		:userInfo="getUserInfo"
		:users="users"
		:indexList="currentIndexList"
		:pendingOrders="pendingOrders"
		:historyOrders="historyOrders"
		@load-tab-data="loadTabData"
			@change-tab="changesTabs"
			@close-position="showModalPC"
			@cancel-pending-order="cancelPendingOrder"
			@update-total-pnl="updateTotalPnl"
	/>
			
									</div>
									
		<!-- 个人中心组件 (移到 trading-interface 外面) -->
		<AccountCenter
			v-if="isPc"
			:visible.sync="accountCenterVisible"
			:userInfo="getUserInfo"
			:rechargeAccount="recharge_account"
			:withdrawalTypeList="withdrawalTypeList"
			:withdrawalFee="withdrawal_fee"
			:virtualStatus="virtualStatus"
			@close="accountCenterVisible = false"
			@logout="confirmLogout"
			@refresh-deposit="loadRechargeInfo"
			@refresh-withdraw="loadRechargeInfo"
		/>
		
		<!-- 理财产品组件 (移到 trading-interface 外面) -->
		<FinancialProducts
			v-if="isPc"
			:visible.sync="showFinanceDialog"
			:productList="financeProductList"
			:loading="financeLoading"
			:userBalance="getUserInfo.amount || 0"
			@close="showFinanceDialog = false"
			@purchase="handleFinancePurchase"
		/>
		
		<!-- 贷款弹窗组件 -->
		<LoanDialog
			v-if="isPc"
			:visible.sync="showLoanDialog"
			@close="showLoanDialog = false"
		/>
		
		<!-- 划转弹窗组件 -->
		<TransferDialog
			v-if="isPc"
			:visible.sync="showTransferDialog"
			@close="showTransferDialog = false"
			@transfer-success="handleTransferSuccess"
		/>
		
		<!-- 关于我们弹窗组件 -->
		<AboutUsDialog
			v-if="isPc"
			:visible.sync="showAboutDialog"
			@close="showAboutDialog = false"
		/>

	<!-- 登录弹窗 -->
		<div v-if="showLoginDialog" class="auth-modal-overlay" @click.self="showLoginDialog = false">
			<div class="auth-modal-container login-modal">
				<button class="modal-close-btn" @click="showLoginDialog = false">×</button>
				<div class="modal-title">{{ $t('login.welcomeLogin') || 'Welcome to login' }}</div>
				
			<div class="modal-form">
				<div class="form-group">
					<label>{{ $t('login.username') || 'Username' }}</label>
					<input type="text" v-model="loginForm.userName" :placeholder="$t('login.enterUsername') || 'Please enter username'" class="form-input" />
				</div>
					
					<div class="form-group">
						<label>{{ $t('login.password') || 'Password' }}</label>
						<input type="password" v-model="loginForm.password" :placeholder="$t('login.enterPassword') || 'Please enter your password'" class="form-input" />
					</div>
					
					<div class="form-links">
						<span class="link-text" @click="showRegisterDialog = true; showLoginDialog = false">{{ $t('login.newUser') || 'New User?' }}<span class="link-highlight">{{ $t('login.joinNow') || 'Join Now' }}</span></span>
						<!-- <span class="link-text link-right" @click="showForgotDialog = true; showLoginDialog = false">{{ $t('login.forgotPassword') || 'Forgot password' }}</span> -->
					</div>
					
					<button class="modal-submit-btn" @click="handleLogin">{{ $t('login.btnLogin') || 'Login' }}</button>
					
					<button class="modal-demo-btn" @click="handleDappLogin">{{ $t('qian-bao-deng-lu') || 'No need to open an account, create a demo account to trade now!' }}</button>
				</div>
			</div>
		</div>

		<!-- 注册弹窗 -->
		<div v-if="showRegisterDialog" class="auth-modal-overlay" @click.self="showRegisterDialog = false">
			<div class="auth-modal-container register-modal">
				<button class="modal-close-btn" @click="showRegisterDialog = false">×</button>
				<div class="modal-title">{{ $t('login.welcomeRegister') || 'Welcome to register' }}</div>
				
				<div class="modal-form">
					<!-- 注册方式选择 -->
					<div class="form-group">
						<label>{{ $t('login.registerMethod') || '注册方式' }}</label>
						<div class="register-method-selector">
							<button 
								type="button" 
								:class="['method-btn', { active: registerForm.registerMethod === 'email' }]"
								@click="selectRegisterMethod('email')"
							>
								{{ $t('login.emailRegister') || '邮箱注册' }}
							</button>
							<button 
								type="button" 
								:class="['method-btn', { active: registerForm.registerMethod === 'phone' }]"
								@click="selectRegisterMethod('phone')"
							>
								{{ $t('login.phoneRegister') || '手机注册' }}
							</button>
						</div>
					</div>
					
					<!-- 用户名输入框 -->
					<div class="form-group">
						<label>{{ $t('login.username') || 'Username' }}</label>
						<input type="text" v-model="registerForm.userName" :placeholder="$t('login.enterUsername') || 'Please enter username'" class="form-input" />
					</div>
					
					<!-- 邮箱输入框 -->
					<div class="form-group" v-if="registerForm.registerMethod === 'email'">
						<label>{{ $t('login.enterEmail') || 'Enter your Email' }}</label>
						<input type="email" v-model="registerForm.email" :placeholder="$t('login.enterEmail') || 'Please enter your email address'" class="form-input" />
					</div>
					
				<!-- 手机号输入框 -->
				<div class="form-group" v-if="registerForm.registerMethod === 'phone'">
					<label>{{ $t('login.telephone') || 'Phone Number' }}</label>
					<div class="phone-input-group">
						<el-select v-model="registerForm.zipCode" class="zip-code-select" :placeholder="$t('common.pleaseSelect')">
							<el-option v-for="zip in areaCodes" :key="zip" :label="zip" :value="zip"></el-option>
						</el-select>
						<input type="tel" v-model="registerForm.phone" :placeholder="$t('login.enterPhone') || 'Please enter your phone number'" class="form-input phone-input" />
					</div>
				</div>
					
					<div class="form-group">
						<label>{{ $t('login.password') || 'Password' }}</label>
						<input type="password" v-model="registerForm.password" :placeholder="$t('login.enterPassword') || 'Please enter your password'" class="form-input" />
					</div>
					
					<div class="form-group">
						<label>{{ $t('login.rePassword') || 'Re-type the password' }}</label>
						<input type="password" v-model="registerForm.rePassword" :placeholder="$t('login.enterPassword') || 'Please enter your password'" class="form-input" />
					</div>
					
					<div class="form-group">
						<label>{{ $t('login.invitationCode') || 'Invitation Code' }}</label>
						<input type="text" v-model="registerForm.invitationCode" :placeholder="$t('login.enterInvitationCode') || 'Please enter the invitation code'" class="form-input" />
					</div>
					
					<div class="form-group">
						<label>{{ $t('login.verificationCode') || 'Verification Code' }}</label>
						<div class="verification-input-group">
							<input type="text" v-model="registerForm.code" :placeholder="$t('login.enterVerificationCode') || 'Please enter the verification code'" class="form-input" />
							<button class="send-code-btn" @click="sendVerificationCode" :disabled="registerCodeCountdown">
								{{ registerCodeCountdown ? registerCodeTime + 's' : ($t('login.send') || 'Send') }}
							</button>
						</div>
					</div>
					
					<button class="modal-submit-btn" @click="handleRegister">{{ $t('login.register') || 'Register' }}</button>
				</div>
			</div>
		</div>

		<!-- 成功提示弹窗 - 使用公共组件 -->
		<SuccessModal ref="successModal" :message="successMessage" :duration="2000" />
	
	<!-- 截图预览弹窗 -->
	<div v-if="showScreenshotModal" class="screenshot-modal-overlay" @click.self="closeScreenshotModal">
		<div class="screenshot-modal-container">
			<div class="screenshot-modal-header">
				<h3>{{ $t('Trading.screenshot') || '截屏' }}</h3>
				<button class="screenshot-close-btn" @click="closeScreenshotModal">×</button>
			</div>
			<div class="screenshot-modal-body">
				<img :src="screenshotUrl" alt="Chart Screenshot" class="screenshot-preview" />
			</div>
			<div class="screenshot-modal-footer">
				<button class="screenshot-save-btn" @click="saveScreenshot">
					{{ $t('Trading.save') || '保存' }}
				</button>
			</div>
		</div>
	</div>

		<!-- 忘记密码弹窗 -->
		<div v-if="showForgotDialog" class="auth-modal-overlay" @click.self="showForgotDialog = false">
			<div class="auth-modal-container forgot-modal">
				<button class="modal-close-btn" @click="showForgotDialog = false">×</button>
				<div class="modal-title">{{ $t('login.forgotPassword') || 'Forgot password' }}</div>
				
				<div class="modal-form">
					<div class="form-group">
						<label>{{ $t('login.enterEmail') || 'Enter your Email' }}</label>
						<input type="text" v-model="forgotForm.email" :placeholder="$t('login.enterEmail') || 'Please enter your email address'" class="form-input" />
					</div>
					
					<div class="form-group">
						<label>{{ $t('login.newPassword') || 'New password' }}</label>
						<input type="password" v-model="forgotForm.newPassword" :placeholder="$t('login.enterPassword') || 'Please enter your password'" class="form-input" />
					</div>
					
					<div class="form-group">
						<label>{{ $t('login.rePassword') || 'Re-type the password' }}</label>
						<input type="password" v-model="forgotForm.rePassword" :placeholder="$t('login.enterPassword') || 'Please enter your password'" class="form-input" />
					</div>
					
					<div class="form-group">
						<label>{{ $t('login.verificationCode') || 'Verification Code' }}</label>
						<div class="verification-input-group">
							<input type="text" v-model="forgotForm.code" :placeholder="$t('login.enterVerificationCode') || 'Please enter the verification code'" class="form-input" />
							<button class="send-code-btn" @click="sendResetCode">{{ $t('login.send') || 'Send' }}</button>
						</div>
					</div>
					
				<button class="modal-submit-btn" @click="handleResetPassword">{{ $t('login.resetPassword') || 'Reset Password' }}</button>
			</div>
		</div>
	</div>

	<!-- 成功提示框 -->
	<div v-if="showSuccessModal" class="success-modal-overlay" @click="showSuccessModal = false">
	<div class="success-modal-content" @click.stop>
		<div class="success-icon">
			<svg viewBox="0 0 24 24" class="checkmark-simple">
				<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
			</svg>
		</div>
		<div class="success-text">{{ successMessage }}</div>
	</div>
</div>
</div>
</div>
</div>
</template>
<script>
	import {
		randomLine
	} from "@/utils/tools.js";
	import {
		mapGetters
	} from "vuex";
	import {
		mapState
	} from "vuex";
	import {
		listMarketByType,
		getParamByKey,
		getMarketInfo,
		getKValueByCodeAndDate,
		listSmartOrder,
		listUOrder,
		listBbOrder,
		listOptionsOrder,
		getOptionsOrderById,
		getProfitTotal,
		chedan,
		cancelContractsOrder,
		buyOptions,
		buyU,
		stopU,
		submit,
		checkTradingTime
	} from '@/api/market.js'
	import { handleApiError } from '@/utils/errorCodeHandler'
	import { recharge, withdrawal, repassword } from '@/api/user.js'
	import { upload } from '@/api/upload.js'
	import NavM from "@/components/nav_m.vue";
	import SuccessModal from "@/components/SuccessModal.vue";
	import TradingTopNav from "@/components/TradingTopNav.vue";
	import MarketList from "@/components/MarketList.vue";
	import KLineChart from "@/components/KLineChart.vue";
	import TradingPanel from "@/components/TradingPanel.vue";
	import DrawingToolbar from "@/components/DrawingToolbar.vue";
	import OrderManagement from "@/components/OrderManagement.vue";
	import AccountCenter from "@/components/AccountCenter.vue";
	import FinancialProducts from "@/components/FinancialProducts.vue";
	import LoanDialog from "@/components/LoanDialog.vue";
	import TransferDialog from "@/components/TransferDialog.vue";
	import AboutUsDialog from "@/components/AboutUsDialog.vue";
	import { Dialog } from 'vant';
	export default {
		components: {
			NavM,
		SuccessModal,
		TradingTopNav,
		MarketList,
		KLineChart,
		TradingPanel,
		DrawingToolbar,
		OrderManagement,
		AccountCenter,
		FinancialProducts,
		LoanDialog,
		TransferDialog,
		AboutUsDialog
	},
	data() {
		return {
		// 界面控制
		showTradingInterface: true,
		isUpdatingChart: false, // 防止图表重复绘制的标志
		chartInstance: null, // 存储主图表实例，用于resize
		subChartInstance: null, // 存储副图表实例
		chartResizeHandler: null, // 存储resize处理函数，用于移除监听器
		
		// 绘图工具状态
		activeTool: null, // 当前激活的工具
		showDrawingDropdown: false, // 绘图工具下拉菜单显示状态
		showChannelDropdown: false, // 通道工具下拉菜单显示状态
		showShapeDropdown: false, // 形状工具下拉菜单显示状态
		showFibonacciDropdown: false, // 斐波那契/江恩工具下拉菜单显示状态
		showWaveDropdown: false, // 波浪形态/谐波形态工具下拉菜单显示状态
		showMagnetDropdown: false, // 磁铁模式下拉菜单显示状态
		selectedDrawingTool: null, // 选中的绘图工具类型
		magnetMode: null, // 磁铁模式：'weak' 弱磁, 'strong' 强磁, null 关闭
	isDrawingMode: false, // 是否处于绘图模式
	drawingElements: [], // 存储所有绘制的元素
	currentDrawingElement: null, // 当前正在绘制的元素
	drawingStartPoint: null, // 绘图起始点
	drawingsVisible: true, // 绘图元素是否可见
	indicatorsVisible: true, // 指标线是否可见
		currentIndicatorValues: { // 当前指标值
			ma5: '--',
			ma10: '--',
			ma30: '--',
			ma60: '--'
		},
		cachedIndicatorData: { // 缓存的指标计算数据
			ma5: [],
			ma10: [],
			ma30: [],
			ma60: []
		},
		showMASettings: false, // 是否显示MA设置弹窗
		maSettings: { // MA参数设置
			ma1: 5,
			ma2: 10,
			ma3: 30,
			ma4: 60,
			ma5: null
		},
		showEMASettings: false, // 是否显示EMA设置弹窗
		emaSettings: { // EMA参数设置
			ema1: 6,
			ema2: 12,
			ema3: 20,
			ema4: null,
			ema5: null
		},
		showBOLLSettings: false, // 是否显示BOLL设置弹窗
		bollSettings: { // BOLL参数设置
			period: 20,
			stdDev: 2
		},
		
		// 图表懒加载相关
		chartObserver: null, // Intersection Observer 实例
		initializedCharts: new Set(), // 已初始化的图表集合
		chartInitQueue: [], // 图表初始化队列
		isProcessingQueue: false, // 是否正在处理队列
		chartRetryCount: {}, // 记录每个图表的重试次数
			
		// 语言设置
		currentLanguage: '', // 将在 mounted 中从 store 初始化
		isLanguageSelectorOpen: false, // 语言选择器弹窗开关
		
	// 登录/注册弹窗控制
	showLoginDialog: false,
	showRegisterDialog: false,
	showForgotDialog: false,
		
		// 理财弹窗控制
		showFinanceDialog: false,
		financeProductList: [],
		financeLoading: false,
		financeMsgboxInstance: null,
		
		// 贷款弹窗控制
		showLoanDialog: false,
		// 划转弹窗控制
		showTransferDialog: false,
		// 关于我们弹窗控制
		showAboutDialog: false,
		defaultFinanceImage: 'data:image/png;base64,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',
		// 理财详情弹窗控制
		showFinanceDetailDialog: false,
		selectedFinanceProduct: null,
		financeHistoryList: [],
		financeHistoryLoading: false,
		
		// 登录表单
		loginForm: {
			userName: '',
			password: '',
			ip: ''
		},
		
	// 注册表单
	registerForm: {
		registerMethod: 'email', // 'email' 或 'phone'
		userName: '', // 用户名
		email: '',
		phone: '',
		zipCode: '+852',
		password: '',
		rePassword: '',
		invitationCode: '',
		code: ''
	},
	
	// 验证码倒计时
	registerCodeCountdown: false, // 是否在倒计时
	registerCodeTime: 60, // 倒计时秒数
	registerCodeTimer: null, // 倒计时定时器
		
		// 忘记密码表单
		forgotForm: {
			email: '',
			newPassword: '',
			rePassword: '',
			code: ''
		},
		
		// TronWeb相关
		tronWeb: null,
		
		// 初始化状态控制
		isMounted: false, // 组件是否已mounted
		isInitialized: false, // 组件是否已完成初始化

			// 顶部导航控制
			showSubmitOrder: true, // 控制Submit Order面板显示/隐藏
			showIndicators: false, // 控制技术指标面板显示/隐藏
		showScreenshotModal: false, // 控制截图预览弹窗
		screenshotUrl: '', // 截图URL
	// 主图指标列表
	mainIndicators: [
		{ name: 'MA', label: '', selected: false, type: 'main' },
		{ name: 'EMA', label: '', selected: false, type: 'main' },
		{ name: 'SMA', label: '', selected: false, type: 'main' },
		{ name: 'BOLL', label: '', selected: false, type: 'main' },
		{ name: 'SAR', label: '', selected: false, type: 'main' }
	],
		// 副图指标列表
		subIndicators: [
			{ name: 'MA', label: '', selected: false, type: 'sub' },
				{ name: 'EMA', label: '', selected: false, type: 'sub' },
				{ name: 'MACD', label: '', selected: false, type: 'sub' },
				{ name: 'BOLL', label: '', selected: false, type: 'sub' },
				{ name: 'KDJ', label: '', selected: false, type: 'sub' },
				{ name: 'RSI', label: '', selected: false, type: 'sub' },
				{ name: 'BIAS', label: '', selected: false, type: 'sub' },
				{ name: 'BRAR', label: '', selected: false, type: 'sub' },
				{ name: 'CCI', label: '', selected: false, type: 'sub' },
				{ name: 'DMI', label: '', selected: false, type: 'sub' },
				{ name: 'CR', label: '', selected: false, type: 'sub' },
				{ name: 'PSY', label: '', selected: false, type: 'sub' },
				{ name: 'DMA', label: '', selected: false, type: 'sub' },
				{ name: 'TRIX', label: '', selected: false, type: 'sub' },
				{ name: 'OBV', label: '', selected: false, type: 'sub' },
				{ name: 'VR', label: '', selected: false, type: 'sub' },
				{ name: 'WR', label: '', selected: false, type: 'sub' },
				{ name: 'MTM', label: '', selected: false, type: 'sub' },
				{ name: 'EMV', label: '', selected: false, type: 'sub' },
				{ name: 'SAR', label: '', selected: false, type: 'sub' },
				{ name: 'SMA', label: '', selected: false, type: 'sub' },
				{ name: 'ROC', label: '', selected: false, type: 'sub' },
				{ name: 'PVT', label: '', selected: false, type: 'sub' },
				{ name: 'BBI', label: '', selected: false, type: 'sub' },
				{ name: 'AO', label: '', selected: false, type: 'sub' }
			],

		marketList: [],
		chartData: {},
		// 交易状态相关
		tradingStatuses: {}, // { marketId: { canTrade: true/false, reason: '...' } }
		checkingTradingStatus: false,
		tradingStatusTimer: null,
		// 交易界面数据 - 对标st5-pc
			selectedStock: null,
			selectedPeriod: '1M', // ✅ 默认1分钟K线

			// OHLC信息显示
			currentOHLC: {
				time: '',
				open: '',
				high: '',
				low: '',
				close: '',
				volume: '',
				currentPrice: '' // 鼠标悬停时显示的当前价格
			},

				
				// 当前市场详细信息（包含合约信息）
			currentMarketInfo: null,

		// 交易表单数据 - 新的两级结构
		mainTradeType: 'contract', // 主类型：contract(合约) 或 options(期权)
		contractSubType: 'market', // 合约子类型：market(市价) 或 pending(挂单)
		switchingTransactions: 'marketPrice', // 兼容旧代码，保留
		multiplier: 1, // 杠杆倍数，默认1倍
				tradePrice: 0, // 交易价格
				stopLoss: 0,
				takeProfit: 0,
				quantity: 1,
				stopLossEnabled: false,
				takeProfitEnabled: false,

				// 下单相关状态
				isTrading: false, // 是否正在下单
				clickLimitTime: 1000, // 点击频率限制时间(毫秒)
				lastClickTime: 0, // 上次点击时间

		// 期权相关数据 - 从后端动态获取，不使用硬编码
		optionsInfo: [], // 期权信息配置（从后端API获取）
		optionsIndex: 0, // 当前选中的期权索引
		optionsId: '', // 期权产品ID
		optionsMoney: 100, // 期权投资金额，默认100
		optionsTime: 60, // 期权倒计时时间
		defaultTradeFee: 0, // 默认交易手续费
		currentOptionsRate: 20, // 当前期权收益率
		optionsBuyPrice: 0, // 期权买入价格
		optionsCurrentPrice: 0, // 期权当前价格
		optionsBuyType: '1', // 期权买入类型：1=买涨，2=买跌
		optionsOrderInfo: {}, // 期权订单信息
		optionsPop: false, // 期权弹窗显示状态
		optionsTimer: null, // 期权倒计时定时器
		optionsCountdownTimer: null, // 期权持仓倒计时定时器
		optionsRefreshTimeout: null, // 期权刷新防抖定时器
		optionsLoading: false, // 期权加载状态
		serverTimeOffset: 0, // 服务器时间偏移量（毫秒）：服务器时间 - 客户端时间
		showQuantityDetail: false, // 显示数量详情
			
			// 账户弹窗控制
			accountPopupVisible: false,
			accountCenterVisible: false, // 新的个人中心组件显示状态
			// 账户弹窗相关数据
			accountActiveTab: 'wallet',
			showAccountMenu: false,
			virtualStatus: 1, // 1=真实账户, 2=模拟账户 // 账户弹窗显示状态
			// 充值账户信息（从API获取）
			recharge_account: [],
			recharge_typeIndex: 0, // 当前选择的充值货币索引
			// 提现手续费
			withdrawal_fee: {},
			// 提现方式
			withdrawalTypeList: ['BTC','ETH','USDC','','BANK'],
			withdrawalTypeIndex: 0,
			// 充值凭证表单
			depositProofForm: {
				type: '', // 充值类型
				amount: '', // 充值金额
				prove: '' // 凭证图片URL
			},
		depositProofUploadIndex: 0, // 充值凭证选择的货币索引
		showDepositProofDialog: false, // 显示充值凭证弹窗
		orderId: '', // 订单ID
			lastClickTime: 0, // 上次点击时间，用于防止重复点击
			showSuccessModal: false, // 成功提示弹窗显示状态（已废弃，使用SuccessModal组件）
			successMessage: '', // 成功提示消息内容

				// 挂单交易数据 - 对标st5-pc
				pendingQuantity: 1,
				pendingPrice: 0, // 挂单价格
				pendingMultiplier: 1, // 挂单倍数，默认1倍（数字类型，匹配滑块控件）
				pendingStopLoss: 0, // 挂单止损价
				pendingTakeProfit: 0, // 挂单止盈价
				pendingStopLossEnabled: false, // 挂单止损开关
				pendingTakeProfitEnabled: false, // 挂单止盈开关
				openingTime: 'immediate',

				// 用户信息 - 对标st5-pc
				users: {
					id: '1087978',
					// email: 'xiaofang88888999@gmail.com',
					usdt: 0,
					net_worth: true
				},

			// 订单管理 - 对标st5-pc
			mainOrderType: 'contract', // 主选项卡：'contract' 或 'options'
			navsList: [], // 合约订单选项卡
			optionsNavsList: [], // 期权订单选项卡
			tabIndex: 0,
			scrollH: 150,
			showSuccessModal: false, // 成功提示框
			successMessage: '', // 成功提示内容

				// 持仓数据 - 对标st5-pc
				hylist: {
					yks: -113596.66000, // 盈亏
					caution_money: 0, // 保证金
					handling_fee: 107385.60000 // 手续费
				},

		// 订单列表数据 - 对标st5-pc
			contractIndexList: [], // 合约持仓列表
			optionsIndexList: [], // 期权持仓列表
			indexList: [], // 持仓列表（已废弃，保留用于兼容性）
			pendingOrders: [
					// 示例挂单数据
					{
						id: 721,
						code: 'BTCUSD',
						direction: 1, // 1=买入, 0=卖出
						lots: 1,
						lower_unit_price: 1.00000000,
						current_price: 121264.33,
						take_profit: 0.00000000,
						set_loss: 0.00000000,
						handling_fee: 20.00000000,
						margin: 1.00000000,
						profit: 121263.30000,
						open_time: '2025-10-06 07:12:43'
					}
			], // 挂单列表 - 将从API获取
			historyOrders: [], // 历史订单列表 - 将从API获取
			allOptionsOrders: null, // 所有期权订单缓存（500条）
			allContractOrders: null, // 所有合约订单缓存

			// K线实时更新相关变量
			lastPriceLineUpdate: 0, // 上次价格线更新时间
				lastKlineUpdate: 0, // 上次K线数据更新时间
				klineUpdateInterval: 100, // K线数据更新间隔（毫秒），优化为100ms实现更流畅的实时更新
			}
		},
	computed: {
		// 时间周期选项（支持国际化）
		timePeriods() {
			return [
				{ label: '1M', value: '1M', dateType: '1' },
				{ label: '5M', value: '5M', dateType: '5' },
				{ label: '15M', value: '15M', dateType: '15' },
				{ label: '30M', value: '30M', dateType: '30' },
				{ label: '1H', value: '1H', dateType: '60' },
				{ label: '1D', value: '1D', dateType: 'd' },
				{ label: this.$t('Trading.indicator') || 'Indicator', value: 'indicator', dateType: null }
			];
		},
		
		// 当前语言名称
currentLangName() {
	const name = this.langList && this.langList[this.langIndex] ? this.langList[this.langIndex].name : 'English';
	return name;
},
// 是否有选中的副图指标
hasSelectedSubIndicators() {
	return this.subIndicators && this.subIndicators.some(item => item.selected);
},
// 选中的主图指标
selectedMainIndicators() {
	return this.mainIndicators ? this.mainIndicators.filter(item => item.selected) : [];
},
// 当前显示的选项卡列表（根据合约/期权切换）
currentNavsList() {
	return this.mainOrderType === 'contract' ? this.navsList : this.optionsNavsList;
},
// 当前显示的持仓列表（根据合约/期权切换）
currentIndexList() {
	return this.mainOrderType === 'contract' ? this.contractIndexList : this.optionsIndexList;
},
// 判断用户是否登录 - 使用 Vuex store 状态（响应式）
isUserLoggedIn() {
	// 使用 mapState 映射的 isLogin 和 token
	const result = !!(this.token && (this.isLogin === 'true' || this.isLogin === '1' || this.isLogin === true || this.isLogin === 1));
	return result;
},
// 获取市场分类列表（国际化）
getMarkTypeList() {
	return this.$store.getters.getMarkTypeList || [];
},
	// 计算预估手续费（市价交易）
	// 手续费 = 名义价值 × (tradeFee / 100)
	// 名义价值 = 手数 × 价格 × 合约乘数
	estimatedMarketCommission() {
		if (this.currentMarketInfo && this.currentMarketInfo.contractsInfo && this.currentMarketInfo.contractsInfo.tradeFee !== null && this.currentMarketInfo.contractsInfo.tradeFee !== undefined) {
			const hands = this.quantity || 1; // 手数
			const price = parseFloat(this.currentMarketInfo.price || this.currentMarketInfo.nowPrice || 0); // 币种价格
			const contractSize = this.currentMarketInfo.contractsInfo.handNum || 1; // 合约乘数
			const tradeFeePercent = this.currentMarketInfo.contractsInfo.tradeFee / 100; // 手续费百分比（转换为小数）
			
			// 名义价值 = 手数 × 价格 × 合约乘数
			const nominalValue = hands * price * contractSize;
			// 手续费 = 名义价值 × tradeFee%
			const tradeFee = nominalValue * tradeFeePercent;
			// 保留最多8位小数，但去除末尾的0
			return parseFloat(tradeFee.toFixed(8)).toString();
		}
		return '0';
	},
	// 计算预估保证金（挂单）
	estimatedMargin() {
		// 使用正确的公式：手数 × 杠杆 × contractsInfo.margin
		if (this.currentMarketInfo && this.currentMarketInfo.contractsInfo && this.currentMarketInfo.contractsInfo.margin) {
			const quantity = this.pendingQuantity || 1;
			const multiplier = parseInt(this.pendingMultiplier) || 1;
			const marginValue = this.currentMarketInfo.contractsInfo.margin;
			return (quantity * multiplier * marginValue).toFixed(5);
		}
		return '0.00000';
	},
	// 计算预估手续费（挂单）
	// 手续费 = 名义价值 × (tradeFee / 100)
	// 名义价值 = 手数 × 挂单价格 × 合约乘数
	estimatedCommission() {
		if (this.currentMarketInfo && this.currentMarketInfo.contractsInfo && this.currentMarketInfo.contractsInfo.tradeFee !== null && this.currentMarketInfo.contractsInfo.tradeFee !== undefined) {
			const hands = this.pendingQuantity || 1; // 手数
			const price = this.pendingPrice || parseFloat(this.currentMarketInfo.price || this.currentMarketInfo.nowPrice || 0); // 挂单价格或当前价格
			const contractSize = this.currentMarketInfo.contractsInfo.handNum || 1; // 合约乘数
			const tradeFeePercent = this.currentMarketInfo.contractsInfo.tradeFee / 100; // 手续费百分比（转换为小数）
			
			// 名义价值 = 手数 × 价格 × 合约乘数
			const nominalValue = hands * price * contractSize;
			// 手续费 = 名义价值 × tradeFee%
			const tradeFee = nominalValue * tradeFeePercent;
			// 保留最多8位小数，但去除末尾的0
			return parseFloat(tradeFee.toFixed(8)).toString();
		}
		return '0';
	},

			// 计算秒合约预估手续费
			estimatedOptionsFee() {
				const amount = this.optionsQuantity * 100; // 假设每单位100
				const feeRate = this.defaultTradeFee || 0.3; // 默认0.3%
				return (amount * feeRate / 100).toFixed(2);
			},
	...mapGetters(["marketWsList", "getUserInfo"]),
	...mapState(["isPc", "langList", "langIndex", "isLogin", "token", "darkMode", "areaCodes"]),
			
			// 计算合约保证金 - 对标cruuency页面
			// 保证金 = 手数 * 杠杆 * 设置的margin
			contractsInfoMargin() {
				if (this.currentMarketInfo && this.currentMarketInfo.contractsInfo && this.currentMarketInfo.contractsInfo.margin && this.quantity) {
					return this.quantity * this.multiplier * this.currentMarketInfo.contractsInfo.margin;
				} else {
					return 0;
				}
			},
			
		// 计算交易费 - 对标cruuency页面
		// 交易费 = 名义价值 × (tradeFee / 100)
		// 名义价值 = 手数 × 价格 × 合约乘数
		contractsTradeFee() {
			if (this.currentMarketInfo && this.currentMarketInfo.contractsInfo && this.currentMarketInfo.contractsInfo.tradeFee !== null && this.currentMarketInfo.contractsInfo.tradeFee !== undefined) {
				const hands = this.quantity || 1;
				const price = parseFloat(this.currentMarketInfo.price || this.currentMarketInfo.nowPrice || 0);
				const contractSize = this.currentMarketInfo.contractsInfo.handNum || 1;
				const tradeFeePercent = this.currentMarketInfo.contractsInfo.tradeFee / 100;
				
				// 名义价值 = 手数 × 价格 × 合约乘数
				const nominalValue = hands * price * contractSize;
				// 手续费 = 名义价值 × tradeFee%
				return nominalValue * tradeFeePercent;
			} else {
					return 0;
				}
			},
			
		// 计算总盈亏 - 对标st5-pc
		totalPnL() {
			return this.currentIndexList.reduce((total, order) => total + (order.upsdowns || 0), 0);
		},
		// 计算总保证金 - 对标st5-pc
		totalMargin() {
			return this.currentIndexList.reduce((total, order) => total + parseFloat(order.caution_money || 0), 0);
		},
		// 计算持仓订单表格高度
		positionTableHeight() {
			const minHeight = 400;
			const maxHeight = 600;
			const dataLength = this.currentIndexList ? this.currentIndexList.length : 0;
				// 如果没有数据，返回最小高度
				if (dataLength === 0) return minHeight;
				// 如果数据较少，返回最小高度
				if (dataLength <= 8) return minHeight;
				// 如果数据较多，返回最大高度
				return maxHeight;
			},
			// 计算挂单列表表格高度
			pendingTableHeight() {
				const minHeight = 400;
				const maxHeight = 600;
				const dataLength = this.pendingOrders ? this.pendingOrders.length : 0;
				// 如果没有数据，返回最小高度
				if (dataLength === 0) return minHeight;
				// 如果数据较少，返回最小高度
				if (dataLength <= 8) return minHeight;
				// 如果数据较多，返回最大高度
				return maxHeight;
			},
			// 计算历史订单表格高度
			historyTableHeight() {
				const minHeight = 400;
				const maxHeight = 600;
				const dataLength = this.historyOrders ? this.historyOrders.length : 0;
				// 如果没有数据，返回最小高度
				if (dataLength === 0) return minHeight;
				// 如果数据较少，返回最小高度
				if (dataLength <= 8) return minHeight;
				// 如果数据较多，返回最大高度
				return maxHeight;
			}
		},

	watch: {
		// 注意：不需要在 watch 中调用 getProfitSummary()
		// 因为 loadTabData() 在加载完数据后会自动调用 getProfitSummary()
		// 如果在 watch 中立即调用，会导致使用旧数据计算盈亏
		
	// 监听登录状态变化
	isUserLoggedIn: {
		handler(newVal, oldVal) {
			
			if (newVal && !oldVal) {
				// 从未登录变为已登录
				this.$nextTick(() => {
					this.$forceUpdate();
				});
		} else if (!newVal && oldVal) {
			// 从已登录变为未登录
			this.contractIndexList = [];
			this.optionsIndexList = [];
			this.historyList = [];
			this.pendingList = [];
			this.$nextTick(() => {
				this.$forceUpdate();
			});
		}
		},
		immediate: false
	},
	
	// 监听市价交易止损开关
	stopLossEnabled(newVal) {
		if (newVal && this.selectedStock) {
			// 打开时自动填充当前币种价格
			this.stopLoss = parseFloat(this.selectedStock.nowPrice || this.selectedStock.price || 0);
		}
	},
	
	// 监听市价交易止盈开关
	takeProfitEnabled(newVal) {
		if (newVal && this.selectedStock) {
			// 打开时自动填充当前币种价格
			this.takeProfit = parseFloat(this.selectedStock.nowPrice || this.selectedStock.price || 0);
		}
	},
	
	// 监听挂单止损开关
	pendingStopLossEnabled(newVal) {
		if (newVal && this.selectedStock) {
			// 打开时自动填充当前币种价格
			this.pendingStopLoss = parseFloat(this.selectedStock.nowPrice || this.selectedStock.price || 0);
		}
	},
	
	// 监听挂单止盈开关
	pendingTakeProfitEnabled(newVal) {
		if (newVal && this.selectedStock) {
			// 打开时自动填充当前币种价格
			this.pendingTakeProfit = parseFloat(this.selectedStock.nowPrice || this.selectedStock.price || 0);
		}
	},
		marketWsList: {
				handler: function(val, oldVal) {
					if (val[0]) {
						const data = val;
						this.marketList.forEach(item => {
							data.forEach(item1 => {
								if (item1.code === item.code) {
									item.nowPrice = item1.price;
									item.zdf = item1.zdf;
								}
							});
						});

						// 处理实时K线图更新
						data.forEach(item => {
							// 更新简单图表数据
							if (!this.chartData[item.code]) {
								this.chartData[item.code] = [];
							}
							this.chartData[item.code].push(item.price);
							
							// 🚀 只更新已初始化的图表，避免不必要的初始化
							if (this.initializedCharts.has(item.code)) {
								this.chartInit(item.code);
							}

							// 如果当前选中的股票有实时数据推送，更新K线图和价格信息
							if (this.selectedStock && this.selectedStock.code === item.code) {
								this.updateRealTimeKLineData(item);
								
								// 🔑 关键修复：更新currentMarketInfo的实时价格，确保预估手续费能实时更新
								if (this.currentMarketInfo && this.currentMarketInfo.code === item.code) {
									this.currentMarketInfo.price = item.price;
									this.currentMarketInfo.nowPrice = item.price;
									this.currentMarketInfo.zdf = item.zdf;
								}
							}
						});
					}
				},
				deep: true
			},
			// 监听语言变化，更新导航标签
			'$i18n.locale': {
				handler() {
					this.updateNavsList();
				},
				immediate: false
			},
			// 监听marketList变化，确保数据加载后图表能正常初始化
			marketList: {
				handler(newList, oldList) {
					if (newList && newList.length > 0 && (!oldList || oldList.length === 0)) {
						// 强制DOM更新后再初始化图表
						this.$forceUpdate();
						this.$nextTick(() => {
							this.$nextTick(() => {
								setTimeout(() => {
									this.forceInitAllCharts();
								}, 500);
							});
						});
					}
				},
				immediate: false,
				deep: false
			}
		},


		async mounted() {

		// 标记组件已mounted，避免重复初始化
		this.isMounted = true;
		
	// 初始化当前语言 - 从 store 中获取
	const storedLanguage = this.$store.state.currentLanguage || localStorage.getItem('language') || 'en';
	this.currentLanguage = storedLanguage;
			
			// 加载充值账户信息和提现手续费
			this.loadRechargeInfo();

			// 延迟一点时间执行初始化，确保父组件也完成了mounted
			setTimeout(async () => {
				if (!this.isInitialized) {
					await this.executeFullInitialization();
					this.isInitialized = true;
				} else {
				}
			}, 100);
			
			// 添加键盘事件监听
			document.addEventListener('keydown', this.handleKeyDown);
		},

		// 路由激活时重新初始化 - 解决页面刷新和路由切换问题
		activated() {

			// 检查关键数据是否存在，如果不存在则重新加载
			const needReload = !this.marketList || this.marketList.length === 0;

			if (needReload) {
				// 重新执行完整的初始化流程
				this.reloadAllData();
			} else {
				// 数据正常，只需要重新初始化图表
				this.$nextTick(() => {
					this.reinitializeCharts();
				});
			}
		},

		// 组件销毁前清理
	beforeDestroy() {
		// 清理所有图表实例
		this.clearAllCharts();
		// 清理定时器
		if (this.chartInitTimer) {
			clearTimeout(this.chartInitTimer);
		}
		// 清理期权倒计时定时器
		if (this.optionsCountdownTimer) {
			clearInterval(this.optionsCountdownTimer);
			this.optionsCountdownTimer = null;
		}
		// 清理交易状态检查定时器
		if (this.tradingStatusTimer) {
			clearInterval(this.tradingStatusTimer);
			this.tradingStatusTimer = null;
		}
		// 清理期权刷新防抖定时器
		if (this.optionsRefreshTimeout) {
			clearTimeout(this.optionsRefreshTimeout);
			this.optionsRefreshTimeout = null;
		}
		// 清理 Intersection Observer
		if (this.chartObserver) {
			this.chartObserver.disconnect();
			this.chartObserver = null;
		}
		// 清理页面可见性监听器
		if (typeof document !== 'undefined') {
			document.removeEventListener('visibilitychange', this.handleVisibilityChange);
		}
		// 清理窗口resize监听器
		if (this.chartResizeHandler) {
			window.removeEventListener('resize', this.chartResizeHandler);
			this.chartResizeHandler = null;
		}
	},

		// 页面创建时添加可见性监听
		created() {
			// 监听页面可见性变化，确保页面重新激活时数据是最新的
		if (typeof document !== 'undefined') {
			document.addEventListener('visibilitychange', this.handleVisibilityChange);
			// 添加全局点击事件监听，用于关闭语言选择器
			document.addEventListener('click', this.handleGlobalClick);
		}
	},
	
	beforeDestroy() {
		// 移除全局点击事件监听
		if (typeof document !== 'undefined') {
			document.removeEventListener('click', this.handleGlobalClick);
			document.removeEventListener('keydown', this.handleKeyDown);
		}
		
		// 移除图表绘图事件监听
		const chartContainer = document.querySelector('.middlePC');
		if (chartContainer && this._boundClick) {
			chartContainer.removeEventListener('click', this._boundClick);
		}
		
		// 清理倒计时定时器
		if (this.registerCodeTimer) {
			clearInterval(this.registerCodeTimer);
			this.registerCodeTimer = null;
		}
	},
	methods: {
	// 获取充值二维码URL
	getDepositQrCodeUrl() {
		const item = this.recharge_account[this.recharge_typeIndex];
		if (!item || !item.qr_code) {
			return '';
		}
		
		let qrCode = item.qr_code;
		
		// 对URL进行编码处理，处理中文字符和空格
		try {
			qrCode = encodeURI(qrCode);
		} catch (e) {
			console.error('URL编码失败:', e);
		}
		
		return qrCode;
	},
	// 处理全局点击事件，用于关闭语言选择器和绘图工具下拉菜单
	handleGlobalClick(event) {
		// 如果点击的不是语言选择器相关元素，则关闭弹窗
		const languageButton = event.target.closest('[data-language-button]');
		if (!languageButton && this.isLanguageSelectorOpen) {
			this.isLanguageSelectorOpen = false;
		}
		
		// 如果点击的不是绘图工具按钮，则关闭下拉菜单
		const drawingTool = event.target.closest('.drawing-tool-item');
		if (!drawingTool) {
			if (this.showDrawingDropdown) {
				this.showDrawingDropdown = false;
			}
			if (this.showChannelDropdown) {
				this.showChannelDropdown = false;
			}
			if (this.showShapeDropdown) {
				this.showShapeDropdown = false;
			}
			if (this.showFibonacciDropdown) {
				this.showFibonacciDropdown = false;
			}
			if (this.showWaveDropdown) {
				this.showWaveDropdown = false;
			}
			if (this.showMagnetDropdown) {
				this.showMagnetDropdown = false;
			}
		}
	},
	
	// 切换PC端黑夜模式
	togglePcDarkMode() {
		this.$store.commit('toggleDarkMode');
	},
	
	// ==================== 绘图工具相关方法 ====================
	
	// 处理键盘事件
	handleKeyDown(event) {
		// Delete键：删除选中的绘图元素
		if (event.key === 'Delete' && this.currentDrawingElement) {
			this.deleteSelectedDrawingElement();
		}
		
		// Escape键：退出绘图模式
		if (event.key === 'Escape' && this.isDrawingMode) {
			this.cancelDrawingMode();
		}
	},
	
	// 切换绘图工具下拉菜单
	toggleDrawingToolDropdown() {
		this.showDrawingDropdown = !this.showDrawingDropdown;
		// 关闭其他下拉菜单
		this.showChannelDropdown = false;
		this.showShapeDropdown = false;
		this.showFibonacciDropdown = false;
		this.showWaveDropdown = false;
		if (this.showDrawingDropdown) {
			this.activeTool = 'drawing';
		} else if (!this.isDrawingMode) {
			this.activeTool = null;
		}
	},
	
	// 切换通道工具下拉菜单
	toggleChannelDropdown() {
		this.showChannelDropdown = !this.showChannelDropdown;
		// 关闭其他下拉菜单
		this.showDrawingDropdown = false;
		this.showShapeDropdown = false;
		this.showFibonacciDropdown = false;
		this.showWaveDropdown = false;
		if (this.showChannelDropdown) {
			this.activeTool = 'channel';
		} else if (!this.isDrawingMode) {
			this.activeTool = null;
		}
	},
	
	// 切换形状工具下拉菜单
	toggleShapeDropdown() {
		this.showShapeDropdown = !this.showShapeDropdown;
		// 关闭其他下拉菜单
		this.showDrawingDropdown = false;
		this.showChannelDropdown = false;
		this.showFibonacciDropdown = false;
		this.showWaveDropdown = false;
		if (this.showShapeDropdown) {
			this.activeTool = 'shape';
		} else if (!this.isDrawingMode) {
			this.activeTool = null;
		}
	},
	
	// 切换斐波那契/江恩工具下拉菜单
	toggleFibonacciDropdown() {
		this.showFibonacciDropdown = !this.showFibonacciDropdown;
		// 关闭其他下拉菜单
		this.showDrawingDropdown = false;
		this.showChannelDropdown = false;
		this.showShapeDropdown = false;
		this.showWaveDropdown = false;
		if (this.showFibonacciDropdown) {
			this.activeTool = 'fibonacci';
		} else if (!this.isDrawingMode) {
			this.activeTool = null;
		}
	},
	
	// 切换波浪形态/谐波形态工具下拉菜单
	toggleWaveDropdown() {
		this.showWaveDropdown = !this.showWaveDropdown;
		// 关闭其他下拉菜单
		this.showDrawingDropdown = false;
		this.showChannelDropdown = false;
		this.showShapeDropdown = false;
		this.showFibonacciDropdown = false;
		this.showMagnetDropdown = false;
		if (this.showWaveDropdown) {
			this.activeTool = 'wave';
		} else if (!this.isDrawingMode) {
			this.activeTool = null;
		}
	},
	
	// 切换磁铁模式下拉菜单
	toggleMagnetDropdown() {
		this.showMagnetDropdown = !this.showMagnetDropdown;
		// 关闭其他下拉菜单
		this.showDrawingDropdown = false;
		this.showChannelDropdown = false;
		this.showShapeDropdown = false;
		this.showFibonacciDropdown = false;
		this.showWaveDropdown = false;
		if (this.showMagnetDropdown) {
			this.activeTool = 'magnet';
		} else if (!this.magnetMode) {
			this.activeTool = null;
		}
	},
	
	// 选择磁铁模式
	selectMagnetMode(mode) {
		this.magnetMode = mode;
		this.showMagnetDropdown = false;
		this.activeTool = 'magnet';
		
		// 显示提示信息
		// this.$toast({
		// 	message: mode === 'weak' ? 
		// 		(this.$t('Trading.weakMagnetEnabled') || '弱磁模式已启用') : 
		// 		(this.$t('Trading.strongMagnetEnabled') || '强磁模式已启用'),
		// 	type: 'success',
		// 	duration: 2000
		// });
},
	
	// 应用磁铁吸附（将点击位置吸附到最近的K线关键点）
	applyMagnetSnap(clickX, clickY, chartRect) {
		if (!this.chartInstance || !this.klineData || this.klineData.length === 0) {
			return null;
		}
		
		// 设置吸附距离阈值（像素）
		const snapThreshold = this.magnetMode === 'strong' ? 50 : 25; // 强磁50px，弱磁25px
		
		try {
			// 获取图表坐标系统
			const chartWidth = chartRect.width;
			const chartHeight = chartRect.height;
			
			// 估算每根K线的宽度
			const visibleDataCount = Math.min(this.klineData.length, 100); // 假设可见约100根K线
			const candleWidth = chartWidth / visibleDataCount;
			
			// 找到点击位置对应的K线索引
			const clickIndex = Math.floor(clickX / candleWidth);
			const dataIndex = Math.max(0, Math.min(this.klineData.length - 1, 
				this.klineData.length - visibleDataCount + clickIndex));
			
			// 获取当前K线和相邻K线数据
			const searchRange = this.magnetMode === 'strong' ? 3 : 1; // 强磁搜索3根，弱磁搜索1根
			const startIndex = Math.max(0, dataIndex - searchRange);
			const endIndex = Math.min(this.klineData.length - 1, dataIndex + searchRange);
			
			let closestPoint = null;
			let minDistance = snapThreshold;
			
			// 遍历搜索范围内的K线
			for (let i = startIndex; i <= endIndex; i++) {
				const kline = this.klineData[i];
				if (!kline) continue;
				
				const klineX = (i - (this.klineData.length - visibleDataCount)) * candleWidth + candleWidth / 2;
				
				// 计算K线的高点、低点、开盘价、收盘价在Y轴上的位置
				const priceRange = this.klineData.reduce((acc, k) => {
					return {
						max: Math.max(acc.max, k[2]), // 最高价
						min: Math.min(acc.min, k[3])  // 最低价
					};
				}, { max: -Infinity, min: Infinity });
				
				const priceToY = (price) => {
					const ratio = (priceRange.max - price) / (priceRange.max - priceRange.min);
					return chartHeight * 0.1 + ratio * chartHeight * 0.8; // 留10%边距
				};
				
				// 关键价格点：开盘、收盘、最高、最低
				const keyPoints = [
					{ x: klineX, y: priceToY(kline[1]), label: 'open' },   // 开盘价
					{ x: klineX, y: priceToY(kline[4]), label: 'close' },  // 收盘价
					{ x: klineX, y: priceToY(kline[2]), label: 'high' },   // 最高价
					{ x: klineX, y: priceToY(kline[3]), label: 'low' }     // 最低价
				];
				
				// 找到最近的关键点
				for (const point of keyPoints) {
					const distance = Math.sqrt(
						Math.pow(point.x - clickX, 2) + 
						Math.pow(point.y - clickY, 2)
					);
					
					if (distance < minDistance) {
						minDistance = distance;
						closestPoint = { x: point.x, y: point.y, label: point.label };
					}
				}
			}
			
			if (closestPoint) {
				return closestPoint;
			}
			
		} catch (error) {
			console.error('磁铁吸附计算错误:', error);
		}
		
		return null;
	},
	
	// 选择绘图工具
	selectDrawingTool(toolType) {
		// console.log('🎨 选择绘图工具:', toolType); // 调试日志已清理
		
		this.selectedDrawingTool = toolType;
		this.showDrawingDropdown = false;
		this.showChannelDropdown = false;
		this.showShapeDropdown = false;
		this.showFibonacciDropdown = false;
		this.showWaveDropdown = false;
		this.isDrawingMode = true;
		
		// console.log('✅ 绘图模式已启用'); // 调试日志已清理
		
		// 根据工具类型设置 activeTool
		if (toolType === 'price-channel' || toolType === 'parallel-straight-line') {
			this.activeTool = 'channel';
		} else if (toolType === 'circle' || toolType === 'rectangle' || toolType === 'parallelogram' || toolType === 'triangle') {
			this.activeTool = 'shape';
		} else if (toolType === 'fibonacci-retracement' || toolType === 'fibonacci-grid' || toolType === 'fibonacci-circle' || 
				   toolType === 'fibonacci-spiral' || toolType === 'fibonacci-fan' || toolType === 'fibonacci-extension' || toolType === 'gann-box') {
			this.activeTool = 'fibonacci';
		} else if (toolType === 'xabcd-pattern' || toolType === 'abcd-pattern' || toolType === 'wave-3' || 
				   toolType === 'wave-5' || toolType === 'wave-8' || toolType === 'wave-custom') {
			this.activeTool = 'wave';
		} else {
			this.activeTool = 'drawing';
		}
		
		this.drawingStartPoint = null;
		
		// 为图表添加绘图事件监听
		this.$nextTick(() => {
			// console.log('⏰ 准备添加事件监听器'); // 调试日志已清理
			this.addChartDrawingListeners();
		});
	},
	
	// 添加图表绘图事件监听
	addChartDrawingListeners() {
		// 🔑 查找图表容器
		const chartContainer = document.querySelector('.middlePC');
		if (!chartContainer) {
			console.warn('❌ 未找到图表容器 .middlePC');
			return;
		}
		
		// console.log('✅ 找到图表容器，准备创建事件捕获层'); // 调试日志已清理
		
		// 🔑 确保父容器允许指针事件
		chartContainer.style.pointerEvents = 'auto';
		chartContainer.style.position = 'relative';
		// console.log('✅ 设置父容器 pointer-events: auto'); // 调试日志已清理
		
		// 🔑 创建或获取透明的事件捕获层（覆盖在 ECharts 上方）
		let eventLayer = chartContainer.querySelector('.drawing-event-layer');
		if (!eventLayer) {
			eventLayer = document.createElement('div');
			eventLayer.className = 'drawing-event-layer';
			chartContainer.appendChild(eventLayer);
			
		// 🔑 设置基础样式（不使用 !important，让后续可以灵活控制）
		eventLayer.style.position = 'absolute';
		eventLayer.style.top = '0';
		eventLayer.style.left = '0';
		eventLayer.style.width = '100%';
		eventLayer.style.height = '100%';
		eventLayer.style.zIndex = '100000'; // 🔑 必须高于页面所有元素（包括 99999 的弹窗）
		eventLayer.style.background = 'transparent';
		eventLayer.style.cursor = 'none'; // 隐藏鼠标光标，使用自定义的蓝色基点
		eventLayer.style.display = 'none'; // 初始隐藏
		eventLayer.style.pointerEvents = 'none'; // 初始不捕获事件
			
		// console.log('✅ 创建事件捕获层'); // 调试日志已清理
			
		// 🔑 添加多个测试事件（调试用，已注释）
		// eventLayer.addEventListener('mouseenter', (e) => {
		// 	console.log('✅✅✅ 鼠标进入事件捕获层！', {
		// 		target: e.target.className,
		// 		clientX: e.clientX,
		// 		clientY: e.clientY
		// 	});
		// });
		// eventLayer.addEventListener('mouseleave', (e) => {
		// 	console.log('❌❌❌ 鼠标离开事件捕获层！');
		// });
		// eventLayer.addEventListener('mousemove', (e) => {
		// 	console.log('🔥🔥🔥 直接测试：鼠标移动！', e.clientX, e.clientY);
		// }, { once: true }); // 只触发一次，避免刷屏
		}
		
	// 🔑 只在绘图模式下显示事件捕获层
	if (this.isDrawingMode) {
		eventLayer.style.display = 'block';
		eventLayer.style.pointerEvents = 'auto';
		
		// 🔑 强制刷新样式
		void eventLayer.offsetHeight; 
		
		const computedStyle = getComputedStyle(eventLayer);
		const rect = eventLayer.getBoundingClientRect();
		
	// console.log('✅ 显示事件捕获层'); // 调试日志已清理
		
	// ✅ 事件层已创建并配置完成
	// console.log('✅ 事件捕获层配置完成'); // 调试日志已清理
	
	// 🔑 使用内联方式绑定事件（解决 addEventListener 的 this 上下文问题）
	const self = this; // 保存 Vue 组件的 this 引用
	eventLayer.onmousemove = function(e) {
		// console.log('🔵🔵 onmousemove 触发！'); // 注释掉频繁触发的日志
		if (typeof self.handleChartMouseMove === 'function') {
			self.handleChartMouseMove(e);
		} else {
			console.error('❌ handleChartMouseMove 不是函数！');
		}
	};
	
	eventLayer.onclick = function(e) {
		// console.log('🔵🔵 onclick 触发！'); // 注释掉频繁触发的日志
		self.handleChartClick(e);
	};
	
	eventLayer.onmouseleave = function(e) {
		// console.log('🔵🔵 onmouseleave 触发！'); // 注释掉频繁触发的日志
		self.handleChartMouseLeave(e);
	};
		
	// 保存引用
	this._chartContainer = chartContainer;
	this._eventLayer = eventLayer;
		
	// console.log('✅ 图表绘图事件监听器已添加（内联方式）'); // 调试日志已清理
	} else {
		// 如果不在绘图模式，隐藏事件层
		eventLayer.style.display = 'none';
		eventLayer.style.pointerEvents = 'none';
		// console.log('⚠️ 隐藏事件捕获层（非绘图模式）'); // 调试日志已清理
	}
},
	
	// 🔑 处理鼠标移动事件 - 显示预览直线
	handleChartMouseMove(event) {
		// console.log('🚀🚀🚀 handleChartMouseMove 被调用了！', event); // 注释掉频繁触发的日志
		
		if (!this.isDrawingMode || !this.selectedDrawingTool) {
			// console.log('⚠️ 未进入绘图模式或未选择工具'); // 注释掉频繁触发的日志
			return;
		}
		
		// 为所有绘图工具显示十字线和预览
		// console.log('✅ 准备显示预览，工具类型:', this.selectedDrawingTool); // 注释掉频繁触发的日志
		
		// 🔑 使用缓存的容器引用，优先使用 .middlePC 作为参考容器
		const chartContainer = document.querySelector('.middlePC') || this._chartContainer || event.currentTarget;
		if (!chartContainer) {
			console.error('❌ 未找到图表容器');
			return;
		}
		
		const rect = chartContainer.getBoundingClientRect();
		let mouseX = event.clientX - rect.left;
		let mouseY = event.clientY - rect.top;
		
		// console.log('📍 鼠标位置:', { mouseX, mouseY }); // 注释掉频繁触发的日志
		
		// 应用磁铁吸附
		if (this.magnetMode) {
			const snappedPoint = this.applyMagnetSnap(mouseX, mouseY, rect);
			if (snappedPoint) {
				mouseX = snappedPoint.x;
				mouseY = snappedPoint.y;
				// console.log('🧲 磁铁吸附后:', { mouseX, mouseY }); // 注释掉频繁触发的日志
			}
		}
		
	// 显示十字光标和预览
	this.showDrawingCrosshair(chartContainer, mouseX, mouseY);
	
	// 🔑 对于水平线工具，显示完整的预览（包括横线）
	if (this.selectedDrawingTool === 'horizontal-line') {
		this.showPreviewLine(mouseX, mouseY, rect.width);
	}
	
	// 如果已经有起始点，显示从起始点到当前位置的预览线
	if (this.drawingStartPoint) {
		this.showPreviewLineFromStart(chartContainer, mouseX, mouseY);
	}
},
	
	// 🔑 显示绘图十字光标
	showDrawingCrosshair(chartContainer, mouseX, mouseY) {
		if (!chartContainer) return;
		
		// console.log('✨ 显示十字光标', { mouseX, mouseY }); // 注释掉频繁触发的日志
		
		// 确保容器是相对定位
		if (!chartContainer.style.position || chartContainer.style.position === 'static') {
			chartContainer.style.position = 'relative';
		}
		
		// 垂直十字线
		let crosshairV = chartContainer.querySelector('.drawing-crosshair-vertical');
		if (!crosshairV) {
			crosshairV = document.createElement('div');
			crosshairV.className = 'drawing-crosshair-vertical';
	crosshairV.style.cssText = `
		position: absolute;
		top: 0;
		width: 1px;
		height: 100%;
		background: var(--primary-color);
		pointer-events: none;
		z-index: 100001;
		opacity: 0.5;
	`;
			chartContainer.appendChild(crosshairV);
		}
		crosshairV.style.left = `${mouseX}px`;
		crosshairV.style.display = 'block';
		
		// 水平十字线
		let crosshairH = chartContainer.querySelector('.drawing-crosshair-horizontal');
		if (!crosshairH) {
			crosshairH = document.createElement('div');
			crosshairH.className = 'drawing-crosshair-horizontal';
	crosshairH.style.cssText = `
		position: absolute;
		left: 0;
		width: 100%;
		height: 1px;
		background: var(--primary-color);
		pointer-events: none;
		z-index: 100001;
		opacity: 0.5;
	`;
			chartContainer.appendChild(crosshairH);
		}
		crosshairH.style.top = `${mouseY}px`;
		crosshairH.style.display = 'block';
		
	// 中心点（基点）
	let centerDot = chartContainer.querySelector('.drawing-center-dot');
	if (!centerDot) {
		centerDot = document.createElement('div');
		centerDot.className = 'drawing-center-dot';
	centerDot.style.cssText = `
		position: absolute;
		width: 16px;
		height: 16px;
		background: var(--primary-color);
		border: 3px solid white;
		border-radius: 50%;
		pointer-events: none;
		z-index: 100003;
		box-shadow: 0 2px 8px rgba(0,0,0,0.4);
		transform: translate(-50%, -50%);
	`;
		chartContainer.appendChild(centerDot);
	}
	centerDot.style.left = `${mouseX}px`;
	centerDot.style.top = `${mouseY}px`;
	centerDot.style.display = 'block';
},
	
	// 🔑 显示从起始点到当前位置的预览线
	showPreviewLineFromStart(chartContainer, mouseX, mouseY) {
		if (!chartContainer || !this.drawingStartPoint) return;
		
		console.log('🎨 显示预览线', {
			start: this.drawingStartPoint,
			end: { x: mouseX, y: mouseY }
		});
		
		// 创建或更新预览线
		let previewLine = chartContainer.querySelector('.drawing-preview-connecting-line');
		if (!previewLine) {
			previewLine = document.createElement('div');
			previewLine.className = 'drawing-preview-connecting-line';
	previewLine.style.cssText = `
		position: absolute;
		background: var(--primary-color);
		pointer-events: none;
		z-index: 100002;
		opacity: 0.6;
		transform-origin: left center;
	`;
			chartContainer.appendChild(previewLine);
		}
		
		// 计算线的长度和角度
		const dx = mouseX - this.drawingStartPoint.x;
		const dy = mouseY - this.drawingStartPoint.y;
		const length = Math.sqrt(dx * dx + dy * dy);
		const angle = Math.atan2(dy, dx) * 180 / Math.PI;
		
		// 设置线的样式
		previewLine.style.left = `${this.drawingStartPoint.x}px`;
		previewLine.style.top = `${this.drawingStartPoint.y}px`;
		previewLine.style.width = `${length}px`;
		previewLine.style.height = '2px';
		previewLine.style.transform = `rotate(${angle}deg)`;
		previewLine.style.display = 'block';
	},
	
	// 🔑 显示预览直线
	showPreviewLine(mouseX, mouseY, chartWidth) {
		console.log('🎨 开始显示预览', { mouseX, mouseY, chartWidth });
		
		const chartContainer = document.querySelector('.middlePC');
		if (!chartContainer) {
			console.error('❌ showPreviewLine: 未找到图表容器');
			return;
		}
		
		// 确保容器是相对定位
		if (!chartContainer.style.position || chartContainer.style.position === 'static') {
			chartContainer.style.position = 'relative';
			// console.log('✅ 设置图表容器为 relative 定位'); // 调试日志已清理
		}
		
		// ========== 1. 预览横线（虚线） ==========
		let previewLine = chartContainer.querySelector('.drawing-preview-line');
		if (!previewLine) {
			previewLine = document.createElement('div');
			previewLine.className = 'drawing-preview-line';
	previewLine.style.cssText = `
		position: absolute;
		left: 0;
		width: 100%;
		height: 2px;
		background: transparent;
		pointer-events: none;
		z-index: 100002;
		border-style: dashed;
		border-width: 1px 0 0 0;
		border-color: var(--primary-color);
		opacity: 0.6;
	`;
			chartContainer.appendChild(previewLine);
			// console.log('✅ 创建预览横线'); // 调试日志已清理
		}
		previewLine.style.top = `${mouseY}px`;
		previewLine.style.display = 'block';
		// console.log('✅ 预览横线位置:', mouseY); // 调试日志已清理
		
		// ========== 2. 十字线 - 垂直线 ==========
		let crosshairV = chartContainer.querySelector('.drawing-crosshair-vertical');
		if (!crosshairV) {
			crosshairV = document.createElement('div');
			crosshairV.className = 'drawing-crosshair-vertical';
	crosshairV.style.cssText = `
		position: absolute;
		top: 0;
		width: 1px;
		height: 100%;
		background: var(--primary-color);
		pointer-events: none;
		z-index: 100001;
		opacity: 0.3;
	`;
			chartContainer.appendChild(crosshairV);
			// console.log('✅ 创建垂直十字线'); // 调试日志已清理
		}
		crosshairV.style.left = `${mouseX}px`;
		crosshairV.style.display = 'block';
		// console.log('✅ 垂直十字线位置:', mouseX); // 调试日志已清理
		
		// ========== 3. 十字线 - 水平线（实线，比预览线细） ==========
		let crosshairH = chartContainer.querySelector('.drawing-crosshair-horizontal');
		if (!crosshairH) {
			crosshairH = document.createElement('div');
			crosshairH.className = 'drawing-crosshair-horizontal';
	crosshairH.style.cssText = `
		position: absolute;
		left: 0;
		width: 100%;
		height: 1px;
		background: var(--primary-color);
		pointer-events: none;
		z-index: 100001;
		opacity: 0.3;
	`;
			chartContainer.appendChild(crosshairH);
			// console.log('✅ 创建水平十字线'); // 调试日志已清理
		}
		crosshairH.style.top = `${mouseY}px`;
		crosshairH.style.display = 'block';
		// console.log('✅ 水平十字线位置:', mouseY); // 调试日志已清理
		
	// ========== 4. 中心蓝点（基点） ==========
	let centerDot = chartContainer.querySelector('.drawing-center-dot');
	if (!centerDot) {
		centerDot = document.createElement('div');
		centerDot.className = 'drawing-center-dot';
	centerDot.style.cssText = `
		position: absolute;
		width: 16px;
		height: 16px;
		background: var(--primary-color);
		border: 3px solid white;
		border-radius: 50%;
		pointer-events: none;
		z-index: 100003;
		box-shadow: 0 2px 8px rgba(0,0,0,0.4);
		transform: translate(-50%, -50%);
	`;
		chartContainer.appendChild(centerDot);
		// console.log('✅ 创建中心蓝点'); // 调试日志已清理
	}
	centerDot.style.left = `${mouseX}px`;
	centerDot.style.top = `${mouseY}px`;
	centerDot.style.display = 'block';
	// console.log('✅ 中心蓝点位置:', { mouseX, mouseY }); // 调试日志已清理
		
		// ========== 5. 价格标签 ==========
		let priceLabel = chartContainer.querySelector('.drawing-preview-price');
		if (!priceLabel) {
			priceLabel = document.createElement('div');
			priceLabel.className = 'drawing-preview-price';
	priceLabel.style.cssText = `
		position: absolute;
		right: 10px;
		background: var(--primary-color);
		color: white;
		padding: 3px 8px;
		border-radius: 3px;
		font-size: 12px;
		font-weight: 600;
		white-space: nowrap;
		box-shadow: 0 2px 4px rgba(0,0,0,0.2);
		pointer-events: none;
		z-index: 100002;
		opacity: 0.9;
	`;
			chartContainer.appendChild(priceLabel);
			// console.log('✅ 创建价格标签'); // 调试日志已清理
		}
		const price = this.convertYToPrice(mouseY);
		priceLabel.textContent = price ? price.toFixed(4) : 'N/A';
		priceLabel.style.top = `${mouseY - 12}px`;
		priceLabel.style.display = 'block';
		// console.log('✅ 价格标签:', price); // 调试日志已清理
		
		// ========== 6. 时间标签（底部） ==========
		let timeLabel = chartContainer.querySelector('.drawing-preview-time');
		if (!timeLabel) {
			timeLabel = document.createElement('div');
			timeLabel.className = 'drawing-preview-time';
	timeLabel.style.cssText = `
		position: absolute;
		bottom: 10px;
		background: var(--primary-color);
		color: white;
		padding: 3px 8px;
		border-radius: 3px;
			font-size: 12px;
			font-weight: 600;
			white-space: nowrap;
			box-shadow: 0 2px 4px rgba(0,0,0,0.2);
			pointer-events: none;
			z-index: 100002;
			opacity: 0.9;
			transform: translateX(-50%);
		`;
			chartContainer.appendChild(timeLabel);
			console.log('✅ 创建时间标签');
		}
		const timeValue = this.convertXToTime(mouseX);
		timeLabel.textContent = timeValue || 'N/A';
		timeLabel.style.left = `${mouseX}px`;
		timeLabel.style.display = 'block';
		console.log('✅ 时间标签:', timeValue);
		
		console.log('🎨 预览元素全部显示完成');
	},
	
	// 🔑 鼠标离开图表 - 隐藏预览直线
	handleChartMouseLeave() {
		this.hidePreviewLine();
	},
	
	// 🔑 隐藏预览直线
	hidePreviewLine() {
		const chartContainer = document.querySelector('.middlePC');
		if (!chartContainer) return;
		
		// 隐藏预览横线
		const previewLine = chartContainer.querySelector('.drawing-preview-line');
		if (previewLine) {
			previewLine.style.display = 'none';
		}
		
		// 隐藏连接线
		const connectingLine = chartContainer.querySelector('.drawing-preview-connecting-line');
		if (connectingLine) {
			connectingLine.style.display = 'none';
		}
		
		// 隐藏十字线 - 垂直线
		const crosshairV = chartContainer.querySelector('.drawing-crosshair-vertical');
		if (crosshairV) {
			crosshairV.style.display = 'none';
		}
		
		// 隐藏十字线 - 水平线
		const crosshairH = chartContainer.querySelector('.drawing-crosshair-horizontal');
		if (crosshairH) {
			crosshairH.style.display = 'none';
		}
		
		// 隐藏中心蓝点
		const centerDot = chartContainer.querySelector('.drawing-center-dot');
		if (centerDot) {
			centerDot.style.display = 'none';
		}
		
		// 隐藏价格标签
		const priceLabel = chartContainer.querySelector('.drawing-preview-price');
		if (priceLabel) {
			priceLabel.style.display = 'none';
		}
		
		// 隐藏时间标签
		const timeLabel = chartContainer.querySelector('.drawing-preview-time');
		if (timeLabel) {
			timeLabel.style.display = 'none';
		}
	},
	
	// 处理图表鼠标点击事件（用于一键绘制）
	handleChartClick(event) {
		// console.log('🖱️ 鼠标点击事件触发'); // 调试日志已清理
		
		if (!this.isDrawingMode || !this.selectedDrawingTool) {
			// console.log('⚠️ 未处于绘图模式或未选择工具'); // 调试日志已清理
			return;
		}
		
		// 阻止默认行为，避免与图表交互冲突
		event.preventDefault();
		event.stopPropagation();
		
		// 🔑 隐藏预览直线（点击后确认位置）
		this.hidePreviewLine();
		
		const rect = event.currentTarget.getBoundingClientRect();
		let clickX = event.clientX - rect.left;
		let clickY = event.clientY - rect.top;
		
		const chartWidth = rect.width;
		const chartHeight = rect.height;
		
		// 应用磁铁吸附
		if (this.magnetMode) {
			const snappedPoint = this.applyMagnetSnap(clickX, clickY, rect);
			if (snappedPoint) {
				clickX = snappedPoint.x;
				clickY = snappedPoint.y;
				// console.log('🧲 磁铁吸附后位置:', { clickX, clickY }); // 调试日志已清理
			}
		}
		
		// console.log('📍 点击位置:', { clickX, clickY, chartWidth, chartHeight }); // 调试日志已清理
		
		let startPoint, endPoint;
		
		// 根据不同的工具类型，自动计算起点和终点
		switch(this.selectedDrawingTool) {
			case 'horizontal-line':
				// 水平直线：从左到右穿过点击点
				startPoint = { x: 0, y: clickY };
				endPoint = { x: chartWidth, y: clickY };
				break;
				
			case 'horizontal-ray':
				// 水平射线：从点击点向右延伸
				startPoint = { x: clickX, y: clickY };
				endPoint = { x: chartWidth, y: clickY };
				break;
				
			case 'horizontal-segment':
				// 水平线段：以点击点为中心的水平线
				startPoint = { x: Math.max(0, clickX - 100), y: clickY };
				endPoint = { x: Math.min(chartWidth, clickX + 100), y: clickY };
				break;
				
			case 'vertical-line':
				// 垂直直线：从上到下穿过点击点
				startPoint = { x: clickX, y: 0 };
				endPoint = { x: clickX, y: chartHeight };
				break;
				
			case 'vertical-ray':
				// 垂直射线：从点击点向下延伸
				startPoint = { x: clickX, y: clickY };
				endPoint = { x: clickX, y: chartHeight };
				break;
				
			case 'vertical-segment':
				// 垂直线段：以点击点为中心的垂直线
				startPoint = { x: clickX, y: Math.max(0, clickY - 100) };
				endPoint = { x: clickX, y: Math.min(chartHeight, clickY + 100) };
				break;
				
			case 'line':
				// 斜线：从左下到右上穿过点击点
				startPoint = { x: 0, y: chartHeight };
				endPoint = { x: chartWidth, y: 0 };
				break;
				
			case 'ray':
				// 射线：从点击点向右上延伸
				startPoint = { x: clickX, y: clickY };
				endPoint = { x: chartWidth, y: Math.max(0, clickY - 200) };
				break;
				
			case 'segment':
				// 线段：以点击点为中心的斜线段
				startPoint = { x: Math.max(0, clickX - 100), y: Math.min(chartHeight, clickY + 50) };
				endPoint = { x: Math.min(chartWidth, clickX + 100), y: Math.max(0, clickY - 50) };
				break;
				
			case 'arrow':
				// 箭头：从点击点向右的箭头
				startPoint = { x: clickX, y: clickY };
				endPoint = { x: Math.min(chartWidth, clickX + 150), y: clickY };
				break;
				
			case 'price-line':
				// 价格线：横穿整个图表的水平线
				startPoint = { x: 0, y: clickY };
				endPoint = { x: chartWidth, y: clickY };
				break;
				
			case 'price-channel':
				// 价格通道线：创建两条平行的水平线形成通道
				// 第一次点击时创建上边界，需要用户第二次点击确定下边界
				// 简化实现：以点击点为中心，创建上下各50像素的通道
				startPoint = { x: 0, y: clickY - 50 };
				endPoint = { x: chartWidth, y: clickY + 50 };
				break;
				
			case 'parallel-straight-line':
				// 平行直线：创建两条平行的斜线
				// 简化实现：创建穿过点击点的平行线
				const offset = 50; // 平行线之间的距离
				startPoint = { x: 0, y: clickY - offset };
				endPoint = { x: chartWidth, y: clickY + offset };
				break;
				
			case 'circle':
				// 圆形：以点击点为中心创建一个圆形
				const circleSize = 100; // 圆形的默认大小
				startPoint = { x: clickX - circleSize, y: clickY - circleSize };
				endPoint = { x: clickX + circleSize, y: clickY + circleSize };
				break;
				
			case 'rectangle':
				// 矩形：以点击点为中心创建一个矩形
				const rectWidth = 150;
				const rectHeight = 100;
				startPoint = { x: clickX - rectWidth/2, y: clickY - rectHeight/2 };
				endPoint = { x: clickX + rectWidth/2, y: clickY + rectHeight/2 };
				break;
				
			case 'parallelogram':
				// 平行四边形：以点击点为中心创建一个平行四边形
				const paraWidth = 150;
				const paraHeight = 100;
				startPoint = { x: clickX - paraWidth/2, y: clickY - paraHeight/2 };
				endPoint = { x: clickX + paraWidth/2, y: clickY + paraHeight/2 };
				break;
				
			case 'triangle':
				// 三角形：以点击点为中心创建一个三角形
				const triWidth = 150;
				const triHeight = 100;
				startPoint = { x: clickX - triWidth/2, y: clickY - triHeight/2 };
				endPoint = { x: clickX + triWidth/2, y: clickY + triHeight/2 };
				break;
				
			case 'fibonacci-retracement':
				// 斐波那契回调直线：从点击点向下和向右延伸
				startPoint = { x: clickX, y: clickY - 100 };
				endPoint = { x: clickX, y: clickY + 100 };
				break;
				
			case 'fibonacci-grid':
				// 斐波那契梯格：创建一个网格区域
				const gridSize = 200;
				startPoint = { x: clickX - gridSize/2, y: clickY - gridSize/2 };
				endPoint = { x: clickX + gridSize/2, y: clickY + gridSize/2 };
				break;
				
			case 'fibonacci-circle':
				// 斐波那契圆环：创建同心圆
				const circleRadius = 150;
				startPoint = { x: clickX - circleRadius, y: clickY - circleRadius };
				endPoint = { x: clickX + circleRadius, y: clickY + circleRadius };
				break;
				
			case 'fibonacci-spiral':
				// 斐波那契螺旋：创建螺旋图案
				const spiralSize = 150;
				startPoint = { x: clickX - spiralSize, y: clickY - spiralSize };
				endPoint = { x: clickX + spiralSize, y: clickY + spiralSize };
				break;
				
			case 'fibonacci-fan':
				// 斐波那契速度阻力扇：创建扇形分析线
				startPoint = { x: clickX, y: clickY };
				endPoint = { x: Math.min(chartWidth, clickX + 200), y: Math.min(chartHeight, clickY + 150) };
				break;
				
			case 'fibonacci-extension':
				// 斐波那契趋势扩展：创建趋势扩展线
				startPoint = { x: Math.max(0, clickX - 100), y: clickY };
				endPoint = { x: Math.min(chartWidth, clickX + 100), y: clickY };
				break;
				
			case 'gann-box':
				// 江恩箱：创建江恩方格
				const gannSize = 180;
				startPoint = { x: clickX - gannSize/2, y: clickY - gannSize/2 };
				endPoint = { x: clickX + gannSize/2, y: clickY + gannSize/2 };
				break;
		case 'xabcd-pattern':
			// XABCD形态：创建5点谐波形态
			const xabcdHeight = 150;
			startPoint = { x: Math.max(0, clickX - 200), y: Math.max(0, clickY - xabcdHeight/2) };
			endPoint = { x: Math.min(chartWidth, clickX + 200), y: Math.min(chartHeight, clickY + xabcdHeight/2) };
			break;
			
		case 'abcd-pattern':
			// ABCD形态：创建4点谐波形态
			const abcdHeight = 120;
			startPoint = { x: Math.max(0, clickX - 150), y: Math.max(0, clickY - abcdHeight/2) };
			endPoint = { x: Math.min(chartWidth, clickX + 150), y: Math.min(chartHeight, clickY + abcdHeight/2) };
			break;
			
		case 'wave-3':
			// 三浪：创建3波艾略特波浪
			const wave3Height = 100;
			startPoint = { x: Math.max(0, clickX - 120), y: Math.max(0, clickY - wave3Height/2) };
			endPoint = { x: Math.min(chartWidth, clickX + 120), y: Math.min(chartHeight, clickY + wave3Height/2) };
			break;
			
		case 'wave-5':
			// 五浪：创建5波艾略特波浪
			const wave5Height = 120;
			startPoint = { x: Math.max(0, clickX - 180), y: Math.max(0, clickY - wave5Height/2) };
			endPoint = { x: Math.min(chartWidth, clickX + 180), y: Math.min(chartHeight, clickY + wave5Height/2) };
			break;
			
		case 'wave-8':
			// 八浪：创建8波完整艾略特波浪（5推动+3调整）
			const wave8Height = 140;
			startPoint = { x: Math.max(0, clickX - 240), y: Math.max(0, clickY - wave8Height/2) };
			endPoint = { x: Math.min(chartWidth, clickX + 240), y: Math.min(chartHeight, clickY + wave8Height/2) };
			break;
			
		case 'wave-custom':
			// 任意浪：创建自定义波浪数量
			const waveCustomHeight = 110;
			startPoint = { x: Math.max(0, clickX - 200), y: Math.max(0, clickY - waveCustomHeight/2) };
			endPoint = { x: Math.min(chartWidth, clickX + 200), y: Math.min(chartHeight, clickY + waveCustomHeight/2) };
			break;
			
		default:
			console.warn('未知的绘图工具类型:', this.selectedDrawingTool);
			return;
	}
		
		console.log('✅ 自动计算的起点和终点:', { startPoint, endPoint, clickPoint: { x: clickX, y: clickY } });
		
		// 创建绘图元素，传递实际点击位置
		this.createDrawingElement(startPoint, endPoint, { x: clickX, y: clickY });
	},
	
	// 处理图表鼠标按下事件（保留用于拖拽绘制的备用方案）
	handleChartMouseDown(event) {
		// 暂时禁用拖拽绘制，只使用点击绘制
		return;
	},
	
	// 处理图表鼠标释放事件
	handleChartMouseUp(event) {
		// 暂时禁用拖拽绘制
		return;
	},
	
	// 预览绘图
	previewDrawing(currentPoint) {
		// 这里可以实现实时预览效果
		// 暂时留空，后续可以添加预览功能
	},
	
	// 创建绘图元素
	createDrawingElement(startPoint, endPoint, clickPoint) {
		// 如果是价格线，计算并保存实际价格值
		let priceValue = null;
		if (this.selectedDrawingTool === 'price-line' || this.selectedDrawingTool === 'horizontal-line') {
			priceValue = this.convertYToPrice(startPoint.y);
		}
		
		const element = {
			id: Date.now() + Math.random(),
			type: this.selectedDrawingTool,
			startPoint: startPoint,
			endPoint: endPoint,
			clickPoint: clickPoint || startPoint, // 保存实际点击位置
			priceValue: priceValue, // 保存实际价格值
			createdAt: new Date(),
			visible: true,
			color: 'var(--primary-color)',
			width: 2
		};
		
	this.drawingElements.push(element);
	
	console.log('✅ 绘图元素已创建:', element);
	
	// 渲染绘图元素
	this.renderDrawingElement(element);
	
	// 绘制完成后自动退出绘图模式
	this.exitDrawingMode();
	console.log('✅ 绘图完成，已自动退出绘图模式');
},

// 退出绘图模式
exitDrawingMode() {
	this.isDrawingMode = false;
	this.selectedDrawingTool = null;
	this.drawingStartPoint = null;
	
	// 重置工具栏的激活状态
	if (!this.showDrawingDropdown && !this.showChannelDropdown && !this.showShapeDropdown && !this.showFibonacciDropdown && !this.showWaveDropdown) {
		this.activeTool = null;
	}
	
	// 🔑 隐藏预览直线
	this.hidePreviewLine();
	
	// 🔑 隐藏事件捕获层
	if (this._eventLayer) {
		this._eventLayer.style.display = 'none';
		this._eventLayer.style.pointerEvents = 'none';
		console.log('✅ 隐藏事件捕获层');
	}
	
	// 移除事件监听器，避免影响下次绘图
	if (this._eventLayer) {
		if (this._boundClick) {
			this._eventLayer.removeEventListener('click', this._boundClick);
		}
		if (this._boundMouseMove) {
			this._eventLayer.removeEventListener('mousemove', this._boundMouseMove);
		}
		if (this._boundMouseLeave) {
			this._eventLayer.removeEventListener('mouseleave', this._boundMouseLeave);
		}
	}
	
	console.log('✅ 已退出绘图模式');
},
	
	// 渲染绘图元素
	renderDrawingElement(element) {
		const chartContainer = document.querySelector('.middlePC');
		if (!chartContainer) return;
		
	// 获取或创建绘图覆盖层
	let overlay = chartContainer.querySelector('.drawing-overlay');
	if (!overlay) {
		overlay = document.createElement('div');
		overlay.className = 'drawing-overlay';
		overlay.style.cssText = `
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			pointer-events: none;
			z-index: 10;
			display: ${this.drawingsVisible ? 'block' : 'none'};
		`;
		chartContainer.style.position = 'relative';
		chartContainer.appendChild(overlay);
	} else {
		// 确保覆盖层的显示状态与当前设置一致
		overlay.style.display = this.drawingsVisible ? 'block' : 'none';
	}
		
		// 🔧 修复：如果已存在相同ID的元素，先删除（防止重复渲染）
		const existingElement = chartContainer.querySelector(`[data-element-id="${element.id}"]`);
		if (existingElement) {
			console.warn(`⚠️ 检测到重复元素 ID: ${element.id}，正在删除旧元素`);
			existingElement.remove();
		}
		
		// 创建绘图元素DOM
		const drawingElement = document.createElement('div');
		drawingElement.className = `drawing-element drawing-${element.type}`;
		drawingElement.dataset.elementId = element.id;
		drawingElement.style.position = 'absolute';
		drawingElement.style.pointerEvents = 'auto';
		drawingElement.style.cursor = 'pointer';
		
		// 根据类型设置样式和位置
		this.setDrawingElementStyle(drawingElement, element);
		
		// 添加到覆盖层
		overlay.appendChild(drawingElement);
		
		// 添加点击事件（用于选中和删除）
		drawingElement.addEventListener('click', (e) => {
			e.stopPropagation();
			this.selectDrawingElement(element.id);
		});
	},
	
	// 设置绘图元素样式
	setDrawingElementStyle(domElement, element) {
		const { type, startPoint, endPoint, color, width } = element;
		
		// 🔧 修复：对于全宽的水平线，使用当前图表容器宽度
		const chartContainer = document.querySelector('.middlePC');
		const currentChartWidth = chartContainer ? chartContainer.offsetWidth : 0;
		
		// 计算元素的位置和尺寸
		let left = Math.min(startPoint.x, endPoint.x);
		let top = Math.min(startPoint.y, endPoint.y);
		let w = Math.abs(endPoint.x - startPoint.x);
		let h = Math.abs(endPoint.y - startPoint.y);
		
		// 🔧 对于全宽水平线（horizontal-line 和 price-line），使用当前图表宽度
		if (type === 'horizontal-line' || type === 'price-line') {
			left = 0;
			w = currentChartWidth;
			// 同时更新元素的坐标数据，确保拖动时也能正确
			element.startPoint.x = 0;
			element.endPoint.x = currentChartWidth;
		}
		
		switch(type) {
		case 'horizontal-line':
		case 'horizontal-ray':
		case 'horizontal-segment':
			// 🔧 使用直接赋值而不是累加，避免样式冲突
			domElement.style.left = `${left}px`;
			domElement.style.top = `${startPoint.y}px`;
			domElement.style.width = `${w}px`;
			domElement.style.height = `${width}px`;
			domElement.style.background = color;
			domElement.style.transform = `translateY(-${width/2}px)`;
			
			// 🔑 添加价格标签 - 显示实际价格
			const horizontalPriceLabel = document.createElement('div');
			horizontalPriceLabel.className = 'drawing-price-label';
			horizontalPriceLabel.style.cssText = `
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				background: ${color};
				color: white;
				padding: 3px 8px;
				border-radius: 3px;
				font-size: 12px;
				font-weight: 600;
				white-space: nowrap;
				box-shadow: 0 2px 4px rgba(0,0,0,0.2);
				pointer-events: none;
			`;
			// 使用保存的价格值或重新计算
			const linePrice = element.priceValue || this.convertYToPrice(startPoint.y);
			horizontalPriceLabel.textContent = linePrice ? linePrice.toFixed(4) : 'N/A';
			domElement.appendChild(horizontalPriceLabel);
			
			// 🔑 添加中心拖动基点（在点击位置）
			const centerHandle = document.createElement('div');
			centerHandle.className = 'drawing-handle center-handle';
			// 计算相对于线条元素的位置
			const clickX = element.clickPoint ? element.clickPoint.x : startPoint.x;
			const relativeX = clickX - left; // 相对于线条左边缘的偏移
			centerHandle.style.cssText = `
				position: absolute;
				left: ${relativeX}px;
				top: 50%;
				width: 16px;
				height: 16px;
				background: ${color};
				border: 3px solid white;
				border-radius: 50%;
				transform: translate(-50%, -50%);
				cursor: move;
				z-index: 10;
				display: none;
				box-shadow: 0 2px 8px rgba(0,0,0,0.4);
			`;
			domElement.appendChild(centerHandle);
			
			// 🔑 添加拖动功能
			this.makeHorizontalLineDraggableWithCenter(domElement, element);
			break;
				
			case 'vertical-line':
			case 'vertical-ray':
			case 'vertical-segment':
				// 🔧 使用直接赋值而不是累加，避免样式冲突
				domElement.style.left = `${startPoint.x}px`;
				domElement.style.top = `${top}px`;
				domElement.style.width = `${width}px`;
				domElement.style.height = `${h}px`;
				domElement.style.background = color;
				domElement.style.transform = `translateX(-${width/2}px)`;
				
				// 🔑 添加顶部和底部基点
				const topHandle = document.createElement('div');
				topHandle.className = 'drawing-handle top-handle';
				topHandle.style.cssText = `
					position: absolute;
					left: 50%;
					top: 0;
					width: 12px;
					height: 12px;
					background: ${color};
					border: 3px solid white;
					border-radius: 50%;
					transform: translate(-50%, -50%);
					cursor: move;
					z-index: 10;
					display: none;
					box-shadow: 0 2px 6px rgba(0,0,0,0.3);
				`;
				domElement.appendChild(topHandle);
				
				const bottomHandle = document.createElement('div');
				bottomHandle.className = 'drawing-handle bottom-handle';
				bottomHandle.style.cssText = `
					position: absolute;
					left: 50%;
					bottom: 0;
					width: 12px;
					height: 12px;
					background: ${color};
					border: 3px solid white;
					border-radius: 50%;
					transform: translate(-50%, 50%);
					cursor: move;
					z-index: 10;
					display: none;
					box-shadow: 0 2px 6px rgba(0,0,0,0.3);
				`;
				domElement.appendChild(bottomHandle);
				
				// 添加拖拽功能
				this.makeVerticalLineDraggable(domElement, element);
				break;
				
			case 'line':
			case 'ray':
			case 'segment':
				const angle = Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x) * 180 / Math.PI;
				const length = Math.sqrt(w * w + h * h);
				// 🔧 使用直接赋值而不是累加，避免样式冲突
				domElement.style.left = `${startPoint.x}px`;
				domElement.style.top = `${startPoint.y}px`;
				domElement.style.width = `${length}px`;
				domElement.style.height = `${width}px`;
				domElement.style.background = color;
				domElement.style.transform = `rotate(${angle}deg)`;
				domElement.style.transformOrigin = 'left center';
				
				// 🔑 添加起点和终点基点
				const startHandle = document.createElement('div');
				startHandle.className = 'drawing-handle start-handle';
				startHandle.style.cssText = `
					position: absolute;
					left: 0;
					top: 50%;
					width: 12px;
					height: 12px;
					background: ${color};
					border: 3px solid white;
					border-radius: 50%;
					transform: translate(-50%, -50%);
					cursor: move;
					z-index: 10;
					display: none;
					box-shadow: 0 2px 6px rgba(0,0,0,0.3);
				`;
				domElement.appendChild(startHandle);
				
				const endHandle = document.createElement('div');
				endHandle.className = 'drawing-handle end-handle';
				endHandle.style.cssText = `
					position: absolute;
					right: 0;
					top: 50%;
					width: 12px;
					height: 12px;
					background: ${color};
					border: 3px solid white;
					border-radius: 50%;
					transform: translate(50%, -50%);
					cursor: move;
					z-index: 10;
					display: none;
					box-shadow: 0 2px 6px rgba(0,0,0,0.3);
				`;
				domElement.appendChild(endHandle);
				
				// 添加拖拽功能
				this.makeLineDraggable(domElement, element);
				break;
				
			case 'arrow':
				const arrowAngle = Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x) * 180 / Math.PI;
				const arrowLength = Math.sqrt(w * w + h * h);
				domElement.innerHTML = `
					<svg width="${arrowLength}" height="20" style="position: absolute;">
						<defs>
							<marker id="arrowhead-${element.id}" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
								<polygon points="0 0, 10 3, 0 6" fill="${color}" />
							</marker>
						</defs>
						<line x1="0" y1="10" x2="${arrowLength}" y2="10" stroke="${color}" stroke-width="${width}" marker-end="url(#arrowhead-${element.id})" />
					</svg>
				`;
				domElement.style.cssText += `
					left: ${startPoint.x}px;
					top: ${startPoint.y}px;
					transform: rotate(${arrowAngle}deg);
					transform-origin: left center;
				`;
				break;
				
			case 'price-line':
				domElement.style.cssText += `
					left: 0;
					top: ${startPoint.y}px;
					width: 100%;
					height: ${width}px;
					background: ${color};
					transform: translateY(-${width/2}px);
				`;
				// 添加价格标签 - 显示实际价格
				const priceLabel = document.createElement('div');
				priceLabel.className = 'drawing-price-label';
				priceLabel.style.cssText = `
					position: absolute;
					right: 10px;
					top: 50%;
					transform: translateY(-50%);
					background: ${color};
					color: white;
					padding: 3px 8px;
					border-radius: 3px;
					font-size: 12px;
					font-weight: 600;
					white-space: nowrap;
					box-shadow: 0 2px 4px rgba(0,0,0,0.2);
					pointer-events: none;
				`;
			// 使用保存的价格值或重新计算
			const price = element.priceValue || this.convertYToPrice(startPoint.y);
			priceLabel.textContent = price ? price.toFixed(4) : 'N/A';
			domElement.appendChild(priceLabel);
			
			// 🔑 添加中心拖动基点（在点击位置）
			const priceCenterHandle = document.createElement('div');
			priceCenterHandle.className = 'drawing-handle center-handle';
			// 价格线是全宽的，left 始终是 0，所以直接使用 clickPoint.x
			const priceClickX = element.clickPoint ? element.clickPoint.x : startPoint.x;
			priceCenterHandle.style.cssText = `
				position: absolute;
				left: ${priceClickX}px;
				top: 50%;
				width: 16px;
				height: 16px;
				background: ${color};
				border: 3px solid white;
				border-radius: 50%;
				transform: translate(-50%, -50%);
				cursor: move;
				z-index: 10;
				display: none;
				box-shadow: 0 2px 8px rgba(0,0,0,0.4);
			`;
			domElement.appendChild(priceCenterHandle);
			
			// 🔑 添加拖动功能
			this.makeHorizontalLineDraggableWithCenter(domElement, element);
			break;
			
		case 'price-channel':
			// 价格通道线：渲染两条平行的水平线形成通道
			domElement.innerHTML = `
				<div style="
					position: absolute;
					left: 0;
					top: ${startPoint.y}px;
					width: 100%;
					height: ${width}px;
					background: ${color};
					opacity: 0.6;
				"></div>
				<div style="
					position: absolute;
					left: 0;
					top: ${endPoint.y}px;
					width: 100%;
					height: ${width}px;
					background: ${color};
					opacity: 0.6;
				"></div>
				<div style="
					position: absolute;
					left: 0;
					top: ${startPoint.y}px;
					width: 100%;
					height: ${Math.abs(endPoint.y - startPoint.y)}px;
					background: ${color};
					opacity: 0.1;
				"></div>
			`;
			domElement.style.cssText += `
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
			`;
			break;
		case 'parallel-straight-line':
			// 平行直线：渲染两条平行的斜线
			const line1Angle = Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x) * 180 / Math.PI;
			const lineLength = Math.sqrt(w * w + h * h);
			const midY = (startPoint.y + endPoint.y) / 2;
			
			domElement.innerHTML = `
				<div style="
					position: absolute;
					left: ${startPoint.x}px;
					top: ${startPoint.y}px;
					width: ${lineLength}px;
					height: ${width}px;
					background: ${color};
					transform: rotate(${line1Angle}deg);
					transform-origin: left center;
					opacity: 0.7;
				"></div>
				<div style="
					position: absolute;
					left: ${startPoint.x}px;
					top: ${endPoint.y}px;
					width: ${lineLength}px;
					height: ${width}px;
					background: ${color};
					transform: rotate(${line1Angle}deg);
					transform-origin: left center;
					opacity: 0.7;
				"></div>
			`;
			domElement.style.cssText += `
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
			`;
			break;
			
		case 'circle':
			// 圆形：渲染一个圆形
			const radius = Math.min(w, h) / 2;
			const centerX = (startPoint.x + endPoint.x) / 2;
			const centerY = (startPoint.y + endPoint.y) / 2;
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<ellipse cx="${w/2}" cy="${h/2}" rx="${w/2}" ry="${h/2}" 
						fill="none" stroke="${color}" stroke-width="${width}" opacity="0.8" />
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'rectangle':
			// 矩形：渲染一个矩形
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<rect x="0" y="0" width="${w}" height="${h}" 
						fill="none" stroke="${color}" stroke-width="${width}" opacity="0.8" />
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'parallelogram':
			// 平行四边形：渲染一个平行四边形
			const offset = w * 0.2; // 偏移量为宽度的20%
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<polygon points="${offset},0 ${w},0 ${w - offset},${h} 0,${h}" 
						fill="none" stroke="${color}" stroke-width="${width}" opacity="0.8" />
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'triangle':
			// 三角形：渲染一个三角形
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<polygon points="${w/2},0 ${w},${h} 0,${h}" 
						fill="none" stroke="${color}" stroke-width="${width}" opacity="0.8" />
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'fibonacci-retracement':
			// 斐波那契回调直线：绘制多条水平回调线
			const fibLevels = [0, 0.236, 0.382, 0.5, 0.618, 0.786, 1];
			const retracementLines = fibLevels.map(level => {
				const y = startPoint.y + (endPoint.y - startPoint.y) * level;
				return `<line x1="0" y1="${y - top}" x2="${w}" y2="${y - top}" stroke="${color}" stroke-width="${width}" opacity="0.6" />
						<text x="5" y="${y - top - 5}" fill="${color}" font-size="12">${(level * 100).toFixed(1)}%</text>`;
			}).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					${retracementLines}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'fibonacci-grid':
			// 斐波那契梯格：绘制网格
			const gridLines = [];
			const fibRatios = [0, 0.236, 0.382, 0.5, 0.618, 0.786, 1];
			
			// 水平线
			fibRatios.forEach(ratio => {
				const y = h * ratio;
				gridLines.push(`<line x1="0" y1="${y}" x2="${w}" y2="${y}" stroke="${color}" stroke-width="${width * 0.7}" opacity="0.5" />`);
			});
			
			// 垂直线
			fibRatios.forEach(ratio => {
				const x = w * ratio;
				gridLines.push(`<line x1="${x}" y1="0" x2="${x}" y2="${h}" stroke="${color}" stroke-width="${width * 0.7}" opacity="0.5" />`);
			});
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					${gridLines.join('')}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'fibonacci-circle':
			// 斐波那契圆环：绘制同心圆
			const circles = [0.236, 0.382, 0.5, 0.618, 0.786, 1].map(ratio => {
				const r = Math.min(w, h) / 2 * ratio;
				return `<circle cx="${w/2}" cy="${h/2}" r="${r}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.6" />`;
			}).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					${circles}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'fibonacci-spiral':
			// 斐波那契螺旋：使用路径绘制螺旋
			const spiralPath = `M ${w/2},${h/2} Q ${w},${h/2} ${w},${h} T ${0},${h} ${0},${0} ${w},${0}`;
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<path d="${spiralPath}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.7" />
					<circle cx="${w/2}" cy="${h/2}" r="3" fill="${color}" />
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'fibonacci-fan':
			// 斐波那契速度阻力扇：绘制扇形线
			const fanLevels = [0.382, 0.5, 0.618];
			const fanLines = fanLevels.map(level => {
				const endY = startPoint.y + (endPoint.y - startPoint.y) * level;
				return `<line x1="${startPoint.x - left}" y1="${startPoint.y - top}" 
							x2="${endPoint.x - left}" y2="${endY - top}" 
							stroke="${color}" stroke-width="${width}" opacity="0.7" />`;
			}).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					${fanLines}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'fibonacci-extension':
			// 斐波那契趋势扩展：绘制扩展线
			const extLevels = [1.272, 1.414, 1.618, 2.0, 2.618];
			const extLines = extLevels.map((level, index) => {
				const y = startPoint.y + (index + 1) * 30;
				return `<line x1="0" y1="${y - top}" x2="${w}" y2="${y - top}" 
						stroke="${color}" stroke-width="${width}" opacity="0.6" stroke-dasharray="5,5" />
						<text x="5" y="${y - top - 5}" fill="${color}" font-size="12">${level}</text>`;
			}).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<line x1="0" y1="${h/2}" x2="${w}" y2="${h/2}" stroke="${color}" stroke-width="${width * 1.5}" opacity="0.8" />
					${extLines}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'gann-box':
			// 江恩箱：绘制江恩方格
			const gannLines = [];
			const divisions = 8;
			
			// 水平线
			for (let i = 0; i <= divisions; i++) {
				const y = (h / divisions) * i;
				gannLines.push(`<line x1="0" y1="${y}" x2="${w}" y2="${y}" stroke="${color}" stroke-width="${width * 0.8}" opacity="0.5" />`);
			}
			
			// 垂直线
			for (let i = 0; i <= divisions; i++) {
				const x = (w / divisions) * i;
				gannLines.push(`<line x1="${x}" y1="0" x2="${x}" y2="${h}" stroke="${color}" stroke-width="${width * 0.8}" opacity="0.5" />`);
			}
			
			// 对角线
			gannLines.push(`<line x1="0" y1="0" x2="${w}" y2="${h}" stroke="${color}" stroke-width="${width * 1.2}" opacity="0.7" />`);
			gannLines.push(`<line x1="${w}" y1="0" x2="0" y2="${h}" stroke="${color}" stroke-width="${width * 1.2}" opacity="0.7" />`);
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					${gannLines.join('')}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'xabcd-pattern':
			// XABCD形态：绘制5点谐波形态（蝴蝶、蝙蝠、加特利等）
			const xabcdPoints = [
				{ x: 0, y: h * 0.5, label: 'X' },
				{ x: w * 0.2, y: h * 0.2, label: 'A' },
				{ x: w * 0.4, y: h * 0.4, label: 'B' },
				{ x: w * 0.6, y: h * 0.1, label: 'C' },
				{ x: w * 0.8, y: h * 0.35, label: 'D' }
			];
			
			const xabcdPath = xabcdPoints.map((p, i) => 
				i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`
			).join(' ');
			
			const xabcdLabels = xabcdPoints.map(p => 
				`<circle cx="${p.x}" cy="${p.y}" r="4" fill="${color}" />
				 <text x="${p.x + 8}" y="${p.y - 5}" fill="${color}" font-size="14" font-weight="bold">${p.label}</text>`
			).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<path d="${xabcdPath}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.7" />
					${xabcdLabels}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'abcd-pattern':
			// ABCD形态：绘制4点谐波形态
			const abcdPoints = [
				{ x: 0, y: h * 0.6, label: 'A' },
				{ x: w * 0.3, y: h * 0.2, label: 'B' },
				{ x: w * 0.6, y: h * 0.5, label: 'C' },
				{ x: w, y: h * 0.15, label: 'D' }
			];
			
			const abcdPath = abcdPoints.map((p, i) => 
				i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`
			).join(' ');
			
			const abcdLabels = abcdPoints.map(p => 
				`<circle cx="${p.x}" cy="${p.y}" r="4" fill="${color}" />
				 <text x="${p.x + 8}" y="${p.y - 5}" fill="${color}" font-size="14" font-weight="bold">${p.label}</text>`
			).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<path d="${abcdPath}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.7" />
					${abcdLabels}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
		case 'wave-3':
			// 三浪：绘制3波艾略特波浪
			const wave3Points = [
				{ x: 0, y: h * 0.7 },
				{ x: w * 0.33, y: h * 0.3 },
				{ x: w * 0.67, y: h * 0.5 },
				{ x: w, y: h * 0.2 }
			];
			
			const wave3Path = wave3Points.map((p, i) => 
				i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`
			).join(' ');
			
			const wave3Labels = ['1', '2', '3'].map((label, i) => {
				const midX = (wave3Points[i].x + wave3Points[i + 1].x) / 2;
				const midY = (wave3Points[i].y + wave3Points[i + 1].y) / 2;
				return `<text x="${midX}" y="${midY - 10}" fill="${color}" font-size="12" font-weight="bold">${label}</text>`;
			}).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<path d="${wave3Path}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.7" />
					${wave3Labels}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'wave-5':
			// 五浪：绘制5波艾略特波浪
			const wave5Points = [
				{ x: 0, y: h * 0.7 },
				{ x: w * 0.2, y: h * 0.3 },
				{ x: w * 0.35, y: h * 0.5 },
				{ x: w * 0.6, y: h * 0.15 },
				{ x: w * 0.75, y: h * 0.35 },
				{ x: w, y: h * 0.1 }
			];
			
			const wave5Path = wave5Points.map((p, i) => 
				i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`
			).join(' ');
			
			const wave5Labels = ['1', '2', '3', '4', '5'].map((label, i) => {
				const midX = (wave5Points[i].x + wave5Points[i + 1].x) / 2;
				const midY = (wave5Points[i].y + wave5Points[i + 1].y) / 2;
				return `<text x="${midX}" y="${midY - 10}" fill="${color}" font-size="12" font-weight="bold">${label}</text>`;
			}).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<path d="${wave5Path}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.7" />
					${wave5Labels}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'wave-8':
			// 八浪：绘制8波完整艾略特波浪（5推动+3调整）
			const wave8Points = [
				{ x: 0, y: h * 0.7 },
				{ x: w * 0.125, y: h * 0.35 },
				{ x: w * 0.22, y: h * 0.5 },
				{ x: w * 0.375, y: h * 0.2 },
				{ x: w * 0.47, y: h * 0.4 },
				{ x: w * 0.625, y: h * 0.1 },
				{ x: w * 0.72, y: h * 0.45 },
				{ x: w * 0.875, y: h * 0.25 },
				{ x: w, y: h * 0.5 }
			];
			
			const wave8Path = wave8Points.map((p, i) => 
				i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`
			).join(' ');
			
			const wave8Labels = ['1', '2', '3', '4', '5', 'A', 'B', 'C'].map((label, i) => {
				const midX = (wave8Points[i].x + wave8Points[i + 1].x) / 2;
				const midY = (wave8Points[i].y + wave8Points[i + 1].y) / 2;
				return `<text x="${midX}" y="${midY - 10}" fill="${color}" font-size="11" font-weight="bold">${label}</text>`;
			}).join('');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<path d="${wave8Path}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.7" />
					${wave8Labels}
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
			
		case 'wave-custom':
			// 任意浪：绘制自定义波浪（这里示例4波）
			const waveCustomPoints = [
				{ x: 0, y: h * 0.6 },
				{ x: w * 0.25, y: h * 0.3 },
				{ x: w * 0.5, y: h * 0.5 },
				{ x: w * 0.75, y: h * 0.25 },
				{ x: w, y: h * 0.45 }
			];
			
			const waveCustomPath = waveCustomPoints.map((p, i) => 
				i === 0 ? `M ${p.x},${p.y}` : `L ${p.x},${p.y}`
			).join(' ');
			
			domElement.innerHTML = `
				<svg width="${w}" height="${h}" style="position: absolute;">
					<path d="${waveCustomPath}" fill="none" stroke="${color}" stroke-width="${width}" opacity="0.7" />
				</svg>
			`;
			domElement.style.cssText += `
				left: ${left}px;
				top: ${top}px;
				width: ${w}px;
				height: ${h}px;
			`;
			break;
	}
},
	
	// 将X坐标转换为时间值
	convertXToTime(xCoord) {
		if (!this.chartInstance) return null;
		
		try {
			// 获取图表配置
			const option = this.chartInstance.getOption();
			if (!option || !option.xAxis || !option.xAxis[0]) return null;
			
			// 获取X轴数据（时间数组）
			const dates = option.xAxis[0].data;
			if (!dates || dates.length === 0) return null;
			
			// 获取图表容器尺寸
			const chartDom = this.chartInstance.getDom();
			const chartRect = chartDom.getBoundingClientRect();
			const gridOption = option.grid && option.grid[0] ? option.grid[0] : {};
			
			// 计算实际绘图区域
			const leftPadding = this.parsePercent(gridOption.left, chartRect.width) || 0;
			const rightPadding = this.parsePercent(gridOption.right, chartRect.width) || 0;
			const plotWidth = chartRect.width - leftPadding - rightPadding;
			
			// 计算相对位置
			const relativeX = xCoord - leftPadding;
			const ratio = relativeX / plotWidth;
			
			// 计算对应的数据索引
			const dataIndex = Math.round(ratio * (dates.length - 1));
			const clampedIndex = Math.max(0, Math.min(dataIndex, dates.length - 1));
			
			// 返回对应的时间值
			const timeValue = dates[clampedIndex];
			
			// 格式化时间显示 - 显示完整日期时间
			if (typeof timeValue === 'string') {
				// 如果是 "2025-10-25 14:56" 格式，格式化为 "10-25 14:56"
				if (timeValue.includes(' ')) {
					const parts = timeValue.split(' ');
					const datePart = parts[0]; // "2025-10-25"
					const timePart = parts[1]; // "14:56"
					
					// 提取月-日
					const dateSegments = datePart.split('-');
					if (dateSegments.length === 3) {
						return `${dateSegments[1]}-${dateSegments[2]} ${timePart}`; // "10-25 14:56"
					}
					return timeValue; // 如果格式不对，返回原值
				}
				return timeValue;
			}
			
			return timeValue;
		} catch (error) {
			console.error('❌ 转换X坐标为时间失败:', error);
			return null;
		}
	},
	
	// 辅助函数：解析百分比或像素值
	parsePercent(value, total) {
		if (typeof value === 'string' && value.endsWith('%')) {
			return (parseFloat(value) / 100) * total;
		}
		return parseFloat(value) || 0;
	},
	
	// 将Y坐标转换为实际价格值
	convertYToPrice(yCoord) {
		if (!this.chartInstance) return null;
		
		try {
			// 获取图表配置
			const option = this.chartInstance.getOption();
			if (!option || !option.yAxis || !option.yAxis[0]) return null;
			
			// 获取Y轴的最大值和最小值
			const yAxis = option.yAxis[0];
			let yMax = yAxis.max;
			let yMin = yAxis.min;
			
			// 如果是自动计算的范围，从K线数据中获取
			if (yMax === undefined || yMin === undefined) {
				const klineData = option.series && option.series[0] ? option.series[0].data : [];
				if (klineData.length === 0) return null;
				
				const allHighs = klineData.map(item => item[3]); // 最高价
				const allLows = klineData.map(item => item[2]);  // 最低价
				yMax = Math.max(...allHighs);
				yMin = Math.min(...allLows);
			}
			
			// 获取图表容器的高度
			const chartContainer = document.querySelector('.middlePC');
			if (!chartContainer) return null;
			
			const chartHeight = chartContainer.offsetHeight;
			
			// 转换Y坐标到价格值
			// Y坐标是从上到下递增的，价格是从下到上递增的
			const priceRange = yMax - yMin;
			const price = yMax - (yCoord / chartHeight) * priceRange;
			
			return price;
		} catch (error) {
			console.error('转换Y坐标到价格失败:', error);
			return null;
		}
	},
	
// 选中绘图元素
selectDrawingElement(elementId) {
	const element = this.drawingElements.find(el => el.id === elementId);
	if (!element) return;
	
	// 🔧 修复：不添加任何视觉高亮效果，避免干扰线条显示
	// 仅记录选中状态，不修改DOM样式
	const domElement = document.querySelector(`[data-element-id="${elementId}"]`);
	if (domElement) {
		// 不修改样式，保持线条原始外观
		// domElement.style.opacity = '0.7';
		// domElement.style.boxShadow = 'none';
	}
	
	this.currentDrawingElement = element;
},

// 🔑 使水平直线可拖动（带中心基点）
makeHorizontalLineDraggableWithCenter(domElement, element) {
	// 鼠标悬停时显示中心基点
	domElement.addEventListener('mouseenter', () => {
		domElement.style.opacity = '0.8';
		const centerHandle = domElement.querySelector('.center-handle');
		if (centerHandle) {
			centerHandle.style.display = 'block';
		}
	});
	
	domElement.addEventListener('mouseleave', () => {
		domElement.style.opacity = '1';
		const centerHandle = domElement.querySelector('.center-handle');
		if (centerHandle) {
			centerHandle.style.display = 'none';
		}
	});
	
	// 拖拽中心基点（可以上下和左右移动）
	const centerHandle = domElement.querySelector('.center-handle');
	if (centerHandle) {
		centerHandle.addEventListener('mousedown', (e) => {
			e.stopPropagation();
			let isDragging = true;
			const startX = e.clientX;
			const startY = e.clientY;
			const originalTop = parseFloat(domElement.style.top) || 0;
			const originalCenterX = parseFloat(centerHandle.style.left) || 0;
			// 🔧 保存原始的宽度和左边距（像素值）
			const originalWidth = parseFloat(domElement.style.width) || 0;
			const originalLeft = parseFloat(domElement.style.left) || 0;
			
			const handleMove = (moveEvent) => {
				if (!isDragging) return;
				
				const deltaX = moveEvent.clientX - startX;
				const deltaY = moveEvent.clientY - startY;
				
				// 更新线条的Y位置（价格）
				const newTop = originalTop + deltaY;
				domElement.style.top = `${newTop}px`;
				
				// 更新基点的X位置（相对位置）
				const newCenterX = originalCenterX + deltaX;
				centerHandle.style.left = `${newCenterX}px`;
				
				// 🔧 修复：明确保持线条的原始宽度和位置（使用像素值）
				domElement.style.width = `${originalWidth}px`;
				domElement.style.left = `${originalLeft}px`;
				
				// 更新价格标签
				const priceLabel = domElement.querySelector('.drawing-price-label');
				if (priceLabel) {
					const price = this.convertYToPrice(newTop);
					priceLabel.textContent = price ? price.toFixed(4) : 'N/A';
				}
			};
			
			const handleUp = () => {
				if (isDragging) {
					isDragging = false;
					
					// 更新元素数据
					const newY = parseFloat(domElement.style.top) || 0;
					const newRelativeCenterX = parseFloat(centerHandle.style.left) || 0;
					// 计算绝对位置（使用 originalLeft）
					const newAbsoluteCenterX = originalLeft + newRelativeCenterX;
					
					// 只更新Y位置和点击位置，保持X范围不变
					element.startPoint.y = newY;
					element.endPoint.y = newY;
					element.clickPoint = { x: newAbsoluteCenterX, y: newY };
					element.priceValue = this.convertYToPrice(newY);
					
					// 🔧 注意：不要更新startPoint.x和endPoint.x，这样可以保持线条的完整宽度
					// 🔧 也不要调用 updateDrawingElement 重新渲染，因为我们已经直接更新了DOM
					
					document.removeEventListener('mousemove', handleMove);
					document.removeEventListener('mouseup', handleUp);
				}
			};
			
			document.addEventListener('mousemove', handleMove);
			document.addEventListener('mouseup', handleUp);
		});
	}
},

// 🔑 使水平直线可拖动（旧版本，保留兼容性）
makeHorizontalLineDraggable(domElement, element) {
	let isDragging = false;
	let startY = 0;
	let startTop = 0;
	
	// 整条线的拖动（上下移动价格）
	const handleLineMouseDown = (e) => {
		// 如果点击的是端点，不处理
		if (e.target.classList.contains('drawing-handle')) {
			return;
		}
		
		isDragging = true;
		startY = e.clientY;
		startTop = parseFloat(domElement.style.top) || 0;
		e.stopPropagation();
		
		document.addEventListener('mousemove', handleLineMouseMove);
		document.addEventListener('mouseup', handleLineMouseUp);
	};
	
	const handleLineMouseMove = (e) => {
		if (!isDragging) return;
		
		const deltaY = e.clientY - startY;
		const newTop = startTop + deltaY;
		
		// 更新DOM位置
		domElement.style.top = `${newTop}px`;
		
		// 更新价格标签
		const priceLabel = domElement.querySelector('.drawing-price-label');
		if (priceLabel) {
			const price = this.convertYToPrice(newTop);
			priceLabel.textContent = price ? price.toFixed(4) : 'N/A';
		}
	};
	
	const handleLineMouseUp = () => {
		if (isDragging) {
			isDragging = false;
			
			// 更新元素数据
			const newY = parseFloat(domElement.style.top) || 0;
			element.startPoint.y = newY;
			element.endPoint.y = newY;
			element.priceValue = this.convertYToPrice(newY);
			
			document.removeEventListener('mousemove', handleLineMouseMove);
			document.removeEventListener('mouseup', handleLineMouseUp);
		}
	};
	
	// 添加鼠标悬停提示
	domElement.addEventListener('mouseenter', () => {
		domElement.style.cursor = 'ns-resize';
		domElement.style.opacity = '0.8';
		
		// 显示端点
		const handles = domElement.querySelectorAll('.drawing-handle');
		handles.forEach(handle => {
			handle.style.display = 'block';
		});
	});
	
	domElement.addEventListener('mouseleave', () => {
		if (!isDragging) {
			domElement.style.cursor = 'pointer';
			domElement.style.opacity = '1';
			
			// 隐藏端点
			const handles = domElement.querySelectorAll('.drawing-handle');
			handles.forEach(handle => {
				handle.style.display = 'none';
			});
		}
	});
	
	// 绑定拖动事件
	domElement.addEventListener('mousedown', handleLineMouseDown);
	
	// 端点拖动（左右移动时间范围）
	const leftHandle = domElement.querySelector('.left-handle');
	const rightHandle = domElement.querySelector('.right-handle');
	
	if (leftHandle) {
		leftHandle.addEventListener('mousedown', (e) => {
			e.stopPropagation();
			let handleIsDragging = true;
			const startX = e.clientX;
			const startLeft = parseFloat(domElement.style.left) || 0;
			const startWidth = parseFloat(domElement.style.width) || 0;
			
			const handleMove = (moveE) => {
				if (!handleIsDragging) return;
				const deltaX = moveE.clientX - startX;
				const newLeft = startLeft + deltaX;
				const newWidth = startWidth - deltaX;
				
				if (newWidth > 20) { // 最小宽度20px
					domElement.style.left = `${newLeft}px`;
					domElement.style.width = `${newWidth}px`;
					element.startPoint.x = newLeft;
				}
			};
			
			const handleUp = () => {
				handleIsDragging = false;
				document.removeEventListener('mousemove', handleMove);
				document.removeEventListener('mouseup', handleUp);
			};
			
			document.addEventListener('mousemove', handleMove);
			document.addEventListener('mouseup', handleUp);
		});
	}
	
	if (rightHandle) {
		rightHandle.addEventListener('mousedown', (e) => {
			e.stopPropagation();
			let handleIsDragging = true;
			const startX = e.clientX;
			const startWidth = parseFloat(domElement.style.width) || 0;
			
			const handleMove = (moveE) => {
				if (!handleIsDragging) return;
				const deltaX = moveE.clientX - startX;
				const newWidth = startWidth + deltaX;
				
				if (newWidth > 20) { // 最小宽度20px
					domElement.style.width = `${newWidth}px`;
					element.endPoint.x = element.startPoint.x + newWidth;
				}
			};
			
			const handleUp = () => {
				handleIsDragging = false;
				document.removeEventListener('mousemove', handleMove);
				document.removeEventListener('mouseup', handleUp);
			};
			
			document.addEventListener('mousemove', handleMove);
			document.addEventListener('mouseup', handleUp);
		});
	}
	
	// 默认隐藏端点
	const handles = domElement.querySelectorAll('.drawing-handle');
	handles.forEach(handle => {
		handle.style.display = 'none';
	});
},

// 🔑 使斜线可拖动
makeLineDraggable(domElement, element) {
	// 鼠标悬停时显示基点
	domElement.addEventListener('mouseenter', () => {
		domElement.style.opacity = '0.8';
		const handles = domElement.querySelectorAll('.drawing-handle');
		handles.forEach(handle => {
			handle.style.display = 'block';
		});
	});
	
	domElement.addEventListener('mouseleave', () => {
		domElement.style.opacity = '1';
		const handles = domElement.querySelectorAll('.drawing-handle');
		handles.forEach(handle => {
			handle.style.display = 'none';
		});
	});
	
	// 拖拽起点
	const startHandle = domElement.querySelector('.start-handle');
	if (startHandle) {
		startHandle.addEventListener('mousedown', (e) => {
			e.stopPropagation();
			let isDragging = true;
			const startX = e.clientX;
			const startY = e.clientY;
			const originalStartX = element.startPoint.x;
			const originalStartY = element.startPoint.y;
			
			const handleMove = (moveEvent) => {
				if (!isDragging) return;
				const deltaX = moveEvent.clientX - startX;
				const deltaY = moveEvent.clientY - startY;
				
				element.startPoint.x = originalStartX + deltaX;
				element.startPoint.y = originalStartY + deltaY;
				
				// 重新渲染
				this.updateDrawingElement(element);
			};
			
			const handleUp = () => {
				isDragging = false;
				document.removeEventListener('mousemove', handleMove);
				document.removeEventListener('mouseup', handleUp);
			};
			
			document.addEventListener('mousemove', handleMove);
			document.addEventListener('mouseup', handleUp);
		});
	}
	
	// 拖拽终点
	const endHandle = domElement.querySelector('.end-handle');
	if (endHandle) {
		endHandle.addEventListener('mousedown', (e) => {
			e.stopPropagation();
			let isDragging = true;
			const startX = e.clientX;
			const startY = e.clientY;
			const originalEndX = element.endPoint.x;
			const originalEndY = element.endPoint.y;
			
			const handleMove = (moveEvent) => {
				if (!isDragging) return;
				const deltaX = moveEvent.clientX - startX;
				const deltaY = moveEvent.clientY - startY;
				
				element.endPoint.x = originalEndX + deltaX;
				element.endPoint.y = originalEndY + deltaY;
				
				// 重新渲染
				this.updateDrawingElement(element);
			};
			
			const handleUp = () => {
				isDragging = false;
				document.removeEventListener('mousemove', handleMove);
				document.removeEventListener('mouseup', handleUp);
			};
			
			document.addEventListener('mousemove', handleMove);
			document.addEventListener('mouseup', handleUp);
		});
	}
},

// 🔑 使垂直线可拖动
makeVerticalLineDraggable(domElement, element) {
	// 鼠标悬停时显示基点
	domElement.addEventListener('mouseenter', () => {
		domElement.style.opacity = '0.8';
		const handles = domElement.querySelectorAll('.drawing-handle');
		handles.forEach(handle => {
			handle.style.display = 'block';
		});
	});
	
	domElement.addEventListener('mouseleave', () => {
		domElement.style.opacity = '1';
		const handles = domElement.querySelectorAll('.drawing-handle');
		handles.forEach(handle => {
			handle.style.display = 'none';
		});
	});
	
	// 拖拽顶部基点
	const topHandle = domElement.querySelector('.top-handle');
	if (topHandle) {
		topHandle.addEventListener('mousedown', (e) => {
			e.stopPropagation();
			let isDragging = true;
			const startY = e.clientY;
			const originalY = element.startPoint.y;
			
			const handleMove = (moveEvent) => {
				if (!isDragging) return;
				const deltaY = moveEvent.clientY - startY;
				element.startPoint.y = originalY + deltaY;
				
				// 重新渲染
				this.updateDrawingElement(element);
			};
			
			const handleUp = () => {
				isDragging = false;
				document.removeEventListener('mousemove', handleMove);
				document.removeEventListener('mouseup', handleUp);
			};
			
			document.addEventListener('mousemove', handleMove);
			document.addEventListener('mouseup', handleUp);
		});
	}
	
	// 拖拽底部基点
	const bottomHandle = domElement.querySelector('.bottom-handle');
	if (bottomHandle) {
		bottomHandle.addEventListener('mousedown', (e) => {
			e.stopPropagation();
			let isDragging = true;
			const startY = e.clientY;
			const originalY = element.endPoint.y;
			
			const handleMove = (moveEvent) => {
				if (!isDragging) return;
				const deltaY = moveEvent.clientY - startY;
				element.endPoint.y = originalY + deltaY;
				
				// 重新渲染
				this.updateDrawingElement(element);
			};
			
			const handleUp = () => {
				isDragging = false;
				document.removeEventListener('mousemove', handleMove);
				document.removeEventListener('mouseup', handleUp);
			};
			
			document.addEventListener('mousemove', handleMove);
			document.addEventListener('mouseup', handleUp);
		});
	}
	
	// 整条线左右拖动
	domElement.addEventListener('mousedown', (e) => {
		if (e.target.classList.contains('drawing-handle')) return;
		
		let isDragging = true;
		const startX = e.clientX;
		const originalX = element.startPoint.x;
		
		const handleMove = (moveEvent) => {
			if (!isDragging) return;
			const deltaX = moveEvent.clientX - startX;
			element.startPoint.x = originalX + deltaX;
			element.endPoint.x = originalX + deltaX;
			
			// 重新渲染
			this.updateDrawingElement(element);
		};
		
		const handleUp = () => {
			isDragging = false;
			document.removeEventListener('mousemove', handleMove);
			document.removeEventListener('mouseup', handleUp);
		};
		
		document.addEventListener('mousemove', handleMove);
		document.addEventListener('mouseup', handleUp);
	});
},

// 🔑 更新绘图元素（重新渲染）
updateDrawingElement(element) {
	const chartContainer = document.querySelector('.middlePC');
	if (!chartContainer) return;
	
	// 找到对应的DOM元素
	const domElement = chartContainer.querySelector(`[data-element-id="${element.id}"]`);
	if (!domElement) return;
	
	// 移除旧的元素
	domElement.remove();
	
	// 重新渲染
	this.renderDrawingElement(element);
},
	
// 取消绘图模式
cancelDrawingMode() {
	this.isDrawingMode = false;
	this.selectedDrawingTool = null;
	this.drawingStartPoint = null;
	this.activeTool = null;
	
	// 🔑 隐藏预览直线
	this.hidePreviewLine();
	
	// 🔑 隐藏事件捕获层
	if (this._eventLayer) {
		this._eventLayer.style.display = 'none';
		this._eventLayer.style.pointerEvents = 'none';
		console.log('✅ 取消绘图模式，隐藏事件捕获层');
	}
	
	// 移除事件监听
	if (this._eventLayer) {
		if (this._boundClick) {
			this._eventLayer.removeEventListener('click', this._boundClick);
		}
		if (this._boundMouseMove) {
			this._eventLayer.removeEventListener('mousemove', this._boundMouseMove);
		}
		if (this._boundMouseLeave) {
			this._eventLayer.removeEventListener('mouseleave', this._boundMouseLeave);
		}
	}
},
	
// 删除选中的绘图元素
deleteSelectedDrawingElement() {
	if (!this.currentDrawingElement) return;
	
	const elementId = this.currentDrawingElement.id;
	
	// 从数组中移除
	this.drawingElements = this.drawingElements.filter(el => el.id !== elementId);
	
	// 从DOM中移除
	const domElement = document.querySelector(`[data-element-id="${elementId}"]`);
	if (domElement) {
		domElement.remove();
	}
	
	this.currentDrawingElement = null;
},
	
// 清除所有绘图元素
clearAllDrawingElements() {
	this.drawingElements = [];
	
	const overlay = document.querySelector('.drawing-overlay');
	if (overlay) {
		overlay.remove();
	}
},

// 切换绘图显示/隐藏
toggleDrawingVisibility() {
	this.drawingsVisible = !this.drawingsVisible;
	
	const overlay = document.querySelector('.drawing-overlay');
	if (overlay) {
		overlay.style.display = this.drawingsVisible ? 'block' : 'none';
	}
	
	// 更新所有绘图元素的 visible 状态
	this.drawingElements.forEach(element => {
		element.visible = this.drawingsVisible;
	});
	
	// 显示提示信息
	this.$toast({
		message: this.drawingsVisible ? 
			(this.$t('Trading.drawingsVisible') || '绘图已显示') : 
			(this.$t('Trading.drawingsHidden') || '绘图已隐藏'),
		type: 'success',
		duration: 2000
	});
	
	console.log('🔍 绘图显示状态:', this.drawingsVisible ? '显示' : '隐藏');
},

// 删除所有绘图
clearAllDrawings() {
	if (this.drawingElements.length === 0) {
		this.$toast({
			message: this.$t('Trading.noDrawingsToDelete') || '当前没有绘图可删除',
			type: 'info',
			duration: 2000
		});
		return;
	}
	
	this.clearAllDrawingElements();
	
	this.$toast({
		message: this.$t('Trading.allDrawingsDeleted') || '已删除所有绘图',
		type: 'success',
		duration: 2000
	});
	
	console.log('🗑️ 已删除所有绘图元素');
},

	// 获取订单的实时价格
	getRealTimePrice(order) {
		if (!order) return '-';
		
		// 获取订单的交易对代码（优先使用marketName）
		const symbol = order.marketName || order.symbol || order.marketCode;
		if (!symbol) {
			const price = order.current_price || order.update_price;
			return price ? parseFloat(price).toFixed(2) : '-';
		}
		
		// 从 marketWsList 中查找对应的实时价格
		const marketData = this.marketWsList.find(item => 
			item.code === symbol || 
			item.marketCode === symbol || 
			item.marketName === symbol
		);
		
		// 如果找到实时数据，返回实时价格（保留2位小数）
		if (marketData && marketData.price) {
			return parseFloat(marketData.price).toFixed(2);
		}
		
		// 备用：返回订单中保存的价格（保留2位小数）
		const price = order.current_price || order.update_price || order.sellPrice;
		return price ? parseFloat(price).toFixed(2) : '-';
	},

		// 重新加载所有数据 - 用于页面刷新后的数据恢复
		async reloadAllData() {

			try {
				// 1. 重新获取市场数据
				await this.getListMarketByType();

				// 2. 重新初始化交易界面
				if (this.marketList && this.marketList.length > 0) {
				this.initTradingInterface();
				this.filteredMarketList = [...this.marketList];
				}

				// 3. 重新加载订单数据
				await this.initOrderData();

				// 4. 确保WebSocket连接
				this.ensureWebSocketConnection();

				// 5. 重新初始化所有图表
				this.$nextTick(() => {
					this.initAllChartsAfterDataLoaded();
				});

			} catch (error) {
				console.error('❌ 重新加载数据失败:', error);
			}
		},

	// 切换语言选择器弹窗
	toggleLanguageSelector() {
		this.isLanguageSelectorOpen = !this.isLanguageSelectorOpen;
		// 强制更新视图
		this.$forceUpdate();
	},
	// 选择语言
	selectLanguage(index) {
		const lang = this.langList[index].value;
		// 使用 Vuex 的 SET_LANG mutation 切换语言
		this.$store.commit('SET_LANG', lang);
		// 更新本地 currentLanguage
		this.currentLanguage = lang;
		// 关闭弹窗
		this.isLanguageSelectorOpen = false;
	},
	
	// 根据语言名称获取对应的国旗图标URL
	getLanguageIcon(langName) {
		const countryMap = {
			'English': 'us',
			'简体中文': 'cn',
			'繁體中文': 'hk',
			'日本語': 'jp',
			'한국어': 'kr',
			'ไทย': 'th',
			'Tiếng Việt': 'vn',
			'français': 'fr',
			'Deutsche': 'de',
			'Русский язык': 'ru',
			'Español': 'es',
			'Português': 'pt',
			'العربية': 'sa',
			'Italiano': 'it'
		};
		
		const countryCode = countryMap[langName] || 'un';
		// 使用在线国旗图标服务
		return `https://flagcdn.com/24x18/${countryCode}.png`;
	},
	
	// 加载充值账户信息
	async loadRechargeInfo() {
		try {
			// 加载提现手续费
			const feeRes = await getParamByKey('withdrawal_fee');
			if (feeRes && feeRes.result) {
				this.withdrawal_fee = feeRes.result;
			}
			
			// 加载充值账户列表
			const accountRes = await getParamByKey('recharge_account');
			if (accountRes && accountRes.result && accountRes.result.paramValue) {
				if (accountRes.result.paramValue.includes('{')) {
					this.recharge_account = JSON.parse(accountRes.result.paramValue);
				}
			}
		} catch (error) {
			console.error('❌ 加载充值信息失败:', error);
		}
	},
	
	// 显示充值凭证提交弹窗
	showDepositProofPopup() {
		// 关闭账户弹窗
		this.$msgbox.close();
		
		// 初始化表单
		this.depositProofForm = {
			type: this.recharge_account[this.recharge_typeIndex]?.currency_name || '',
			amount: '',
			prove: ''
		};
		this.depositProofUploadIndex = this.recharge_typeIndex;
		
		// 使用MessageBox显示充值凭证表单
		const depositProofHtml = `
			<div style="padding: 20px;">
				<div style="margin-bottom: 20px;">
					<div style="font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">类型:</div>
					<select id="deposit-proof-type" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px;">
						${this.recharge_account.map((item, index) => `
							<option value="${index}" ${index === this.recharge_typeIndex ? 'selected' : ''}>
								${item.currency_name}
							</option>
						`).join('')}
					</select>
				</div>
				
				<div style="margin-bottom: 20px;">
					<div style="font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">金额:</div>
					<input 
						id="deposit-proof-amount" 
						type="number" 
						placeholder="投资金额..." 
						style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;"
					>
				</div>
				
				<div style="margin-bottom: 20px;">
					<div style="font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">充值凭证:</div>
					<input 
						id="deposit-proof-file" 
						type="file" 
						accept="image/jpeg,image/jpg,image/png" 
						style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;"
					>
					<div style="font-size: 12px; color: #999; margin-top: 5px;">支持：JPG, JPEG2000, PNG</div>
				</div>
				
				<button onclick="window.accountActions.submitProofForm()" style="width: 100%; padding: 12px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">
					提交
				</button>
			</div>
		`;
		
		// 保存Vue实例的引用
		const vueInstance = this;
		
		// 添加提交表单的全局函数
		window.accountActions.submitProofForm = async function() {
			
			const typeSelect = document.getElementById('deposit-proof-type');
			const amountInput = document.getElementById('deposit-proof-amount');
			const fileInput = document.getElementById('deposit-proof-file');
			
			const selectedIndex = parseInt(typeSelect.value);
			const amount = amountInput.value;
			const file = fileInput.files[0];
			
			
			if (!amount) {
			vueInstance.$toast.warning('请输入充值金额');
			return;
		}
		
		const selectedAccount = vueInstance.recharge_account[selectedIndex];
		if (!selectedAccount) {
			vueInstance.$toast.error('请选择充值类型');
			return;
		}
		
		if (parseFloat(amount) < parseFloat(selectedAccount.limit)) {
			vueInstance.$toast.warning(`充值金额小于最低充值金额 ${selectedAccount.limit}`);
			return;
		}
		
		if (!file) {
			vueInstance.$toast.warning('请上传支付凭证');
				return;
			}
			
			// 上传图片并提交充值申请
			try {
				// 显示上传中提示
				const loadingMsg = vueInstance.$message({
					message: '正在上传凭证，请稍候...',
					type: 'info',
					duration: 0 // 不自动关闭
				});
				
				const formData = new FormData();
				formData.append('file', file);
				
				
				// 等待图片上传完成
				const uploadRes = await upload(formData);
				
				
				// 关闭上传提示
				loadingMsg.close();
				
				// 检查上传结果，支持两种返回格式：{ result: "..." } 或 { url: "..." }
				const uploadedUrl = uploadRes?.result || uploadRes?.url;
				if (!uploadRes || !uploadedUrl) {
					vueInstance.$toast.error('图片上传失败，请重试');
					console.error('❌ 上传失败，响应数据:', uploadRes);
					return;
				}
				
				
				// 图片上传成功，提交充值申请
				const submitLoadingMsg = vueInstance.$message({
					message: '正在提交充值申请...',
					type: 'info',
					duration: 0
				});
				
				const params = {
					type: selectedAccount.currency_name,
					prove: uploadedUrl,
					amount: parseFloat(amount),
					chargeAddress: selectedAccount.address,
				};
				
				
				const rechargeRes = await recharge(params);
				
				
				// 关闭提交提示
				submitLoadingMsg.close();
				
				if (rechargeRes && rechargeRes.code === 200) {
					// 显示成功弹窗（使用公共组件）
					vueInstance.successMessage = vueInstance.$t('common.operationSuccess') || '操作成功';
					vueInstance.$refs.successModal.show();
					
					// 关闭充值凭证弹窗并刷新
					setTimeout(() => {
						// 关闭充值凭证弹窗
						try {
							vueInstance.$msgbox.close();
						} catch (e) {
						}
						
						// 刷新用户信息
						vueInstance.$store.dispatch('GET_USER_INFO');
					}, 2000);
				} else {
					vueInstance.$toast.error(rechargeRes.message || '提交失败，请重试');
				}
			} catch (error) {
				console.error('❌ 提交充值凭证失败:', error);
				vueInstance.$toast.error('提交失败，请重试');
			}
		};
		
		this.$msgbox({
			title: '提交充值凭证',
			message: depositProofHtml,
			dangerouslyUseHTMLString: true,
			showCancelButton: false,
			showConfirmButton: false,
			customClass: 'deposit-proof-msgbox',
			beforeClose: (action, instance, done) => {
				delete window.accountActions.submitProofForm;
				done();
			}
		});
	},
	
	// 显示账户弹窗（使用新组件）
	showAccountPopup() {
		// 使用新的个人中心组件
		this.accountCenterVisible = true;
		return;
		
		// 以下是旧的MessageBox实现（已废弃）
		// 创建左右结构的账户弹窗HTML
		const accountInfoHtml = `
			<div style="display: flex; height: 700px; font-family: Arial, sans-serif;">
			<!-- 左侧菜单 -->
			<div id="account-menu" style="width: 180px; background: var(--card-bg); border-right: 1px solid var(--border-light); padding: 0;">
				<div class="menu-item" data-tab="wallet" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid var(--primary-color); background: var(--primary-color, #0156DC); color: white; font-weight: 500; text-align: center; border-radius: 5px;">
					${this.$t('account.wallet')}
				</div>
				<div class="menu-item" data-tab="deposit" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: var(--text-primary); text-align: center;">
					${this.$t('account.deposit')}
				</div>
				<div class="menu-item" data-tab="withdraw" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: var(--text-primary); text-align: center;">
					${this.$t('account.withdraw')}
				</div>
				<div class="menu-item" data-tab="kyc" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: var(--text-primary); text-align: center;">
					${this.$t('account.kyc')}
				</div>
				<div class="menu-item" data-tab="invite" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: var(--text-primary); text-align: center;">
					${this.$t('account.inviteFriends')}
				</div>
				<div class="menu-item" data-tab="password" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: var(--text-primary); text-align: center;">
					${this.$t('account.password')}
				</div>
				<div class="menu-item" data-tab="support" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: var(--text-primary); text-align: center;">
					${this.$t('account.support')}
				</div>
				<div class="menu-item" data-tab="notice" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: var(--text-primary); text-align: center;">
					${this.$t('account.notice')}
				</div>
				<div class="menu-item" data-tab="logout" style="padding: 15px 20px; cursor: pointer; border-left: 3px solid transparent; color: #f56c6c; text-align: center;" onclick="window.accountActions.logout()">
					${this.$t('account.logout')}
				</div>
			</div>
				
				<!-- 右侧内容区域 -->
				<div style="flex: 1; padding: 30px; overflow-y: auto; background: var(--card-bg);">
					<!-- 钱包内容 -->
					<div id="content-wallet" class="content-panel">
						<div style="text-align: center; background: var(--primary-color, #0156DC); padding: 30px; border-radius: 10px; color: white; margin-bottom: 20px;">
							<div style="font-size: 14px; opacity: 0.9; margin-bottom: 10px;">${this.$t('account.balance_label')}</div>
							<div style="font-size: 36px; font-weight: bold; margin-bottom: 15px;">
								${(this.getUserInfo.amount || 0.00).toFixed(3)}
							</div>
							<div style="display: flex; justify-content: center; gap: 30px; margin-top: 20px;">
								<div style="text-align: center;">
									<div style="font-size: 12px; opacity: 0.8; margin-bottom: 5px;">${this.$t('account.margin')}</div>
									<div style="font-size: 18px; font-weight: 600;">${(this.getUserInfo.profit || 0.00).toFixed(2)}</div>
								</div>
							</div>
						</div>
					</div>
					
				<!-- 入金内容 -->
				<div id="content-deposit" class="content-panel" style="display: none;">
					<h3 style="margin-bottom: 20px; color: var(--text-primary); font-size: 18px; font-weight: 600;">${this.$t('account.deposit')}</h3>
					
			<!-- 选择网络 -->
			<div style="margin-bottom: 20px; display: flex; align-items: center; gap: 15px;">
				<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px;">${this.$t('account.selectNetwork') || '选择网络'}</div>
				<select id="currency-network-select" onchange="window.accountActions.selectCurrency(this.value)" style="flex: 1; max-width: 300px; padding: 10px 12px; border: 1px solid var(--border-color); border-radius: 6px; font-size: 14px; background: var(--input-bg); color: var(--text-primary); cursor: pointer;">
					${this.recharge_account.map((item, index) => `
						<option value="${index}" ${index === 0 ? 'selected' : ''}>${item.currency_name}</option>
					`).join('')}
				</select>
			</div>
				
				<!-- 钱包地址 -->
				<div style="margin-bottom: 20px; display: flex; align-items: center; gap: 15px;">
					<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px;">${this.$t('account.walletAddress') || '钱包地址'}</div>
					<div style="display: flex; gap: 10px; align-items: center; flex: 1;">
						<input 
							readonly 
							id="deposit-address-input"
							value="${this.recharge_account[this.recharge_typeIndex]?.address || ''}" 
							style="flex: 1; padding: 12px; border: 1px solid var(--border-color); border-radius: 8px; background: var(--input-bg); color: var(--text-primary); font-family: monospace; font-size: 13px;"
						>
						<button onclick="window.accountActions.copyAddress()" style="padding: 10px 20px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 8px; cursor: pointer; white-space: nowrap; display: flex; align-items: center; gap: 5px;">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
								<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
							</svg>
						</button>
					</div>
				</div>
				
			<!-- 二维码 -->
			<div style="margin-bottom: 20px; display: flex; align-items: flex-start; gap: 15px;">
				<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px; padding-top: 5px;">${this.$t('account.qrCode') || '钱包地址'}</div>
				<div style="background: var(--card-bg); padding: 15px; border-radius: 8px; text-align: center; border: 1px solid var(--border-light); display: inline-block;">
					<img 
						id="deposit-qr-code"
						src="${this.getDepositQrCodeUrl()}" 
						style="width: 150px; height: 150px; display: block;"
					>
				</div>
			</div>
				
				<!-- 充值数量 -->
				<div style="margin-bottom: 20px; display: flex; align-items: center; gap: 15px;">
					<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px;">${this.$t('account.depositAmountInput') || '充值数量'}</div>
					<input 
						id="deposit-amount-input"
						type="number" 
						placeholder="${this.$t('account.enterDepositAmount') || '请输入充值数量'}" 
						style="flex: 1; padding: 12px; border: 1px solid #dcdfe6; border-radius: 8px; font-size: 14px; box-sizing: border-box;"
					>
				</div>
			<!-- 上传凭证 -->
			<div style="margin-bottom: 20px; display: flex; align-items: flex-start; gap: 15px;">
				<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px; padding-top: 5px;">${this.$t('account.uploadProof') || '上传凭证'}</div>
				<div 
					id="deposit-upload-area"
					onclick="document.getElementById('deposit-proof-input').click()" 
					style="flex: 1; border: 2px dashed #dcdfe6; border-radius: 8px; padding: 30px; text-align: center; cursor: pointer; background: var(--bg-secondary); transition: all 0.3s;"
					onmouseover="this.style.borderColor='var(--primary-color)'; this.style.background='#f0f9ff';"
					onmouseout="this.style.borderColor='#dcdfe6'; this.style.background='#fafafa';"
				>
					<input 
						type="file" 
						id="deposit-proof-input" 
						accept="image/*" 
						onchange="window.accountActions.uploadDepositProof(event)"
						style="display: none;"
					>
					<div id="deposit-upload-content">
						<svg width="40" height="40" viewBox="0 0 24 24" fill="#999" style="margin: 0 auto 8px;">
							<path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
						</svg>
						<div style="color: var(--text-secondary); font-size: 13px; margin-bottom: 4px;">${this.$t('account.clickToUpload') || '点击上传凭证'}</div>
						<div style="color: #999; font-size: 11px;">${this.$t('account.supportedFormats') || '支持 JPG、PNG 格式'}</div>
					</div>
					<div id="deposit-proof-preview" style="display: none;">
						<img id="deposit-proof-img" style="max-width: 100%; max-height: 150px; border-radius: 4px; margin-bottom: 8px;">
						<div style="color: var(--success-color); font-size: 13px;">${this.$t('account.uploadSuccess') || '上传成功'}</div>
					</div>
				</div>
			</div>
					
			<!-- 提交按钮 -->
			<div style="display: flex; gap: 15px; margin-top: 20px;">
				<div style="width: 100px;"></div>
				<button 
					id="submit-deposit-btn"
					onclick="window.accountActions.submitDepositProof()" 
					style="flex: 1; padding: 14px; background: var(--primary-color, #0156DC); color: #fff; border: none; border-radius: 8px; cursor: pointer; font-size: 16px; font-weight: 600;"
				>
					${this.$t('account.submit') || '提交'}
				</button>
			</div>
					
					<!-- 充值记录 -->
					<div style="margin-top: 30px;">
						<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
							<h4 style="color: var(--text-primary); font-size: 16px; font-weight: 600; margin: 0;">${this.$t('account.depositHistory') || '充值记录'}</h4>
							<button onclick="window.accountActions.loadDepositHistory()" style="padding: 6px 15px; background: var(--bg-secondary); color: var(--text-secondary); border: 1px solid #dcdfe6; border-radius: 4px; cursor: pointer; font-size: 13px;">
								${this.$t('common.refresh') || '刷新'}
							</button>
						</div>
						
						<!-- 充值记录列表 -->
						<div id="deposit-history-list" style="max-height: 400px; overflow-y: auto;">
							<div style="text-align: center; padding: 40px; color: #999;">
								${this.$t('common.loading') || '加载中...'}
							</div>
						</div>
					</div>
					</div>
					
					<!-- 出金内容 -->
					<div id="content-withdraw" class="content-panel" style="display: none;">
						<h3 style="margin-bottom: 20px; color: var(--text-primary); font-size: 18px; font-weight: 600;">${this.$t('account.withdraw')}</h3>
						
						<!-- 可用余额 -->
						<div style="background: var(--bg-secondary); padding: 15px; border-radius: 8px; margin-bottom: 20px;">
							<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 5px;">${this.$t('account.availableBalance')}</div>
							<div style="font-size: 24px; color: var(--primary-color, #0156DC); font-weight: bold;">
								${(this.getUserInfo.amount || 0.00).toFixed(2)} USD
							</div>
						</div>
						
						<!-- 提款方式选择 -->
						<div style="margin-bottom: 20px; display: flex; align-items: center; gap: 15px;">
							<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px;">${this.$t('account.withdrawalType')}</div>
							<select id="withdraw-type-select" onchange="window.accountActions && window.accountActions.updateWithdrawEstimate()" style="flex: 1; max-width: 300px; padding: 10px 12px; border: 1px solid var(--border-color); border-radius: 6px; font-size: 14px; background: var(--input-bg); color: var(--text-primary); cursor: pointer;">
								${this.withdrawalTypeList.map((type, index) => type ? `<option value="${index}">${type}</option>` : '').join('')}
							</select>
						</div>
						
						<!-- 提款金额 -->
						<div style="margin-bottom: 20px; display: flex; align-items: center; gap: 15px;">
							<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px;">${this.$t('account.withdrawalAmount')}</div>
							<div style="position: relative; flex: 1;">
								<input id="withdraw-amount-input" type="number" placeholder="${this.$t('account.enterWithdrawalAmount')}" oninput="window.accountActions && window.accountActions.updateWithdrawEstimate()" style="width: 100%; padding: 12px; padding-right: 70px; border: 1px solid #dcdfe6; border-radius: 8px; font-size: 14px; box-sizing: border-box;">
								<button onclick="const input = event.target.previousElementSibling; input.value='${(this.getUserInfo.amount || 0.00).toFixed(2)}'; window.accountActions && window.accountActions.updateWithdrawEstimate();" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); padding: 4px 12px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
									${this.$t('account.all') || '全部'}
								</button>
							</div>
						</div>
						
						<!-- 提款地址 -->
						<div style="margin-bottom: 20px; display: flex; align-items: center; gap: 15px;">
							<div style="font-size: 14px; color: var(--text-primary); font-weight: 500; width: 100px;">${this.$t('account.withdrawalAddress')}</div>
							<input id="withdraw-address-input" type="text" placeholder="${this.$t('account.enterWithdrawalAddress')}" style="flex: 1; padding: 12px; border: 1px solid #dcdfe6; border-radius: 8px; font-size: 14px; box-sizing: border-box;">
						</div>
						
					<!-- 手续费说明 -->
					<div style="margin-bottom: 20px; display: flex; gap: 15px;">
						<div style="width: 100px;"></div>
						<div style="flex: 1; background: var(--bg-secondary); padding: 15px; border-radius: 8px;">
							<div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
								<span style="color: var(--text-secondary); font-size: 14px;">${this.$t('account.handlingFee')}</span>
								<span id="withdraw-fee-display" style="color: var(--text-primary); font-weight: 500;">-</span>
							</div>
							<div style="display: flex; justify-content: space-between;">
								<span style="color: var(--text-secondary); font-size: 14px;">${this.$t('account.estimatedArrival')}</span>
								<span id="withdraw-estimate-display" style="color: var(--text-primary); font-weight: 600; font-size: 16px;">- USD</span>
							</div>
						</div>
					</div>
						
						<!-- 提交按钮 -->
						<div style="display: flex; gap: 15px; margin-bottom: 20px;">
							<div style="width: 100px;"></div>
							<button onclick="console.log('按钮被点击'); console.log('accountActions:', window.accountActions); if (window.accountActions && window.accountActions.submitWithdraw) { window.accountActions.submitWithdraw(); } else { alert('submitWithdraw 函数未找到'); }" style="flex: 1; padding: 14px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 8px; cursor: pointer; font-size: 16px; font-weight: 600;">
								${this.$t('account.submit') || '提交'}
							</button>
						</div>
					
					<!-- 提现记录 -->
					<div style="margin-top: 30px;">
						<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
							<h4 style="color: var(--text-primary); font-size: 16px; font-weight: 600; margin: 0;">${this.$t('account.withdrawHistory') || '提现记录'}</h4>
							<button onclick="window.accountActions.loadWithdrawHistory()" style="padding: 6px 15px; background: var(--bg-secondary); color: var(--text-secondary); border: 1px solid #dcdfe6; border-radius: 4px; cursor: pointer; font-size: 13px;">
								${this.$t('common.refresh') || '刷新'}
							</button>
						</div>
						
						<!-- 提现记录列表 -->
						<div id="withdraw-history-list" style="max-height: 400px; overflow-y: auto;">
							<div style="text-align: center; padding: 40px; color: #999;">
								${this.$t('common.loading') || '加载中...'}
							</div>
						</div>
					</div>
				</div>
					
					<!-- KYC 实名认证 -->
					<div id="content-kyc" class="content-panel" style="display: none;">
						<!-- 步骤1：基本信息 -->
						<div id="kyc-step-1" class="kyc-step">
							<h3 style="margin-bottom: 30px; color: var(--text-primary); font-size: 20px; font-weight: 600;">${this.$t('loan.notVerifyBtn')}</h3>
							
							<!-- 两列布局 -->
							<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
								<!-- 名字 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('loan.firstName')}</label>
									<input id="kyc-firstname" type="text" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
								</div>
								
								<!-- 姓氏 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('loan.lastName')}</label>
									<input id="kyc-lastname" type="text" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
								</div>
								
								<!-- 性别 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('loan.sex')}</label>
									<select id="kyc-sex" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
										<option value="1">${this.$t('loan.male')}</option>
										<option value="0">${this.$t('loan.female')}</option>
									</select>
								</div>
								
								<!-- 生日 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('loan.birthdate')}</label>
									<input id="kyc-birthday" type="date" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
								</div>
								
								<!-- 国家 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('loan.country')}</label>
									<input id="kyc-country" type="text" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
								</div>
								
								<!-- 地址 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('loan.address')}</label>
									<input id="kyc-address" type="text" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
								</div>
								
								<!-- 电话号码 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('account.phoneNumber')}</label>
									<div style="display: flex; gap: 8px; align-items: center;">
										<select id="kyc-phone-code" style="flex-shrink: 0; padding: 10px; border: 1px solid var(--border-color); border-radius: 4px; font-size: 14px; background: var(--input-bg); color: var(--text-primary); min-width: 80px;">
											<option value="+1">+1</option>
											<option value="+44">+44</option>
											<option value="+86" selected>+86</option>
											<option value="+81">+81</option>
											<option value="+82">+82</option>
											<option value="+65">+65</option>
											<option value="+852">+852</option>
											<option value="+853">+853</option>
											<option value="+886">+886</option>
											<option value="+49">+49</option>
											<option value="+33">+33</option>
											<option value="+39">+39</option>
											<option value="+34">+34</option>
											<option value="+31">+31</option>
											<option value="+32">+32</option>
											<option value="+41">+41</option>
											<option value="+46">+46</option>
											<option value="+47">+47</option>
											<option value="+45">+45</option>
											<option value="+358">+358</option>
											<option value="+48">+48</option>
											<option value="+420">+420</option>
											<option value="+43">+43</option>
											<option value="+61">+61</option>
											<option value="+64">+64</option>
											<option value="+55">+55</option>
											<option value="+52">+52</option>
											<option value="+54">+54</option>
											<option value="+56">+56</option>
											<option value="+57">+57</option>
											<option value="+51">+51</option>
											<option value="+90">+90</option>
											<option value="+7">+7</option>
											<option value="+27">+27</option>
											<option value="+234">+234</option>
											<option value="+20">+20</option>
											<option value="+966">+966</option>
											<option value="+971">+971</option>
											<option value="+91">+91</option>
											<option value="+62">+62</option>
											<option value="+63">+63</option>
											<option value="+60">+60</option>
											<option value="+66">+66</option>
											<option value="+84">+84</option>
										</select>
										<input id="kyc-phone" type="tel" placeholder="${this.$t('account.enterPhoneNumber')}" style="flex: 1; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
									</div>
								</div>
								
								<!-- 证件类型 -->
								<div style="margin-bottom: 15px;">
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 8px; font-weight: 500;">${this.$t('loan.document')}</label>
									<select id="kyc-doctype" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;">
										<option value="1">${this.$t('loan.idCard')}</option>
										<option value="2">${this.$t('loan.passport')}</option>
										<option value="3">${this.$t('loan.driverLicense')}</option>
									</select>
								</div>
							</div>
							
							<!-- 上传证件照片 -->
							<h4 style="margin: 30px 0 20px 0; color: var(--text-primary); font-size: 16px; font-weight: 600;">${this.$t('loan.uploadDocuments')}</h4>
							
							<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-bottom: 30px;">
								<!-- 证件正面 -->
								<div>
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">${this.$t('loan.tipIdCardFront')}</label>
									<div id="kyc-upload-front" onclick="document.getElementById('kyc-file-front').click()" style="width: 100%; height: 200px; border: 2px dashed #dcdfe6; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; background: var(--bg-secondary); transition: all 0.3s;">
										<svg viewBox="0 0 1024 1024" width="48" height="48" style="fill: #999; margin-bottom: 10px;">
											<path d="M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"/>
											<path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-13.1 64.6-36.9 88.6C829.7 674.6 798.3 688 764.6 688H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h44.4C874.5 764 960 674.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
										</svg>
										<div style="font-size: 14px; color: var(--text-secondary);">${this.$t('common.clickToUpload')}</div>
									</div>
									<input id="kyc-file-front" type="file" accept="image/*" style="display: none;" onchange="window.accountActions.handleKycFileUpload(event, 'front')">
								</div>
								
								<!-- 证件反面 -->
								<div>
									<label style="display: block; font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">${this.$t('loan.tipIdCardBack')}</label>
									<div id="kyc-upload-back" onclick="document.getElementById('kyc-file-back').click()" style="width: 100%; height: 200px; border: 2px dashed #dcdfe6; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; background: var(--bg-secondary); transition: all 0.3s;">
										<svg viewBox="0 0 1024 1024" width="48" height="48" style="fill: #999; margin-bottom: 10px;">
											<path d="M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"/>
											<path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-13.1 64.6-36.9 88.6C829.7 674.6 798.3 688 764.6 688H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h44.4C874.5 764 960 674.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
										</svg>
										<div style="font-size: 14px; color: var(--text-secondary);">${this.$t('common.clickToUpload')}</div>
									</div>
									<input id="kyc-file-back" type="file" accept="image/*" style="display: none;" onchange="window.accountActions.handleKycFileUpload(event, 'back')">
								</div>
							</div>
							
							<!-- 提交按钮 -->
							<button onclick="window.accountActions.submitKycDirectly()" style="width: 100%; padding: 14px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 600; transition: all 0.3s;">
								${this.$t('loan.submit')}
							</button>
						</div>
					</div>
					
					<div id="content-invite" class="content-panel" style="display: none;">
						<h3 style="margin-bottom: 20px; color: var(--text-primary); font-size: 18px; font-weight: 600;">${this.$t('account.inviteFriends')}</h3>
						
						<!-- 邀请码显示 -->
						<div style="text-align: center; margin-bottom: 30px;">
							<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 15px;">${this.$t('account.inviteCode')}</div>
							<div style="font-size: 32px; color: var(--primary-color, #0156DC); font-weight: bold; letter-spacing: 4px; margin-bottom: 15px;">
								${this.getUserInfo.inviteNumber || 'yms0'}
							</div>
						</div>
						
						<!-- 二维码显示 -->
						<div style="text-align: center; margin-bottom: 30px;">
							<img 
								src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(window.location.origin + '/#/pass/register?code=' + (this.getUserInfo.inviteNumber || 'yms0'))}" 
								style="width: 200px; height: 200px; border: 1px solid #e4e7ed; border-radius: 8px;"
							>
						</div>
						
						<!-- 邀请链接 -->
						<div style="background: var(--bg-secondary); padding: 15px; border-radius: 8px; margin-bottom: 20px;">
							<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 10px;">${this.$t('account.inviteLink')}</div>
							<div style="word-break: break-all; font-size: 12px; color: var(--text-primary); font-family: monospace; line-height: 1.6;">
								${window.location.origin}/#/pass/register?code=${this.getUserInfo.inviteNumber || 'yms0'}
							</div>
						</div>
						
					<!-- 复制链接按钮 -->
					<button onclick="window.accountActions.copyInviteLink()" style="width: 100%; padding: 12px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">
						${this.$t('account.copyInviteLink')}
					</button>
					</div>
					<div id="content-password" class="content-panel" style="display: none;">
						<h3 style="margin-bottom: 20px; color: var(--text-primary); font-size: 18px; font-weight: 600;">${this.$t('account.password')}</h3>
						
						<!-- 手机号（只读） -->
						<div style="margin-bottom: 20px;">
							<div style="font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">${this.$t('account.phoneNumber')}</div>
							<input 
								id="password-phone-input"
								type="text" 
								readonly 
								value="${this.getUserInfo.phone || ''}" 
								style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box; background: #f5f7fa; color: #999;"
							>
						</div>
						
						<!-- 新密码 -->
						<div style="margin-bottom: 20px;">
							<div style="font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">${this.$t('account.newPassword')}</div>
							<input 
								id="password-new-input"
								type="password" 
								placeholder="${this.$t('account.enterNewPassword')}" 
								style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;"
							>
							<div style="font-size: 12px; color: #999; margin-top: 5px;">${this.$t('account.passwordLengthHint')}</div>
						</div>
						
						<!-- 确认密码 -->
						<div style="margin-bottom: 30px;">
							<div style="font-size: 14px; color: var(--text-primary); margin-bottom: 10px; font-weight: 500;">${this.$t('account.confirmPassword')}</div>
							<input 
								id="password-confirm-input"
								type="password" 
								placeholder="${this.$t('account.enterConfirmPassword')}" 
								style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 4px; font-size: 14px; box-sizing: border-box;"
							>
						</div>
						
						<!-- 保存按钮 -->
						<button onclick="window.accountActions.savePassword()" style="width: 100%; padding: 12px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; font-weight: 500;">
							保存
						</button>
					</div>
					
					<div id="content-support" class="content-panel" style="display: none;">
						<h3 style="margin-bottom: 20px; color: var(--text-primary); font-size: 18px; font-weight: 600;">${this.$t('account.support')}</h3>
						
						<!-- WhatsApp Service -->
						<div style="background: #fff; color: var(--text-primary); cursor: pointer; border-radius: 8px; padding: 20px; display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px; border: 1px solid #e4e7ed; transition: all 0.3s;" onclick="window.open('https://wa.me/16236988384', '_blank')" onmouseover="this.style.borderColor='var(--primary-color)'; this.style.boxShadow='0 2px 12px rgba(1, 102, 252, 0.15)'" onmouseout="this.style.borderColor='#e4e7ed'; this.style.boxShadow='none'">
							<div style="display: flex; align-items: center; gap: 15px;">
								<div style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; background: var(--primary-color-10); border-radius: 50%;">
									<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="var(--success-color)">
										<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
									</svg>
								</div>
								<div>
									<div style="font-size: 16px; font-weight: 500; margin-bottom: 4px; color: var(--text-primary);">WhatsApp Service</div>
									<div style="font-size: 14px; color: var(--text-secondary);">+16236988384</div>
								</div>
							</div>
							<div>
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
									<polyline points="9 18 15 12 9 6"></polyline>
								</svg>
							</div>
						</div>
						
						<!-- Online Service -->
						<div style="background: #fff; color: var(--text-primary); cursor: pointer; border-radius: 8px; padding: 20px; display: flex; align-items: center; justify-content: space-between; border: 1px solid #e4e7ed; transition: all 0.3s;" onclick="window.accountActions.openOnlineService()" onmouseover="this.style.borderColor='var(--primary-color)'; this.style.boxShadow='0 2px 12px rgba(1, 102, 252, 0.15)'" onmouseout="this.style.borderColor='#e4e7ed'; this.style.boxShadow='none'">
							<div style="display: flex; align-items: center; gap: 15px;">
								<div style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; background: var(--primary-color-10); border-radius: 50%;">
									<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
										<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
									</svg>
								</div>
								<div>
									<div style="font-size: 16px; font-weight: 500; color: var(--text-primary);">Online Service</div>
								</div>
							</div>
							<div>
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
									<polyline points="9 18 15 12 9 6"></polyline>
								</svg>
							</div>
						</div>
					</div>
					
					<div id="content-notice" class="content-panel" style="display: none;">
						<h3 style="margin-bottom: 20px; color: var(--text-primary); font-size: 18px; font-weight: 600;">${this.$t('account.notice')}</h3>
						
						<!-- 暂无数据提示 -->
						<div style="text-align: center; padding: 60px 20px; color: #999;">
							<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" style="margin: 0 auto 20px; opacity: 0.3;">
								<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
								<polyline points="14 2 14 8 20 8"></polyline>
								<line x1="16" y1="13" x2="8" y2="13"></line>
								<line x1="16" y1="17" x2="8" y2="17"></line>
								<polyline points="10 9 9 9 8 9"></polyline>
							</svg>
							<div style="font-size: 16px; font-weight: 400;">${this.$t('toast.noData')}</div>
						</div>
					</div>
				</div>
			</div>
		`;
		
		// 保存Vue实例的引用以便全局函数使用
		const vueInstance = this;
		
		// 设置全局函数供按钮调用
		window.accountActions = {
		selectCurrency: function(index) {
			vueInstance.recharge_typeIndex = parseInt(index);
			
			// 更新充值地址和二维码
			const selectedAccount = vueInstance.recharge_account[index];
			
			if (selectedAccount) {
		// 更新充值地址（完整地址）
		const addressInput = document.getElementById('deposit-address-input');
		if (addressInput && selectedAccount.address) {
			addressInput.value = selectedAccount.address;
		}
		
		// 更新二维码 - 使用后端返回的qr_code图片链接
		const qrCode = document.getElementById('deposit-qr-code');
		
		if (qrCode && selectedAccount.qr_code) {
			// 对URL进行编码处理
			let qrCodeUrl = selectedAccount.qr_code;
			try {
				qrCodeUrl = encodeURI(qrCodeUrl);
			} catch (e) {
				console.error('URL编码失败:', e);
			}
			
			// 更新图片src
			qrCode.src = qrCodeUrl;
		}
				
			}
		},
		
		// 上传充值凭证
		uploadDepositProof: async function(event) {
			const file = event.target.files[0];
			if (!file) return;
			
			// 验证文件类型
			if (!file.type.startsWith('image/')) {
				vueInstance.$toast.error(vueInstance.$t('account.pleaseUploadImage') || '请上传图片文件');
				return;
			}
			
			// 验证文件大小（5MB）
			if (file.size > 5 * 1024 * 1024) {
				vueInstance.$toast.error(vueInstance.$t('account.fileTooLarge') || '图片大小不能超过5MB');
				return;
			}
			
			try {
				// 显示预览
				const reader = new FileReader();
				reader.onload = function(e) {
					const preview = document.getElementById('deposit-proof-preview');
					const content = document.getElementById('deposit-upload-content');
					const img = document.getElementById('deposit-proof-img');
					
					if (preview && content && img) {
						img.src = e.target.result;
						content.style.display = 'none';
						preview.style.display = 'block';
					}
				};
				reader.readAsDataURL(file);
				
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', file);
				
				const response = await vueInstance.$http.post('/common/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				
				if (response.code === 200) {
					// 保存上传的图片URL
					window.depositProofUrl = response.url || response.data?.url || response.fileName;
					vueInstance.$toast.success(vueInstance.$t('account.uploadSuccess') || '上传成功');
				} else {
					throw new Error(response.msg || '上传失败');
				}
			} catch (error) {
				console.error('❌ 上传凭证失败:', error);
				vueInstance.$toast.error((vueInstance.$t('account.uploadFailed') || '上传失败') + '：' + (error.message || '请稍后重试'));
				
				// 重置预览
				const preview = document.getElementById('deposit-proof-preview');
				const content = document.getElementById('deposit-upload-content');
				if (preview && content) {
					preview.style.display = 'none';
					content.style.display = 'block';
				}
				event.target.value = ''; // 重置文件输入
			}
		},
			copyAddress: function() {
				const selectedAccount = vueInstance.recharge_account[vueInstance.recharge_typeIndex];
				if (selectedAccount && selectedAccount.address) {
					navigator.clipboard.writeText(selectedAccount.address).then(() => {
						vueInstance.$toast.success('地址已複製');
					}).catch(() => {
						alert(vueInstance.$t('account.copyFailed'));
					});
				}
			},
		submitDepositProof: async function() {
			// 获取充值数量
			const amountInput = document.getElementById('deposit-amount-input');
			const amount = amountInput ? parseFloat(amountInput.value) : 0;
			
			// 验证充值数量
			if (!amount || amount <= 0) {
				vueInstance.$toast.error(vueInstance.$t('account.pleaseEnterAmount') || '请输入充值数量');
				return;
			}
			
			// 验证是否上传凭证
			if (!window.depositProofUrl) {
				vueInstance.$toast.error(vueInstance.$t('account.pleaseUploadProof') || '请上传充值凭证');
				return;
			}
			
			// 获取当前选择的货币
			const selectedAccount = vueInstance.recharge_account[vueInstance.recharge_typeIndex];
			if (!selectedAccount) {
				vueInstance.$toast.error('请选择充值网络');
				return;
			}
			
			try {
				vueInstance.$toast.info(vueInstance.$t('common.submitting') || '提交中...');
				
				// 提交充值申请
				const response = await vueInstance.$http.post('/swx/customer/user/recharge', {
					type: selectedAccount.currency_name,
					amount: amount,
					prove: window.depositProofUrl,
					chargeAddress: selectedAccount.address,
				});
				
				if (response.code === 200) {
				// 显示成功弹窗（使用公共组件）
				vueInstance.successMessage = vueInstance.$t('common.operationSuccess') || '操作成功';
				vueInstance.$refs.successModal.show();
				
				// 2秒后处理后续逻辑
				setTimeout(() => {
					// 重置表单
					if (amountInput) amountInput.value = '';
					window.depositProofUrl = '';
					const preview = document.getElementById('deposit-proof-preview');
					const content = document.getElementById('deposit-upload-content');
					if (preview && content) {
						preview.style.display = 'none';
						content.style.display = 'block';
					}
					document.getElementById('deposit-proof-input').value = '';
					
				// 刷新充值记录和用户信息
				if (window.accountActions && window.accountActions.loadDepositHistory) {
					window.accountActions.loadDepositHistory();
				}
				vueInstance.$store.dispatch('GET_USER_INFO');
				}, 2000);
				} else {
					throw new Error(response.msg || response.message || '提交失败');
				}
			} catch (error) {
				console.error('❌ 提交充值凭证失败:', error);
				vueInstance.$toast.error((vueInstance.$t('account.submitFailed') || '提交失败') + '：' + (error.message || '请稍后重试'));
			}
		},
		updateWithdrawEstimate: function() {
			// 更新预计到账金额
			const amountInput = document.querySelector('#withdraw-amount-input');
			const feeDisplay = document.querySelector('#withdraw-fee-display');
			const estimateDisplay = document.querySelector('#withdraw-estimate-display');
			
			if (!amountInput || !estimateDisplay) return;
			
			const amount = parseFloat(amountInput.value) || 0;
			if (amount <= 0) {
				estimateDisplay.textContent = '- USD';
				if (feeDisplay) {
					feeDisplay.textContent = '-';
				}
				return;
			}
			
			// 计算手续费和到账金额
			const feeRatePercent = parseFloat(vueInstance.withdrawal_fee?.paramValue || 0.025);
			const feeRate = feeRatePercent / 100;
			const fee = amount * feeRate;
			const estimatedAmount = amount - fee;
			
			// 更新显示 - 显示具体的手续费金额
			if (feeDisplay) {
				feeDisplay.textContent = fee.toFixed(2);
			}
			estimateDisplay.textContent = estimatedAmount.toFixed(2) + ' USD';
		},
			submitWithdraw: function() {
				console.log('🚀 submitWithdraw 函数被调用');
				
				// 获取提款表单数据
				const withdrawAmount = document.querySelector('#content-withdraw input[type="number"]').value;
				const withdrawAddress = document.querySelector('#content-withdraw input[type="text"]').value;
				const withdrawTypeSelect = document.querySelector('#withdraw-type-select');
				const withdrawalType = withdrawTypeSelect ? parseInt(withdrawTypeSelect.value) : 0;
				
				console.log('📊 提款数据:', { withdrawAmount, withdrawAddress, withdrawalType });
				
				// 验证是否为真实账户
				if (vueInstance.virtualStatus != 1) {
					vueInstance.$toast.warning(vueInstance.$t('account.demoAccountRestriction') || '模拟账户不能使用该功能');
					return;
				}
				
				// 验证金额
				if (!withdrawAmount) {
					vueInstance.$toast.warning(vueInstance.$t('account.enterWithdrawalAmount'));
					return;
				}
				
				if (parseFloat(withdrawAmount) <= 0) {
					vueInstance.$toast.warning(vueInstance.$t('account.enterValidAmount') || '请输入正确的金额');
					return;
				}
				
				// 验证余额
				if (parseFloat(withdrawAmount) > parseFloat(vueInstance.getUserInfo.amount || 0)) {
					vueInstance.$toast.warning(vueInstance.$t('account.insufficientBalance') || '余额不足');
					return;
				}
				
				// 验证地址（非银行转账需要地址）
				if (vueInstance.withdrawalTypeList[withdrawalType] !== 'BANK') {
					if (!withdrawAddress) {
						vueInstance.$toast.warning(vueInstance.$t('account.enterWithdrawalAddress'));
						return;
					}
				}
				
				// 准备API参数
				const params = {
					amount: parseFloat(withdrawAmount),
					btcAddress: withdrawAddress || '',
					withdrawalType: withdrawalType
				};
				
				// 用户确认后，开始提交
				const loadingMsg = vueInstance.$message({
					message: vueInstance.$t('common.submitting') || '正在提交...',
					type: 'info',
					duration: 0
				});
				
				
				// 使用Vue实例的$http发起请求
				vueInstance.$http.post('/swx/customer/user/withdrawal', params).then(res => {
					loadingMsg.close();
					
					if (res && res.code === 200) {
						// 显示成功弹窗（使用公共组件）
						vueInstance.successMessage = vueInstance.$t('common.operationSuccess') || '操作成功';
						vueInstance.$refs.successModal.show();
						
						// 2秒后清理并刷新
						setTimeout(() => {
							// 清空输入框
							const amountInput = document.querySelector('#withdraw-amount-input');
							const addressInput = document.querySelector('#withdraw-address-input');
							if (amountInput) amountInput.value = '';
							if (addressInput) addressInput.value = '';
							
							// 刷新用户信息
							vueInstance.$store.dispatch('GET_USER_INFO');
							
							// 刷新提现记录
							if (window.accountActions && window.accountActions.loadWithdrawHistory) {
								window.accountActions.loadWithdrawHistory();
							}
						}, 2000);
					} else {
						vueInstance.$toast.error(res.message || vueInstance.$t('common.submitFailed') || '提交失败，请重试');
					}
				}).catch(error => {
					console.error('❌ 提款API调用失败:', error);
					loadingMsg.close();
					vueInstance.$toast.error(vueInstance.$t('common.submitFailed') || '提交失败，请重试');
				});
			},
			copyInviteLink: function() {
				// 复制邀请链接
				const inviteCode = vueInstance.getUserInfo.inviteNumber || 'yms0';
				const inviteLink = `${window.location.origin}/#/pass/register?code=${inviteCode}`;
				
				// 使用 Clipboard API
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(inviteLink).then(() => {
						vueInstance.$toast.success(vueInstance.$t('account.inviteLinkCopied'));
					}).catch(() => {
						// 降级方案
						vueInstance.fallbackCopyInviteLink(inviteLink);
					});
				} else {
					// 降级方案
					vueInstance.fallbackCopyInviteLink(inviteLink);
				}
			},
			savePassword: function() {
				// 获取表单数据
				const newPassword = document.querySelector('#password-new-input').value;
				const confirmPassword = document.querySelector('#password-confirm-input').value;
				// 验证新密码
				if (!newPassword) {
					vueInstance.$toast.error(vueInstance.$t('account.passwordRequired'));
					return;
				}
				
				// 验证密码长度
				if (newPassword.length < 6) {
					vueInstance.$toast.error(vueInstance.$t('account.passwordTooShort'));
					return;
				}
				
				// 验证确认密码
				if (!confirmPassword) {
					vueInstance.$toast.error(vueInstance.$t('account.confirmPasswordRequired'));
					return;
				}
				
				// 验证两次密码是否一致
				if (newPassword !== confirmPassword) {
					vueInstance.$toast.error(vueInstance.$t('account.passwordMismatch'));
					return;
				}
				
				// 显示加载提示
				const loadingMsg = vueInstance.$message({
					message: vueInstance.$t('account.saving'),
					type: 'info',
					duration: 0
				});
				
				
				// 调用API
				repassword({
					password: newPassword,
					rePaossword: confirmPassword
				}).then(res => {
					loadingMsg.close();
					
					if (res && res.code == '200') {
						vueInstance.$toast.success(vueInstance.$t('account.passwordChangeSuccess'));
						
						// 清空输入框
						document.querySelector('#password-new-input').value = '';
						document.querySelector('#password-confirm-input').value = '';
						
						// 延迟关闭弹窗
						setTimeout(() => {
							try {
								// 关闭所有MessageBox
								const msgboxes = document.querySelectorAll('.el-message-box__wrapper');
								msgboxes.forEach(box => {
									box.remove();
								});
								
								// 移除遮罩层
								const modals = document.querySelectorAll('.v-modal');
								modals.forEach(modal => {
									modal.remove();
								});
								
								// 恢复body的overflow
								document.body.style.overflow = '';
								document.body.classList.remove('el-popup-parent--hidden');
								
							} catch (e) {
							}
						}, 1000);
					} else {
						vueInstance.$toast.error(res.message || vueInstance.$t('account.passwordChangeFailed'));
					}
				}).catch(error => {
					console.error('❌ 修改密码失败:', error);
					loadingMsg.close();
					vueInstance.$toast.error(vueInstance.$t('account.passwordChangeFailed'));
				});
			},
			openOnlineService: function() {
				// 打开在线客服
				const origin = window.location.origin;
				window.open(origin + '/service.html?language=en', '_blank');
			},
			logout: function() {
				vueInstance.$msgbox.close();
				vueInstance.confirmLogout();
			},
			
			// ========== KYC 相关方法 ==========
			kycNextStep: function() {
				
				// 验证第一步的表单数据
				const firstname = document.getElementById('kyc-firstname').value.trim();
				const lastname = document.getElementById('kyc-lastname').value.trim();
				const sex = document.getElementById('kyc-sex').value;
				const birthday = document.getElementById('kyc-birthday').value;
				const country = document.getElementById('kyc-country').value.trim();
				const address = document.getElementById('kyc-address').value.trim();
				const phoneCode = document.getElementById('kyc-phone-code').value;
				const phone = document.getElementById('kyc-phone').value.trim();
				const doctype = document.getElementById('kyc-doctype').value;
				
				// 验证必填字段
				if (!firstname || !lastname || !birthday || !country || !address || !phone) {
					vueInstance.$toast.warning(vueInstance.$t('account.fillCompleteInfo') || '请填写完整信息');
					return;
				}
				
				// 验证手机号格式（简单验证：至少6位数字）
				if (phone.length < 6 || !/^\d+$/.test(phone)) {
					vueInstance.$toast.warning(vueInstance.$t('account.enterValidPhone') || '请填写正确的电话号码');
					return;
				}
				
				// 组合区号和手机号（去掉+号，只拼接数字部分）
				const fullPhone = phoneCode.replace('+', '') + phone;
				
				// 存储表单数据
				window.kycFormData = {
					name: firstname,
					surname: lastname,
					sex: sex,
					birthday: birthday,
					country: country,
					address: address,
					phone: fullPhone, // 使用完整的手机号（包含区号）
					cardType: doctype
				};
				
				
				// 切换到第二步
				document.getElementById('kyc-step-1').style.display = 'none';
				document.getElementById('kyc-step-2').style.display = 'block';
			},
			
			// 直接提交KYC认证（合并步骤）
			submitKycDirectly: function() {
				console.log('🚀 submitKycDirectly 被调用');
				
				// 验证第一步的表单数据
				const firstname = document.getElementById('kyc-firstname').value.trim();
				const lastname = document.getElementById('kyc-lastname').value.trim();
				const sex = document.getElementById('kyc-sex').value;
				const birthday = document.getElementById('kyc-birthday').value;
				const country = document.getElementById('kyc-country').value.trim();
				const address = document.getElementById('kyc-address').value.trim();
				const phoneCode = document.getElementById('kyc-phone-code').value;
				const phone = document.getElementById('kyc-phone').value.trim();
				const doctype = document.getElementById('kyc-doctype').value;
				
				// 验证必填字段
				if (!firstname || !lastname || !birthday || !country || !address || !phone) {
					vueInstance.$toast.warning(vueInstance.$t('account.fillCompleteInfo') || '请填写完整信息');
					return;
				}
				
				// 验证手机号格式（简单验证：至少6位数字）
				if (phone.length < 6 || !/^\d+$/.test(phone)) {
					vueInstance.$toast.warning(vueInstance.$t('account.enterValidPhone') || '请填写正确的电话号码');
					return;
				}
				
				// 验证是否已上传两张图片
				if (!window.kycImageData || !window.kycImageData.front || !window.kycImageData.back) {
					vueInstance.$toast.warning(vueInstance.$t('account.uploadIDPhotos') || '请上传证件正反面照片');
					return;
				}
				
				// 组合区号和手机号（去掉+号，只拼接数字部分）
				const fullPhone = phoneCode.replace('+', '') + phone;
				
				// 组装提交数据 - 使用与H5端相同的字段名
				const submitData = {
					name: firstname,
					surname: lastname,
					sex: sex,
					birthday: birthday,
					country: country,
					address: address,
					phone: fullPhone,
					idType: doctype,
					frontImg: window.kycImageData.front,    // 使用图片URL路径
					reverseImg: window.kycImageData.back    // 使用图片URL路径
				};
				
				console.log('📤 提交KYC数据:', submitData);
				
				// 显示提交中提示
				const loadingMsg = vueInstance.$message({
					message: vueInstance.$t('tiJiaoZhong') || '提交中...',
					type: 'info',
					duration: 0
				});
				// 调用KYC认证API - 正确的接口
				vueInstance.$http.post('/swx/customer/user/identification', submitData).then(res => {
					loadingMsg.close();
					
					if (res.code === 200) {
						vueInstance.$toast.success(vueInstance.$t('tiJiaoChengGong') || '提交成功');
						
						// 清除临时数据
						delete window.kycImageData;
						
						// 清空表单
						document.getElementById('kyc-firstname').value = '';
						document.getElementById('kyc-lastname').value = '';
						document.getElementById('kyc-country').value = '';
						document.getElementById('kyc-address').value = '';
						document.getElementById('kyc-phone').value = '';
						document.getElementById('kyc-birthday').value = '';
						
						// 重置上传区域
						const frontArea = document.getElementById('kyc-upload-front');
						const backArea = document.getElementById('kyc-upload-back');
						const uploadSvg = `
							<svg viewBox="0 0 1024 1024" width="48" height="48" style="fill: #999; margin-bottom: 10px;">
								<path d="M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"/>
								<path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-13.1 64.6-36.9 88.6C829.7 674.6 798.3 688 764.6 688H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h44.4C874.5 764 960 674.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
							</svg>
							<div style="font-size: 14px; color: var(--text-secondary);">${vueInstance.$t('common.clickToUpload')}</div>
						`;
						if (frontArea) frontArea.innerHTML = uploadSvg;
						if (backArea) backArea.innerHTML = uploadSvg;
						
						// 2秒后关闭弹窗并刷新
						setTimeout(() => {
							// 关闭弹窗
							vueInstance.$msgbox.close();
							
							// 刷新用户信息
							vueInstance.$store.dispatch('GET_USER_INFO');
						}, 2000);
					} else {
						vueInstance.$toast.error(res.message || res.msg || vueInstance.$t('common.submitFailed') || '提交失败');
					}
				}).catch(err => {
					loadingMsg.close();
					console.error('❌ KYC认证提交失败:', err);
					vueInstance.$toast.error(vueInstance.$t('common.submitFailed') || '提交失败，请稍后重试');
				});
			},
			
			kycPrevStep: function() {
				document.getElementById('kyc-step-1').style.display = 'block';
				document.getElementById('kyc-step-2').style.display = 'none';
			},
			
			handleKycFileUpload: function(event, type) {
				const file = event.target.files[0];
				if (!file) return;
				
				// 验证文件类型
				if (!file.type.startsWith('image/')) {
					vueInstance.$toast.warning(vueInstance.$t('common.uploadImageFile') || '请上传图片文件');
					return;
				}
				
				// 验证文件大小（最大5MB）
				if (file.size > 5 * 1024 * 1024) {
					vueInstance.$toast.warning(vueInstance.$t('common.imageSizeLimit') || '图片大小不能超过5MB');
					return;
				}
				
				// 显示上传中提示
				const uploadArea = document.getElementById(`kyc-upload-${type}`);
				if (uploadArea) {
					uploadArea.innerHTML = `
						<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
							<div style="width: 48px; height: 48px; border: 4px solid #dcdfe6; border-top-color: var(--primary-color, #0156DC); border-radius: 50%; animation: spin 0.8s linear infinite;"></div>
							<div style="margin-top: 10px; font-size: 14px; color: var(--text-secondary);">${vueInstance.$t('common.uploading') || '上传中...'}</div>
						</div>
					`;
				}
				
				// 上传图片
				const formData = new FormData();
				formData.append('file', file);
				
				// 调用上传API - 修改为正确的上传接口
				vueInstance.$http.post('/swx/customer/user/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(res => {
					if (res.code === 200 && res.url) {
						const imageUrl = res.url;  // 使用返回的url字段
						
						// 更新UI显示
						if (uploadArea) {
							uploadArea.innerHTML = `<img src="${imageUrl}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;">`;
						}
						
						// 存储图片URL
						if (!window.kycImageData) {
							window.kycImageData = {};
						}
						window.kycImageData[type] = imageUrl;
						
						vueInstance.$toast.success(vueInstance.$t('common.uploadSuccess') || '图片上传成功');
					} else {
						// 上传失败，恢复原始UI
						if (uploadArea) {
							uploadArea.innerHTML = `
								<svg viewBox="0 0 1024 1024" width="48" height="48" style="fill: #999; margin-bottom: 10px;">
									<path d="M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"/>
									<path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-13.1 64.6-36.9 88.6C829.7 674.6 798.3 688 764.6 688H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h44.4C874.5 764 960 674.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
								</svg>
								<div style="font-size: 14px; color: var(--text-secondary);">${vueInstance.$t('common.clickToUpload')}</div>
							`;
						}
						vueInstance.$toast.error(res.msg || vueInstance.$t('common.uploadFailed') || '图片上传失败');
					}
				}).catch(err => {
					console.error('❌ 图片上传失败:', err);
					// 上传失败，恢复原始UI
					if (uploadArea) {
						uploadArea.innerHTML = `
							<svg viewBox="0 0 1024 1024" width="48" height="48" style="fill: #999; margin-bottom: 10px;">
								<path d="M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"/>
								<path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-13.1 64.6-36.9 88.6C829.7 674.6 798.3 688 764.6 688H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h44.4C874.5 764 960 674.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
							</svg>
							<div style="font-size: 14px; color: var(--text-secondary);">${vueInstance.$t('common.clickToUpload')}</div>
						`;
					}
					vueInstance.$toast.error(vueInstance.$t('common.uploadFailed') || '图片上传失败');
				});
				
				// 清空input，允许重新选择同一文件
				event.target.value = '';
			},
			
			submitKyc: function() {
				
				// 验证是否已上传两张图片
				if (!window.kycImageData || !window.kycImageData.front || !window.kycImageData.back) {
					vueInstance.$toast.warning(vueInstance.$t('account.uploadIDPhotos') || '请上传证件正反面照片');
					return;
				}
				
				// 组装提交数据 - 使用与H5端相同的字段名
				const submitData = {
					...window.kycFormData,
					frontImg: window.kycImageData.front,    // 使用图片URL路径
					reverseImg: window.kycImageData.back,   // 使用图片URL路径
					idType: window.kycFormData.cardType     // 证件类型字段名
				};
				
				console.log('📤 提交KYC数据:', submitData);
				
				// 显示提交中提示
				const loadingMsg = vueInstance.$message({
					message: vueInstance.$t('common.submitting') || '提交中...',
					type: 'info',
					duration: 0
				});
				
				// 调用KYC认证API - 正确的接口
				vueInstance.$http.post('/swx/customer/user/identification', submitData).then(res => {
					loadingMsg.close();
					
					if (res.code === 200) {
						// 显示成功弹窗（使用公共组件）
						vueInstance.successMessage = vueInstance.$t('common.submitSuccess') || '提交成功';
						vueInstance.$refs.successModal.show();
						
						// 清除临时数据
						delete window.kycFormData;
						delete window.kycImageData;
						
						// 2秒后关闭弹窗并刷新
						setTimeout(() => {
							// 关闭弹窗
							vueInstance.$msgbox.close();
							
							// 刷新用户信息
							vueInstance.$store.dispatch('GET_USER_INFO');
						}, 2000);
					} else {
						vueInstance.$toast.error(res.message || res.msg || vueInstance.$t('common.submitFailed') || '提交失败');
					}
				}).catch(err => {
					loadingMsg.close();
					console.error('❌ KYC认证提交失败:', err);
					vueInstance.$toast.error(vueInstance.$t('common.submitFailed') || '提交失败，请稍后重试');
				});
			},
			
			switchTab: (tabName) => {
				// 隐藏所有内容面板
				document.querySelectorAll('.content-panel').forEach(panel => {
					panel.style.display = 'none';
				});
				// 显示选中的面板
				const targetPanel = document.getElementById(`content-${tabName}`);
				if (targetPanel) {
					targetPanel.style.display = 'block';
				}
				
			// 更新菜单样式
			document.querySelectorAll('.menu-item').forEach(item => {
				item.style.borderLeft = '3px solid transparent';
				item.style.background = 'transparent';
				item.style.color = '#333';
				item.style.fontWeight = 'normal';
				item.style.borderRadius = '0';
			});
			const activeItem = document.querySelector(`[data-tab="${tabName}"]`);
			if (activeItem) {
				activeItem.style.borderLeft = '3px solid var(--primary-color)';
				activeItem.style.background = 'var(--primary-color)';
				activeItem.style.color = 'white';
				activeItem.style.fontWeight = '500';
				activeItem.style.borderRadius = '15px';
			}
				
				// KYC特殊处理：切换到KYC时重置到第一步
				if (tabName === 'kyc') {
					const step1 = document.getElementById('kyc-step-1');
					const step2 = document.getElementById('kyc-step-2');
					if (step1 && step2) {
						step1.style.display = 'block';
						step2.style.display = 'none';
					}
					
					 // 检查用户KYC状态
					if (vueInstance.getUserInfo.idefinderStatus == 1) {
						// 已认证，显示提示
						if (targetPanel) {
							targetPanel.innerHTML = `
								<div style="text-align: center; padding: 60px 20px;">
									<svg viewBox="0 0 1024 1024" width="80" height="80" style="fill: var(--success-color); margin-bottom: 20px;">
										<path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"/>
									</svg>
									<h3 style="font-size: 20px; color: var(--text-primary); margin-bottom: 10px;">${vueInstance.$t('account.verified') || '已认证'}</h3>
								</div>
							`;
						}
					} else if (vueInstance.getUserInfo.idefinderStatus === 0) {
						// 审核中，显示提示
						if (targetPanel) {
							targetPanel.innerHTML = `
								<div style="text-align: center; padding: 60px 20px;">
									<svg viewBox="0 0 1024 1024" width="80" height="80" style="fill: var(--primary-color); margin-bottom: 20px;">
										<path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"/>
										<path d="M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"/>
									</svg>
									<h3 style="font-size: 20px; color: var(--text-primary); margin-bottom: 10px;">${vueInstance.$t('loan.pendingReview') || '审核中'}</h3>
								</div>
							`;
						}
					}
				}
				
			// 加载充值记录时也调用一次
			if (tabName === 'deposit') {
				setTimeout(() => {
					if (window.accountActions && window.accountActions.loadDepositHistory) {
						window.accountActions.loadDepositHistory();
					}
				}, 100);
			}
			
			// 加载提现记录时也调用一次
			if (tabName === 'withdraw') {
				setTimeout(() => {
					if (window.accountActions && window.accountActions.loadWithdrawHistory) {
						window.accountActions.loadWithdrawHistory();
					}
				}, 100);
			}
			},
			
			// 加载充值记录
			loadDepositHistory: async () => {
				const listContainer = document.getElementById('deposit-history-list');
				if (!listContainer) return;
				
				try {
					listContainer.innerHTML = '<div style="text-align: center; padding: 40px; color: #999;">加载中...</div>';
					
				const res = await vueInstance.$http.get('/swx/customer/user/listRecharge', {
					params: {
						pageNo: 1,
						pageSize: 500
					}
				});
				
				if (res.code === 200 && res.result && res.result.records && res.result.records.length > 0) {
					const records = res.result.records;
						
					const getStatusText = (status) => {
						switch(status) {
							case 0: return { text: vueInstance.$t('account.pending') || '待审核', color: 'var(--warning-color)' };
							case 1: return { text: vueInstance.$t('account.completed') || '已完成', color: 'var(--success-color)' };
							case 2: return { text: vueInstance.$t('account.rejected') || '已拒绝', color: 'var(--danger-color)' };
							default: return { text: vueInstance.$t('account.unknown') || '未知', color: 'var(--text-tertiary)' };
						}
					};
					
					listContainer.innerHTML = records.map(record => {
						const statusInfo = getStatusText(record.status);
						return `
							<div style="background: white; border-radius: 8px; padding: 15px; margin-bottom: 10px; border: 1px solid #e4e7ed; border-left: 3px solid ${statusInfo.color};">
								<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
									<div style="font-weight: 600; color: var(--text-primary); font-size: 15px;">${record.type || 'USDT'} ${vueInstance.$t('account.deposit') || '充值'}</div>
									<div style="padding: 3px 10px; background: ${statusInfo.color}20; color: ${statusInfo.color}; border-radius: 12px; font-size: 12px; font-weight: 500;">
										${statusInfo.text}
									</div>
								</div>
								<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; font-size: 13px; color: var(--text-secondary);">
									<div style="grid-column: 1 / -1;">
										<span style="color: #999;">${vueInstance.$t('account.depositCryptoQty') || '充值数量'}：</span>
										<span style="color: var(--text-primary); font-weight: 500;">${record.amount || 0} ${(record.type || 'USDT').trim()}</span>
									</div>
									<div style="grid-column: 1 / -1;">
										<span style="color: #999;">${vueInstance.$t('account.depositUsdtValue') || '折合 USDC'}：</span>
										<span style="color: var(--success-color); font-weight: 500;">${record.currency != null ? record.currency : '-'} USDC</span>
									</div>
									<div style="grid-column: 1 / -1;">
										<span style="color: #999;">${vueInstance.$t('account.depositAddress') || '充值地址'}：</span>
										<span style="color: var(--text-secondary); font-family: monospace; font-size: 12px; word-break: break-all;">${record.chargeAddress ? (record.chargeAddress.length > 35 ? record.chargeAddress.slice(0, 18) + '...' + record.chargeAddress.slice(-17) : record.chargeAddress) : '-'}</span>
									</div>
									<div style="grid-column: 1 / -1;">
										<span style="color: #999;">${vueInstance.$t('account.applyTime') || '申请时间'}：</span>
										<span style="color: var(--text-secondary);">${record.createTime || '-'}</span>
									</div>
									${record.updateTime && record.status !== 0 ? `
										<div style="grid-column: 1 / -1;">
											<span style="color: #999;">${vueInstance.$t('account.processTime') || '处理时间'}：</span>
											<span style="color: var(--text-secondary);">${record.updateTime}</span>
										</div>
									` : ''}
								</div>
							</div>
						`;
					}).join('');
					} else {
					listContainer.innerHTML = `
						<div style="text-align: center; padding: 60px 20px;">
							<svg viewBox="0 0 1024 1024" width="64" height="64" style="fill: #d9d9d9; margin-bottom: 15px;">
								<path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326z m1.8 562H232V136h302v216c0 23.2 18.8 42 42 42h216v494z"/>
							</svg>
							<p style="color: #999; font-size: 14px;">${vueInstance.$t('account.noDepositRecords') || '暂无充值记录'}</p>
						</div>
					`;
					}
				} catch (error) {
				console.error('加载充值记录失败:', error);
				listContainer.innerHTML = `
					<div style="text-align: center; padding: 40px 20px;">
						<p style="color: #f56c6c; font-size: 14px; margin-bottom: 10px;">${vueInstance.$t('account.loadFailed') || '加载失败'}</p>
						<button onclick="window.accountActions.loadDepositHistory()" style="padding: 8px 20px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 4px; cursor: pointer;">
							${vueInstance.$t('common.retry') || '重试'}
						</button>
					</div>
				`;
				}
			},
			
			// 加载提现记录
			loadWithdrawHistory: async () => {
				const listContainer = document.getElementById('withdraw-history-list');
				if (!listContainer) return;
				
				try {
					listContainer.innerHTML = '<div style="text-align: center; padding: 40px; color: #999;">加载中...</div>';
					
				const res = await vueInstance.$http.get('/swx/customer/user/listWithdrwal', {
					params: {
						pageNo: 1,
						pageSize: 500
					}
				});
				
				if (res.code === 200 && res.result && res.result.records && res.result.records.length > 0) {
					const records = res.result.records;
						
				const getStatusText = (status) => {
					switch(status) {
						case 0: return { text: vueInstance.$t('account.pending') || '待审核', color: 'var(--warning-color)' };
						case 1: return { text: vueInstance.$t('account.completed') || '已完成', color: 'var(--success-color)' };
						case 2: return { text: vueInstance.$t('account.rejected') || '已拒绝', color: 'var(--danger-color)' };
						default: return { text: vueInstance.$t('account.unknown') || '未知', color: 'var(--text-tertiary)' };
					}
				};
				
				listContainer.innerHTML = records.map(record => {
					const statusInfo = getStatusText(record.status);
					const actualAmount = (record.amount || 0) - (record.withdrawalFee || 0);
					return `
						<div style="background: white; border-radius: 8px; padding: 15px; margin-bottom: 10px; border: 1px solid #e4e7ed; border-left: 3px solid ${statusInfo.color};">
							<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
								<div style="font-weight: 600; color: var(--text-primary); font-size: 15px;">${record.type || 'USDT'} ${vueInstance.$t('account.withdraw') || '提现'}</div>
								<div style="padding: 3px 10px; background: ${statusInfo.color}20; color: ${statusInfo.color}; border-radius: 12px; font-size: 12px; font-weight: 500;">
									${statusInfo.text}
								</div>
							</div>
						<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; font-size: 13px; color: var(--text-secondary);">
							<div>
								<span style="color: #999;">${vueInstance.$t('account.withdrawAmount') || '提现金额'}：</span>
								<span style="color: var(--text-primary); font-weight: 500;">${record.amount || 0} USD</span>
							</div>
							<div>
								<span style="color: #999;">${vueInstance.$t('account.handlingFee') || '手续费'}：</span>
								<span style="color: var(--danger-color); font-weight: 500;">${record.withdrawalFee || 0} USD</span>
							</div>
							<div style="grid-column: 1 / -1;">
								<span style="color: #999;">${vueInstance.$t('account.receivedAmount') || '到账金额'}：</span>
								<span style="color: var(--success-color); font-weight: 500;">${actualAmount.toFixed(2)} USD</span>
							</div>
							<div style="grid-column: 1 / -1;">
								<span style="color: #999;">${vueInstance.$t('account.applyTime') || '申请时间'}：</span>
								<span style="color: var(--text-secondary);">${record.createTime || record.date || '-'}</span>
							</div>
							${record.reason ? `
								<div style="grid-column: 1 / -1; background: var(--danger-color)10; padding: 8px; border-radius: 4px; margin-top: 5px;">
									<span style="color: var(--danger-color); font-size: 12px;">${vueInstance.$t('account.rejectReason') || '拒绝原因'}：${record.reason}</span>
								</div>
							` : ''}
							${record.updateTime && record.status !== 0 ? `
								<div style="grid-column: 1 / -1;">
									<span style="color: #999;">${vueInstance.$t('account.processTime') || '处理时间'}：</span>
									<span style="color: var(--text-secondary);">${record.updateTime}</span>
								</div>
							` : ''}
						</div>
						</div>
					`;
				}).join('');
					} else {
				listContainer.innerHTML = `
					<div style="text-align: center; padding: 60px 20px;">
						<svg viewBox="0 0 1024 1024" width="64" height="64" style="fill: #d9d9d9; margin-bottom: 15px;">
							<path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326z m1.8 562H232V136h302v216c0 23.2 18.8 42 42 42h216v494z"/>
						</svg>
						<p style="color: #999; font-size: 14px;">${vueInstance.$t('account.noWithdrawRecords') || '暂无提现记录'}</p>
					</div>
				`;
					}
				} catch (error) {
			console.error('加载提现记录失败:', error);
			listContainer.innerHTML = `
				<div style="text-align: center; padding: 40px 20px;">
					<p style="color: #f56c6c; font-size: 14px; margin-bottom: 10px;">${vueInstance.$t('account.loadFailed') || '加载失败'}</p>
					<button onclick="window.accountActions.loadWithdrawHistory()" style="padding: 8px 20px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 4px; cursor: pointer;">
						${vueInstance.$t('common.retry') || '重试'}
					</button>
				</div>
			`;
				}
			}
		};
		
		// 调试：确认 window.accountActions 已创建
		// 显示弹窗
		this.$msgbox({
			title: this.getUserInfo.email || this.getUserInfo.phone || 'xiaotang88889999@gmail.com',
			message: accountInfoHtml,
			dangerouslyUseHTMLString: true,
			showCancelButton: false,
			showConfirmButton: false,
			customClass: 'account-popup-msgbox-large',
			beforeClose: (action, instance, done) => {
				delete window.accountActions;
				done();
			}
		}).then(() => {
		}).catch(() => {
		});
		
		// 弹窗显示后绑定菜单点击事件并设置宽度
		setTimeout(() => {
			// 设置弹窗宽度
			const msgbox = document.querySelector('.account-popup-msgbox-large');
			if (msgbox) {
				msgbox.style.width = '1200px';
				msgbox.style.maxWidth = '95vw';
			}
			
			const elMessageBox = document.querySelector('.account-popup-msgbox-large .el-message-box');
			if (elMessageBox) {
				elMessageBox.style.width = '1200px';
				elMessageBox.style.maxWidth = '95vw';
			}
			
			// 绑定菜单点击事件
			const menuItems = document.querySelectorAll('#account-menu .menu-item');
			menuItems.forEach(item => {
				const tabName = item.getAttribute('data-tab');
				if (tabName && tabName !== 'logout') {
					item.onclick = () => window.accountActions.switchTab(tabName);
				}
			});
		}, 100);
	},
		
		// 处理账户切换
		handleAccountSwitch(accountType) {
			// 可以在这里处理账户切换逻辑
			// 例如更新用户数据、刷新订单列表等
		},
		
	// 账户弹窗相关方法
	toggleAccountMenu() {
		this.showAccountMenu = !this.showAccountMenu;
	},
	
	switchAccount(type) {
		// 这里可以添加账户切换的逻辑
		// 例如：切换数据源、刷新订单列表等
	},
	
	goToProfile() {
		this.accountPopupVisible = false;
		this.$router.push('/profile');
	},
	
	// 显示理财弹窗
	async showFinancePopup() {
		// 使用新的Vue组件方式显示理财弹窗
		this.showFinanceDialog = true;
		// 加载理财产品列表
		await this.loadFinanceProducts();
		return; // 直接返回，不再执行下面的旧代码
		
		// ========== 以下为旧的DOM操作代码，已废弃 ==========
		// 检查是否有残留的弹窗和遮罩层
		const allMsgboxWrappers = document.querySelectorAll('.el-message-box__wrapper');
		const allModals = document.querySelectorAll('.v-modal');
		
		
		// 只清理残留元素（如果有的话）
		if (allMsgboxWrappers.length > 0 || allModals.length > 0) {
			allMsgboxWrappers.forEach(wrapper => {
				wrapper.remove();
			});
			allModals.forEach(modal => {
				modal.remove();
			});
			
			// 等待一小段时间，确保清理完成
			await new Promise(resolve => setTimeout(resolve, 100));
		} else {
		}
		
		// 加载理财产品列表
		//await this.loadFinanceProducts();
		
		// 创建理财弹窗HTML
		const financeHtml = `
			<div style="font-family: Arial, sans-serif; max-height: 600px; overflow-y: auto;">
				<!-- 标题和历史记录按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;padding-top: 20px">
					<div style="font-size: 20px; font-weight: bold;">
						${this.$t('Financial.title') || '理财产品'}
					</div>
					<button id="finance-history-btn" style="background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 6px; padding: 8px 16px; font-size: 14px; cursor: pointer; transition: all 0.3s;">
						${this.$t('Financial.records') || '历史记录'}
					</button>
				</div>
				
				<!-- 产品列表 -->
				<div id="finance-products-container" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 15px;">
					${this.financeProductList.map((item, index) => `
						<div class="finance-product-card" data-index="${index}" style="background: #f8f9fa; border-radius: 12px; padding: 20px; cursor: pointer; transition: all 0.3s; border: 1px solid #e8e8e8;">
							<div style="display: flex; align-items: center; margin-bottom: 15px;">
								<img src="${item.logo || this.defaultFinanceImage}" onerror="this.src='${this.defaultFinanceImage}'" style="width: 40px; height: 40px; margin-right: 12px; border-radius: 8px;" />
								<div style="font-size: 16px; font-weight: 600; color: var(--text-primary);">${item.name}</div>
							</div>
							<div style="display: flex; justify-content: space-between; margin-bottom: 15px;">
								<div>
									<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 5px;">${this.$t('Financial.subscriptionPrice') || '认购价格'}</div>
									<div style="font-size: 16px; font-weight: 600; color: var(--text-primary);">${item.min}-${item.max}</div>
								</div>
								<div>
									<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 5px;">${this.$t('Financial.yieldRate') || '收益率'}</div>
									<div style="font-size: 20px; font-weight: bold; color: var(--primary-color, #0156DC);">${item.rate}%</div>
								</div>
							</div>
							<button class="finance-buy-btn" data-index="${index}" style="width: 100%; height: 40px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.3s;">
								${this.$t('Financial.detail') || '查看详情'}
							</button>
						</div>
					`).join('')}
				</div>
				
				${this.financeProductList.length === 0 ? `
					<div style="text-align: center; padding: 40px; color: #999;">
						<div style="font-size: 48px; margin-bottom: 10px;">📊</div>
						<div>${this.$t('Financial.noProducts') || '暂无理财产品'}</div>
					</div>
				` : ''}
			</div>
		`;
		
		// 使用原生DOM创建弹窗
		// 创建完整的弹窗HTML（包含遮罩和容器）
		const popupHtml = `
			<div class="finance-popup" style="
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				z-index: 99999;
				display: flex;
				justify-content: center;
				align-items: center;
			">
				<div class="finance-popup-content" style="
					background: var(--card-bg);
	transition: background-color 0.3s ease;
					border-radius: 12px;
					padding: 30px;
					width: 90%;
					max-width: 900px;
					max-height: 85vh;
					overflow-y: auto;
					position: relative;
					box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
				">
					<!-- 关闭按钮 -->
					<button id="close-finance-popup" style="
						position: absolute;
						top: 15px;
						right: 15px;
						background: none;
						border: none;
						font-size: 28px;
						cursor: pointer;
						color: var(--text-tertiary);
	transition: color 0.3s ease;
						padding: 0;
						width: 30px;
						height: 30px;
						display: flex;
						align-items: center;
						justify-content: center;
						line-height: 1;
						z-index: 1;
					">×</button>
					
					${financeHtml}
				</div>
			</div>
		`;
		
		// 创建弹窗元素
		const popupElement = document.createElement('div');
		popupElement.innerHTML = popupHtml;
		const popup = popupElement.firstElementChild;
		
		// 添加到页面
		document.body.appendChild(popup);
		
		
		// 保存Vue实例引用
		const self = this;
		
		// 存储事件处理器引用以便清理
		let escHandler = null;
		let scrollHandler = null;
		let popupClickHandler = null;
		
		// 关闭弹窗的统一函数 - 包含事件监听器清理
		const closeFinancePopup = () => {
			// 移除ESC键监听器
			if (escHandler) {
				document.removeEventListener('keydown', escHandler);
				escHandler = null;
			}
			// 移除滚动监听器
			if (scrollHandler && scrollContainer) {
				scrollContainer.removeEventListener('wheel', scrollHandler);
				scrollHandler = null;
			}
			// 移除popup点击监听器
			if (popupClickHandler) {
				popup.removeEventListener('click', popupClickHandler);
				popupClickHandler = null;
			}
			// 移除弹窗
			if (popup && popup.parentNode) {
				document.body.removeChild(popup);
			}
		};
		// 添加关闭按钮事件
		const closeBtn = popup.querySelector('#close-finance-popup');
		if (closeBtn) {
			closeBtn.addEventListener('click', closeFinancePopup);
		}
		
		// 添加点击背景关闭事件
		popupClickHandler = (e) => {
			if (e.target === popup) {
				closeFinancePopup();
			}
		};
		popup.addEventListener('click', popupClickHandler);
		
		// 添加ESC键关闭事件
		escHandler = (e) => {
			if (e.key === 'Escape') {
				closeFinancePopup();
			}
		};
		document.addEventListener('keydown', escHandler);
		
		// 阻止滚动穿透 - 找到实际的滚动容器
		const scrollContainer = popup.querySelector('div[style*="max-height: 600px"]');
		if (scrollContainer) {
			
			// 阻止滚动事件穿透到背景，但允许内部正常滚动
			scrollHandler = (e) => {
				// 检查是否到达滚动边界
				const atTop = scrollContainer.scrollTop === 0;
				const atBottom = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight;
				
				// 只有在边界时才阻止默认行为，否则允许正常滚动
				if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
					e.preventDefault();
					e.stopPropagation();
				}
				// 内部滚动时不阻止，只阻止穿透到背景
			};
			scrollContainer.addEventListener('wheel', scrollHandler, { passive: false });
		} else {
		}
		
		// 添加事件监听
		// 历史记录按钮点击事件
		const historyBtn = popup.querySelector('#finance-history-btn');
		if (historyBtn) {
			historyBtn.addEventListener('click', () => {
				// 先关闭当前弹窗
				closeFinancePopup();
				// 延迟显示历史记录
				setTimeout(() => {
					self.showFinanceHistory();
				}, 100);
			});
			
			historyBtn.addEventListener('mouseenter', function() {
				this.style.background = '#0052cc';
				this.style.transform = 'translateY(-1px)';
			});
			historyBtn.addEventListener('mouseleave', function() {
				this.style.background = 'var(--primary-color)';
				this.style.transform = 'translateY(0)';
			});
		}
		
		// 产品卡片悬停效果
		const cards = popup.querySelectorAll('.finance-product-card');
		cards.forEach(card => {
			card.addEventListener('mouseenter', function() {
				this.style.transform = 'translateY(-4px)';
				this.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
			});
			card.addEventListener('mouseleave', function() {
				this.style.transform = 'translateY(0)';
				this.style.boxShadow = 'none';
			});
		});
		
		// 详情按钮点击事件
		const buyBtns = popup.querySelectorAll('.finance-buy-btn');
		buyBtns.forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.stopPropagation();
				const index = parseInt(btn.getAttribute('data-index'));
				const product = self.financeProductList[index];
				// 先关闭当前弹窗
				closeFinancePopup();
				// 延迟显示详情
				setTimeout(() => {
					self.showFinanceDetail(product);
				}, 100);
			});
			
			btn.addEventListener('mouseenter', function() {
				this.style.background = '#0052cc';
				this.style.transform = 'translateY(-2px)';
			});
			btn.addEventListener('mouseleave', function() {
				this.style.background = 'var(--primary-color)';
				this.style.transform = 'translateY(0)';
			});
		});
		
	},
	
		// 加载理财产品列表
		async loadFinanceProducts() {
			try {
				this.financeLoading = true;
				
				// 调用固定 ID 获取智能交易产品配置（对标 H5 版本）
				const response = await this.$http.get('/swx/customer/index/getMarketInfo/1733912542293639169');
			
			
			if (response && response.code === 200 && response.result) {
				const result = response.result;
				
				// 解析 smartInfo 配置
				if (result.smartInfo && result.smartInfo.smartInfo) {
					const smartInfoArray = JSON.parse(result.smartInfo.smartInfo);
					
				// 将配置列表转换为产品列表
				this.financeProductList = smartInfoArray.map((config, index) => ({
					id: `smart_${index}`,
					smartIndex: index,
					marketId: result.smartInfo.id,
					name: config.name,
					days: config.days,
					rate: config.rate,
					min: config.min,
					max: config.max,
					type: config.type ?? 0,
					smartId: config.id,
					logo: config.logo  // 从 smartInfo 中获取 logo
				}));
					
				} else {
					this.financeProductList = [];
					this.$toast.warning(this.$t('Financial.noProducts') || '暂无理财产品');
				}
			} else {
				this.financeProductList = [];
				this.$toast.error(this.$t('Financial.loadError') || '加载失败');
			}
		} catch (error) {
			console.error('❌ 加载理财产品失败:', error);
			this.$toast.error(this.$t('Financial.loadError') || '加载失败');
			this.financeProductList = [];
		} finally {
			this.financeLoading = false;
		}
	},
	
	// 处理理财产品购买 - 新组件方式
	async handleFinancePurchase(data) {
		console.log('💰 收到购买请求:', data);
		
		const { product, amount } = data;
		
		console.log('📦 产品信息:', product);
		console.log('💵 购买金额:', amount);
		
		// 检查登录状态
		if (!this.isUserLoggedIn) {
			this.showLoginModal();
			return;
		}
		
		try {
			// 使用正确的API接口和参数（对标H5版本）
			const params = {
				marketId: String(product.marketId),
				allDay: String(product.days),
				amount: String(amount),
				rate: String(product.rate),
				type: String(product.type || 0),
				smartId: String(product.smartId)
			};
			
			console.log('📤 发送参数:', params);
			
			// 调用购买接口
			const response = await this.$http.post('/swx/customer/order/buySmart', params);
			
			console.log('📥 API响应:', response);
			
		// 兼容 code 为字符串或数字的情况
		if (response && (response.code === 200 || response.code === '200')) {
			console.log('✅ 购买成功！');
			
			// 使用 SuccessModal 组件显示成功提示
			this.successMessage = this.$t('Financial.purchaseSuccess') || '理财产品购买成功！';
			this.$refs.successModal.show();
			
			// 刷新用户余额
			this.getInfo();
			
			// 关闭理财弹窗
			this.showFinanceDialog = false;
		} else {
			// 只有在明确失败时才显示错误提示
			console.error('❌ 购买失败，响应:', response);
			// 删除错误提示，因为成功的弹窗已经显示了
			// this.$toast.error(response.msg || this.$t('Financial.purchaseError') || '购买失败');
		}
	} catch (error) {
		console.error('❌ 购买理财产品失败:', error);
		// 只在真正出错时显示
		// this.$toast.error(this.$t('Financial.purchaseError') || '购买失败，请稍后重试');
		}
	},
	
	// 显示贷款弹窗
	showLoanPopup() {
		// 显示贷款弹窗而不是路由跳转
		this.showLoanDialog = true;
	},
	
	// 显示划转弹窗
	showTransferPopup() {
		// 显示划转弹窗
		this.showTransferDialog = true;
	},
	
	// 划转成功回调
	handleTransferSuccess() {
		// 刷新用户信息（余额）
		this.getUserInfoData();
	},
	
	// 显示关于我们弹窗
	showAboutPopup() {
		// 显示关于我们弹窗
		this.showAboutDialog = true;
	},
	
	// 显示理财产品详情弹窗
	showFinanceDetail(item) {
		
		// 关闭原生DOM理财弹窗
		const financePopup = document.querySelector('.finance-popup');
		if (financePopup && financePopup.parentNode) {
			financePopup.parentNode.removeChild(financePopup);
		}
		
		// 关闭Element UI弹窗（如果有）
		const msgboxWrapper = document.querySelector('.el-message-box__wrapper');
		if (msgboxWrapper) {
			msgboxWrapper.remove();
		}
		
		// 清除所有遮罩层
		const allModals = document.querySelectorAll('.v-modal');
		if (allModals.length > 0) {
			allModals.forEach(modal => modal.remove());
		}
		
		// 设置选中的产品
		this.selectedFinanceProduct = item;
		
		// 延迟显示详情弹窗，确保主弹窗完全关闭
		setTimeout(() => {
			this.showFinanceDetailPopup(item);
		}, 200);
	},
	
	// 显示详情弹窗的具体实现 - 使用原生DOM
	showFinanceDetailPopup(item) {
		
		// 创建详情弹窗HTML - 使用原生DOM
		const detailContentHtml = `
			<div style="font-family: Arial, sans-serif; max-width: 500px;">
				<!-- 产品标题 -->
				<div style="font-size: 24px; font-weight: bold; margin-bottom: 20px; text-align: center; color: var(--text-primary);">
					${item.name}
				</div>
				
				<!-- 产品信息 -->
				<div style="background: #f8f9fa; border-radius: 12px; padding: 20px; margin-bottom: 20px;">
					<div style="display: flex; justify-content: space-between; margin-bottom: 15px;">
						<div>
							<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 5px;">${this.$t('Financial.subscriptionPrice') || '认购价格'}</div>
							<div style="font-size: 18px; font-weight: 600; color: var(--text-primary);">$${item.min} - $${item.max}</div>
						</div>
						<div>
							<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 5px;">${this.$t('Financial.yieldRate') || '收益率'}</div>
							<div style="font-size: 24px; font-weight: bold; color: var(--primary-color, #0156DC);">${item.rate}%</div>
						</div>
					</div>
					<div style="display: flex; justify-content: space-between; margin-bottom: 15px;">
						<div>
							<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 5px;">${this.$t('Financial.duration') || '投资期限'}</div>
							<div style="font-size: 16px; font-weight: 600; color: var(--text-primary);">${item.days} ${this.$t('Financial.days') || '天'}</div>
						</div>
					<div>
						<div style="font-size: 14px; color: var(--text-secondary); margin-bottom: 5px;">${this.$t('Financial.type') || '产品类型'}</div>
						<div style="font-size: 16px; font-weight: 600; color: var(--text-primary);">${item.name}</div>
					</div>
					</div>
				</div>
				
				<!-- 产品描述 -->
				<div style="margin-bottom: 20px;">
					<div style="font-size: 16px; font-weight: 600; margin-bottom: 10px; color: var(--text-primary);">${this.$t('Financial.description') || '产品描述'}</div>
					<div style="font-size: 14px; color: var(--text-secondary); line-height: 1.6;">
						${this.$t('Financial.descriptionText') || '这是一个智能理财产品，通过算法自动交易，为您提供稳定的收益。'}
					</div>
				</div>
				
				<!-- 购买金额输入 -->
				<div style="margin-bottom: 20px;">
					<div style="font-size: 16px; font-weight: 600; margin-bottom: 10px; color: var(--text-primary);">
						${this.$t('Financial.purchaseAmount') || '购买金额'}
					</div>
					<div style="position: relative;">
						<input 
							id="finance-amount-input" 
							type="number" 
							placeholder="${this.$t('Financial.enterAmount') || '请输入购买金额'}"
							style="
								width: 100%;
								height: 50px;
								padding: 0 60px 0 50px;
								border: 2px solid #e0e0e0;
								border-radius: 8px;
								font-size: 16px;
								outline: none;
								transition: all 0.3s;
								box-sizing: border-box;
							"
							min="${item.min}"
							max="${item.max}"
						/>
						<span style="
							position: absolute;
							left: 20px;
							top: 50%;
							transform: translateY(-50%);
							font-size: 18px;
							font-weight: 600;
							color: var(--text-secondary);
	transition: color 0.3s ease;
						">$</span>
						<button 
							id="finance-max-btn"
							style="
								position: absolute;
								right: 10px;
								top: 50%;
								transform: translateY(-50%);
								background: var(--primary-color, #0156DC);
								color: white;
								border: none;
								border-radius: 6px;
								padding: 6px 12px;
								font-size: 12px;
								cursor: pointer;
								transition: all 0.2s;
							"
						>
							${this.$t('Financial.max') || '最大'}
						</button>
					</div>
					<div style="display: flex; justify-content: space-between; margin-top: 8px; font-size: 12px; color: #999;">
						<span>${this.$t('Financial.minAmount') || '最小'}: $${item.min}</span>
						<span>${this.$t('Financial.maxAmount') || '最大'}: $${item.max}</span>
					</div>
					<div id="amount-error-message" style="
						color: #ff4d4f;
						font-size: 13px;
						margin-top: 8px;
						display: none;
						animation: shake 0.3s;
					"></div>
				</div>
				
				<!-- 操作按钮 -->
				<div style="display: flex; gap: 10px;">
					<button id="finance-buy-now-btn" style="flex: 1; height: 45px; background: var(--primary-color, #0156DC); color: white; border: none; border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.3s;">
						${this.$t('Financial.buyNow') || '立即购买'}
					</button>
					<button id="finance-cancel-btn" style="flex: 1; height: 45px; background: #f5f5f5; color: var(--text-secondary); border: 1px solid #ddd; border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.3s;">
						${this.$t('common.cancel') || '取消'}
					</button>
				</div>
			</div>
		`;
		
		// 创建完整的弹窗HTML（包含遮罩和容器）
		const popupHtml = `
			<div class="finance-detail-popup" style="
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				z-index: 99999;
				display: flex;
				justify-content: center;
				align-items: center;
			">
				<div class="finance-detail-content" style="
					background: var(--card-bg);
	transition: background-color 0.3s ease;
					border-radius: 12px;
					padding: 30px;
					max-width: 550px;
					max-height: 85vh;
					overflow-y: auto;
					position: relative;
					box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
				">
					<!-- 关闭按钮 -->
					<button id="close-detail-popup" style="
						position: absolute;
						top: 15px;
						right: 15px;
						background: none;
						border: none;
						font-size: 28px;
						cursor: pointer;
						color: var(--text-tertiary);
	transition: color 0.3s ease;
						padding: 0;
						width: 30px;
						height: 30px;
						display: flex;
						align-items: center;
						justify-content: center;
						line-height: 1;
					">×</button>
					
					${detailContentHtml}
				</div>
			</div>
		`;
		// 创建弹窗元素
		const popupElement = document.createElement('div');
		popupElement.innerHTML = popupHtml;
		const popup = popupElement.firstElementChild;
		
		// 添加到页面
		document.body.appendChild(popup);
		
		
		// 保存Vue实例引用
		const vueInstance = this;
		
		// 存储事件处理器引用以便清理
		let escHandler = null;
		let popupClickHandler = null;
		
		// 关闭弹窗的统一函数 - 包含事件监听器清理
		const closeDetailPopup = () => {
			// 移除ESC键监听器
			if (escHandler) {
				document.removeEventListener('keydown', escHandler);
				escHandler = null;
			}
			// 移除popup点击监听器
			if (popupClickHandler) {
				popup.removeEventListener('click', popupClickHandler);
				popupClickHandler = null;
			}
			// 移除弹窗
			if (popup && popup.parentNode) {
				document.body.removeChild(popup);
			}
		};
		
		// 添加关闭按钮事件
		const closeBtn = popup.querySelector('#close-detail-popup');
		if (closeBtn) {
			closeBtn.addEventListener('click', closeDetailPopup);
		}
		
		// 添加点击背景关闭事件
		popupClickHandler = (e) => {
			if (e.target === popup) {
				closeDetailPopup();
			}
		};
		popup.addEventListener('click', popupClickHandler);
		
		// 添加ESC键关闭事件
		escHandler = (e) => {
			if (e.key === 'Escape') {
				closeDetailPopup();
			}
		};
		document.addEventListener('keydown', escHandler);
		
		// 金额输入框验证逻辑
		const amountInput = popup.querySelector('#finance-amount-input');
		const errorMessage = popup.querySelector('#amount-error-message');
		const maxBtn = popup.querySelector('#finance-max-btn');
		
		// 验证金额函数
		const validateAmount = (amount) => {
			const num = parseFloat(amount);
			
			if (!amount || amount.trim() === '') {
				errorMessage.textContent = vueInstance.$t('Financial.errorEmpty') || '请输入购买金额';
				errorMessage.style.display = 'block';
				return false;
			}
			
			if (isNaN(num) || num <= 0) {
				errorMessage.textContent = vueInstance.$t('Financial.errorInvalid') || '请输入有效的金额';
				errorMessage.style.display = 'block';
				return false;
			}
			
			if (num < item.min) {
				errorMessage.textContent = (vueInstance.$t('Financial.errorMinAmount') || '购买金额不能小于 ${min}').replace('${min}', '$' + item.min);
				errorMessage.style.display = 'block';
				return false;
			}
			
			if (num > item.max) {
				errorMessage.textContent = (vueInstance.$t('Financial.errorMaxAmount') || '购买金额不能大于 ${max}').replace('${max}', '$' + item.max);
				errorMessage.style.display = 'block';
				return false;
			}
			
			errorMessage.style.display = 'none';
			return true;
		};
		
		// 输入框焦点效果
		if (amountInput) {
			amountInput.addEventListener('focus', () => {
				amountInput.style.borderColor = 'var(--primary-color)';
				amountInput.style.boxShadow = '0 0 0 3px rgba(58, 105, 250, 0.1)';
			});
			
			amountInput.addEventListener('blur', () => {
				amountInput.style.borderColor = '#e0e0e0';
				amountInput.style.boxShadow = 'none';
			});
			
			// 输入时实时验证
			amountInput.addEventListener('input', () => {
				if (amountInput.value) {
					validateAmount(amountInput.value);
				} else {
					errorMessage.style.display = 'none';
				}
			});
		}
		
		// 最大金额按钮
		if (maxBtn) {
			maxBtn.addEventListener('mouseenter', () => {
				const primaryDark = getComputedStyle(document.documentElement).getPropertyValue('--primary-dark').trim() || '#689F38';
				maxBtn.style.background = primaryDark;
			});
			maxBtn.addEventListener('mouseleave', () => {
				maxBtn.style.background = 'var(--primary-color)';
			});
			maxBtn.addEventListener('click', () => {
				if (amountInput) {
					amountInput.value = item.max;
					validateAmount(item.max.toString());
				}
			});
		}
		
		// 立即购买按钮
		const buyNowBtn = popup.querySelector('#finance-buy-now-btn');
		if (buyNowBtn) {
			buyNowBtn.addEventListener('click', () => {
				const amount = amountInput ? amountInput.value : '';
				
				// 验证金额
				if (!validateAmount(amount)) {
					// 验证失败，输入框添加错误样式
					if (amountInput) {
						amountInput.style.borderColor = '#ff4d4f';
						amountInput.style.animation = 'shake 0.3s';
						setTimeout(() => {
							amountInput.style.animation = '';
						}, 300);
						amountInput.focus();
					}
					return;
				}
				
				// 验证成功，传递金额信息
				const purchaseData = {
					...item,
					purchaseAmount: parseFloat(amount)
				};
				vueInstance.handleFinancePurchaseOld(purchaseData);
				closeDetailPopup();
			});
			
			buyNowBtn.addEventListener('mouseenter', function() {
				const primaryDark = getComputedStyle(document.documentElement).getPropertyValue('--primary-dark').trim() || '#689F38';
				this.style.background = primaryDark;
				this.style.transform = 'translateY(-2px)';
			});
			buyNowBtn.addEventListener('mouseleave', function() {
				this.style.background = 'var(--primary-color)';
				this.style.transform = 'translateY(0)';
			});
		}
		
		// 取消按钮
		const cancelBtn = popup.querySelector('#finance-cancel-btn');
		if (cancelBtn) {
			cancelBtn.addEventListener('click', () => {
				closeDetailPopup();
			});
			
			cancelBtn.addEventListener('mouseenter', function() {
				this.style.background = '#e8e8e8';
				this.style.borderColor = '#ccc';
			});
			cancelBtn.addEventListener('mouseleave', function() {
				this.style.background = '#f5f5f5';
				this.style.borderColor = '#ddd';
			});
		}
		
	},
	
	// 加载理财历史记录
	async loadFinanceHistory() {
		try {
			this.financeHistoryLoading = true;
			// 调用API获取历史记录（对标H5版本）
			const response = await this.$http.get('/swx/customer/order/listSmartOrder', {
				params: {
					pageNo: 1,
					pageSize: 20
				}
			});
			
			
			if (response && response.code === 200) {
				let orderList = [];
				
				// 解析响应数据（对标H5版本）
				if (response.result) {
					if (response.result.records) {
						orderList = response.result.records;
					} else if (response.result.list) {
						orderList = response.result.list;
					} else if (Array.isArray(response.result)) {
						orderList = response.result;
					}
				}
				
				
			// 转换为显示格式
			this.financeHistoryList = orderList.map(order => ({
				id: order.id,
				productName: order.smartName || order.productName || 'Bond-i',
				date: this.formatOrderTime(order.buyTime || order.createTime),
				amount: order.amount,
				profit: order.allProfit || order.currentProfit || this.calculateOrderProfit(order),
				currentProfit: order.currentProfit || order.allProfit || this.calculateOrderProfit(order),
				rate: parseFloat(order.rate) || 0,
				days: order.allDay,
				status: order.status,
				createTime: order.buyTime || order.createTime,
				// 保留原始数据以便后续使用
				rawOrder: order
			}));
				
			} else {
				this.financeHistoryList = [];
			}
		} catch (error) {
			console.error('❌ 加载理财历史记录失败:', error);
			this.financeHistoryList = [];
		} finally {
			this.financeHistoryLoading = false;
		}
	},
	
	// 格式化订单时间
	formatOrderTime(timestamp) {
		if (!timestamp) return '--';
		const date = new Date(timestamp);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		return `${year}-${month}-${day} ${hours}:${minutes}`;
	},

	// 统一的时间轴标签格式化函数
	formatKLineTimeLabel(value, index, dates, period) {
		if (!value) return '';

		// 处理多种时间格式
		let month, day, timeStr;

		// 处理 "2025-10-25 07:05" 或 "2025-10-25 07:05:30" 格式（带连字符）
		if (typeof value === 'string' && value.includes('-')) {
			const parts = value.split(' ');
			if (parts.length >= 2) {
				const datePart = parts[0]; // "2025-10-25"
				timeStr = parts[1].trim(); // "07:05" 或 "07:05:30"
				
				// 如果是完整时间格式（带秒），截取到分钟
				if (timeStr.length > 5) {
					timeStr = timeStr.substring(0, 5);
				}
				
				// 解析日期部分
				const dateComponents = datePart.split('-');
				if (dateComponents.length === 3) {
					month = dateComponents[1]; // "10"
					day = dateComponents[2]; // "25"
				}
			}
		}
		// 处理 "20251008 10:15" 或 "20251008 10:00:00" 格式（无连字符）
		else if (typeof value === 'string' && value.length >= 13) {
			const dateStr = value.substring(0, 8); // "20251008"
			timeStr = value.substring(9).trim(); // "10:15" 或 "10:00:00"
			
			// 如果是完整时间格式（带秒），截取到分钟
			if (timeStr.length > 5) {
				timeStr = timeStr.substring(0, 5);
			}

			// 格式化日期部分
			month = dateStr.substring(4, 6);
			day = dateStr.substring(6, 8);
		}

		// 如果成功解析出日期和时间，根据时间周期决定显示格式
		if (month && day && timeStr) {
			switch (period) {
				case '1D':
					// 日线: 只显示月-日
					return `${month}-${day}`;
					
				case '1W':
					// 周线: 显示月-日
					return `${month}-${day}`;
					
				case '1Mon':
					// 月线: 显示月-日
					return `${month}-${day}`;
					
				case '1H':
					// 1小时: 显示月-日 时:分
					return `${month}-${day} ${timeStr}`;
					
				case '30M':
					// 30分钟: 只显示时:分
					return timeStr;
					
				case '15M':
					// 15分钟: 只显示时:分
					return timeStr;
					
				case '5M':
					// 5分钟: 只显示时:分
					return timeStr;
					
				case '1M':
					// 1分钟: 只显示时:分
					return timeStr;
					
				default:
					// 默认情况：显示时:分
					return timeStr;
			}
		}

		// 如果格式不匹配，直接返回原值
		return value;
	},
	
	// 计算订单收益
	calculateOrderProfit(order) {
		if (!order.amount || !order.rate || !order.allDay) return 0;
		return (order.amount * order.rate * order.allDay / 100).toFixed(2);
	},
	
	// 获取理财状态颜色
	getFinanceStatusColor(status) {
		// status = 0: 进行中, status = 1: 已完成
		const colorMap = {
			0: 'var(--success-color)', // 进行中 - 绿色
			1: 'var(--text-tertiary)'   // 已完成 - 灰色
		};
		return colorMap[status] || 'var(--text-tertiary)';
	},
	
	// 获取理财状态文本
	getFinanceStatusText(status) {
		// status = 0: 进行中, status = 1: 已完成
		const statusTextMap = {
			0: this.$t('Financial.statusActive') || '进行中',
			1: this.$t('Financial.statusCompleted') || '已完成'
		};
		return statusTextMap[status] || (this.$t('Financial.statusUnknown') || '未知');
	},
	
	// 显示理财历史记录
	async showFinanceHistory() {
		
		// 关闭原生DOM理财弹窗
		const financePopup = document.querySelector('.finance-popup');
		if (financePopup && financePopup.parentNode) {
			financePopup.parentNode.removeChild(financePopup);
		}
		
		// 关闭Element UI弹窗（如果有）
		const msgboxWrapper = document.querySelector('.el-message-box__wrapper');
		if (msgboxWrapper) {
			msgboxWrapper.remove();
		}
		
		// 清除所有遮罩层
		const allModals = document.querySelectorAll('.v-modal');
		if (allModals.length > 0) {
			allModals.forEach(modal => modal.remove());
		}
		
		// 先加载历史记录数据
		await this.loadFinanceHistory();
		
		// 延迟显示历史记录弹窗，确保主弹窗完全关闭
		setTimeout(() => {
			this.showHistoryPopup();
		}, 200);
	},
	
	// 显示历史记录弹窗的具体实现
	showHistoryPopup() {
		// 创建历史记录弹窗HTML - 表格样式
		const historyHtml = `
			<div style="font-family: Arial, sans-serif;">
				<!-- 历史记录表格 -->
				<div id="finance-history-list" style="padding: 0; overflow-x: auto;">
					${this.financeHistoryList.length > 0 ? `
						<table style="
							width: 100%;
							border-collapse: collapse;
							background: var(--card-bg);
	transition: background-color 0.3s ease;
							border-radius: 8px;
							overflow: hidden;
						">
							<thead>
								<tr style="background: #f5f5f5;">
									<th style="padding: 12px 16px; text-align: left; font-size: 14px; font-weight: 600; color: var(--text-secondary); border-bottom: 1px solid #e8e8e8;">${this.$t('Financial.productName') || '产品名称'}</th>
									<th style="padding: 12px 16px; text-align: right; font-size: 14px; font-weight: 600; color: var(--text-secondary); border-bottom: 1px solid #e8e8e8;">${this.$t('Financial.amount') || '金额'}</th>
									<th style="padding: 12px 16px; text-align: center; font-size: 14px; font-weight: 600; color: var(--text-secondary); border-bottom: 1px solid #e8e8e8;">${this.$t('Financial.investmentPeriod') || '投资周期'}</th>
									<th style="padding: 12px 16px; text-align: center; font-size: 14px; font-weight: 600; color: var(--text-secondary); border-bottom: 1px solid #e8e8e8;">${this.$t('Financial.dailyRate') || '日利率'}</th>
									<th style="padding: 12px 16px; text-align: right; font-size: 14px; font-weight: 600; color: var(--text-secondary); border-bottom: 1px solid #e8e8e8;">${this.$t('Financial.currentProfit') || '当期利润'}</th>
									<th style="padding: 12px 16px; text-align: left; font-size: 14px; font-weight: 600; color: var(--text-secondary); border-bottom: 1px solid #e8e8e8;">${this.$t('Financial.purchaseTime') || '购买时间'}</th>
									<th style="padding: 12px 16px; text-align: center; font-size: 14px; font-weight: 600; color: var(--text-secondary); border-bottom: 1px solid #e8e8e8;">${this.$t('Financial.status') || '状态'}</th>
								</tr>
							</thead>
							<tbody>
								${this.financeHistoryList.map((record, index) => {
									// 确保使用正确的字段
									const currentProfit = record.profit || record.currentProfit || '0.00';
									const statusText = record.status === 0 ? (this.$t('Financial.statusActive') || '进行中') : (this.$t('Financial.statusCompleted') || '已完成');
									const statusColor = record.status === 0 ? 'var(--primary-color)' : 'var(--success-color)';
									const statusBg = record.status === 0 ? 'var(--primary-color-10)' : 'var(--success-color)15';
									
									return `
										<tr style="border-bottom: 1px solid #f0f0f0; transition: background 0.2s;" onmouseover="this.style.background='#fafafa'" onmouseout="this.style.background='white'">
											<td style="padding: 14px 16px; font-size: 14px; color: var(--text-primary); text-align: left; font-weight: 600;">${record.productName || 'Bond-i'}</td>
											<td style="padding: 14px 16px; font-size: 14px; color: var(--text-primary); text-align: right; font-weight: 500;">${parseFloat(record.amount).toFixed(2)}</td>
											<td style="padding: 14px 16px; font-size: 14px; color: var(--text-secondary); text-align: center;">${record.days || 0} ${this.$t('Financial.days') || '天'}</td>
											<td style="padding: 14px 16px; font-size: 14px; color: var(--text-primary); text-align: center; font-weight: 500;">${record.rate || 0}%</td>
											<td style="padding: 14px 16px; font-size: 14px; color: var(--success-color); text-align: right; font-weight: 600;">${parseFloat(currentProfit).toFixed(2)}</td>
											<td style="padding: 14px 16px; font-size: 14px; color: var(--text-secondary); text-align: left;">${record.date || '--'}</td>
											<td style="padding: 14px 16px; font-size: 14px; text-align: center;">
												<span style="
													display: inline-block;
													padding: 4px 12px;
													border-radius: 4px;
													font-size: 13px;
													font-weight: 500;
													background: ${statusBg};
													color: ${statusColor};
												">
													${statusText}
												</span>
											</td>
										</tr>
									`;
								}).join('')}
							</tbody>
						</table>
					` : `
						<div style="text-align: center; padding: 80px 20px;">
							<svg style="width: 80px; height: 80px; opacity: 0.5; margin-bottom: 20px;" viewBox="0 0 1024 1024">
								<path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326z m1.8 562H232V136h302v216c0 23.2 18.8 42 42 42h216v494z" fill="#d9d9d9"/>
								<path d="M312 560h400v64H312z m0 152h400v64H312z m0-304h200v64H312z" fill="#d9d9d9"/>
							</svg>
							<p style="font-size: 15.5px; color: #999;">${this.$t('Financial.noRecords') || '暂无投资记录'}</p>
						</div>
					`}
				</div>
			</div>
		`;
		
		// 显示历史记录弹窗
		// 使用原生DOM创建弹窗
		// 创建弹窗HTML - 优化简洁版
		const popupHtml = `
			<div class="finance-history-popup" style="
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.4);
				z-index: 99999;
				display: flex;
				justify-content: center;
				align-items: center;
			">
				<div class="finance-history-content" style="
					background: #fff;
					border-radius: 8px;
					padding: 0;
					width: 90%;
					max-width: 1100px;
					max-height: 80vh;
					overflow: hidden;
					position: relative;
					box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
				">
					<!-- 导航栏 -->
					<div class="finance-history-header" style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 14px 18px;
						background: #fff;
						border-bottom: 1px solid #f0f0f0;
						position: sticky;
						top: 0;
						z-index: 100;
					">
						<div style="width: 24px;"></div>
						<h3 style="margin: 0; font-size: 16px; font-weight: 600; color: var(--text-primary);">${this.$t('Financial.records') || '投资记录'}</h3>
						<button id="close-history-popup" style="
							background: none;
							border: none;
							font-size: 24px;
							cursor: pointer;
							color: var(--text-secondary);
	transition: color 0.3s ease;
							padding: 0;
							width: 24px;
							height: 24px;
							display: flex;
							align-items: center;
							justify-content: center;
							line-height: 1;
							transition: color 0.2s;
						" onmouseover="this.style.color='#333'" onmouseout="this.style.color='#666'">×</button>
					</div>
					
					<!-- 内容区域 -->
					<div class="finance-history-body" style="
						padding: 10px;
						max-height: calc(80vh - 50px);
						overflow-y: auto;
						background: var(--bg-secondary);
					">
						${historyHtml}
					</div>
				</div>
			</div>
		`;
		
		// 创建弹窗元素
		const popupElement = document.createElement('div');
		popupElement.innerHTML = popupHtml;
		const popup = popupElement.firstElementChild;
		
		// 添加到页面
		document.body.appendChild(popup);
		
		
		// 保存Vue实例引用
		const vueInstance = this;
		
		// 存储事件处理器引用以便清理
		let escHandler = null;
		let popupClickHandler = null;
		let wheelHandler = null;
		let touchHandler = null;
		
		// 关闭弹窗的统一函数 - 包含事件监听器清理
		const closeHistoryPopup = () => {
			
			// 移除ESC键监听器
			if (escHandler) {
				document.removeEventListener('keydown', escHandler);
				escHandler = null;
			}
			
			// 移除popup点击监听器
			if (popupClickHandler) {
				popup.removeEventListener('click', popupClickHandler);
				popupClickHandler = null;
			}
			
			// 移除滚动监听器
			const historyBody = popup.querySelector('.finance-history-body');
			if (wheelHandler && historyBody) {
				historyBody.removeEventListener('wheel', wheelHandler);
				wheelHandler = null;
			}
			if (touchHandler && historyBody) {
				historyBody.removeEventListener('touchmove', touchHandler);
				touchHandler = null;
			}
			
			// 移除弹窗
			if (popup && popup.parentNode) {
				document.body.removeChild(popup);
			}
			
			// 清除可能残留的遮罩层
			const modalBackdrop = document.querySelector('.v-modal');
			if (modalBackdrop) {
				modalBackdrop.remove();
			}
		};
		
		// 添加关闭事件
		const closeBtn = popup.querySelector('#close-history-popup');
		if (closeBtn) {
			closeBtn.addEventListener('click', closeHistoryPopup);
		}
		
		// 添加点击背景关闭事件
		popupClickHandler = (e) => {
			if (e.target === popup) {
				closeHistoryPopup();
			}
		};
		popup.addEventListener('click', popupClickHandler);
		
		// 添加ESC键关闭事件
		escHandler = (e) => {
			if (e.key === 'Escape') {
				closeHistoryPopup();
			}
		};
		document.addEventListener('keydown', escHandler);
		// 阻止滚动穿透 - 找到滚动容器并阻止事件冒泡
		const historyBody = popup.querySelector('.finance-history-body');
		if (historyBody) {
			
			// 阻止滚动事件穿透到背景
			wheelHandler = (e) => {
				e.stopPropagation();
				
				// 检查是否到达滚动边界
				const atTop = historyBody.scrollTop === 0;
				const atBottom = historyBody.scrollTop + historyBody.clientHeight >= historyBody.scrollHeight;
				
				// 如果在边界且继续滚动，则阻止默认行为
				if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
					e.preventDefault();
				}
			};
			historyBody.addEventListener('wheel', wheelHandler, { passive: false });
			
			// 阻止触摸滚动穿透（移动端）
			touchHandler = (e) => {
				e.stopPropagation();
			};
			historyBody.addEventListener('touchmove', touchHandler, { passive: true });
		}
		
		
	},
	
	// 处理理财购买 - 旧方法（废弃，保留用于旧的DOM弹窗）
	async handleFinancePurchaseOld(item) {
		
		// 1. 检查登录状态
		if (!this.isUserLoggedIn) {
			this.showLoginModal();
			return;
		}
		
		try {
			// 2. 调用真实的购买API（对标H5版本）
			const params = {
				marketId: item.marketId,           // 字符串
				allDay: String(item.days),         // 字符串
				amount: String(item.purchaseAmount || item.min),  // 使用用户输入的金额或默认最小金额
				rate: String(item.rate),           // 字符串
				type: String(item.type || 0),      // 字符串
				smartId: String(item.smartId)      // 字符串
			};
			
			console.log('📤 发送购买参数:', params);
			
			// 调用购买接口
			const response = await this.$http.post('/swx/customer/order/buySmart', params);
			
			console.log('📥 购买响应:', response);
			
			// 兼容 code 为字符串或数字的情况
			if (response && (response.code === '200' || response.code === 200)) {
				console.log('✅ 购买成功！');
				
				// 使用 SuccessModal 组件显示成功提示
				this.successMessage = this.$t('Financial.purchaseSuccess') || '理财产品购买成功！';
				this.$refs.successModal.show();
				
				// 刷新用户余额
				this.$store.dispatch('GET_USER_INFO');
				
				// 清理弹窗和遮罩层
				this.cleanupAfterPurchase();
				
			} else {
			console.error('❌ 购买失败，响应:', response);
			// 删除错误提示，因为成功的弹窗已经显示了
			// const errorMessage = this.getFinanceErrorMessage(response.message, response.code);
			// this.$toast.error(errorMessage);
			}
		} catch (error) {
			console.error('❌ 购买理财产品失败:', error);
		// 只在控制台记录错误，不显示错误提示
		// const errorMessage = this.getFinanceErrorMessage(error.message);
		// this.$toast.error(errorMessage);
		}
	},
	
	// 获取理财产品错误的国际化提示
	getFinanceErrorMessage(message, code) {
		// 错误消息映射表
		const errorMap = {
			'超过购买产品次数': 'Financial.errorExceedPurchaseLimit',
			'余额不足': 'Financial.errorInsufficientBalance',
			'产品已下架': 'Financial.errorProductOffline',
			'产品不存在': 'Financial.errorProductNotExist',
			'购买金额不符合要求': 'Financial.errorInvalidAmount',
			'系统繁忙': 'Financial.errorSystemBusy',
			'请先完成实名认证': 'Financial.errorRequireKYC'
		};
		
		// 查找匹配的错误消息
		for (const [key, i18nKey] of Object.entries(errorMap)) {
			if (message && message.includes(key)) {
				return this.$t(i18nKey);
			}
		}
		
		// 如果没有匹配的，返回原始消息或默认错误提示
		return message || this.$t('Financial.purchaseError') || '认购失败';
	},
	
	// 购买后清理弹窗和遮罩层
	cleanupAfterPurchase() {
		
		// 1. 关闭原生DOM弹窗（详情弹窗）
		const detailPopup = document.querySelector('.finance-detail-popup');
		if (detailPopup && detailPopup.parentNode) {
			detailPopup.parentNode.removeChild(detailPopup);
		}
		
		// 2. 关闭Element UI弹窗（如果有）
		const msgboxWrapper = document.querySelector('.el-message-box__wrapper');
		if (msgboxWrapper) {
			msgboxWrapper.remove();
		}
		
		// 3. 清除所有遮罩层
		const allModals = document.querySelectorAll('.v-modal');
		allModals.forEach(modal => {
			modal.remove();
		});
		
		
		// 刷新用户金额
		this.$store.dispatch('GET_USER_INFO');
	},
	
	goToDeposit() {
			// 跳转到入金页面
			this.$router.push('/profile/balance');
			this.accountPopupVisible = false;
		},
		
		goToWithdraw() {
		// 跳转到出金页面
		this.$router.push('/profile/balance');
		this.accountPopupVisible = false;
	},
	
	fallbackCopyInviteLink(text) {
		// 降级方案：使用传统的 textarea 复制方法
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();
		
		try {
			const successful = document.execCommand('copy');
			if (successful) {
				this.$toast.success(this.$t('account.inviteLinkCopied'));
			} else {
				this.$toast.error(this.$t('account.copyFailed'));
			}
		} catch (err) {
			this.$toast.error(this.$t('account.copyFailed'));
		}
		
		document.body.removeChild(textarea);
	},
	async confirmLogout() {
	// 先关闭个人中心弹窗，避免遮挡确认对话框
	this.accountCenterVisible = false;
	
	// 等待一小段时间确保弹窗关闭动画完成
	await this.$nextTick();
	
		// 确认退出登录（Vant Dialog）
		try {
			await Dialog.confirm({
				title: this.$t('account.logoutConfirmTitle') || '提示',
				message: this.$t('account.logoutConfirmMessage') || '是否退出登录',
				confirmButtonText: this.$t('account.confirm') || '确定',
				cancelButtonText: this.$t('account.cancel') || '取消',
			});
			// 执行退出登录逻辑
			await this.$store.dispatch('loginOut');
			this.$toast.success(this.$t('account.logoutSuccess') || '已退出登錄');
		} catch (error) {
		// 用户取消退出，重新打开个人中心弹窗
		this.accountCenterVisible = true;
		}
	},
		
		// 获取订单类型显示文本
		getOrderTypeDisplay(orderType) {
				const typeMap = {
					'contract': this.$t('Trading.contractOrder') || '合约',
					'option': this.$t('Trading.binaryOrder') || '期权',
					'options': this.$t('Trading.binaryOrder') || '期权',
					'binary': this.$t('Trading.binaryOrder') || '期权',
					'spot': this.$t('Trading.spotOrder') || '现货',
					'future': this.$t('Trading.futureOrder') || '期货',
					'swap': this.$t('Trading.swapOrder') || '掉期',
					'margin': this.$t('Trading.marginOrder') || '杠杆',
					'合约': this.$t('Trading.contractOrder') || '合约',
					'期权': this.$t('Trading.binaryOrder') || '期权',
					'现货': this.$t('Trading.spotOrder') || '现货',
					'期货': this.$t('Trading.futureOrder') || '期货',
					'掉期': this.$t('Trading.swapOrder') || '掉期',
					'杠杆': this.$t('Trading.marginOrder') || '杠杆'
				};
				return typeMap[orderType] || orderType || this.$t('Trading.unknownOrder') || '未知';
			},

			// 检查点击频率限制
			checkClickLimit() {
				const now = Date.now();
				if (now - this.lastClickTime < this.clickLimitTime) {
					this.$toast.warning(this.$t('Trading.clickTooFast') || '点击过于频繁，请稍后再试');
					return false;
				}
				this.lastClickTime = now;
				return true;
			},

		// 初始化基础配置 - 不依赖任何异步数据
		initBasicConfig() {
			// 初始化导航列表（支持国际化）
			this.updateNavsList();

		},

			// 确保WebSocket连接正常工作
			ensureWebSocketConnection() {

				// 检查store中的WebSocket连接状态
				if (!this.$store.state.marketWsList || this.$store.state.marketWsList.length === 0) {
					// 重新建立WebSocket连接
					this.$store.dispatch("GET_WS_MARKET").then((res) => {
					}).catch((err) => {
						console.error('❌ WebSocket重新连接失败:', err);
					});
				} else {
				}
			},

			// 在所有数据加载完成后初始化图表
			initAllChartsAfterDataLoaded() {

				// 延迟一点时间确保DOM完全渲染
				setTimeout(() => {
					// 1. 初始化市场列表的小图表
					if (this.marketList && this.marketList.length > 0) {
						this.initAllMarketCharts();
					}

					// 2. 初始化交易界面的主图表
					if (this.selectedStock && this.showTradingInterface) {
						setTimeout(() => {
							this.updateTradingChart();
						}, 300);
					}

					// 3. 额外的保险措施：检查并重试失败的图表
					setTimeout(() => {
						this.checkAndRetryChartInit();
					}, 1000);
				}, 200);
			},

			// 基本界面初始化（用于出错时的降级处理）
			initBasicInterface() {
				// 初始化空的筛选列表
				this.filteredMarketList = [];

			// 初始化导航列表
			this.updateNavsList();

			// 设置默认选中的股票（如果有的话）
			if (this.marketList && this.marketList.length > 0) {
				this.selectedStock = this.marketList[0];
				// 获取第一个币种的详细信息，包括合约配置
				if (this.selectedStock.id) {
					this.getMarketInfoById(this.selectedStock.id);
				}
			}

		},

			// 处理页面可见性变化
			handleVisibilityChange() {
				if (document.visibilityState === 'visible') {

					// 页面重新可见时，检查关键数据是否存在
					const hasMarketData = this.marketList && this.marketList.length > 0;
					const hasWebSocketData = this.$store.state.marketWsList && this.$store.state.marketWsList.length > 0;

					if (!hasMarketData) {
						this.reloadAllData();
					} else if (!hasWebSocketData) {
						this.ensureWebSocketConnection();
					} else {
					}
				}
			},

			// 处理父组件mounted事件 - 解决页面刷新时子组件不执行mounted的问题
			async handleParentMounted() {
				// 如果子组件还没有mounted或者没有初始化，则执行初始化
				if (!this.isMounted || !this.isInitialized) {
					this.isMounted = true;
					await this.executeFullInitialization();
					this.isInitialized = true;
				} else {
				}
			},
			// 执行完整的初始化流程 - 用于页面刷新后的初始化
			async executeFullInitialization() {

				try {
					// 1. 首先初始化基础配置
					this.initBasicConfig();

				// 2. 获取市场数据
				const success = await this.getListMarketByType();

				if (success && this.marketList && this.marketList.length > 0) {

					// 3. 检查交易状态
					await this.checkAllTradingTimes();
					
					// 启动定时器每分钟更新交易状态
					if (this.tradingStatusTimer) {
						clearInterval(this.tradingStatusTimer);
					}
					this.tradingStatusTimer = setInterval(() => {
						this.checkAllTradingTimes();
					}, 60000);

					// 4. 初始化交易界面
					this.initTradingInterface();

					// 5. 初始化筛选列表
					this.filteredMarketList = [...this.marketList];

						// 5. 初始化订单数据
				await this.initOrderData();

						// 6. 检查默认选中品种的期权配置
						if (this.selectedStock && this.selectedStock.id) {
							await this.getMarketOptionsInfo(this.selectedStock.id);
						}

						// 7. 确保WebSocket连接
						this.ensureWebSocketConnection();

						// 7. 强制更新DOM并初始化图表
				this.$nextTick(() => {
							this.initAllChartsAfterDataLoaded();
						});

					} else {
						this.initBasicInterface();
					}
			} catch (error) {
					console.error('❌ 完整初始化流程执行失败:', error);
					this.initBasicInterface();
				}
			},

	// 判断是否为买入方向（买涨/买多）
	// 支持多种数据格式：type数字、type_name字符串、direction数字
	isBuyDirection(row) {
		// 优先使用数字类型判断
		// type: 0=买涨/买入, 1=买跌/卖出
		if (row.type !== undefined && row.type !== null) {
			return row.type === 0 || row.type === '0';
		}
		// direction: 0=买入, 1=卖出（与type相反）
		if (row.direction !== undefined && row.direction !== null) {
			return row.direction === 0 || row.direction === '0';
		}
		// 兼容后端返回的中文字符串（不推荐但需要兼容）
		if (row.type_name) {
			const buyTypes = ['买涨', '买入', 'Buy', 'Buy Up', 'Long'];
			return buyTypes.includes(row.type_name);
		}
		// 默认返回false
		return false;
	},

	// 获取订单的实时价格（从marketWsList获取）
	getRealTimePrice(order) {
		if (!order) return '-';
		
		// 获取订单的交易对代码（优先使用marketName）
		const symbol = order.marketName || order.symbol || order.marketCode;
		if (!symbol) {
			const price = order.current_price || order.update_price;
			return price ? parseFloat(price).toFixed(2) : '-';
		}
		
		// 从 marketWsList 中查找对应的实时价格
		if (this.marketWsList && this.marketWsList.length > 0) {
			const marketData = this.marketWsList.find(item => 
				item.code === symbol || 
				item.marketCode === symbol || 
				item.marketName === symbol
			);
			
			// 如果找到实时数据，返回实时价格（保留2位小数）
			if (marketData && marketData.price) {
				return parseFloat(marketData.price).toFixed(2);
			}
		}
		
		// 备用：返回订单中保存的价格（保留2位小数）
		const price = order.current_price || order.update_price || order.sellPrice;
		return price ? parseFloat(price).toFixed(2) : '-';
		},
			
			// 更新导航标签列表（支持语言切换）
			updateNavsList() {
				// 合约订单选项卡
				this.navsList = [
					this.$t('Trading.positions') || '持仓',
					this.$t('Trading.pendingOrders') || '挂单',
					this.$t('Trading.history') || '历史'
				];
				// 期权订单选项卡
				this.optionsNavsList = [
					this.$t('Trading.holding') || '交易中',
					this.$t('Trading.closed') || '已平仓'
				];
			},
			
			// 显示登录弹窗
			showLoginModal() {
				this.showLoginDialog = true;
				this.showRegisterDialog = false;
				this.showForgotDialog = false;
			},
			
			// 显示注册弹窗
			showRegisterModal() {
				this.showRegisterDialog = true;
				this.showLoginDialog = false;
				this.showForgotDialog = false;
			},
			
			// 处理登录
		async handleLogin() {
			if (!this.loginForm.userName) {
				this.$toast.error(this.$t('login.enterEmail') || '请输入邮箱');
				return;
			}
			if (!this.loginForm.password) {
				this.$toast.error(this.$t('toast.password') || '请输入密码');
				return;
			}
			
			try {
				const res = await this.$store.dispatch('login', this.loginForm);
				if (res.code == '200') {
					this.$toast.success(this.$t('login.loginSuccess') || '登录成功');
					this.showLoginDialog = false;
					
					// 登录成功后的数据刷新
					await this.afterLoginSuccess();
				} else {
					this.$toast.error(this.$t(res.message) || res.message);
				}
			} catch (error) {
				console.error('登录失败:', error);
				this.$toast.error(this.$t('login.loginFailed') || '登录失败');
			}
		},
		
		// 登录成功后的处理
		async afterLoginSuccess() {
			try {
				// 1. 等待一小段时间确保 localStorage 已更新
				await new Promise(resolve => setTimeout(resolve, 100));
				
				// 2. 获取用户信息
				await this.$store.dispatch('GET_USER_INFO');
				// 3. 立即强制更新UI，确保右侧面板显示
				this.$forceUpdate();
				
				// 4. 刷新订单数据
				await this.loadTabData(this.tabIndex);
				
				// 5. 再次强制更新UI，确保订单数据显示
				await this.$nextTick();
				this.$forceUpdate();
			} catch (error) {
				console.error('❌ 登录后数据刷新失败:', error);
			}
		},
			
			// 创建模拟账户（原Dapp登录）
			async handleDappLogin() {
				try {
					// 直接创建模拟账户
					const res = await this.$http.post('/swx/customer/login/createDemoAccount');
					
					if (res.code == '200' || res.code == 200) {
						// 保存登录信息
						localStorage.setItem('token', res.result.token);
						localStorage.setItem('userInfo', JSON.stringify(res.result));
						localStorage.setItem('isLogin', true);
						this.$store.commit('setToken', res.result.token);
						this.$store.commit('set_isLogin', true);
						this.$store.commit('set_userInfo', res.result);
						
						// 提示用户
						this.$toast.success(this.$t('login.loginSuccess') || '登录成功');
						
						// 关闭登录弹窗
						this.showLoginDialog = false;
						
						// 登录成功后的数据刷新
						await this.afterLoginSuccess();
					} else {
						this.$toast.error(res.message || '创建模拟账户失败');
					}
				} catch (error) {
					console.error('创建模拟账户失败:', error);
					this.$toast.error('创建模拟账户失败，请稍后重试');
				}
			},
			
			// 选择注册方式
			selectRegisterMethod(method) {
				this.registerForm.registerMethod = method;
				// 清空对应的输入框
				if (method === 'email') {
					this.registerForm.phone = '';
				} else {
					this.registerForm.email = '';
				}
			},
			
			// 处理注册
			async handleRegister() {
				// 验证表单
				const isPhone = this.registerForm.registerMethod === 'phone';
				
				// 验证用户名
				if (!this.registerForm.userName) {
					this.$toast.error(this.$t('toast.userName') || '请输入用户名');
					return;
				}
				
				if (isPhone) {
					if (!this.registerForm.phone) {
						this.$toast.error(this.$t('login.qingShuRuShouJiHao') || '请输入手机号');
						return;
					}
				} else {
					if (!this.registerForm.email) {
						this.$toast.error(this.$t('login.qingShuRuYouXiang') || '请输入邮箱');
						return;
					}
				}
				
				if (!this.registerForm.password) {
					this.$toast.error(this.$t('toast.password') || '请输入密码');
					return;
				}
				
				if (this.registerForm.password !== this.registerForm.rePassword) {
					this.$toast.error(this.$t('account.passwordMismatch') || '两次密码不一致');
					return;
				}
				
				if (!this.registerForm.code) {
					this.$toast.error(this.$t('login.enterVerificationCode') || '请输入验证码');
					return;
				}
				
				try {
					// 构建注册参数 - 完全对标手机端逻辑
					const registerData = {
						userName: this.registerForm.userName, // 用户名
						phone: isPhone ? this.registerForm.phone : this.registerForm.email, // 手机号或邮箱
						password: this.registerForm.password,
						rePaossword: this.registerForm.rePassword, // 注意：后端使用 rePaossword（拼写错误但需保持一致）
						code: this.registerForm.code,
						invetedUser: this.registerForm.invitationCode || '', // 注意：后端使用 invetedUser
						ip: '', // 可以留空或获取真实IP
						isPhone: isPhone,
						zipCode: isPhone ? this.registerForm.zipCode : '+852' // 手机注册传区号，邮箱注册传默认值
					};
					
					console.log('📤 PC端注册参数:', registerData);
					
					const res = await this.$http.post('/swx/customer/login/register', registerData);
					
				if (res.code == '200' || res.code == 200) {
					this.$toast.success(this.$t('login.registerSuccess') || '注册成功');
					
					// 切换到登录弹窗
					this.showRegisterDialog = false;
					this.showLoginDialog = true;
					
					// 清空注册表单
					this.registerForm = {
						registerMethod: 'email',
						userName: '',
						email: '',
						phone: '',
						zipCode: '+852',
						password: '',
						rePassword: '',
						invitationCode: '',
						code: ''
					};
				} else {
					// 尝试翻译错误消息（如果是错误码如10091等）
					const msg = res.message || res.msg || '注册失败';
					const translatedMsg = this.$t(msg) !== msg ? this.$t(msg) : msg;
					this.$toast.error(translatedMsg);
				}
			} catch (error) {
				console.error('❌ 注册失败:', error);
				// 尝试翻译错误消息
				const errorMsg = error.message || error.msg || '注册失败';
				const translatedErrorMsg = this.$t(errorMsg) !== errorMsg ? this.$t(errorMsg) : errorMsg;
				this.$toast.error(translatedErrorMsg);
			}
			},
			
			// 发送验证码
			async sendVerificationCode() {
				// 如果正在倒计时，直接返回
				if (this.registerCodeCountdown) {
					return;
				}
				
				// 验证输入
				if (this.registerForm.registerMethod === 'email') {
					if (!this.registerForm.email) {
						this.$toast.error(this.$t('login.qingShuRuYouXiang') || '请输入邮箱');
						return;
					}
				} else {
					if (!this.registerForm.phone) {
						this.$toast.error(this.$t('login.qingShuRuShouJiHao') || '请输入手机号');
						return;
					}
				}
				
				try {
					const isPhone = this.registerForm.registerMethod === 'phone';
					
					// 构建请求参数 - 对标手机端逻辑
					const requestData = {
						email: isPhone ? this.registerForm.phone : this.registerForm.email, // 手机号或邮箱
						type: this.$i18n.locale === 'zh-CN' ? 'cn' : 'en',
						zipCode: isPhone ? this.registerForm.zipCode : '+852', // 手机注册传区号，邮箱注册传默认值
						isPhone: isPhone
					};
					
					console.log('📤 发送验证码参数:', requestData);
					
			const res = await this.$http.post('/swx/customer/login/sendCode', requestData);
			
			if (res.code == '200' || res.code == 200) {
				this.$toast.success(this.$t('login.yanZhengMaYiFaSong') || '验证码已发送');
				
				// 开始倒计时
				this.startRegisterCodeCountdown();
			} else if (res.code == 10089 || res.code == '10089' || res.message == '10089' || res.message == 10089) {
				// 验证码已发送，请稍后再试
				this.$toast.warning(this.$t('10089') || '验证码已发送，请稍后再试');
				// 开始倒计时
				this.startRegisterCodeCountdown();
			} else {
				// 检查message是否是错误码
				const msg = res.message || res.msg || '发送失败';
				const translatedMsg = this.$t(msg) !== msg ? this.$t(msg) : msg;
				this.$toast.error(translatedMsg);
			}
		} catch (error) {
			console.error('❌ 发送验证码失败:', error);
			// 捕获错误时也检查是否为10089
			if (error.code == 10089 || error.code == '10089' || error.message == '10089' || error.message == 10089) {
				this.$toast.warning(this.$t('10089') || '验证码已发送，请稍后再试');
				this.startRegisterCodeCountdown();
			} else {
				this.$toast.error(this.$t('login.faSongShiBai') || '发送失败');
			}
		}
			},
			
			// 开始注册验证码倒计时
			startRegisterCodeCountdown() {
				this.registerCodeCountdown = true;
				this.registerCodeTime = 60;
				
				this.registerCodeTimer = setInterval(() => {
					this.registerCodeTime--;
					if (this.registerCodeTime <= 0) {
						clearInterval(this.registerCodeTimer);
						this.registerCodeTimer = null;
						this.registerCodeCountdown = false;
						this.registerCodeTime = 60;
					}
				}, 1000);
			},
			// 发送重置密码验证码
			async sendResetCode() {
				if (!this.forgotForm.email) {
					this.$toast.error(this.$t('login.qingShuRuYouXiang') || '请输入邮箱');
					return;
				}
				
		try {
			const res = await this.$http.post('/swx/customer/login/sendCode', {
				email: this.forgotForm.email,
				type: this.$i18n.locale === 'zh-CN' ? 'cn' : 'en',
				zipCode: '+852',
				isPhone: false
			});
			
			if (res.code == '200' || res.code == 200) {
				this.$toast.success(this.$t('login.yanZhengMaYiFaSong') || '验证码已发送');
			} else if (res.code == 10089 || res.code == '10089' || res.message == '10089' || res.message == 10089) {
				// 验证码已发送，请稍后再试
				this.$toast.warning(this.$t('10089') || '验证码已发送，请稍后再试');
			} else {
				const msg = res.message || res.msg || '发送失败';
				const translatedMsg = this.$t(msg) !== msg ? this.$t(msg) : msg;
				this.$toast.error(translatedMsg);
			}
		} catch (error) {
			console.error('发送验证码失败:', error);
			// 捕获错误时也检查是否为10089
			if (error.code == 10089 || error.code == '10089' || error.message == '10089' || error.message == 10089) {
				this.$toast.warning(this.$t('10089') || '验证码已发送，请稍后再试');
			} else {
				this.$toast.error(this.$t('login.faSongShiBai') || '发送失败');
			}
		}
			},
			
			// 处理重置密码
			async handleResetPassword() {
				if (!this.forgotForm.email) {
					this.$toast.error(this.$t('login.qingShuRuYouXiang') || '请输入邮箱');
					return;
				}
				if (!this.forgotForm.newPassword) {
					this.$toast.error(this.$t('toast.password') || '请输入新密码');
					return;
				}
				if (this.forgotForm.newPassword !== this.forgotForm.rePassword) {
					this.$toast.error(this.$t('account.passwordMismatch') || '两次密码不一致');
					return;
				}
				if (!this.forgotForm.code) {
					this.$toast.error(this.$t('login.enterVerificationCode') || '请输入验证码');
					return;
				}
				
				try {
					const res = await this.$http.post('/swx/customer/user/resetPassword', {
						email: this.forgotForm.email,
						password: this.forgotForm.newPassword,
						code: this.forgotForm.code
					});
					
					if (res.code == '200') {
						this.$toast.success(this.$t('login.passwordResetSuccess') || '密码重置成功');
						// 切换到登录弹窗
						this.showForgotDialog = false;
						this.showLoginDialog = true;
						// 清空表单
						this.forgotForm = {
							email: '',
							newPassword: '',
							rePassword: '',
							code: ''
						};
					} else {
						this.$toast.error(this.$t(res.message) || res.message);
					}
				} catch (error) {
					console.error('重置密码失败:', error);
					this.$toast.error(this.$t('login.resetFailed') || '重置失败');
				}
		},

		// 重新初始化所有图表 - 解决路由切换后图表不显示的问题
			reinitializeCharts() {
				// 等待DOM完全渲染
				this.$nextTick(() => {
					// 重新初始化首页小图表 - 使用统一的批量初始化方法
					if (this.marketList && this.marketList.length > 0) {
						// 延迟一点时间确保DOM完全渲染
						setTimeout(() => {
							this.initAllMarketCharts();
						}, 200);
					}

					// 重新初始化交易图表
					if (this.selectedStock && this.showTradingInterface) {
						setTimeout(() => {
							this.updateTradingChart();
						}, 500);
					}
				});
			},

			// 清理所有图表实例
			clearAllCharts() {
				// 清理首页小图表
				if (this.marketList && this.marketList.length > 0) {
					this.marketList.forEach(item => {
						const dom = document.getElementById(item.code);
						if (dom && this.$echarts) {
							this.$echarts.dispose(dom);
						}
					});
				}

				// 清理交易图表
				if (this.chartInstance) {
					this.chartInstance.dispose();
					this.chartInstance = null;
				}

				if (this.tradingChart) {
					this.tradingChart.dispose();
					this.tradingChart = null;
				}
			},

			// 安全的图表初始化方法 - 带重试机制
			safeInitChart(code, delay = 0) {
				setTimeout(() => {
					const dom = document.getElementById(code);
					if (dom && this.chartData[code]) {
						this.chartInit(code);
					} else {
						// 重试机制：如果DOM不存在，延迟重试
						if (!dom && delay < 2000) {
							this.safeInitChart(code, delay + 200);
						}
					}
				}, delay);
			},

			// 批量初始化所有市场图表 - 优化版本：只初始化默认选中的
			initAllMarketCharts() {
				if (!this.marketList || this.marketList.length === 0) {
					return;
				}

				// 只初始化第一个（默认选中的）
				if (this.selectedStock) {
					const code = this.selectedStock.code;
					setTimeout(() => {
						this.initChartOnDemand(code);
					}, 200);
				}
			},

			// 检查并重试图表初始化 - 额外的保险措施
			// ✅ 优化：只检查默认选中的图表，不再检查所有图表
			checkAndRetryChartInit() {
				if (!this.marketList || this.marketList.length === 0) {
					return;
				}

				// ✅ 只检查第一个（默认选中的）图表
				const firstStock = this.marketList[0];
				if (!firstStock) return;

				const code = firstStock.code;
				const dom = document.getElementById(code);

				// 如果DOM存在且有数据，但还没初始化，则初始化
				if (dom && this.chartData[code] && !this.initializedCharts.has(code)) {
					this.initChartOnDemand(code);
				}
			},

			// 🚀 按需初始化单个图表 - 只在选择交易对时初始化
			initChartOnDemand(code) {
				// 如果已经初始化过，跳过
				if (this.initializedCharts.has(code)) {
					return;
				}

				// 初始化重试计数器
				if (!this.chartRetryCount[code]) {
					this.chartRetryCount[code] = 0;
				}

				// 检查重试次数，超过5次则放弃
				const MAX_RETRIES = 5;
				if (this.chartRetryCount[code] >= MAX_RETRIES) {
					delete this.chartRetryCount[code];
					return;
				}

				// 延迟一点时间，等待DOM渲染完成
				this.$nextTick(() => {
					const dom = document.getElementById(code);
					if (!dom) {
						this.chartRetryCount[code]++;
						return;
					}

					const hasData = this.chartData[code] && this.chartData[code].length > 0;
					if (!hasData) {
						this.chartRetryCount[code]++;
						return;
					}

					const rect = dom.getBoundingClientRect();
					if (rect.width > 0 && rect.height > 0) {
						try {
							this.chartInit(code);
							this.initializedCharts.add(code);
							delete this.chartRetryCount[code];
						} catch (error) {
							this.chartRetryCount[code]++;
						}
					} else {
						// DOM 尺寸无效，延迟重试
						this.chartRetryCount[code]++;
						setTimeout(() => {
							this.initChartOnDemand(code);
						}, 200);
					}
				});
			},

			// 强制初始化所有图表 - 优化版本（只初始化第一个默认选中的）
			forceInitAllCharts() {
				// 清空之前的状态
				this.initializedCharts.clear();
				this.chartInitQueue = [];
				
				// 只初始化第一个（默认选中的）交易对图表
				if (this.marketList && this.marketList.length > 0) {
					const firstStock = this.marketList[0];
					
					// 延迟初始化，确保DOM已渲染
					setTimeout(() => {
						this.initChartOnDemand(firstStock.code);
					}, 300);
				}
			},

		// 订单管理方法 - 对标st5-pc
		changesTabs(index) {
			this.tabIndex = index;
			
			// 强制刷新：清除缓存
			this.allContractOrders = null;
			this.allOptionsOrders = null;
			
			// 切换选项卡时获取对应数据
			this.loadTabData(index);
		},

		// 根据选项卡加载对应数据
		async loadTabData(tabIndex, forceRefresh = false) {
			const orderType = this.mainOrderType;
			
			// 如果需要强制刷新，清除对应的缓存
			if (forceRefresh) {
				if (orderType === 'contract') {
					this.allContractOrders = null;
				} else {
					this.allOptionsOrders = null;
				}
			}
			
			try {
				if (orderType === 'contract') {
					// 合约订单
					switch(tabIndex) {
						case 0: // 持仓
							await this.getPositionData(forceRefresh);
							break;
						case 1: // 挂单
							await this.getPendingOrderData(forceRefresh);
							break;
						case 2: // 历史
							await this.getHistoryOrderData(forceRefresh);
							break;
					}
				} else {
					// 期权订单
					switch(tabIndex) {
						case 0: // 交易中
							await this.getOptionsPositionData(forceRefresh);
							break;
						case 1: // 已平仓
							await this.getOptionsHistoryData(forceRefresh);
							break;
					}
				}

				// 每次切换都更新盈亏汇总
				await this.getProfitSummary();

			} catch (error) {
				console.error(`❌ 加载选项卡数据失败: ${tabIndex}`, error);
			}
		},

			// 初始化订单数据
			async initOrderData() {
				
				// 检查登录状态
				const token = localStorage.getItem('token');
				const isLogin = localStorage.getItem('isLogin');
				const isLoggedIn = !!(token || isLogin === 'true' || isLogin === '1');
				
				if (!isLoggedIn) {
					return;
				}
				
				try {
					// 默认加载持仓数据
					await this.loadTabData(0);

					// 强制更新DOM以确保表格正确渲染
					this.$nextTick(() => {
					});
				} catch (error) {
					console.error('❌ 初始化订单数据失败:', error);
				}
			},

			// 修改止盈止损
			clicksTp() {
				// 这里可以打开修改止盈止损的弹窗
			},


		// 平仓操作
		showModalPC(row) {
			// 直接执行平仓操作，不需要确认弹窗
			this.closePosition(row);
		},
		// 平仓方法 - 支持合约和期权订单平仓
			async closePosition(order) {
				
				try {
					if (this.mainOrderType === 'contract') {
						// 合约订单使用 stopU 接口
						//console.log('📤 执行合约平仓操作:', order)
						//console.log('🔍 订单数据结构分析:', {
						// 	id: order.id,
						// 	symbol: order.symbol,
						// 	marketCode: order.marketCode,
						// 	marketName: order.marketName,
						// 	type: order.type,
						// 	direction: order.direction,
						// 	type_name: order.type_name,
						// 	allFields: Object.keys(order)
						// })
						
						// 判断订单方向：1=买多，0=卖空
						const orderType = order.type === 1 || order.type === '1' || 
						                 order.direction === 1 || order.direction === '1' ? 1 : 0
						
						const params = {
							id: order.id,
							symbol: order.symbol || order.marketCode || order.marketName || '-',
							type: orderType
						};
						const res = await stopU(params);
						
			if (res && res.code === 200) {
				// 平仓成功，从对应的持仓列表中移除
				if (this.mainOrderType === 'contract') {
					const index = this.contractIndexList.findIndex(item => item.id === order.id);
					if (index > -1) {
						this.contractIndexList.splice(index, 1);
					}
				} else {
					const index = this.optionsIndexList.findIndex(item => item.id === order.id);
					if (index > -1) {
						this.optionsIndexList.splice(index, 1);
					}
				}
				
			// 显示成功提示（使用公共组件）
			this.successMessage = this.$t('common.operationSuccess') || '操作成功';
			this.$refs.successModal.show();
			
			// ✅ 立即刷新余额显示
			if (this.$refs.tradingPanel) {
				this.$refs.tradingPanel.fetchAccountBalances();
			}
			if (this.$refs.orderManagement) {
				this.$refs.orderManagement.fetchAccountBalances();
			}
			
			// 刷新订单数据
			await this.refreshOrderData();
						} else {
							// 显示后端返回的具体错误信息
							const errorMsg = res.message || res.msg || this.$t('Trading.closePositionError') || '平仓失败';
							this.$toast.error(errorMsg);
							console.error('❌ 平仓失败 - 响应详情:', {
								code: res.code,
								message: res.message,
								msg: res.msg,
								result: res.result
							});
						}
					} else if (this.mainOrderType === 'options') {
						// 期权订单：期权订单通常不能手动平仓，只能等待到期
						// 但这里可以刷新数据，确保状态更新
						this.$toast.info(this.$t('Trading.optionsCannotClose') || '期权订单无法手动平仓，请等待到期');
						
						// 刷新订单数据
						await this.refreshOrderData();
					}
				} catch (error) {
					console.error('❌ 平仓异常 - 错误详情:', error);
					console.error('错误堆栈:', error.stack);
					
					// 提取更详细的错误信息
					let errorMsg = this.$t('Trading.closePositionError') || '平仓失败，请重试';
					if (error.response) {
						console.error('错误响应:', error.response);
						errorMsg = error.response.data?.message || error.response.data?.msg || errorMsg;
					}
					
					this.$toast.error(errorMsg);
				}
			},

			// 刷新订单数据 - 通用方法
			async refreshOrderData() {
				try {
					//console.log('🔄 开始刷新订单数据...');
					
					// 刷新用户余额（平仓后余额会变化）
					await this.$store.dispatch('GET_USER_INFO');
					
					// 清空缓存，强制重新从API获取最新数据
					if (this.mainOrderType === 'contract') {
						// 清空合约订单缓存
						this.allContractOrders = null;
						//console.log('🔄 重新获取合约订单数据...');
						await this.getAllContractOrders();
					}
					
					// 根据当前订单类型和标签页刷新数据
					//console.log('🔄 刷新当前标签页数据...');
					await this.loadTabData(this.tabIndex);
					
					// 刷新盈亏汇总
					//console.log('🔄 刷新盈亏汇总...');
					await this.getProfitSummary();
					
					// 强制更新视图
					this.$forceUpdate();
					
					//console.log('✅ 订单数据刷新完成');
				} catch (error) {
					console.error('❌ 刷新订单数据失败:', error);
				}
			},

	// 更新总盈亏（接收子组件传来的实时波动盈亏）- 只在持仓中tab使用
	updateTotalPnl(totalPnl) {
		// 子组件只在持仓中tab时发送这个事件，所以直接更新即可
		if (this.hylist) {
			this.hylist.yks = totalPnl
		}
	},

	// 撤销挂单 - 直接执行，显示简洁的成功提示
	async cancelPendingOrder(order) {
		try {
			// 根据订单类型调用不同的撤单API
			let cancelRes;
			if (order.orderType === 'contract') {
				// 合约订单撤单 - 使用新的专用接口
				cancelRes = await cancelContractsOrder({ orderId: order.id });
			} else {
				// 期权订单撤单 - 使用原有接口
				cancelRes = await chedan({ id: order.id });
			}
			
			if (cancelRes && cancelRes.code === 200) {
				// API调用成功，从本地列表中移除
				const index = this.pendingOrders.findIndex(item => item.id === order.id);
				if (index > -1) {
					this.pendingOrders.splice(index, 1);
				}
				
			// 显示成功提示（使用公共组件）
			this.successMessage = this.$t('Trading.cancelSuccess') || '操作成功';
			this.$refs.successModal.show();

			// ✅ 立即刷新余额显示
			if (this.$refs.tradingPanel) {
				this.$refs.tradingPanel.fetchAccountBalances();
			}
			if (this.$refs.orderManagement) {
				this.$refs.orderManagement.fetchAccountBalances();
			}

			// 刷新用户余额（撤单后保证金会返还）
			await this.$store.dispatch('GET_USER_INFO');

				// 清空缓存，强制重新从API获取数据
				if (this.mainOrderType === 'contract') {
					this.allContractOrders = null;
					await this.getAllContractOrders();
				}

				// 重新获取挂单数据以确保数据同步
				await this.getPendingOrderData();
				
				// 强制更新视图
				this.$forceUpdate();
			} else {
				this.$toast.error(cancelRes?.message || this.$t('Trading.cancelError') || '撤单失败');
			}
		} catch (error) {
			console.error('撤单失败:', error);
			this.$toast.error(this.$t('Trading.cancelError') || '撤单失败，请稍后重试');
		}
	},
			// 交易界面方法
			selectStock(stock) {
				this.selectedStock = stock;

				// 更新交易价格
				const currentPrice = parseFloat(stock.price || stock.currentPrice || 0);
				this.tradePrice = currentPrice;

				// 如果挂单价格为0，则设置为当前价格
				if (this.pendingPrice === 0) {
					this.pendingPrice = currentPrice;
				}

				// 更新选中股票的价格显示 - 确保数据结构与cruuency页面一致
				if (this.selectedStock) {
					this.selectedStock.price = currentPrice.toString();
					this.selectedStock.nowPrice = currentPrice;
					// 确保有id字段
					if (!this.selectedStock.id && stock.id) {
						this.selectedStock.id = stock.id;
					}
				}

				// 🚀 按需初始化该交易对的小图表（如果还没初始化）
				this.initChartOnDemand(stock.code);

				// 获取选中股票的详细市场信息，在获取完成后再更新图表
				if (stock.id) {
					this.getMarketInfoById(stock.id);
					// 获取期权配置信息
					this.getMarketOptionsInfo(stock.id);
				} else {
					// 如果没有ID，直接更新图表
					this.updateTradingChart();
				}
			},
			selectPeriod(period) {
				if (period === 'indicator') {
					// 切换技术指标面板显示/隐藏
					this.showIndicators = !this.showIndicators;
				} else {
					this.selectedPeriod = period;
					// 重新获取对应时间周期的K线数据
					if (this.selectedStock) {
						this.updateTradingChart();
					}
				}
			},

		// 切换Submit Order面板显示/隐藏
		toggleSubmitOrder() {
			this.showSubmitOrder = !this.showSubmitOrder;
			// 如果显示Submit Order面板，确保有选中的股票
			if (this.showSubmitOrder && !this.selectedStock && this.marketList.length > 0) {
				this.selectedStock = this.marketList[0];
				this.tradePrice = parseFloat(this.selectedStock.price || this.selectedStock.currentPrice);
			}

			// 等待DOM更新后重新调整图表大小
			this.$nextTick(() => {
				if (this.chartInstance) {
					setTimeout(() => {
						this.chartInstance.resize();
					}, 300); // 给一个短暂延迟确保DOM完全更新
				}
			});
		},
	
	// 切换指标面板显示/隐藏
	toggleIndicators() {
		this.showIndicators = !this.showIndicators;
	},
	
	// K线图操作方法
	handleChartScreenshot() {
		// 截图功能：将图表导出为图片并显示预览弹窗
		if (this.chartInstance) {
			const url = this.chartInstance.getDataURL({
				type: 'png',
				pixelRatio: 2,
				backgroundColor: this.darkMode ? '#1a1a1a' : '#ffffff'
			});
			
			// 显示截图预览弹窗
			this.screenshotUrl = url;
			this.showScreenshotModal = true;
		}
	},
	
	// 保存截图
	saveScreenshot() {
		if (this.screenshotUrl) {
			const link = document.createElement('a');
			link.download = `chart_${new Date().getTime()}.png`;
			link.href = this.screenshotUrl;
			link.click();
		}
	},
	
	// 关闭截图预览
	closeScreenshotModal() {
		this.showScreenshotModal = false;
		this.screenshotUrl = '';
	},
	
	handleChartZoomIn() {
		// 放大功能：只调整X轴，Y轴不受影响
		if (this.chartInstance) {
			const option = this.chartInstance.getOption();
			const dataZoom = option.dataZoom && option.dataZoom[0];
			
			if (dataZoom) {
				// 严格检查当前值
				let currentStart = dataZoom.start !== undefined ? dataZoom.start : 0;
				let currentEnd = dataZoom.end !== undefined ? dataZoom.end : 100;
				
				// 如果是初始状态（显示全部100%），先缩小到80%
				if (currentStart === 0 && currentEnd === 100) {
					currentStart = 20;
					currentEnd = 100;
				}
				
				let range = currentEnd - currentStart;
				
				// 每次缩小2%的范围（最小保持10%的范围）
				if (range > 10) {
					const newRange = Math.max(10, range - 2);
					const newStart = currentEnd - newRange;
					
					// 使用setOption，filterMode: 'none' 防止Y轴自动调整
					this.chartInstance.setOption({
						dataZoom: [{
							type: 'inside',
							xAxisIndex: [0],
							start: Math.max(0, newStart),
							end: currentEnd,
							filterMode: 'none',
							zoomOnMouseWheel: false,
							moveOnMouseMove: true,
							preventDefaultMouseMove: true
						}]
					}, {
						replaceMerge: ['dataZoom']
					});
				}
			}
		}
	},
	
	handleChartZoomOut() {
		// 缩小功能：只调整X轴，Y轴不受影响
		if (this.chartInstance) {
			const option = this.chartInstance.getOption();
			const dataZoom = option.dataZoom && option.dataZoom[0];
			
			if (dataZoom) {
				// 严格检查当前值
				const currentStart = dataZoom.start !== undefined ? dataZoom.start : 0;
				const currentEnd = dataZoom.end !== undefined ? dataZoom.end : 100;
				const range = currentEnd - currentStart;
				
				// 每次扩大2%的范围（最大到100%）
				if (range < 100) {
					const newRange = Math.min(100, range + 2);
					const newStart = currentEnd - newRange;
					
					// 使用setOption，filterMode: 'none' 防止Y轴自动调整
					this.chartInstance.setOption({
						dataZoom: [{
							type: 'inside',
							xAxisIndex: [0],
							start: Math.max(0, newStart),
							end: currentEnd,
							filterMode: 'none',
							zoomOnMouseWheel: false,
							moveOnMouseMove: true,
							preventDefaultMouseMove: true
						}]
					}, {
						replaceMerge: ['dataZoom']
					});
				}
			}
		}
	},
	
	handleChartMoveLeft() {
		// 左移功能：每次向左移动3%
		if (this.chartInstance) {
			const option = this.chartInstance.getOption();
			const dataZoom = option.dataZoom && option.dataZoom[0];
			if (dataZoom) {
				let currentStart = dataZoom.start || 0;
				let currentEnd = dataZoom.end || 100;
				let range = currentEnd - currentStart;
				
				// 如果当前是100%显示，先缩小到80%，然后再移动
				if (range >= 100) {
					range = 80;
					const center = 50; // 从中心开始
					currentStart = center - range / 2;
					currentEnd = center + range / 2;
				}
				
				// 每次移动3%
				const step = 3;
				const newStart = Math.max(0, currentStart - step);
				const newEnd = newStart + range;
				
				this.chartInstance.dispatchAction({
					type: 'dataZoom',
					start: newStart,
					end: Math.min(100, newEnd)
				});
			}
		}
	},
	
	handleChartMoveRight() {
		// 右移功能：每次向右移动3%
		if (this.chartInstance) {
			const option = this.chartInstance.getOption();
			const dataZoom = option.dataZoom && option.dataZoom[0];
			if (dataZoom) {
				let currentStart = dataZoom.start || 0;
				let currentEnd = dataZoom.end || 100;
				let range = currentEnd - currentStart;
				
				// 如果当前是100%显示，先缩小到80%，然后再移动
				if (range >= 100) {
					range = 80;
					const center = 50; // 从中心开始
					currentStart = center - range / 2;
					currentEnd = center + range / 2;
				}
				
				// 每次移动3%
				const step = 3;
				const newEnd = Math.min(100, currentEnd + step);
				const newStart = newEnd - range;
				
				this.chartInstance.dispatchAction({
					type: 'dataZoom',
					start: Math.max(0, newStart),
					end: newEnd
				});
			}
		}
	},
	
	handleChartFullscreen() {
		// 全屏功能：使整个网站全屏
		try {
			if (!document.fullscreenElement) {
				// 进入全屏 - 全屏整个文档
				const fullscreenPromise = document.documentElement.requestFullscreen
					? document.documentElement.requestFullscreen()
					: document.documentElement.webkitRequestFullscreen
					? document.documentElement.webkitRequestFullscreen()
					: document.documentElement.mozRequestFullScreen
					? document.documentElement.mozRequestFullScreen()
					: document.documentElement.msRequestFullscreen
					? document.documentElement.msRequestFullscreen()
					: null;
				
				if (fullscreenPromise) {
					fullscreenPromise.then(() => {
						console.log('进入全屏成功');
						// 全屏后调整图表大小
						setTimeout(() => {
							if (this.chartInstance) {
								this.chartInstance.resize();
							}
						}, 200);
					}).catch((err) => {
						console.error('进入全屏失败:', err);
					});
				}
			} else {
				// 退出全屏
				const exitPromise = document.exitFullscreen
					? document.exitFullscreen()
					: document.webkitExitFullscreen
					? document.webkitExitFullscreen()
					: document.mozCancelFullScreen
					? document.mozCancelFullScreen()
					: document.msExitFullscreen
					? document.msExitFullscreen()
					: null;
				
				if (exitPromise) {
					exitPromise.then(() => {
						console.log('退出全屏成功');
						// 退出全屏后调整图表大小
						setTimeout(() => {
							if (this.chartInstance) {
								this.chartInstance.resize();
							}
						}, 200);
					}).catch((err) => {
						console.error('退出全屏失败:', err);
					});
				}
			}
		} catch (error) {
			console.error('全屏操作出错:', error);
		}
		},

			// 切换技术指标选择状态
			toggleIndicator(indicator) {
				indicator.selected = !indicator.selected;
				// 这里可以添加更新图表显示技术指标的逻辑
				this.updateChartIndicators();
			},

	// 更新图表技术指标显示
	updateChartIndicators() {
		const selectedMainIndicators = this.mainIndicators.filter(item => item.selected);
		const selectedSubIndicators = this.subIndicators.filter(item => item.selected);
		// 直接重新获取K线数据并绘制，避免数据格式问题
		if (this.selectedStock && this.selectedStock.code) {
			this.getKLineDataForTrading(this.selectedStock.code);
		}
	},
	
	// 切换单个指标线显示/隐藏
	toggleIndicatorVisibility(indicator) {
		// 切换指标的visible状态（默认为true）
		const currentVisible = indicator.visible !== false; // 如果没设置或为true，则当前是可见的
		this.$set(indicator, 'visible', !currentVisible);
		
		if (this.chartInstance) {
			const option = this.chartInstance.getOption();
			const series = option.series;
			
			// 根据指标名称找到对应的系列并切换可见性
			series.forEach((s, index) => {
				if (indicator.name === 'MA') {
					// 只控制MA线条
					if (s.type === 'line' && s.name && s.name.startsWith('MA')) {
						series[index] = {
							...series[index],
							lineStyle: {
								...series[index].lineStyle,
								opacity: indicator.visible ? 1 : 0
							}
						};
					}
				} else if (indicator.name === 'EMA') {
					// 控制EMA线条
					if (s.type === 'line' && s.name && s.name.startsWith('EMA')) {
						series[index] = {
							...series[index],
							lineStyle: {
								...series[index].lineStyle,
								opacity: indicator.visible ? 1 : 0
							}
						};
					}
				} else if (indicator.name === 'SMA') {
					// 控制SMA线条
					if (s.type === 'line' && s.name && s.name.startsWith('SMA')) {
						series[index] = {
							...series[index],
							lineStyle: {
								...series[index].lineStyle,
								opacity: indicator.visible ? 1 : 0
							}
						};
					}
				} else if (indicator.name === 'BOLL') {
					if (s.type === 'line' && s.name && s.name.startsWith('BOLL')) {
						series[index] = {
							...series[index],
							lineStyle: {
								...series[index].lineStyle,
								opacity: indicator.visible ? 1 : 0
							}
						};
					}
				} else if (indicator.name === 'SAR') {
					if (s.name === 'SAR') {
						series[index] = {
							...series[index],
							itemStyle: {
								...series[index].itemStyle,
								opacity: indicator.visible ? 1 : 0
							}
						};
					}
				}
			});
			
			this.chartInstance.setOption({ series });
		}
	},
	
	// 打开指标参数设置弹窗
	openIndicatorSettings(indicator) {
		if (indicator.name === 'MA') {
			this.showMASettings = true;
		} else if (indicator.name === 'EMA') {
			this.showEMASettings = true;
		} else if (indicator.name === 'BOLL') {
			this.showBOLLSettings = true;
		}
		// 其他指标的设置弹窗可以在这里添加
	},
	
	// 保存MA设置
	saveMASettings() {
		this.showMASettings = false;
		// 重新绘制图表以应用新的MA参数
		this.updateChartIndicators();
	},
	
	// 保存EMA设置
	saveEMASettings() {
		this.showEMASettings = false;
		// 重新绘制图表以应用新的EMA参数
		this.updateChartIndicators();
	},
	
	// 保存BOLL设置
	saveBOLLSettings() {
		this.showBOLLSettings = false;
		// 重新绘制图表以应用新的BOLL参数
		this.updateChartIndicators();
	},
	
	// 删除单个指标（不需要确认）
	removeIndicator(indicator) {
		// 取消该指标的选中状态
		indicator.selected = false;
		// 更新图表
		this.updateChartIndicators();
	},
	
	// 更新副图显示
	updateSubChart(selectedSubIndicators, klineValues, dates) {
		if (!this.subChartInstance) {
			// 如果没有副图实例，创建一个
			const subChartDom = document.getElementById('sub-chart');
			if (subChartDom && selectedSubIndicators.length > 0) {
				this.subChartInstance = this.$echarts.init(subChartDom);
				this.initSubChart(selectedSubIndicators, klineValues, dates);
			}
		} else if (selectedSubIndicators.length > 0) {
			// 更新现有副图
			this.initSubChart(selectedSubIndicators, klineValues, dates);
		} else {
			// 如果没有选中的副图指标，清空副图
			this.subChartInstance.clear();
		}
	},
	
	// 初始化副图
	initSubChart(selectedIndicators, klineValues, dates) {
		if (!this.subChartInstance) return;
		
		const subSeries = [];
		
	// 动态获取主题色
	const primaryColor = getComputedStyle(document.documentElement)
		.getPropertyValue('--primary-color').trim() || '#8BC34A';
	
	// 先添加K线图
	subSeries.push({
		name: 'K线',
		type: 'candlestick',
		data: klineValues,
		itemStyle: {
			color: primaryColor,      // 阳线颜色（涨 - 绿色）
			color0: '#FD1050',     // 阴线颜色（跌 - 红色）
			borderColor: primaryColor,
			borderColor0: '#FD1050'
		},
		barWidth: '60%',
		animation: false
	});
		
		// 再添加副图指标
		this.addIndicatorSeries(selectedIndicators, klineValues, subSeries);
		
		const option = {
			grid: {
				left: '50px',
				right: '50px',
				top: '20px',
				bottom: '0'  // 🔑 时间轴紧贴底部，无额外空白
			},
			xAxis: {
				type: 'category',
				data: dates, // 使用和主图相同的日期数据
				axisLine: { show: false },  // 🔑 隐藏X轴线
				axisLabel: { 
					show: true, // 显示X轴标签
					color: '#999',
					fontSize: 10,
					interval: 'auto' // 自动显示标签
				},
				splitLine: { show: false }
			},
		yAxis: {
			type: 'value',
			position: 'right',
			scale: true,
			axisLine: { show: false },
			axisTick: { show: false },
			axisLabel: {
				color: '#999',
				fontSize: 10
				},
				splitLine: {
				show: false  // 隐藏Y轴网格线
				}
			},
			series: subSeries,
			animation: false
		};
		
		this.subChartInstance.setOption(option, { notMerge: true });
	},
	// 添加指标系列到series数组
	addIndicatorSeries(indicators, klineValues, seriesArray) {
		indicators.forEach(indicator => {
			if (indicator.name === 'MA') {
				const ma5 = this.calculateMA(klineValues, this.maSettings.ma1 || 5);
				const ma10 = this.calculateMA(klineValues, this.maSettings.ma2 || 10);
				const ma30 = this.calculateMA(klineValues, this.maSettings.ma3 || 30);
				const ma60 = this.calculateMA(klineValues, this.maSettings.ma4 || 60);
				
				// 缓存MA计算结果
				this.cachedIndicatorData.ma5 = ma5;
				this.cachedIndicatorData.ma10 = ma10;
				this.cachedIndicatorData.ma30 = ma30;
				this.cachedIndicatorData.ma60 = ma60;
				
				seriesArray.push({
					name: 'MA5',
					type: 'line',
					data: ma5,
					smooth: true,
					lineStyle: { width: 1, color: '#FF6B9D' },
					showSymbol: false,
					animation: false
				});
				seriesArray.push({
					name: 'MA10',
					type: 'line',
					data: ma10,
					smooth: true,
					lineStyle: { width: 1, color: '#40A9FF' },
					showSymbol: false,
					animation: false
				});
				seriesArray.push({
					name: 'MA30',
					type: 'line',
					data: ma30,
					smooth: true,
					lineStyle: { width: 1, color: '#9254DE' },
					showSymbol: false,
					animation: false
				});
				seriesArray.push({
					name: 'MA60',
					type: 'line',
					data: ma60,
					smooth: true,
					lineStyle: { width: 1, color: '#FFD666' },
					showSymbol: false,
					animation: false
				});
		} else if (indicator.name === 'EMA') {
			// 使用emaSettings中的配置
			const emaConfigs = [
				{ period: this.emaSettings.ema1, name: 'EMA1', color: '#91D5FF' },
				{ period: this.emaSettings.ema2, name: 'EMA2', color: '#ADC6FF' },
				{ period: this.emaSettings.ema3, name: 'EMA3', color: '#D3ADF7' },
				{ period: this.emaSettings.ema4, name: 'EMA4', color: '#B37FEB' },
				{ period: this.emaSettings.ema5, name: 'EMA5', color: '#9254DE' }
			];
			
			emaConfigs.forEach(config => {
				if (config.period) { // 只添加已配置的EMA
					const emaData = this.calculateEMA(klineValues, config.period);
					seriesArray.push({
						name: `EMA${config.period}`,
						type: 'line',
						data: emaData,
						smooth: true,
						lineStyle: { width: 1, color: config.color },
						showSymbol: false,
						animation: false
					});
				}
			});
		} else if (indicator.name === 'SMA') {
			const sma = this.calculateSMA(klineValues, 10);
			seriesArray.push({
				name: 'SMA10',
				type: 'line',
				data: sma,
				smooth: true,
				lineStyle: { width: 1, color: 'var(--success-color)' },
				showSymbol: false,
				animation: false
			});
		} else if (indicator.name === 'BOLL') {
			const boll = this.calculateBOLL(klineValues, this.bollSettings.period || 20, this.bollSettings.stdDev || 2);
			seriesArray.push({
				name: 'BOLL-UP',
				type: 'line',
				data: boll.upper,
				smooth: true,
				lineStyle: { width: 1, color: '#F759AB', type: 'dashed' },
				showSymbol: false,
				animation: false
			});
			seriesArray.push({
				name: 'BOLL-MID',
				type: 'line',
				data: boll.middle,
				smooth: true,
				lineStyle: { width: 1, color: '#722ED1' },
				showSymbol: false,
				animation: false
			});
			seriesArray.push({
				name: 'BOLL-DN',
				type: 'line',
				data: boll.lower,
				smooth: true,
				lineStyle: { width: 1, color: '#F759AB', type: 'dashed' },
				showSymbol: false,
				animation: false
			});
		} else if (indicator.name === 'SAR') {
			const sar = this.calculateSAR(klineValues);
			seriesArray.push({
				name: 'SAR',
				type: 'scatter',
				data: sar,
				symbolSize: 4,
				itemStyle: { color: '#13C2C2' },
				animation: false
			});
		} else if (indicator.name === 'MACD') {
			const macd = this.calculateMACD(klineValues);
			seriesArray.push({
				name: 'MACD-DIF',
				type: 'line',
				data: macd.dif,
				smooth: true,
				lineStyle: { width: 1, color: '#FF6B9D' },
				showSymbol: false,
				animation: false
			});
			seriesArray.push({
				name: 'MACD-DEA',
				type: 'line',
				data: macd.dea,
				smooth: true,
				lineStyle: { width: 1, color: '#40A9FF' },
				showSymbol: false,
				animation: false
			});
			seriesArray.push({
				name: 'MACD-BAR',
				type: 'bar',
				data: macd.bar,
				itemStyle: {
					color: (params) => {
						return params.value >= 0 ? '#f23c48' : 'var(--primary-color)';
					}
				},
				animation: false
			});
		} else if (indicator.name === 'KDJ') {
			const kdj = this.calculateKDJ(klineValues);
			seriesArray.push({
				name: 'KDJ-K',
				type: 'line',
				data: kdj.k,
				smooth: true,
				lineStyle: { width: 1, color: '#FFC53D' },
				showSymbol: false,
				animation: false
			});
			seriesArray.push({
				name: 'KDJ-D',
				type: 'line',
				data: kdj.d,
				smooth: true,
				lineStyle: { width: 1, color: '#40A9FF' },
				showSymbol: false,
				animation: false
			});
			seriesArray.push({
				name: 'KDJ-J',
				type: 'line',
				data: kdj.j,
				smooth: true,
				lineStyle: { width: 1, color: '#9254DE' },
				showSymbol: false,
				animation: false
			});
		} else if (indicator.name === 'RSI') {
			const rsi = this.calculateRSI(klineValues, 14);
			seriesArray.push({
				name: 'RSI',
				type: 'line',
				data: rsi,
				smooth: true,
				lineStyle: { width: 1, color: '#FF7A45' },
				showSymbol: false,
				animation: false
			});
		} else if (indicator.name === 'BIAS') {
			const bias = this.calculateBIAS(klineValues, 6);
			seriesArray.push({
				name: 'BIAS',
				type: 'line',
				data: bias,
				smooth: true,
				lineStyle: { width: 1, color: '#B37FEB' },
				showSymbol: false,
				animation: false
			});
		} else if (indicator.name === 'BRAR') {
			const brar = this.calculateBRAR(klineValues);
			seriesArray.push({
				name: 'BR',
				type: 'line',
				data: brar.br,
				smooth: true,
				lineStyle: { width: 1, color: '#FFD666' },
				showSymbol: false,
				animation: false
			});
			seriesArray.push({
				name: 'AR',
				type: 'line',
				data: brar.ar,
				smooth: true,
				lineStyle: { width: 1, color: '#95DE64' },
				showSymbol: false,
				animation: false
			});
		}
	});
},
			async placeTrade(type) {
				// 市价交易方法 - 合约交易，使用buyU接口

				// 检查点击频率限制
				if (!this.checkClickLimit()) {
					return;
				}

				// 检查是否正在下单
				if (this.isTrading) {
					this.$toast.warning(this.$t('Trading.orderInProgress') || '订单处理中，请稍候...');
					return;
				}

				// 检查必要参数
				if (!this.selectedStock) {
					this.$toast.error(this.$t('Trading.selectSymbolFirst') || '请先选择交易品种');
					return;
				}

				if (!this.quantity || this.quantity <= 0) {
					this.$toast.error(this.$t('Trading.invalidQuantity') || '请输入有效的交易数量');
					return;
				}

				this.isTrading = true;

				try {
					// 检查是否有合约配置信息
					if (!this.currentMarketInfo || !this.currentMarketInfo.contractsInfo) {
						this.$toast.error(this.$t('Trading.contractsConfigNotLoaded') || '合约配置未加载，请重新选择交易品种');
						return;
					}

				// ✅ 验证止盈止损价格合理性
				const orderType = type === 'buy' ? 0 : 1 // 0=买多, 1=卖空
				const currentPrice = parseFloat(this.selectedStock.nowPrice || this.selectedStock.price || 0)
				
				if (currentPrice > 0) {
					// 买多订单
					if (orderType === 0) {
						// 止盈价必须高于当前价
						if (this.takeProfitEnabled && this.takeProfit > 0 && this.takeProfit <= currentPrice) {
							this.$toast.error(this.$t('Trading.buyTpMustHigher') || '买入(做多)止盈值不能低于开仓值')
							this.isTrading = false
							return
						}
						// 止损价必须低于当前价
						if (this.stopLossEnabled && this.stopLoss > 0 && this.stopLoss >= currentPrice) {
							this.$toast.error(this.$t('Trading.buySlMustLower') || '买入(做多)止损值不能高于开仓值')
							this.isTrading = false
							return
						}
					}
					// 卖空订单
					else if (orderType === 1) {
						// 止盈价必须低于当前价
						if (this.takeProfitEnabled && this.takeProfit > 0 && this.takeProfit >= currentPrice) {
							this.$toast.error(this.$t('Trading.sellTpMustLower') || '卖出(做空)止盈值不能高于开仓值')
							this.isTrading = false
							return
						}
						// 止损价必须高于当前价
						if (this.stopLossEnabled && this.stopLoss > 0 && this.stopLoss <= currentPrice) {
							this.$toast.error(this.$t('Trading.sellSlMustHigher') || '卖出(做空)止损值不能低于开仓值')
							this.isTrading = false
							return
						}
					}
				}

				// 构建合约交易参数 - 对标cruuency页面的buyU接口
				const params = {
					delegateType: 0, // 委托类型：0=市价，1=限价
					constractsId: this.currentMarketInfo.contractsInfo.id, // 合约ID（从contractsInfo获取）
					type: type === 'buy' ? 0 : 1, // 0=买多，1=卖空
					buyPrice: this.selectedStock.nowPrice || this.selectedStock.price, // 买入价格
					hands: this.quantity, // 手数
					leverage: this.multiplier, // 杠杆倍数
					margin: this.contractsInfoMargin, // 使用computed计算的保证金
					tradeFee: this.contractsTradeFee, // 使用computed计算的交易费
					stopLoss: this.stopLossEnabled ? this.stopLoss : 0, // 止盈价格
					stopProfit: this.takeProfitEnabled ? this.takeProfit : 0 // 止损价格
				};
					const res = await buyU(params);

			if (res.code === 200) {
				// 显示成功提示
				this.successMessage = this.$t('Trading.orderSuccess') || '下单成功';
				this.$refs.successModal.show();
				
			// ✅ 立即刷新余额和订单列表
			if (this.$refs.tradingPanel) {
				this.$refs.tradingPanel.fetchAccountBalances();
			}
			if (this.$refs.orderManagement) {
				this.$refs.orderManagement.fetchAccountBalances();
			}
			this.loadOrderData();
				} else {
					const errorMsg = handleApiError(res);
					// ✅ 只在有错误信息时才显示提示
					if (errorMsg) {
						this.$toast.error(errorMsg);
					}
					console.error('❌ 合约下单失败:', res);
				}
			} catch (error) {
				console.error('❌ 合约下单异常:', error);
				const errorMsg = error.response ? handleApiError(error.response.data) : (this.$t('Trading.orderError') || '下单失败，请重试');
				// ✅ 只在有错误信息时才显示提示
				if (errorMsg) {
					this.$toast.error(errorMsg);
				}
			} finally {
				this.isTrading = false;
			}
		},

			// 挂单交易方法
			async placePendingOrder(type) {
				// 检查点击频率限制
				if (!this.checkClickLimit()) {
					return;
				}

				// 检查是否正在下单
				if (this.isTrading) {
					this.$toast.warning(this.$t('Trading.orderInProgress') || '订单处理中，请稍候...');
					return;
				}

				// 检查必要参数
				if (!this.selectedStock) {
					this.$toast.error(this.$t('Trading.selectSymbolFirst') || '请先选择交易品种');
					return;
				}

				if (!this.pendingQuantity || this.pendingQuantity <= 0) {
					this.$toast.error(this.$t('Trading.invalidQuantity') || '请输入有效的交易数量');
					return;
				}

			if (!this.pendingPrice || this.pendingPrice <= 0) {
				this.$toast.error(this.$t('Trading.invalidPrice') || '请输入有效的挂单价格');
				return;
			}

			// 🔑 验证挂单价格的合理性
			const currentPrice = parseFloat(this.pendingPrice);
			const marketPrice = parseFloat(this.selectedStock.nowPrice || this.selectedStock.price || 0);
			
			if (type === 'buy') {
				// 买入挂单：价格必须低于当前市场价
				if (currentPrice >= marketPrice) {
					this.$toast.error(this.$t('Trading.buyLimitPriceError') || `买入挂单价格必须低于当前市场价 ${marketPrice.toFixed(2)}`);
					return;
				}
			} else {
				// 卖出挂单：价格必须高于当前市场价
				if (currentPrice <= marketPrice) {
					this.$toast.error(this.$t('Trading.sellLimitPriceError') || `卖出挂单价格必须高于当前市场价 ${marketPrice.toFixed(2)}`);
					return;
				}
			}

			this.isTrading = true;

	try {
	// ✅ 验证止盈止损价格合理性
	const orderType = type === 'buy' ? 0 : 1 // 0=买多, 1=卖空
	const orderPrice = parseFloat(this.pendingPrice)
	
	if (orderPrice > 0) {
		// 买多订单
		if (orderType === 0) {
			// 止盈价必须高于挂单价
			if (this.pendingTakeProfitEnabled && this.pendingTakeProfit > 0 && this.pendingTakeProfit <= orderPrice) {
				this.$toast.error(this.$t('Trading.buyTpMustHigher') || '买入(做多)止盈值不能低于开仓值')
				this.isTrading = false
				return
			}
			// 止损价必须低于挂单价
			if (this.pendingStopLossEnabled && this.pendingStopLoss > 0 && this.pendingStopLoss >= orderPrice) {
				this.$toast.error(this.$t('Trading.buySlMustLower') || '买入(做多)止损值不能高于开仓值')
				this.isTrading = false
				return
			}
		}
		// 卖空订单
		else if (orderType === 1) {
			// 止盈价必须低于挂单价
			if (this.pendingTakeProfitEnabled && this.pendingTakeProfit > 0 && this.pendingTakeProfit >= orderPrice) {
				this.$toast.error(this.$t('Trading.sellTpMustLower') || '卖出(做空)止盈值不能高于开仓值')
				this.isTrading = false
				return
			}
			// 止损价必须高于挂单价
			if (this.pendingStopLossEnabled && this.pendingStopLoss > 0 && this.pendingStopLoss <= orderPrice) {
				this.$toast.error(this.$t('Trading.sellSlMustHigher') || '卖出(做空)止损值不能低于开仓值')
				this.isTrading = false
				return
			}
		}
	}
	
	// 构建挂单参数 - 使用与市价下单相同的合约结构，只是delegateType不同
	// 使用正确的保证金计算公式：手数 × 杠杆 × contractsInfo.margin
	const marginValue = this.currentMarketInfo.contractsInfo.margin;
	const margin = this.pendingQuantity * this.pendingMultiplier * marginValue
	// 手续费 = 名义价值 × (tradeFee / 100)
	// 名义价值 = 手数 × 挂单价格 × 合约乘数
	const contractSize = this.currentMarketInfo.contractsInfo.handNum || 1;
	const tradeFeePercent = (this.currentMarketInfo.contractsInfo.tradeFee || 0) / 100;
	const nominalValue = this.pendingQuantity * this.pendingPrice * contractSize
	const tradeFee = nominalValue * tradeFeePercent
	
	const params = {
		delegateType: 1, // 委托类型：0=市价，1=限价
		constractsId: this.currentMarketInfo.contractsInfo.id, // 合约ID（与市价下单保持一致）
		type: type === 'buy' ? 0 : 1, // 0=买多，1=卖空
		buyPrice: this.pendingPrice, // 挂单价格
		hands: this.pendingQuantity, // 手数
		leverage: this.pendingMultiplier, // 杠杆倍数（使用挂单专用变量）
		margin: margin, // 保证金（手数 × 杠杆 × margin配置）
		tradeFee: tradeFee, // 交易费（保证金 × tradeFee% / 100）
		stopLoss: this.pendingStopLossEnabled && this.pendingStopLoss > 0 ? this.pendingStopLoss : 0, // 止损价格（使用挂单专用变量）
		stopProfit: this.pendingTakeProfitEnabled && this.pendingTakeProfit > 0 ? this.pendingTakeProfit : 0 // 止盈价格（使用挂单专用变量）
	};
				const res = await buyU(params);

			if (res.code === 200) {
				// 显示成功提示
				this.successMessage = this.$t('Trading.orderSuccess') || '下单成功';
				this.$refs.successModal.show();
				
			// ✅ 立即刷新余额和订单列表
			if (this.$refs.tradingPanel) {
				this.$refs.tradingPanel.fetchAccountBalances();
			}
			if (this.$refs.orderManagement) {
				this.$refs.orderManagement.fetchAccountBalances();
			}
			this.loadOrderData();
				} else {
					const errorMsg = handleApiError(res);
					// ✅ 只在有错误信息时才显示提示
					if (errorMsg) {
						this.$toast.error(errorMsg);
					}
					console.error('❌ 挂单失败:', res);
				}
			} catch (error) {
				console.error('❌ 挂单异常:', error);
				const errorMsg = error.response ? handleApiError(error.response.data) : (this.$t('Trading.pendingOrderError') || '挂单失败，请重试');
				// ✅ 只在有错误信息时才显示提示
				if (errorMsg) {
					this.$toast.error(errorMsg);
				}
			} finally {
				this.isTrading = false;
			}
		},

			// 增加数量
			increaseQuantity() {
				this.pendingQuantity += 1;
			},

			// 减少数量
			decreaseQuantity() {
				if (this.pendingQuantity > 1) {
					this.pendingQuantity -= 1;
				}
			},

			// 秒合约相关方法
			// 选择期权时间
			selectOptionsTime(index) {
				this.optionsIndex = index;
				if (this.optionsInfo[index]) {
					this.currentOptionsRate = this.optionsInfo[index].rate;
				this.optionsTime = Number(this.optionsInfo[index].seconds);
				}
			},

		// 增加投资金额
		increaseOptionsMoney() {
			this.optionsMoney += 10; // 每次增加10
		},

	// 减少投资金额
	decreaseOptionsMoney() {
		if (this.optionsMoney > 100) {
			this.optionsMoney -= 10; // 每次减少10，最小保持100
		}
	},

	// 关闭期权弹窗
	async closeOptionsPopup() {
		this.optionsPop = false;
		if (this.optionsTimer) {
			clearInterval(this.optionsTimer);
			this.optionsTimer = null;
		}
		
		// 刷新订单数据
		//console.log('🔄 期权弹窗已关闭，刷新订单数据...');
		
		// 强制刷新所有期权订单数据
		await this.getAllOptionsOrders();
		
		// 刷新订单列表（会根据 mainOrderType 自动选择刷新方式）
		await this.loadOrderData(true);
		
		//console.log('✅ 期权弹窗关闭后数据刷新完成');
	},


			// 隐藏期权弹窗并重置数据（再次下单）
			hideOptionsPopup() {
				this.optionsPop = false;
				if (this.optionsTimer) {
					clearInterval(this.optionsTimer);
					this.optionsTimer = null;
				}
			// 重置期权数据
			this.optionsBuyPrice = '';
			this.optionsCurrentPrice = '';
			this.optionsMoney = 100; // 重置为默认金额
			this.optionsBuyType = '';
			this.orderId = '';
			this.optionsOrderInfo = {};
			this.optionsLoading = false;
				// 重置倒计时时间
				if (this.optionsInfo && this.optionsInfo.length > 0) {
					this.optionsTime = Number(this.optionsInfo[this.optionsIndex].seconds);  // 🔑 确保转换为数字类型
				}
			},

			// 计算预期利润
			getExpectedProfit() {
				if (!this.optionsBuyPrice || !this.optionsCurrentPrice) return '+0.00';
				
				const buyPrice = parseFloat(this.optionsBuyPrice);
				const currentPrice = parseFloat(this.optionsCurrentPrice);
				const priceDiff = currentPrice - buyPrice;
				
				// 根据买入类型判断是否盈利
				let isProfit = false;
				if (this.optionsBuyType === '1') {
					// 买涨：价格上涨为盈利
					isProfit = priceDiff > 0;
				} else {
					// 买跌：价格下跌为盈利
					isProfit = priceDiff < 0;
				}
				
				// 计算利润（简化计算，实际应该根据期权规则计算）
				const profit = isProfit ? this.optionsMoney * (this.currentOptionsRate / 100) : -this.optionsMoney;
				
				return (profit > 0 ? '+' : '') + profit.toFixed(2);
			},

			// 获取预期利润样式类
			getExpectedProfitClass() {
				const profit = this.getExpectedProfit();
				return profit.startsWith('+') ? 'profit-positive' : 'profit-negative';
			},

			// 随机数生成函数（模拟价格波动）
			randomNumber(basePrice) {
				const fluctuation = 0.001; // 0.1%的波动范围
				const change = (Math.random() - 0.5) * 2 * fluctuation;
				return basePrice * (1 + change);
			},

			// 根据订单ID获取期权订单结果
			async getOptionsOrderById() {
				try {
					if (!this.orderId) return;


					// 调用API获取订单结果
					const res = await getOptionsOrderById(this.orderId);
					
					if (res.code === 200 && res.result) {
						this.optionsOrderInfo = res.result;
						this.optionsCurrentPrice = res.result.currentPrice || this.optionsCurrentPrice;
						
						// 显示结果消息
						if (res.result.resultType === 1) {
							// 获胜
							this.$toast({
								message: `${this.$t('Trading.optionsWin') || '期权获胜！'} ${this.$t('Trading.profit') || '收益'}: +${res.result.income} USD`,
								type: 'success',
								duration: 3000
							});
						} else {
							// 失败
							this.$toast({
								message: `${this.$t('Trading.optionsLose') || '期权失败'} ${this.$t('Trading.loss') || '亏损'}: ${res.result.income} USD`,
								type: 'error',
								duration: 3000
							});
						}
					} else {
						// API调用失败，使用模拟结果
						const isWin = Math.random() > 0.5;
						const resultMessage = isWin ?
							(this.$t('Trading.optionsWin') || '期权获胜！') :
							(this.$t('Trading.optionsLose') || '期权失败');

						this.$toast({
							message: resultMessage,
							type: isWin ? 'success' : 'error',
							duration: 3000
						});
					}

					// 刷新订单列表
					this.loadOrderData();

				} catch (error) {
					console.error('❌ 获取期权订单结果失败:', error);
					
					// 出错时也显示模拟结果
					const isWin = Math.random() > 0.5;
					const resultMessage = isWin ?
						(this.$t('Trading.optionsWin') || '期权获胜！') :
						(this.$t('Trading.optionsLose') || '期权失败');

					this.$toast({
						message: resultMessage,
						type: isWin ? 'success' : 'error',
						duration: 3000
					});
				} finally {
					this.optionsLoading = false;
				}
			},

			// 秒合约下单 - 对标currency页面逻辑
		async placeOptionsContract(type) {
			try {
				// 验证交易数量
				const quantity = parseInt(this.optionsMoney);
				if (isNaN(quantity) || quantity < 10) {
					this.$toast.warning('交易数量必须大于等于10');
					return;
				}

				// 检查点击限制
				if (!this.checkClickLimit()) {
					return;
				}

				// 检查是否选择了交易品种
				if (!this.selectedStock || !this.selectedStock.id) {
					this.$toast.warning(this.$t('Trading.selectSymbolFirst') || '请先选择交易品种');
					return;
				}

					// 检查期权配置是否加载
					if (!this.optionsId || !this.optionsInfo || this.optionsInfo.length === 0) {
						// 尝试重新加载期权配置
						await this.getMarketOptionsInfo(this.selectedStock.id);
						
						// 再次检查配置
						if (!this.optionsId || !this.optionsInfo || this.optionsInfo.length === 0) {
							this.$toast.warning(this.$t('Trading.optionsConfigNotLoaded') || '期权配置未加载，请重新选择交易品种');
							return;
						}
					}

					// 计算限制时间
					var limitTime = this.optionsInfo[this.optionsIndex].seconds;
					if (this.optionsInfo[this.optionsIndex].type == '2') {
						limitTime = this.optionsInfo[this.optionsIndex].seconds * 24 * 60 * 60;
					}

					// 构建请求参数 - 对标cruuency页面逻辑
					let params = {
						amount: this.optionsMoney,
						optionsId: this.optionsId,
						type: type,
						buyPrice: this.selectedStock.nowPrice || this.selectedStock.price || this.selectedStock.currentPrice,
						limitTime: limitTime,
						marketId: this.selectedStock.id,
						limitType: this.optionsInfo[this.optionsIndex].type
					};
					// 验证最小投资金额
					if (Number(params.amount) <= Number(this.optionsInfo[this.optionsIndex].min)) {
						this.$toast.error(this.optionsInfo[this.optionsIndex].seconds + (this.$t('qi-quan-zui-di-tou-zi') || '秒期权最低投资') + this.optionsInfo[this.optionsIndex].min);
						return;
					}

					// 验证投资金额
					if (params.amount <= 0) {
						this.$toast.error(this.$t('Financial.enterAmount') || '请输入投资金额');
						return;
					}

					// 设置期权相关数据
					this.currentOptionsRate = this.optionsInfo[this.optionsIndex].rate;
					this.optionsBuyPrice = this.selectedStock.nowPrice || this.selectedStock.price;
					this.optionsCurrentPrice = this.selectedStock.nowPrice || this.selectedStock.price;
					this.optionsBuyType = type;
					this.optionsLoading = true;

			// 调用下单接口
			const res = await buyOptions(params);

		if (res.code == 200) {
	// 清除之前的定时器
		if (this.optionsTimer) {
			clearInterval(this.optionsTimer);
			this.optionsTimer = null;
		}
			
			// 初始化期权订单数据和倒计时
			this.orderId = res.result;
			this.optionsTime = Number(limitTime);  // 🔑 确保转换为数字类型
			this.optionsOrderInfo = {
				buyPrice: this.optionsBuyPrice,
				amount: this.optionsMoney,
				limitTime: limitTime
			};
			
	// 使用 nextTick 确保数据更新后再显示成功提示
	this.$nextTick(() => {
		// 不显示期权详情弹窗，直接显示成功提示
		// this.optionsPop = true;
		
		// 使用 SuccessModal 组件显示成功提示
		this.successMessage = this.$t('xiaDanChengGong') || '下单成功';
		this.$refs.successModal.show();
	});

	// 不再显示倒计时弹窗，直接刷新订单数据
	// 清除倒计时定时器（不再需要）
	if (this.optionsTimer) {
		clearInterval(this.optionsTimer);
		this.optionsTimer = null;
	}
	
	// 重置期权数据
	this.optionsBuyPrice = '';
	this.optionsCurrentPrice = '';
	this.optionsMoney = 100;
	this.optionsBuyType = '';
	this.optionsLoading = false;
	
	// 强制刷新所有期权订单数据
	await this.getAllOptionsOrders();
	// ✅ 立即刷新余额
	if (this.$refs.tradingPanel) {
		this.$refs.tradingPanel.fetchAccountBalances();
	}
	if (this.$refs.orderManagement) {
		this.$refs.orderManagement.fetchAccountBalances();
	}
	// 刷新订单列表（强制刷新）
	await this.loadOrderData(true);
			} else {
				const errorMsg = handleApiError(res);
				// ✅ 只在有错误信息时才显示提示
				if (errorMsg) {
					this.$toast.error(errorMsg);
				}
			}
			} catch (error) {
				console.error('❌ 秒合约下单失败:', error);
				const errorMsg = error.response ? handleApiError(error.response.data) : (this.$t('Trading.orderFailed') || '下单失败，请重试');
				// ✅ 只在有错误信息时才显示提示
				if (errorMsg) {
					this.$toast.error(errorMsg);
				}
			} finally {
				this.optionsLoading = false;
			}
		},

			// 时间选择器相关方法（现在使用el-select，不需要手动处理）

			// 获取市场期权配置信息
			async getMarketOptionsInfo(marketId) {
				try {
					const res = await getMarketInfo(marketId);

					if (res.code === 200 && res.result) {
						const result = res.result;

						// 检查是否支持期权交易
						if (result.canOptions === 1 && result.optionsInfo && result.optionsInfo.optionsInfo) {
							// 解析期权配置
							this.optionsInfo = JSON.parse(result.optionsInfo.optionsInfo);
							this.optionsId = result.optionsInfo.id;

							// 设置默认期权时间和收益率
							if (this.optionsInfo.length > 0) {
								const defaultOption = this.optionsInfo[this.optionsIndex];
								this.optionsTime = Number(defaultOption.seconds);  // 🔑 确保转换为数字类型
								this.currentOptionsRate = defaultOption.rate || 20;  // 🔑 修复：使用正确的变量名

								// 确保最小投资金额
								this.optionsInfo.forEach(element => {
									if (element.min === null || element.min === undefined) {
										element.min = 0;
									}
								});
							}
						} else {
							this.optionsInfo = [];
							this.optionsId = '';
							this.currentOptionsRate = 0;  // 🔑 修复：使用正确的变量名
						}
					}
				} catch (error) {
					console.error('❌ 获取期权配置失败:', error);
					this.optionsInfo = [];
					this.optionsId = '';
					this.currentOptionsRate = 0;  // 🔑 修复：使用正确的变量名
				}
			},

	// 刷新订单数据
	async loadOrderData(forceRefresh = true) {
		try {
			//console.log('🔄 loadOrderData 被调用，forceRefresh =', forceRefresh, 'mainTradeType =', this.mainTradeType);
			
			// 如果是强制刷新，清除缓存
			if (forceRefresh) {
				this.allContractOrders = null;
				this.allOptionsOrders = null;
				//console.log('🗑️ 已清除订单缓存，准备重新获取');
			}
			
			// 先确保订单缓存数据加载完成
			if (!this.allContractOrders) {
				await this.getAllContractOrders();
			}
			if (!this.allOptionsOrders) {
				await this.getAllOptionsOrders();
			}
			
			// ✅ 刷新订单的同时刷新余额
			if (this.$refs.orderManagement) {
				this.$refs.orderManagement.fetchAccountBalances();
			}
			
			// 根据当前订单类型刷新对应数据（使用 mainTradeType）
			if (this.mainTradeType === 'contract') {
				// 合约订单：刷新持仓、挂单、历史
				await this.getPositionData();
				await this.getPendingOrderData();
				await this.getHistoryOrderData();
			} else {
				// 期权订单：强制刷新交易中、已平仓
				await this.getOptionsPositionData(forceRefresh);
				await this.getOptionsHistoryData(forceRefresh);
			}
			
			// 刷新盈亏汇总
			await this.getProfitSummary();
			
			//console.log('✅ loadOrderData 完成');
		} catch (error) {
			console.error('❌ 刷新订单数据失败:', error);
		}
	},
		initTradingInterface() {
			// 初始化选中第一个股票
			if (this.marketList.length > 0) {
				this.selectedStock = this.marketList[0];
				this.tradePrice = parseFloat(this.selectedStock.price || this.selectedStock.currentPrice);
				
				// 获取第一个币种的详细信息，包括合约配置
				if (this.selectedStock.id) {
					this.getMarketInfoById(this.selectedStock.id);
				}

					// 初始化图表
					this.$nextTick(() => {
						this.updateTradingChart();
					});
				}
			},
			initTradingChart() {
				// 这里可以初始化K线图表
			// 由于没有引入图表库，这里只是占位
		},
	chartInit(code, hundred = []) {
				// 基于准备好的dom，初始化echarts实例
				let dom = document.getElementById(code);
				if (!dom) {
					return;
				}

				// 检查 DOM 尺寸是否有效
				const rect = dom.getBoundingClientRect();
				if (rect.width === 0 || rect.height === 0) {
					return;
				}

				// 检查数据是否存在
				if (!this.chartData[code] && hundred.length === 0) {
					return;
				}

				try {
					// 安全地销毁现有实例
					if (this.$echarts) {
						this.$echarts.dispose(dom);
					}
					const myChart = this.$echarts.init(dom);

					// 指定图表的配置项和数据
					var timeData = [];
					var valueData = [];
					// // 控制数据长度，只保留最近的 N 个数据，可以根据需要调整
					var maxLength = 100;
					if (hundred.length === 0) {
						timeData = this.chartData[code].map((item, index) => index);
						valueData = this.chartData[code].map(item => item).filter(item => item != 0);
						// 超过最大长度时就删掉前面的
						if (timeData.length > maxLength) {
							let num = timeData.length - maxLength;
							for (let i = 0; i < num; i++) {
								timeData.shift();
								valueData.shift();
							}
						}
					} else {
						hundred.forEach(item => {
							timeData.push(item.time);
							valueData.push(item.price);
						})
						if (timeData.length > maxLength) {
							timeData.shift();
							valueData.shift();
						}
					}

					// // //console.log(timeData);
					// // //console.log(valueData);
					if (!valueData[0]) {
						valueData = randomLine();
					}
					let red = '#ff2828';
					let green = '#44b400';

					var option = {
						xAxis: {
							type: 'category',
							data: timeData,
							show: false,
						},
						grid: {
							left: '10%',
							right: '10%',
							top: '10%',
							bottom: '10%',
						},
						yAxis: {
							type: 'value',
							show: false,
							// 取数据的最大值和最小值
							max: function(value) {
								return Math.max.apply(null, valueData);
							},
							min: function(value) {
								return Math.min.apply(null, valueData);
							},
						},
						series: [{
							type: 'line',
							data: valueData,
							symbol: 'none',
							animation: false, // 取消折线的动画
							itemStyle: {
								color: this.marketList.find(item => item.code === code).zdf > 0 ? red : green
							},
							lineStyle: {
								width: 4, // 再次增加折线的线条宽度，让K线更粗
							},
						}],
					};

					// 使用刚指定的配置项和数据显示图表。
					myChart.setOption(option);
					////console.log(`图表初始化成功: ${code}`);

				} catch (error) {
					console.error(`图表初始化失败: ${code}`, error);
				}
			},
			async getListMarketByType() {

				try {
					const res = await listMarketByType();

					if (res && res.result && Array.isArray(res.result)) {
						// 只显示 status === 1 且 showIndex === 1 的币种
						this.marketList = res.result.filter(item => item.status === 1 && item.showIndex === 1);

					// 初始化选中第一个股票
					if (this.marketList.length > 0 && !this.selectedStock) {
						this.selectedStock = this.marketList[0];
						this.tradePrice = parseFloat(this.selectedStock.price);

							// 获取选中股票的详细市场信息
						if (this.selectedStock.id) {
							this.getMarketInfoById(this.selectedStock.id);
						}
					}

					// 设置图表数据
					this.marketList.forEach((item, index) => {
						this.marketList[index].nowPrice = item.price;
							// 确保图表数据是有效的数组
							if (item.hundred && Array.isArray(item.hundred)) {
						this.chartData[item.code] = item.hundred;
							} else {
								// 如果没有历史数据，创建一个包含当前价格的数组
								this.chartData[item.code] = [item.price];
							}

							
						});

						return true; // 返回成功标志
					} else {
						console.error('❌ 市场数据格式异常:', res);
						this.marketList = [];
						return false;
					}
				} catch (err) {
					console.error('❌ 获取市场数据失败:', err);
					this.marketList = [];
					return false;
				}
			},
			// 获取市场详细信息
			getMarketInfoById(id) {
				if (!id) return;

				getMarketInfo(id).then(res => {
					if (res.code === 200) {
						this.currentMarketInfo = res.result;
						
						// 更新选中股票的详细信息
						if (this.selectedStock && this.currentMarketInfo) {
							this.selectedStock.open = this.currentMarketInfo.open || this.selectedStock.price;
							this.selectedStock.high = this.currentMarketInfo.high || this.selectedStock.price;
							this.selectedStock.low = this.currentMarketInfo.low || this.selectedStock.price;
							this.selectedStock.close = this.currentMarketInfo.close || this.selectedStock.price;
							
							// 如果支持合约交易，记录合约配置信息
							if (this.currentMarketInfo.canContracts == 1 && this.currentMarketInfo.contractsInfo) {
								this.selectedStock.contractsInfo = this.currentMarketInfo.contractsInfo;
							}

							// 更新中间面板的图表
							this.updateTradingChart();
						}
					}
				}).catch(err => {
					console.error('获取市场信息失败:', err);
				});
			},

			// 更新交易图表 - 修复重复绘制问题
			updateTradingChart() {
				if (!this.selectedStock) return;

				// 防抖机制：如果正在更新图表，则跳过
				if (this.isUpdatingChart) {
					return;
				}

				this.isUpdatingChart = true;

				// 使用选中品种的代码作为图表数据
				const code = this.selectedStock.code;
				// 先销毁现有图表实例，避免重复绘制
				if (this.tradingChart) {
					this.tradingChart.dispose();
					this.tradingChart = null;
				}

				// 获取真实的K线数据
				this.getKLineDataForTrading(code);
			},
			// 获取交易界面的K线数据
			async getKLineDataForTrading(code) {
				try {
					// 根据选中的时间周期获取对应的dateType参数
					const selectedPeriodObj = this.timePeriods.find(p => p.value === this.selectedPeriod);
					const params = {
						code: code,
						dateType: selectedPeriodObj ? selectedPeriodObj.dateType : '5' // 默认5分钟
					};

					const res = await getKValueByCodeAndDate(params);

					if (res.code === 200 && res.result && res.result.length > 0) {

						// 处理K线数据格式
						const klineData = res.result.map(item => {
							// //console.log('处理数据项:', item);
							return {
								date: item.date,
								open: item.kpPrice || item.open || item.openPrice,
								high: item.hignPrice || item.high || item.highPrice,
								low: item.lowPrice || item.low || item.lowPrice,
								close: item.spPrice || item.close || item.closePrice,
								volume: item.dealNum || item.volume || item.dealVolume || 0
							};
						}).sort((a, b) => {
							// 按时间正序排列，确保最早的数据在前，最新的数据在后
							if (a.date && b.date) {
								return a.date.localeCompare(b.date);
							}
							return 0;
						});

						// 调试：检查数据排序
						// 更新OHLC信息显示 - 使用最新的K线数据和计算最高最低点
						if (klineData.length > 0) {
							const latestData = klineData[klineData.length - 1];

							// 计算当前数据集中的最高点和最低点
							const allHighs = klineData.map(item => Number(item.high));
							const allLows = klineData.map(item => Number(item.low));
							const maxHigh = Math.max(...allHighs);
							const minLow = Math.min(...allLows);
						this.currentOHLC = {
							time: latestData.date || new Date().toLocaleString(),
							open: latestData.open,
						high: latestData.high,
						low: latestData.low,
							close: latestData.close,
							volume: latestData.volume || 'n/a',
							currentPrice: latestData.close
						};
						}

						// 使用真实K线数据初始化图表
						this.initTradingChartWithKLineData(code, klineData);
					} else {
						// 如果没有K线数据，使用模拟数据
						this.createMockKLineData(code);
					}
				} catch (error) {
					console.error('获取K线数据失败:', error);
					// 出错时使用模拟数据
					this.createMockKLineData(code);
				}
			},

			// 实时更新K线图（价格线和浮标）
			updateRealTimeKLine(realtimeData) {
				if (!this.chartInstance || !realtimeData) return;

				// 防抖机制：限制更新频率（优化为50ms实现更流畅的实时更新）
				const now = Date.now();
				if (this.lastPriceLineUpdate && (now - this.lastPriceLineUpdate) < 50) {
					return; // 50ms内不重复更新价格线
				}
				this.lastPriceLineUpdate = now;


				try {
					// 获取当前图表配置
					const option = this.chartInstance.getOption();
					if (!option || !option.series || option.series.length < 2) return;

					const currentPrice = parseFloat(realtimeData.price);
					const dates = option.xAxis[0].data;

					// 获取开盘价来判断涨跌
				const klineData = option.series[0].data;
				const openPrice = klineData && klineData.length > 0 ? klineData[0][0] : currentPrice;

				// ✅ 使用主题色作为价格线颜色（不再区分涨跌）
				const primaryColor = getComputedStyle(document.documentElement)
					.getPropertyValue('--primary-color').trim() || '#0156DC';
				const lineColor = primaryColor; // 统一使用主题色

					// 找到当前价格线的索引（通常是第二个series）
					let currentPriceLineIndex = -1;
					for (let i = 0; i < option.series.length; i++) {
						if (option.series[i].name === '当前价格线') {
							currentPriceLineIndex = i;
							break;
						}
					}

					if (currentPriceLineIndex !== -1) {
						// 更新现有的当前价格线
						const updatedSeries = [...option.series];
						updatedSeries[currentPriceLineIndex] = {
							...updatedSeries[currentPriceLineIndex],
							data: dates.map(() => currentPrice),
							lineStyle: {
								...updatedSeries[currentPriceLineIndex].lineStyle,
								color: lineColor
							}
						};

						// 更新最右侧的当前价格标签（scatter系列）
						const scatterIndex = option.series.findIndex(s => s.type === 'scatter');
						if (scatterIndex !== -1 && option.series[scatterIndex].data) {
							const scatterData = [...option.series[scatterIndex].data];
							// 更新当前价格点
							const currentPricePointIndex = scatterData.findIndex(point => point.name === '当前价格');
							if (currentPricePointIndex !== -1) {
								scatterData[currentPricePointIndex] = {
									...scatterData[currentPricePointIndex],
									value: [dates.length - 1, currentPrice, currentPrice], // 原样显示价格，不截断
									itemStyle: { color: lineColor },
									label: {
										...scatterData[currentPricePointIndex].label,
										backgroundColor: lineColor
									}
								};
								updatedSeries[scatterIndex] = {
									...updatedSeries[scatterIndex],
									data: scatterData
								};
							}
						}

						// 更新图表
						this.chartInstance.setOption({
							series: updatedSeries
						}, false);
					}

				// 更新OHLC显示 - 原样显示价格，不截断
				this.currentOHLC = {
					...this.currentOHLC,
					currentPrice: currentPrice
				};

					// 更新选中股票的价格显示
					if (this.selectedStock) {
						this.selectedStock.price = currentPrice.toString();
						this.selectedStock.nowPrice = currentPrice;
					}
				} catch (error) {
					console.error('实时更新K线图失败:', error);
				}
			},

			// 处理实时K线数据更新（真正的K线数据更新）
			updateRealTimeKLineData(realtimeData) {
				if (!realtimeData || !this.selectedStock || !this.chartInstance) return;

				const currentPrice = parseFloat(realtimeData.price);

				// 防抖机制：限制K线数据更新频率
				const now = Date.now();
				if (this.lastKlineUpdate && (now - this.lastKlineUpdate) < this.klineUpdateInterval) {
					// 频率限制内，只更新价格线
					this.updateRealTimeKLine(realtimeData);
					return;
				}
				this.lastKlineUpdate = now;
				try {
					// 获取当前图表配置
					const option = this.chartInstance.getOption();
					if (!option || !option.series || option.series.length === 0) return;

					// 获取当前K线数据
					const klineData = [...option.series[0].data];
					const dates = [...option.xAxis[0].data];

					if (klineData.length === 0) return;

					// 获取最后一根K线数据
					const lastKlineIndex = klineData.length - 1;
					const lastKline = klineData[lastKlineIndex];
					const lastDate = dates[lastKlineIndex];

					// ❌ 禁用实时创建新K线功能，避免时区问题
					// 只更新最后一根K线，新K线由后端数据决定
					const shouldCreateNewKline = false;

					if (shouldCreateNewKline) {
						// ❌ 此分支已禁用，不会创建新K线
						// 创建新的K线数据点
						const newTimeStr = this.formatTimeForKline(new Date());
						const newKline = [
							currentPrice,  // 开盘价 = 当前价格
							currentPrice,  // 收盘价 = 当前价格
							currentPrice,  // 最低价 = 当前价格
							currentPrice   // 最高价 = 当前价格
						];

						// 添加新的K线数据点
						klineData.push(newKline);
						dates.push(newTimeStr);

						// 限制K线数据长度，避免内存过大
						const maxKlineCount = 200;
						if (klineData.length > maxKlineCount) {
							klineData.shift();
							dates.shift();
						}
				} else {
					// 更新最后一根K线的数据
					const updatedKline = [
						lastKline[0],  // 开盘价保持不变
						currentPrice,  // 收盘价 = 当前价格
						Math.min(lastKline[2], currentPrice),  // 最低价
						Math.max(lastKline[3], currentPrice)   // 最高价
					];

					klineData[lastKlineIndex] = updatedKline;
				}

				// 更新图表数据 - 只更新必要的部分
				this.chartInstance.setOption({
					xAxis: {
						data: dates
					},
					series: [{
						data: klineData
					}]
				}, false, true); // 第三个参数为true表示不合并，提高性能

				// 🔑 更新OHLC信息显示 - 使用最新的K线数据
				const latestKline = klineData[klineData.length - 1];
				const latestDate = dates[dates.length - 1];
				if (latestKline && latestDate) {
					this.currentOHLC = {
						time: latestDate,
						open: latestKline[0],
						high: latestKline[3],
						low: latestKline[2],
						close: latestKline[1],
						volume: this.currentOHLC.volume || 'n/a',
						currentPrice: currentPrice
					};
				}

				// 同时更新当前价格线
			this.updateRealTimeKLine(realtimeData);

				} catch (error) {
					console.error('❌ 实时K线数据更新失败:', error);
					// 如果更新失败，至少更新价格线
					this.updateRealTimeKLine(realtimeData);
				}
			},

			// 判断是否需要创建新的K线数据点
			shouldCreateNewKline(lastDateStr, currentTime) {
				if (!lastDateStr) return true;

				try {
					// 解析最后一根K线的时间
					let lastTime;
					if (lastDateStr.length === 8) {
						// 格式: 20231201
						const year = parseInt(lastDateStr.substring(0, 4));
						const month = parseInt(lastDateStr.substring(4, 6)) - 1;
						const day = parseInt(lastDateStr.substring(6, 8));
						lastTime = new Date(year, month, day);
					} else if (lastDateStr.includes(' ')) {
						// 格式: 20231201 14:30
						const [datePart, timePart] = lastDateStr.split(' ');
						const year = parseInt(datePart.substring(0, 4));
						const month = parseInt(datePart.substring(4, 6)) - 1;
						const day = parseInt(datePart.substring(6, 8));
						const [hour, minute] = timePart.split(':').map(Number);
						lastTime = new Date(year, month, day, hour, minute);
					} else {
						return true; // 无法解析，创建新K线
					}

					// 根据选中的时间周期判断
					const selectedPeriodObj = this.timePeriods.find(p => p.value === this.selectedPeriod);
					const periodMinutes = this.getPeriodMinutes(selectedPeriodObj ? selectedPeriodObj.dateType : '5');

					// 计算时间差（分钟）
					const timeDiff = (currentTime.getTime() - lastTime.getTime()) / (1000 * 60);

					// 如果时间差超过周期，则创建新K线
					return timeDiff >= periodMinutes;

				} catch (error) {
					console.error('判断K线时间失败:', error);
					return false; // 出错时不创建新K线，只更新现有K线
				}
			},

			// 获取时间周期对应的分钟数
			getPeriodMinutes(dateType) {
				const periodMap = {
					'1': 1,    // 1分钟
					'5': 5,    // 5分钟
					'15': 15,  // 15分钟
					'30': 30,  // 30分钟
					'60': 60,  // 1小时
					'240': 240, // 4小时
					'1440': 1440 // 1天
				};
				return periodMap[dateType] || 5; // 默认5分钟
			},

			// 格式化时间用于K线显示
			formatTimeForKline(time) {
				const year = time.getFullYear();
				const month = (time.getMonth() + 1).toString().padStart(2, '0');
				const day = time.getDate().toString().padStart(2, '0');
				const hour = time.getHours().toString().padStart(2, '0');
				const minute = time.getMinutes().toString().padStart(2, '0');

				// 根据时间周期返回不同格式
				const selectedPeriodObj = this.timePeriods.find(p => p.value === this.selectedPeriod);
				const dateType = selectedPeriodObj ? selectedPeriodObj.dateType : '5';

				if (dateType === '1440') {
					// 日线只显示日期
					return `${year}${month}${day}`;
				} else {
					// 分钟线显示日期+时间
					return `${year}${month}${day} ${hour}:${minute}`;
				}
			},

			// 创建模拟K线数据
			createMockKLineData(code) {
				const currentPrice = parseFloat(this.selectedStock.price || this.selectedStock.currentPrice);
				const mockData = Array(20).fill(currentPrice).map((price, index) => {
					// 创建一些模拟的价格波动
					const variation = (Math.random() - 0.5) * price * 0.02; // 2%的波动
					const newPrice = price + variation;
					return {
						date: new Date(Date.now() - (19 - index) * 60000).toISOString().slice(0, 10).replace(/-/g, ''),
						open: newPrice,
						high: newPrice * 1.01,
						low: newPrice * 0.99,
						close: newPrice,
						volume: Math.floor(Math.random() * 1000000)
					};
				});
				this.initTradingChartWithKLineData(code, mockData);
			},

		// 获取颜色类型 - 对标st5-pc的$utils.getColor方法
		getColorType(change) {
			const changeValue = parseFloat(change) || 0;
			if (changeValue > 0) return 12; // 上涨 - 蓝色
			if (changeValue < 0) return 13; // 下跌 - 红色
			return 14; // 平盘 - 灰色
		},
	// 计算MA均线
	calculateMA(data, period) {
		const result = [];
		for (let i = 0; i < data.length; i++) {
			let sum = 0;
			const actualPeriod = Math.min(i + 1, period); // 使用实际可用的数据点数
			for (let j = 0; j < actualPeriod; j++) {
				sum += data[i - j][1]; // 使用收盘价
			}
			// 不使用toFixed，保留完整精度让ECharts处理
			result.push(sum / actualPeriod);
		}
		return result;
	},

	// 计算EMA指数移动平均线
	calculateEMA(data, period) {
		const result = [];
		const multiplier = 2 / (period + 1);
		
		// 第一个EMA值就是第一个收盘价
		let ema = data[0][1];
		
		for (let i = 0; i < data.length; i++) {
			if (i === 0) {
				result.push(ema); // 保留完整精度
			} else {
				ema = (data[i][1] - ema) * multiplier + ema;
				result.push(ema); // 保留完整精度
			}
		}
		return result;
	},

		// 计算SMA简单移动平均线
		calculateSMA(data, period) {
			return this.calculateMA(data, period);
		},

	// 计算BOLL布林带
	calculateBOLL(data, period = 20, stdDev = 2) {
		const result = { upper: [], middle: [], lower: [] };
		
		for (let i = 0; i < data.length; i++) {
			// 计算中轨（MA） - 使用实际可用的数据点
			let sum = 0;
			const actualPeriod = Math.min(i + 1, period);
			for (let j = 0; j < actualPeriod; j++) {
				sum += data[i - j][1];
			}
			const ma = sum / actualPeriod;
			
			// 计算标准差
			let variance = 0;
			for (let j = 0; j < actualPeriod; j++) {
				variance += Math.pow(data[i - j][1] - ma, 2);
			}
			const std = Math.sqrt(variance / actualPeriod);
			
			result.middle.push(ma); // 保留完整精度
			result.upper.push(ma + stdDev * std); // 保留完整精度
			result.lower.push(ma - stdDev * std); // 保留完整精度
		}
		
		return result;
	},

	// 计算SAR抛物线指标
	calculateSAR(data, step = 0.02, max = 0.2) {
		const result = [];
		if (data.length === 0) return result;
		
		let sar = data[0][2]; // 初始SAR为第一个最低价
		let ep = data[0][3];  // 极值点，初始为第一个最高价
		let af = step;        // 加速因子
		let isUptrend = true; // 趋势方向
		
		result.push(sar); // 保留完整精度
		
		for (let i = 1; i < data.length; i++) {
			const high = data[i][3];
			const low = data[i][2];
			
			// 计算新的SAR
			sar = sar + af * (ep - sar);
			
			if (isUptrend) {
				if (low < sar) {
					isUptrend = false;
					sar = ep;
					ep = low;
					af = step;
				} else {
					if (high > ep) {
						ep = high;
						af = Math.min(af + step, max);
					}
				}
			} else {
				if (high > sar) {
					isUptrend = true;
					sar = ep;
					ep = high;
					af = step;
				} else {
					if (low < ep) {
						ep = low;
						af = Math.min(af + step, max);
					}
				}
			}
			
			result.push(sar); // 保留完整精度
		}
		
		return result;
	},

	// 计算KDJ指标
	calculateKDJ(data, period = 9, k = 3, d = 3) {
		const result = { k: [], d: [], j: [] };
		let kValue = 50;
		let dValue = 50;
		
		for (let i = 0; i < data.length; i++) {
			// 找到实际可用周期内的最高价和最低价
			const actualPeriod = Math.min(i + 1, period);
			let highest = data[i][3];
			let lowest = data[i][2];
			for (let j = 1; j < actualPeriod; j++) {
				highest = Math.max(highest, data[i - j][3]);
				lowest = Math.min(lowest, data[i - j][2]);
			}
			
			// 计算RSV
			const rsv = highest === lowest ? 0 : ((data[i][1] - lowest) / (highest - lowest)) * 100;
			
			// 计算K值
			kValue = (kValue * (k - 1) + rsv) / k;
			// 计算D值
			dValue = (dValue * (d - 1) + kValue) / d;
			// 计算J值
			const jValue = 3 * kValue - 2 * dValue;
			
			result.k.push(kValue); // 保留完整精度
			result.d.push(dValue); // 保留完整精度
			result.j.push(jValue); // 保留完整精度
		}
		
		return result;
	},

	// 计算RSI相对强弱指标
	calculateRSI(data, period = 14) {
		const result = [];
		
		for (let i = 0; i < data.length; i++) {
			if (i === 0) {
				result.push(50); // 第一个点默认为50
				continue;
			}
				
			let gains = 0;
			let losses = 0;
			const actualPeriod = Math.min(i, period);
			
			for (let j = 1; j <= actualPeriod; j++) {
				const change = data[i - j + 1][1] - data[i - j][1];
				if (change > 0) {
					gains += change;
				} else {
					losses -= change;
				}
			}
				
			const avgGain = gains / actualPeriod;
			const avgLoss = losses / actualPeriod;
			
			if (avgLoss === 0) {
				result.push(100);
			} else {
				const rs = avgGain / avgLoss;
				const rsi = 100 - (100 / (1 + rs));
				result.push(rsi); // 保留完整精度
			}
		}
		
		return result;
	},

	// 计算BIAS乖离率
	calculateBIAS(data, period = 6) {
		const result = [];
		
		for (let i = 0; i < data.length; i++) {
			let sum = 0;
			const actualPeriod = Math.min(i + 1, period);
			for (let j = 0; j < actualPeriod; j++) {
				sum += data[i - j][1];
			}
			const ma = sum / actualPeriod;
			const bias = ((data[i][1] - ma) / ma) * 100;
			
			result.push(bias); // 保留完整精度
		}
		
		return result;
	},

	// 计算MACD指标
	calculateMACD(data, fastPeriod = 12, slowPeriod = 26, signalPeriod = 9) {
		const result = { dif: [], dea: [], bar: [] };
		
		// 计算快线EMA和慢线EMA
		const fastEMA = this.calculateEMA(data, fastPeriod);
		const slowEMA = this.calculateEMA(data, slowPeriod);
		
		// 计算DIF (差离值)
		for (let i = 0; i < data.length; i++) {
			result.dif.push(fastEMA[i] - slowEMA[i]);
		}
		
		// 计算DEA (DIF的EMA)
		let dea = result.dif[0];
		const multiplier = 2 / (signalPeriod + 1);
		
		for (let i = 0; i < result.dif.length; i++) {
			if (i === 0) {
				result.dea.push(dea);
			} else {
				dea = (result.dif[i] - dea) * multiplier + dea;
				result.dea.push(dea);
			}
		}
		
		// 计算BAR (柱状图)
		for (let i = 0; i < data.length; i++) {
			result.bar.push((result.dif[i] - result.dea[i]) * 2);
		}
		
		return result;
	},

	// 计算BRAR指标
	calculateBRAR(data, period = 26) {
		const result = { br: [], ar: [] };
		
		for (let i = 0; i < data.length; i++) {
			let brSum1 = 0;
			let brSum2 = 0;
			let arSum1 = 0;
			let arSum2 = 0;
			
			const actualPeriod = Math.min(i + 1, period);
			for (let j = 0; j < actualPeriod; j++) {
				const index = i - j;
				const high = data[index][3];
				const low = data[index][2];
				const open = data[index][0];
				const close = index > 0 ? data[index - 1][1] : open;
				
				brSum1 += high - close;
				brSum2 += close - low;
				arSum1 += high - open;
				arSum2 += open - low;
			}
			
			const br = brSum2 === 0 ? 0 : (brSum1 / brSum2) * 100;
			const ar = arSum2 === 0 ? 0 : (arSum1 / arSum2) * 100;
			
			result.br.push(br); // 保留完整精度
			result.ar.push(ar); // 保留完整精度
		}
		
		return result;
	},

			// 格式化价格显示
			formatPrice(price) {
				if (!price && price !== 0) return '--';
				const priceValue = parseFloat(price);
				if (isNaN(priceValue)) return '--';
				return priceValue.toFixed(2);
			},

			// 格式化涨跌幅显示
			formatChange(change) {
				if (!change && change !== 0) return '0.00';
				const changeValue = parseFloat(change);
				if (isNaN(changeValue)) return '0.00';
				return Math.abs(changeValue).toFixed(2);
			},

			// 为交易界面初始化K线图表 - 对标st5-pc
			initTradingChartWithKLineData(code, klineData) {
				// 使用trading-chart作为容器ID
				const chartId = 'trading-chart';
				let dom = document.getElementById(chartId);
				if (!dom) {
					console.error('找不到图表容器:', chartId);
					return;
				}

			// 清除之前的图表实例
			this.$echarts.dispose(dom);
			const myChart = this.$echarts.init(dom);
			
			// 保存图表实例到data中，用于后续resize
			this.chartInstance = myChart;
		// 准备K线图数据 - 转换为ECharts K线图需要的格式
			const dates = klineData.map(item => item.date);
			const klineValues = klineData.map(item => [
				parseFloat(item.open),   // 开盘价
				parseFloat(item.close),  // 收盘价
				parseFloat(item.low),    // 最低价
				parseFloat(item.high)    // 最高价
			]);
			const volumes = klineData.map(item => parseFloat(item.volume) || 0);

			// 调试信息：检查K线数据和最高最低点
				const allHighs = klineValues.map(item => item[3]); // 最高价
				const allLows = klineValues.map(item => item[2]);  // 最低价
				const maxHigh = Math.max(...allHighs);
				const minLow = Math.min(...allLows);
			
			// 🔑 智能计算显示范围（与移动端相同的逻辑）
			const { startPercentage, displayPercentage } = (() => {
				const totalDataCount = klineData.length;
				const chartWidth = dom.offsetWidth || 1200;
				
				// PC端：根据宽度和数据量计算
				let targetDisplayCount = Math.min(Math.floor(chartWidth / 8), totalDataCount);  // 约每8px一根K线
				targetDisplayCount = Math.max(targetDisplayCount, 60);  // 最少显示60条
				targetDisplayCount = Math.min(targetDisplayCount, totalDataCount);  // 不超过总数
				
				const displayPercentage = Math.min(100, (targetDisplayCount / totalDataCount) * 100);
				const startPercentage = Math.max(0, 100 - displayPercentage);
				
				return { startPercentage, displayPercentage };
			})();
			
			// 折线图配置 - 对标st5-pc样式
			const option = {
				animation: false, // 移除动画效果
				// 移除标题显示
				tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						},
						// 只显示坐标轴信息，不显示详细的K线数据
						formatter: (params) => {
							if (params && params.length > 0) {
								const dataIndex = params[0].dataIndex;
								const klineItem = klineData[dataIndex];
								if (klineItem) {
									// 计算当前数据集中的最高点和最低点
									const allHighs = klineData.map(item => Number(item.high));
									const allLows = klineData.map(item => Number(item.low));
									const maxHigh = Math.max(...allHighs);
									const minLow = Math.min(...allLows);

				// 更新OHLC信息显示 - 原样显示价格，不截断
				this.currentOHLC = {
					time: klineItem.date || new Date().toLocaleString(),
					open: klineItem.open,
					high: klineItem.high,
					low: klineItem.low,
					close: klineItem.close,
					volume: klineItem.volume || 'n/a',
					currentPrice: klineItem.close
				};
					
					// 更新指标值显示
					if (this.mainIndicators.some(ind => ind.name === 'MA' && ind.selected)) {
						const dataIndex = params[0].dataIndex;
						
						// 使用缓存的MA值
						const ma5 = this.cachedIndicatorData.ma5[dataIndex];
						const ma10 = this.cachedIndicatorData.ma10[dataIndex];
						const ma30 = this.cachedIndicatorData.ma30[dataIndex];
						const ma60 = this.cachedIndicatorData.ma60[dataIndex];
						
						this.currentIndicatorValues = {
							ma5: (ma5 !== null && ma5 !== undefined) ? ma5.toFixed(4) : '--',
							ma10: (ma10 !== null && ma10 !== undefined) ? ma10.toFixed(4) : '--',
							ma30: (ma30 !== null && ma30 !== undefined) ? ma30.toFixed(4) : '--',
							ma60: (ma60 !== null && ma60 !== undefined) ? ma60.toFixed(4) : '--'
						};
					}
				}
			}
							return ''; // 返回空字符串，只显示十字线
						}
					},
					// 添加缩放功能 - 支持手势缩放
					dataZoom: [
						{
							type: 'inside',        // 内置缩放，支持鼠标滚轮和触摸手势
							xAxisIndex: 0,         // 对X轴进行缩放
							filterMode: 'filter',  // 过滤模式
							start: startPercentage,  // 🔑 动态计算起始位置
							end: 100,              // 到100%结束，显示最新数据
							minSpan: 20,           // 🔑 最小显示20%的数据，避免过度缩小
							maxSpan: 100,          // 最大缩放比例100%
							zoomOnMouseWheel: true,    // 鼠标滚轮缩放
							moveOnMouseMove: true,     // 鼠标拖拽平移
							moveOnMouseWheel: false    // 鼠标滚轮不平移
						},
						{
							type: 'inside',        // 内置缩放
							yAxisIndex: 0,         // 对Y轴进行缩放
							filterMode: 'empty',   // 空白模式
							zoomOnMouseWheel: false,   // Y轴不响应滚轮缩放
							moveOnMouseMove: false,    // Y轴不响应鼠标拖拽
							zoomLock: true            // 锁定Y轴缩放，只允许手动触发
						},
						// 🔑 添加 Slider dataZoom 支持鼠标拖拽
						{
							type: 'slider',        // Slider 缩放器，支持PC端拖拽
							xAxisIndex: 0,         // 对X轴进行缩放
							filterMode: 'filter',  // 过滤模式
							start: startPercentage,  // 🔑 动态计算起始位置
							end: 100,              // 到100%结束，显示最新数据
							show: false,           // 🔑 隐藏slider显示
							height: 18,            // Slider高度
							bottom: '2%',          // 距离底部距离
							textStyle: {
								color: '#999'
							},
							fillerColor: 'rgba(58, 105, 250, 0.2)',  // 🔑 蓝色半透明
							handleColor: 'var(--primary-color)', // 🔑 拖拽手柄颜色 - 蓝色
							borderColor: 'var(--primary-color)'  // 🔑 边框颜色 - 蓝色
						}
				],
				grid: {
					left: '3%',
					right: '4%',
					bottom: '0',  // 🔑 时间轴紧贴底部，无额外空白
					top: '8%',
					containLabel: true
				},
					xAxis: {
						type: 'category',
						data: dates,
						boundaryGap: true, // 改为true，增加左右间距
						axisLine: {
							show: false,  // 🔑 隐藏X轴线
							lineStyle: {
								color: '#e0e0e0'
							}
						},
						axisTick: {
							show: false
						},
					axisLabel: {
						show: true, // 显示X轴标签
						color: '#666',
						fontSize: 10,
						interval: 'auto', // 自动间隔显示标签
						formatter: (value, index) => {
							return this.formatKLineTimeLabel(value, index, dates, this.selectedPeriod);
						}
					},
						splitLine: {
							show: false
						}
					},
				yAxis: {
					type: 'value',
					position: 'right',
					scale: true,
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
						},
						axisLabel: {
							formatter: function(value) {
								return value.toFixed(4);
							},
							color: '#666'
						},
						splitLine: {
							show: false  // 隐藏Y轴网格线
						}
					},
				series: (() => {
					// 计算最高点和最低点
					const allHighs = klineValues.map(item => item[3]); // 最高价
					const allLows = klineValues.map(item => item[2]);  // 最低价
					const maxHigh = Math.max(...allHighs);
					const minLow = Math.min(...allLows);

					// 找到最高点和最低点的索引
					const maxIndex = allHighs.findIndex(high => high === maxHigh);
					const minIndex = allLows.findIndex(low => low === minLow);

					// 获取当前价格（最新的收盘价）
					const currentPrice = klineValues[klineValues.length - 1][1]; // 最新收盘价
					const openPrice = klineValues[0][0]; // 开盘价

				// 动态获取主题色
			const primaryColor = getComputedStyle(document.documentElement)
				.getPropertyValue('--primary-color').trim() || '#0156DC';
			
			// ✅ 使用主题色作为价格线颜色（不再区分涨跌）
			const lineColor = primaryColor; // 统一使用主题色
					// 基础系列数组
					const seriesArray = [
						{
							name: 'K线图',
							type: 'candlestick',
							data: klineValues,
							animation: false, // 禁用K线动画
							barWidth: '70%', // 设置K线宽度，对标st5样式
				itemStyle: {
						// 阳线样式（涨 - 绿色）
						color: primaryColor,        // 阳线实体颜色
						color0: '#FD1050',       // 阴线实体颜色（跌 - 红色）
						borderColor: primaryColor,  // 阳线边框和影线颜色
						borderColor0: '#FD1050', // 阴线边框和影线颜色
						borderWidth: 1,          // 影线宽度
						borderWidth0: 1          // 阴线影线宽度
					},
								emphasis: {
									itemStyle: {
										borderWidth: 2,
										borderWidth0: 2
									}
								}
							},
							// 添加当前价格线
							{
								name: '当前价格线',
								type: 'line',
								data: dates.map(() => currentPrice), // 所有点都是当前价格
								lineStyle: {
									color: lineColor,
									width: 1,
									type: 'dashed',
									opacity: 0.6
								},
								symbol: 'none',
								animation: false,
								silent: true,
								z: 5
							},
							// 添加独立的scatter系列显示最高最低点标签
							{
								name: '价格标记',
								type: 'scatter',
								data: [
									{
										name: '最高点',
										value: [maxIndex, maxHigh, maxHigh.toFixed(4)],
										itemStyle: {
											color: 'transparent',  // 透明点
											borderColor: 'transparent',
											borderWidth: 0
										},
										label: {
											show: true,
											formatter: function(params) {
												return params.value[2];
											},
											position: 'top',
											color: '#999',        // 灰色字体
											fontSize: 10,         // 小字体
											fontWeight: 'normal'  // 正常字重
										}
									},
									{
										name: '最低点',
										value: [minIndex, minLow, minLow.toFixed(4)],
										itemStyle: {
											color: 'transparent',  // 透明点
											borderColor: 'transparent',
											borderWidth: 0
										},
										label: {
											show: true,
											formatter: function(params) {
												return params.value[2];
											},
											position: 'bottom',
											color: '#999',        // 灰色字体
											fontSize: 10,         // 小字体
											fontWeight: 'normal'  // 正常字重
										}
									},
								{
									name: '当前价格',
									value: [dates.length - 1, currentPrice, currentPrice], // 原样显示价格，不截断
									itemStyle: {
										color: 'transparent',  // 改为透明，不显示标记点
										borderColor: 'transparent',
										borderWidth: 0
									},
									label: {
										show: true,
										formatter: function(params) {
											return params.value[2];
										},
										position: 'right',
											color: '#fff',
											fontSize: 12,
											fontWeight: 'bold',
											backgroundColor: lineColor,  // 使用当前价格线的颜色
											padding: [4, 8],
											borderRadius: 4
										}
									}
								],
								symbolSize: 0,  // 设置为0，不显示标记点
								animation: false,
								z: 10
							}
					];

		// 添加技术指标 - 只添加主图指标到主图
		const selectedMainIndicators = this.mainIndicators.filter(ind => ind.selected);
		// 只添加主图指标到主图series
		this.addIndicatorSeries(selectedMainIndicators, klineValues, seriesArray);

		return seriesArray;
				})()
				};

		// 设置图表选项
		myChart.setOption(option);

	// 初始化副图（如果有选中的副图指标）
	const selectedSubIndicators = this.subIndicators.filter(item => item.selected);
	if (selectedSubIndicators.length > 0) {
		this.$nextTick(() => {
			const subChartDom = document.getElementById('sub-chart');
			if (subChartDom) {
				// 销毁旧的副图实例
				if (this.subChartInstance) {
					this.subChartInstance.dispose();
				}
				// 创建新的副图实例
				this.subChartInstance = this.$echarts.init(subChartDom);
				this.initSubChart(selectedSubIndicators, klineValues, dates);
			}
		});
	} else {
		// 如果没有选中的副图指标，清空副图
		if (this.subChartInstance) {
			this.subChartInstance.dispose();
			this.subChartInstance = null;
		}
	}
		// 响应式调整 - 移除旧的监听器，避免内存泄漏
		if (this.chartResizeHandler) {
			window.removeEventListener('resize', this.chartResizeHandler);
		}
		
		// 创建新的resize处理函数
		const self = this;
		this.chartResizeHandler = function() {
			myChart.resize();
			if (self.subChartInstance) {
				self.subChartInstance.resize();
			}
		};
		window.addEventListener('resize', this.chartResizeHandler);
				// 验证图表是否正确渲染
				setTimeout(() => {
				}, 1000);

				// 重置更新标志
				this.isUpdatingChart = false;
			},

			// 订单管理方法
			selectOrderTab(index) {
				this.selectedOrderTab = index;
			},

			// 获取持仓数据 - 接入真实API（合约持仓订单）
		// 获取所有合约订单（一次性获取，根据status过滤）
		async getAllContractOrders() {
			try {
				// 不传status参数，获取所有合约订单
				const res = await listUOrder({ pageNo: 1, pageSize: 500 });

				if (res && res.code === 200) {
					const records = res.result?.records || res.result || [];
					
					// 映射并存储所有订单
					this.allContractOrders = Array.isArray(records) ? records.map(item => ({
						...item,
						orderType: 'contract',
						displayType: '合约',
						symbol: item.marketCode || item.marketName || '-',
						marketName: item.marketName || item.marketCode || '-',
						marketCode: item.marketCode || '-',
						number: item.hands || 0,
						price: item.buyPrice || 0,
						buyPrice: item.buyPrice || 0,
						sellPrice: item.sellPrice || item.buyPrice || 0,
						update_price: item.sellPrice || item.buyPrice || 0,
						target_profit_price: item.stopLoss || '-', // stopLoss是止盈参数
						stop_loss_price: item.stopProfit || '-', // stopProfit是止损参数
						trade_fee: item.tradeFee || 0,
						caution_money: item.margin || 0,
						upsdowns: item.income || 0,
						profit: item.income || 0,
						income: item.income || 0,
						buyTime: item.createTime,
						createTime: item.createTime,
						updateTime: item.updateTime,
						transaction_time: item.updateTime || item.createTime
					})) : [];

					//console.log(`✅ 合约订单数据加载成功: 共 ${this.allContractOrders.length} 条记录`);
					//console.log(`   - 挂单中 (status=0): ${this.allContractOrders.filter(o => o.status === 0).length} 条`);
					//console.log(`   - 持仓中 (status=1): ${this.allContractOrders.filter(o => o.status === 1).length} 条`);
					//console.log(`   - 已平仓 (status=2): ${this.allContractOrders.filter(o => o.status === 2).length} 条`);
					
					return this.allContractOrders;
				} else {
					this.allContractOrders = [];
					return [];
				}
			} catch (error) {
				console.error('❌ 获取所有合约订单失败:', error);
				this.allContractOrders = [];
				return [];
			}
		},

		async getPositionData(forceRefresh = false) {
			
			// 检查登录状态
			const token = localStorage.getItem('token');
			const isLogin = localStorage.getItem('isLogin');
			const isLoggedIn = !!(token || isLogin === 'true' || isLogin === '1');
			
		if (!isLoggedIn) {
			this.contractIndexList = [];
			return;
		}
		
		try {
			// 如果需要强制刷新或还没有缓存，先获取所有订单
			if (forceRefresh || !this.allContractOrders) {
				await this.getAllContractOrders();
			}

			// 从缓存中过滤 status=1 且 isXj=0 的订单（持仓中）
			this.contractIndexList = (this.allContractOrders || []).filter(item => item.status === 1 && item.isXj === 0);
				
				//console.log(`✅ 合约持仓数据加载成功: ${this.contractIndexList.length} 条记录`);

				// 计算总盈亏和保证金
				this.calculateTotals();
			} catch (error) {
				console.error('❌ 获取合约持仓数据失败:', error);
				this.contractIndexList = [];
			}

			// 强制更新DOM
			this.$forceUpdate();
		},

	// 获取挂单数据 - 从缓存中过滤 status=0 且 isXj=1 的订单
	async getPendingOrderData(forceRefresh = false) {
		try {
			// 如果需要强制刷新或还没有缓存，先获取所有订单
			if (forceRefresh || !this.allContractOrders) {
				await this.getAllContractOrders();
			}


					let allPendingOrders = [];

					// 从缓存中过滤合约挂单（status=0 且 isXj=1）
					const contractPending = (this.allContractOrders || []).filter(order => order.status === 0 && order.isXj === 1);
					allPendingOrders = [...contractPending];
					
					//console.log(`✅ 挂单数据加载成功: ${allPendingOrders.length} 条记录`);

					// 按时间排序（最新的在前）
					allPendingOrders.sort((a, b) => {
						const timeA = new Date(a.transaction_time || a.createTime || 0);
						const timeB = new Date(b.transaction_time || b.createTime || 0);
						return timeB - timeA;
					});

					this.pendingOrders = allPendingOrders;
				} catch (error) {
					console.error('❌ 获取挂单数据失败:', error);
					// 出错时设置为空数组
					this.pendingOrders = [];
				}

				// 强制更新DOM
				this.$forceUpdate();
			},

	// 获取历史订单数据 - 从缓存中过滤 status=1 的订单
	async getHistoryOrderData(forceRefresh = false) {
		try {
			// 如果需要强制刷新或还没有缓存，先获取所有订单
			if (forceRefresh || !this.allContractOrders) {
				await this.getAllContractOrders();
			}

					let allOrders = [];

					// 从缓存中过滤合约历史订单（status=2 已平仓）
					const contractOrders = (this.allContractOrders || []).filter(order => order.status === 2);
					allOrders = [...contractOrders];
					
					//console.log(`✅ 历史订单数据加载成功: ${allOrders.length} 条记录`);

					// 按时间排序（最新的在前）
					allOrders.sort((a, b) => {
						const timeA = new Date(a.transaction_time || a.createTime || 0);
						const timeB = new Date(b.transaction_time || b.createTime || 0);
						return timeB - timeA;
					});

					this.historyOrders = allOrders;

				} catch (error) {
					console.error('❌ 获取合约历史订单数据失败:', error);
					// 出错时设置为空数组
					this.historyOrders = [];
				}

				// 强制更新DOM
				this.$forceUpdate();
			},

			// 获取所有期权订单数据（一次性获取500条，然后根据status过滤）
		async getAllOptionsOrders() {
			try {
				// 不传status参数，获取所有订单，pageSize=500
				const res = await listOptionsOrder({ pageNo: 1, pageSize: 500 });

				if (res && res.code === 200) {
					const records = res.result?.records || res.result || [];
					
					// 计算服务器时间偏移 - 使用最新的订单创建时间
					if (Array.isArray(records) && records.length > 0) {
						// 找到最新的订单（createTime 最大的）
						const latestOrder = records.reduce((latest, current) => {
							const latestTime = new Date((latest.createTime || '').replace(/-/g, '/').replace(/\.\d+/, '')).getTime();
							const currentTime = new Date((current.createTime || '').replace(/-/g, '/').replace(/\.\d+/, '')).getTime();
							return currentTime > latestTime ? current : latest;
						}, records[0]);
						
						const serverTime = latestOrder.createTime;
						if (serverTime) {
							this.calculateServerTimeOffset(serverTime);
						}
					}
					
					// 映射并存储所有订单
					const allOrders = Array.isArray(records) ? records.map(item => ({
							...item,
							orderType: 'options',
							displayType: '期权',
							symbol: item.marketCode || item.marketName || '-',
							marketName: item.marketName || item.marketCode || '-',
							marketCode: item.marketCode || '-',
							number: 1,
							price: item.buyPrice || 0,
							buyPrice: item.buyPrice || 0,
							sellPrice: item.endPrice || 0,
							update_price: item.endPrice || item.buyPrice || 0,
							endPrice: item.endPrice || 0,
							leverage: item.leverage || null,
							target_profit_price: '-',
							stop_loss_price: '-',
							trade_fee: item.tradeFee || 0,
							tradeFee: item.tradeFee || 0,
							caution_money: item.amount || 0,
							amount: item.amount || 0,
							upsdowns: item.income || 0,
							income: item.income || 0,
							profit: item.income || 0,
							buyTime: item.createTime || '',
							createTime: item.createTime || '',
							updateTime: item.updateTime || item.createTime || '',
							transaction_time: item.updateTime || item.createTime || '',
							// 期权特有字段
							limitTime: item.limitTime || 0,
							rate: item.rate || 0,
							type: item.type, // 1=看涨, 2=看跌
							resultType: item.resultType, // 1=盈利, 2=亏损
							status: item.status // 0=交易中, 1=已平仓
						})) : [];
						
						// 存储所有订单数据
						this.allOptionsOrders = allOrders;
					} else {
						this.allOptionsOrders = [];
					}
				} catch (error) {
					console.error('❌ 获取期权订单数据失败:', error);
					this.allOptionsOrders = [];
				}
			},

		// 获取期权持仓数据（从缓存中过滤 status=0）
	async getOptionsPositionData(forceRefresh = false) {
		
		// 如果需要强制刷新，或者还没有加载所有订单，先加载
		if (forceRefresh || !this.allOptionsOrders) {
			await this.getAllOptionsOrders();
		}
		
		// 过滤出 status=0 的订单（持仓中）
		this.optionsIndexList = (this.allOptionsOrders || []).filter(item => item.status === 0);
		
		//console.log(`✅ 期权持仓数据加载成功: ${this.optionsIndexList.length} 条记录`);
		
		// 启动期权倒计时定时器
		this.startOptionsCountdownTimer();
		
		this.$forceUpdate();
	},

		// 获取期权历史数据（从缓存中过滤 status=1）
		async getOptionsHistoryData(forceRefresh = false) {
			
			// 如果需要强制刷新，或者还没有加载所有订单，先加载
			if (forceRefresh || !this.allOptionsOrders) {
				await this.getAllOptionsOrders();
			}
			
			// 过滤出 status=1 的订单（已平仓）
			this.historyOrders = (this.allOptionsOrders || []).filter(item => item.status === 1);
			
		this.$forceUpdate();
	},

	// 计算服务器时间偏移量
	calculateServerTimeOffset(serverTimeStr) {
		if (!serverTimeStr) {
			return;
		}
		
		try {
			// 将服务器时间字符串转换为时间戳
			const serverTime = new Date(serverTimeStr.replace(/-/g, '/').replace(/\.\d+/, '')).getTime();
			const clientTime = new Date().getTime();
			
			// 计算偏移量：服务器时间 - 客户端时间
			this.serverTimeOffset = serverTime - clientTime;
			
			const offsetHours = (this.serverTimeOffset / 1000 / 3600).toFixed(2);
			const offsetMinutes = Math.floor(Math.abs(this.serverTimeOffset) / 1000 / 60);
			
			//console.log('⏰ 服务器时间偏移量已更新:', {
			// 	serverTime: serverTimeStr,
			// 	serverTimeMs: serverTime,
			// 	serverTimeDate: new Date(serverTime).toLocaleString(),
			// 	clientTimeMs: clientTime,
			// 	clientTimeDate: new Date(clientTime).toLocaleString(),
			// 	offset: this.serverTimeOffset + 'ms',
			// 	offsetHours: offsetHours + 'h',
			// 	offsetMinutes: offsetMinutes + 'min',
			// 	note: this.serverTimeOffset > 0 ? '服务器时间比客户端快' : '客户端时间比服务器快'
			// });
		} catch (error) {
			console.error('❌ 计算服务器时间偏移量失败:', error);
		}
	},
	// 计算期权倒计时
	getOptionsCountdown(order) {
		// 如果订单已完成（status === 2），返回 0 表示已结束
		if (order.status === 2) {
			return 0;
		}
		
		if (!order.limitTime) {
			return 0;
		}
		
		// 尝试从多个字段获取创建时间
		let createTimeStr = order.createTime || order.buyTime || order.updateTime;
		if (!createTimeStr) {
			return 0;
		}
		
	// 将创建时间转换为时间戳
	const createTime = new Date(createTimeStr.replace(/-/g, '/').replace(/\.\d+/, '')).getTime();
	if (isNaN(createTime)) {
		console.warn('⚠️ 无效的创建时间:', createTimeStr, 'order:', order);
		return 0;
	}
	
	// 获取当前时间
	const now = new Date().getTime();
	
	// 计算从订单创建到现在已经过去的时间（毫秒）
	const elapsedTime = now - createTime;
	
	// 计算剩余时间（秒）
	// limitTime 是期限（秒），如 180s、360s、720s
	const remaining = Math.max(0, Math.floor((order.limitTime * 1000 - elapsedTime) / 1000));
		
		// 调试日志 - 只在第一次计算时打印
		if (!order._countdownDebugLogged) {
			order._countdownDebugLogged = true;
			//console.log('🔍 倒计时调试信息:', {
			// 	orderId: order.id,
			// 	createTimeStr: createTimeStr,
			// 	createTime: createTime,
			// 	createTimeDate: new Date(createTime).toLocaleString(),
			// 	limitTime: order.limitTime + 's',
			// 	limitTimeMs: order.limitTime * 1000,
			// 	clientNow: clientNow,
			// 	clientNowDate: new Date(clientNow).toLocaleString(),
			// 	timeOffset: TIME_OFFSET_MS + 'ms (6小时)',
			// 	serverNow: serverNow,
			// 	serverNowDate: new Date(serverNow).toLocaleString(),
			// 	elapsedTime: elapsedTime + 'ms (' + Math.floor(elapsedTime / 1000) + 's)',
			// 	remainingSeconds: remaining + 's',
			// 	计算公式: `剩余 = (限时时长 ${order.limitTime * 1000} - 已过去时间 ${elapsedTime}) / 1000`
			// });
		}
		
		// 如果倒计时已经为0但订单状态还是1（进行中），刷新订单状态（但不在render中触发）
		if (remaining === 0 && order.status === 1) {
			// 使用 nextTick 避免在渲染过程中修改状态
			if (!this.optionsRefreshTimeout) {
				this.$nextTick(() => {
					this.optionsRefreshTimeout = setTimeout(() => {
						//console.log('⏰ 倒计时结束，刷新期权订单数据...');
						this.getOptionsPositionData(true);
						this.optionsRefreshTimeout = null;
					}, 2000);
				});
			}
		}
		
		return remaining;
	},

			// 启动期权倒计时定时器
			startOptionsCountdownTimer() {
				// 清除之前的定时器
				if (this.optionsCountdownTimer) {
					clearInterval(this.optionsCountdownTimer);
				}
				
		// 启动新的定时器，每秒更新一次
		this.optionsCountdownTimer = setInterval(() => {
			// 检查是否有期权持仓需要倒计时
			const hasActiveOptions = this.optionsIndexList.some(order => this.getOptionsCountdown(order) > 0);
					
					if (hasActiveOptions) {
						// 强制更新视图以刷新倒计时显示
						this.$forceUpdate();
					} else {
						// 如果没有活跃的期权订单，停止定时器并刷新数据
						clearInterval(this.optionsCountdownTimer);
						this.optionsCountdownTimer = null;
						
						// 刷新期权数据，将已结束的订单移到历史
						if (this.mainOrderType === 'options' && this.tabIndex === 0) {
							this.getOptionsPositionData();
						}
					}
				}, 1000);
			},

	// 获取盈亏汇总数据 - 根据当前订单类型分别计算（与手机端逻辑一致）
	async getProfitSummary() {
		try {
			// 盈亏：根据当前订单类型和tab显示对应的盈亏
			let profitLoss = 0;
			
		// 如果是持仓中tab（tabIndex=0），计算持仓订单的初始盈亏
		// 之后由子组件 OrderManagement 通过 updateTotalPnl 实时更新（带波动效果）
		if (this.tabIndex === 0) {
			// 持仓中：计算当前持仓订单的初始盈亏
			profitLoss = this.currentIndexList.reduce((sum, order) => {
				return sum + (parseFloat(order.upsdowns) || parseFloat(order.income) || 0);
			}, 0);
			} else {
				// 其他tab：显示历史订单的累计盈亏
				if (this.mainOrderType === 'contract') {
					// 合约模式：只显示合约历史订单的盈亏
					profitLoss = this.calculateContractHistoryProfitLoss();
				} else {
					// 期权模式：只显示期权历史订单的盈亏
					profitLoss = this.calculateFutureHistoryProfitLoss();
				}
			}
			
	// 保证金：合约模式下根据不同tab分别计算（使用 mainOrderType）
	let currentMargin = 0;
	if (this.mainOrderType === 'contract') {
				switch(this.tabIndex) {
					case 0: // 持仓tab
						currentMargin = this.calculatePositionsMargin();
						break;
					case 1: // 挂单tab
						currentMargin = this.calculatePendingMargin();
						break;
					case 2: // 历史tab
						currentMargin = this.calculateHistoryMargin();
						break;
					default:
						currentMargin = 0;
				}
			} else {
				// 期权模式不显示保证金
				currentMargin = 0;
			}
			
			this.hylist = {
				yks: profitLoss,
				caution_money: currentMargin
			};
				} catch (error) {
					console.error('获取盈亏汇总失败:', error);
				}
			},

		// 计算总计数据
		calculateTotals() {
			if (this.currentIndexList.length > 0) {
				const totalPnl = this.currentIndexList.reduce((sum, item) => sum + (parseFloat(item.upsdowns) || 0), 0);
				const totalMargin = this.currentIndexList.reduce((sum, item) => sum + (parseFloat(item.caution_money) || 0), 0);

					this.hylist = {
						yks: totalPnl.toFixed(2),
						caution_money: totalMargin.toFixed(2)
					};
				}
			},
			
		// 计算合约历史订单的累计盈亏
		calculateContractHistoryProfitLoss() {
			let contractPnL = 0;
			
			// 合约历史订单盈亏（使用缓存的所有订单）
			if (this.allContractOrders && this.allContractOrders.length > 0) {
				const contractHistory = this.allContractOrders.filter(order => order.status === 2);
				contractPnL = contractHistory.reduce((sum, order) => {
					return sum + (parseFloat(order.upsdowns) || parseFloat(order.income) || 0);
				}, 0);
			}
			
			return contractPnL;
		},
			
		// 计算期权历史订单的累计盈亏
		calculateFutureHistoryProfitLoss() {
			let futurePnL = 0;
			
			// 期权历史订单盈亏（使用缓存的所有订单）
			if (this.allOptionsOrders && this.allOptionsOrders.length > 0) {
				const futureHistory = this.allOptionsOrders.filter(order => order.status === 1);
				futurePnL = futureHistory.reduce((sum, order) => {
					return sum + (parseFloat(order.upsdowns) || parseFloat(order.income) || 0);
				}, 0);
				console.log(`💰 PC端期权历史订单数: ${futureHistory.length}, 累计盈亏: ${futurePnL.toFixed(2)}`);
			}
			
			return futurePnL;
		},
			
		// 计算持仓保证金总和
		calculatePositionsMargin() {
			return this.currentIndexList.reduce((sum, position) => sum + (parseFloat(position.caution_money) || 0), 0);
		},
			
		// 计算挂单保证金总和
		calculatePendingMargin() {
			return this.pendingOrders.reduce((sum, order) => sum + (parseFloat(order.caution_money) || 0), 0);
		},
		
		// 计算历史订单保证金总和
		calculateHistoryMargin() {
			return this.historyOrders.reduce((sum, order) => sum + (parseFloat(order.caution_money) || 0), 0);
		},
			selectPosition(position) {
				// 这里可以添加选择持仓的逻辑，比如显示详情弹窗
			},
			selectPendingOrder(order) {
				// 这里可以添加选择挂单的逻辑
			},
			selectHistoryOrder(order) {
				// 这里可以添加选择历史订单的逻辑
			},
		cancelOrder(order) {
			// 取消挂单
			const index = this.pendingOrders.findIndex(o => o.id === order.id);
			if (index > -1) {
				this.pendingOrders.splice(index, 1);
				// 这里可以添加API调用来取消订单
			}
		},
		
		// ========== 交易状态检查相关方法 ==========
		// 检查单个币种的交易时间
		async checkSingleTradingTime(marketId, tradeType = 1) {
			try {
				const res = await checkTradingTime({
					marketId: marketId,
					tradeType: tradeType // 1=合约, 2=期权
				})
				
				if (res.code === 200) {
					// 缓存交易状态
					this.$set(this.tradingStatuses, marketId, {
						canTrade: res.result.canTrade,
						reason: res.result.reason,
						currentTime: res.result.currentTime
					})
					return res.result.canTrade
				}
			} catch (error) {
				console.error('检查交易时间失败:', error)
				// 失败时默认为不可交易
				this.$set(this.tradingStatuses, marketId, {
					canTrade: false,
					reason: '无法获取交易状态'
				})
				return false
			}
		},
		
		// 批量检查交易时间
		async checkAllTradingTimes() {
			if (this.checkingTradingStatus || !this.marketList || this.marketList.length === 0) {
				return
			}
			
			this.checkingTradingStatus = true
			
			try {
				// 为每个币种检查交易时间
				const promises = this.marketList.map(item => 
					this.checkSingleTradingTime(item.id, 1) // 1=合约
				)
				
				await Promise.all(promises)
			} catch (error) {
				console.error('批量检查交易时间失败:', error)
			} finally {
				this.checkingTradingStatus = false
			}
		},
		
		// 获取交易状态
		getTradingStatus(marketId) {
			const status = this.tradingStatuses[marketId]
			if (!status) {
				return { canTrade: null, reason: '检查中...' }
			}
			return status
		}
	}
}
</script>
<style scoped>
	/* 防止页面出现水平滚动条 */
	* {
		box-sizing: border-box;
	}
	
	/* 隐藏所有垂直滚动条但保持滚动功能 */
	* {
		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* IE and Edge */
	}
	
	*::-webkit-scrollbar {
		display: none; /* Chrome, Safari and Opera */
	}
	
	.home {
		margin-top: 10px;
		width: 100%;
		/* height: 100vh; */
		overflow: visible;
		overflow-x: hidden;
		max-width: 100vw;
		box-sizing: border-box;
	}

	.home-header {
		width: 12rem;
		margin: auto;
		position: relative;
	}

	.home-header .home-header-title {
		width: 7.27rem;
		/* height: 2.09rem; */
		color: #000;
		font-size: 0.30rem;
		line-height: 0.7rem;
		font-family: Mabry Pro;
		font-weight: 600;
	}

	.home-header .home-header-app {
		width: 2.4rem;
		height: 0.82rem;
		border-radius: 0.16rem;
		padding: 0.18rem 0.24rem;
		background: #fff;
		margin-top: 0;
		/* margin-top: 0.86rem; */
		position: relative;
		font-family: Mabry Pro;
		color:#000;
		border: 1px solid #000;
	}

	.home-header .home-header-app .app-icon {
		position: absolute;
		width: 0.23rem;
		height: 0.28rem;
		left: 0.25rem;
		top: 0.24rem;
	}
	.info_list .app-icon{
		float: left;
    width: 0.23rem;
    height: 0.28rem;
    left: 0.25rem;
    top: 0.24rem;

	}

	.home-header .home-header-app .app-right {
		position: absolute;
		left: 0.61rem;
	}

	.home-header .home-header-app .app-right .app-ava {
		font-weight: 400;
		font-size: 0.14rem;
		line-height: 0.14rem;
		/* color: hsla(0, 0%, 100%, 0.7); */
	}

	.home-header .home-header-app .app-right .app-store {
		font-weight: 700;
		font-size: 0.24rem;
		line-height: 0.24rem;
		/* color: #fff; */
	}

	.home-header .home-header-application,
	.home-header .home-header-credit {
		font-family: Mabry Pro;
		margin-top: 0.75rem;
	}

	.home-header .home-header-application .icon-title,
	.home-header .home-header-credit .icon-title {
		height: 0.24rem;
		display: flex;
		font-weight: 700;
		font-size: 0.24rem;
		color: #000;
		margin-bottom: 0.16rem;
	}

	.home-header .home-header-application .icon-title img,
	.home-header .home-header-credit .icon-title img {
		width: 0.22rem;
		height: 0.24rem;
		transform: rotate(90deg);
		margin-top: 0.12rem;
		position: relative;
		top: -0.12rem;
	}

	.home-header .home-header-application .icon-title span,
	.home-header .home-header-credit .icon-title span {
		margin-left: 0.12rem;
		font-family: Mabry Pro;
	}
	.home-header .home-header-application .icon-content,
	.home-header .home-header-credit .icon-content {
		font-family: Mabry Pro;
		width: 4.1rem;
		height: 0.38rem;
		font-weight: 400;
		font-size: 0.15rem;
		line-height: 0.22rem;
		position: relative;
		left: 0.34rem;
	}

	.home-header .home-header-credit {
		margin-top: 0.46rem;
	}

	.home-header .home-header-box {
		/* width: 10.22rem; */
		/* height: 1.22rem; */
		background: #fff;
		box-shadow: 0 0.56rem 0.54rem rgba(0, 0, 0, 0.04);
		border-radius: 0.14rem;
		margin-top: 1.48rem;
		display: flex;
		align-items: center;
		padding: 0.68rem 0.89rem;
		z-index: 1;
	}

	.home-header .home-header-box .box-mill,
	.home-header .home-header-box .box-money,
	.home-header .home-header-box .box-times {
		height: 1.22rem;
		width: 3.49rem;
	}

	.home-header .home-header-box .box-mill .box-top,
	.home-header .home-header-box .box-money .box-top,
	.home-header .home-header-box .box-times .box-top {
		height: 0.52rem;
		font-weight: 500;
		font-size: 0.52rem;
		line-height: 100%;
		color: #000;
		font-family: Mabry Pro;
		margin-bottom: 0.18rem;
	}

	.home-header .home-header-box .box-mill .box-content,
	.home-header .home-header-box .box-money .box-content,
	.home-header .home-header-box .box-times .box-content {
		height: 0.52rem;
		font-weight: 400;
		font-size: 0.22rem;
		line-height: 0.3rem;
		font-family: Mabry Pro;
		color: rgba(0, 0, 0, 0.6);
	}

	.home-header .home-header-box .box-times {
		width: 2.36rem;
		margin-left: 0.94rem;
		margin-right: 1.01rem;
	}

	.home-header .home-header-box .box-mill {
		width: 2.43rem;
	}

	.home-header .home-header-imgs {
		position: absolute;
		right: 0.89rem;
		top: -0.48rem;
		width: 5.34rem;
		height: 8.82rem;
	}

	.home-header .home-header-imgs .imgs-left {
		position: absolute;
		width: 2.74rem;
		height: 5.59rem;
		left: -0.3rem;
		top: 2.6rem;
		filter: drop-shadow(-0.15rem 1.04rem 0.4rem rgba(0, 0, 0, 0.08));
		z-index: -1;
	}

	.home-header .home-header-imgs .imgs-right {
		position: absolute;
		width: 3.32rem;
		height: 8.82rem;
		right: 0;
		filter: drop-shadow(-0.15rem 1.04rem 0.4rem rgba(0, 0, 0, 0.08));
		background-size: cover;
		z-index: -1;
	}

	.home-body {
		display: none;
		width: 13.2rem;
		margin: auto;
		margin-top: 1rem;
	}

	.home-body .box-butttons1 {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: stretch;
	}

	.home-body .box-butttons1 .buttons-big {
		padding: 0.34rem 0;
		width: 6.51rem;
		border-radius: 0.16rem;
		background: #000;
		background-size: cover;
		position: relative;
		overflow: hidden;
	}

	.home-body .box-butttons1 .buttons-big .info-buttons-content {
		position: relative;
		width: 100%;
		height: 100%;
		z-index: 2;
	}

	.home-body .box-butttons1 .buttons-big .info-buttons-content .content-icon {
		width: 0.28rem;
		height: 0.28rem;
		background: url(../../../assets/img/icon_vetor.e4607d5d.svg) no-repeat;
		border-radius: 0.28rem;
		margin: 0 auto;
	}

	.home-body .box-butttons1 .buttons-big .info-buttons-content .content-text {
		width: 100%;
		height: 0.24rem;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 700;
		font-size: 0.24rem;
		line-height: 0.24rem;
		color: #fff;
		margin-top: 0.16rem;
		margin-bottom: 0.12rem;
		text-align: center;
	}

	.home-body .box-butttons1 .buttons-big .info-buttons-content .content-text1 {
		padding: 0 0.3rem;
		box-sizing: border-box;
		width: 100%;
		line-height: 0.2rem;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 300;
		font-size: 0.16rem;
		color: hsla(0, 0%, 100%, 0.6);
		text-align: center;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.home-body .box-butttons1 .buttons-big2:before {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #9ee970);
		transform: rotate(-90deg);
		display: inline-block;
		border-radius: 0.55rem;
		position: absolute;
		right: -0.35rem;
		top: -0.7rem;
	}

	.home-body .box-butttons1 .buttons-big2:after {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #a5a6f5);
		transform: rotate(-30deg);
		display: inline-block;
		border-radius: 0.55rem;
		position: absolute;
		left: 1.2rem;
		bottom: -0.7rem;
	}

	.home-body .box-butttons1 .buttons-big1 {
		background: unset;
		border: 0.01rem solid #000;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.home-body .box-butttons1 .buttons-big1 .content-icon {
		width: 0.42rem;
		height: 0.42rem;
		background: url(../../../assets/img/icon_bell1.98a9a1d5.svg) no-repeat;
		background-size: cover;
	}

	.home-body .box-butttons1 .buttons-big1 .content-text {
		width: 80%;
		height: 0.5rem;
		font-weight: 700;
		font-size: 0.22rem;
		color: #000;
		margin-top: 0.15rem;
		text-align: center;
	}

	.home-body .box-butttons2 {
		margin-top: 0.18rem;
		width: 100%;
		height: 2.68rem;
		display: flex;
		justify-content: space-between;
	}

	.home-body .box-butttons2 .butttons2 {
		width: 3.18rem;
		height: 2.68rem;
		border-radius: 0.1rem;
		background: #000 no-repeat;
		background-size: cover;
		position: relative;
		overflow: hidden;
	}

	.home-body .box-butttons2 .butttons2 .info-buttons-content {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 2;
	}

	.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-icon {
		width: 0.46rem;
		height: 0.46rem;
		text-align: center;
		margin: auto;
		margin-top: 0.54rem;
	}

	.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-icon1 {
		margin-top: 0.35rem;
	}

	.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text1 {
		width: 100%;
		font-weight: 300;
		font-size: 0.12rem;
		line-height: 100%;
		text-align: center;
		color: hsla(0, 0%, 100%, 0.6);
		margin-top: 0.17rem;
		margin-bottom: 0.12rem;
		font-family: Mabry Pro;
	}

	.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text2 {
		width: 100%;
		font-weight: 700;
		font-size: 0.2rem;
		line-height: 100%;
		text-align: center;
		color: #fff;
		margin-bottom: 0.12rem;
		font-family: Mabry Pro;
	}

	.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text3 {
		width: 100%;
		font-weight: 300;
		font-size: 0.12rem;
		line-height: 0.2rem;
		text-align: center;
		color: hsla(0, 0%, 100%, 0.6);
		margin-bottom: 0.12rem;
		font-family: Mabry Pro;
	}

	.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-button {
		font-family: Mabry Pro;
		width: 1.14rem;
		height: 0.34rem;
		background: #fff;
		border-radius: 0.22rem;
		font-weight: 500;
		font-size: 0.14rem;
		line-height: 100%;
		text-align: center;
		line-height: 0.34rem;
		margin: auto;
	}

	.home-body .box-butttons2 .butttons2:before {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #a5a6f5);
		display: inline-block;
		border-radius: 0.55rem;
		position: absolute;
		left: -0.2rem;
		bottom: -0.4rem;
	}

	.home-body .box-butttons2 .butttons2:after {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #9ee970);
		transform: rotate(-180deg);
		display: inline-block;
		border-radius: 0.55rem;
		position: absolute;
		right: -0.2rem;
		top: -0.5rem;
	}

	.box-lists {
		width: 9.86rem;
		margin: auto;
		margin-top: 1.3rem;
		margin-bottom: 1.3rem
	}

	.box-lists .box-heder {
		width: 100%;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 400;
		font-size: .18rem;
		line-height: 100%;
		color: rgba(0, 0, 0, .5);
		height: .38rem;
		display: flex;
		justify-content: space-between
	}
	.box-lists .box-heder div {
		float: left
	}
	.box-lists .box-heder .box-heder1 {
		margin-left: .44rem;
		text-align: left;
		width: 2.47rem
	}

	.box-lists .box-heder .box-heder2 {
		text-align: right;
		width: 1.4rem
	}

	.box-lists .box-heder .box-heder3 {
		width: 1.8rem;
		text-align: right;
		margin-right: .6rem
	}

	.box-lists .box-heder .box-heder4 {
		width: 1.19rem;
		text-align: right;
		margin-right: .6rem
	}

	.box-lists .box-heder .box-heder4-1 {
		margin-right: 0
	}

	.box-lists .box-heder .box-heder5 {
		width: 1.21rem;
		text-align: right
	}

	.box-lists .box-body .box-list {
		width: 100%;
		height: .84rem;
		background: #fff;
		box-shadow: 0 .34rem .44rem rgba(0, 0, 0, .08);
		border-radius: .16rem;
		margin-bottom: .16rem;
		position: relative;
		display: flex;
		justify-content: space-between;
		cursor: pointer
	}

	.box-lists .box-body .box-list div {
		float: left
	}

	.box-lists .box-body .box-list .box-heder1 {
		margin-left: .44rem;
		text-align: left;
		width: 2.47rem;
		line-height: .84rem;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 700
	}

	.box-lists .box-body .box-list .box-heder1 img {
		height: .36rem;
		vertical-align: middle;
		margin-right: .1rem
	}

	.box-lists .box-body .box-list .box-heder2 {
		text-align: right;
		width: 1.14rem;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 500;
		color: #44b400;
		line-height: .84rem
	}

	.box-lists .box-body .box-list .box-heder2-1 {
		color: #ff2828
	}

	.box-lists .box-body .box-list .box-heder3 {
		width: 1.8rem;
		text-align: right;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 400;
		line-height: .7rem;
		color: rgba(0, 0, 0, .5);
		display: flex;
		align-items: center
	}

	.box-lists .box-body .box-list .box-heder3 .chart {
		width: 1.8rem;
		height: .6rem
	}

	.box-lists .box-body .box-list .box-heder3 img {
		width: 1.1rem;
		height: .32rem
	}

	.box-lists .box-body .box-list .box-heder4 {
		width: 1.19rem;
		text-align: right;
		margin-right: .6rem;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 400;
		line-height: .84rem;
		color: rgba(0, 0, 0, .5)
	}

	.box-lists .box-body .box-list .box-heder4-1 {
		margin-right: 0
	}

	.box-lists .box-body .box-list .box-heder5 {
		width: 1.21rem;
		text-align: right;
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 400;
		line-height: .84rem;
		color: rgba(0, 0, 0, .5)
	}

	.box-lists .box-body .box-list .box-heder5-1 {
		width: 1.21rem
	}

	.box-lists .box-body .box-list .box-heder5-1 .add-button {
		display: inline-block;
		width: .63rem;
		height: .74rem;
		background: #efefef;
		border-radius: .16rem;
		font-weight: 500;
		font-size: .26rem;
		color: #000;
		text-align: center;
		line-height: .74rem;
		margin-top: .05rem;
		float: right;
		cursor: pointer
	}

	.box-lists .box-body .box-list-no {
		cursor: auto
	}

	.box-lists .box-body .box-list1 {
		z-index: 3
	}

	.box-lists .box-body .box-list2 {
		z-index: 2
	}

	.box-lists .box-body .box-list3 {
		z-index: 1
	}

	.home-mobile {
		padding-top: .9rem;
		width: 100%
	}

	.home-mobile .content {
		width: calc(100% - .48rem);
		margin: auto
	}

	.home-mobile .content .new-feature {
		width: 100%;
		background: #000;
		border-radius: .2rem;
		padding: .26rem;
		position: relative;
		overflow: hidden
	}

	.home-mobile .content .new-feature .new-feature-content {
		position: relative;
		z-index: 2
	}

	.home-mobile .content .new-feature .new-feature-content .feature-icon {
		width: .28rem;
		height: .28rem;
		margin-bottom: .16rem
	}

	.home-mobile .content .new-feature .new-feature-content .feature-title {
		font-family: Mabry Pro;
		font-style: normal;
		font-weight: 500;
		font-size: .22rem;
		color: #fff;
		margin-bottom: .12rem
	}

	.home-mobile .content .new-feature .new-feature-content .feature-content {
		font-family: Mabry Pro;
		font-style: normal;
		font-size: .14rem;
		color: hsla(0, 0%, 100%, .6);
		line-height: .2rem;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden
	}

	.home-mobile .content .new-feature:before {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #9ee970);
		transform: rotate(-90deg);
		display: inline-block;
		border-radius: .55rem;
		position: absolute;
		right: -.35rem;
		top: -.7rem
	}

	.home-mobile .content .new-feature:after {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #a5a6f5);
		transform: rotate(-30deg);
		display: inline-block;
		border-radius: .55rem;
		position: absolute;
		left: 1.2rem;
		bottom: -.7rem
	}

	.home-mobile .content .wallet {
		width: 100%;
		height: .5rem;
		background: #fff;
		border: .01rem solid #000;
		border-radius: .16rem;
		font-weight: 700;
		font-size: .16rem;
		color: #000;
		margin-top: .12rem;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center
	}

	.home-mobile .content .wallet img {
		width: .28rem;
		height: .28rem;
		vertical-align: middle
	}

	.home-mobile .content .wallet .msg-content {
		max-width: 80%
	}

	.home-mobile .content .info-buttons {
		width: 100%;
		height: max-content;
		background: #000;
		margin-top: .12rem;
		border-radius: .2rem;
		font-family: Mabry Pro;
		font-style: normal;
		text-align: center;
		position: relative;
		overflow: hidden
	}

	.home-mobile .content .info-buttons .info-buttons-content {
		position: relative;
		z-index: 2;
		width: 100%;
		height: max-content
	}

	.home-mobile .content .info-buttons .info-buttons-content .null-height {
		width: 100%;
		height: .4rem
	}

	.home-mobile .content .info-buttons .info-buttons-content .icon {
		width: .4rem;
		height: .4rem;
		margin: auto
	}

	.home-mobile .content .info-buttons .info-buttons-content .info-text1 {
		width: 100%;
		font-weight: 300;
		font-size: .14rem;
		color: hsla(0, 0%, 100%, .6);
		margin-top: .14rem
	}

	.home-mobile .content .info-buttons .info-buttons-content .info-text2 {
		width: 100%;
		font-weight: 500;
		font-size: .22rem;
		color: #fff;
		margin-top: .14rem
	}

	.home-mobile .content .info-buttons .info-buttons-content .info-text3 {
		width: 100%;
		font-weight: 300;
		font-size: .14rem;
		color: hsla(0, 0%, 100%, .6);
		line-height: .2rem;
		margin-top: .14rem
	}

	.home-mobile .content .info-buttons .info-buttons-content .info-text31 {
		width: 3.23rem;
		margin: auto;
		margin-top: .14rem
	}

	.home-mobile .content .info-buttons .info-buttons-content .info-button {
		width: 1.25rem;
		height: .44rem;
		background: #fff;
		border-radius: .22rem;
		font-weight: 500;
		font-size: .16rem;
		color: #000;
		line-height: .44rem;
		margin: auto;
		margin-top: .14rem;
		margin-bottom: .34rem
	}
	.home-mobile .content .info-buttons:before {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #a5a6f5);
		transform: rotate(-100deg);
		display: inline-block;
		border-radius: .55rem;
		position: absolute;
		left: calc(100% - 1.1rem);
		bottom: -.4rem
	}

	.home-mobile .content .info-buttons:after {
		content: "";
		width: 1.1rem;
		height: 1.1rem;
		background: linear-gradient(180deg, transparent, #9ee970);
		transform: rotate(-180deg);
		display: inline-block;
		border-radius: .55rem;
		position: absolute;
		left: -.5rem;
		top: -.5rem
	}

	.home-mobile .content .info-policy {
		display: flex;
		flex-wrap: wrap;
		padding-bottom: .4rem
	}

	.home-mobile .content .info-policy .info_item {
		margin-top: .6rem;
		width: 50%;
		padding-left: .3rem;
		box-sizing: border-box
	}

	.home-mobile .content .info-policy .info_item .info_title {
		margin-bottom: .3rem;
		font-weight: 700;
		font-size: .18rem
	}

	.home-mobile .content .info-policy .info_item .info_list .item_name {
		margin-top: .22rem;
		font-size: .16rem;
		color: rgba(0, 0, 0, .6)
	}

	.home-mobile .masking {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		background-image: url(../../../assets/img/noise.90f9bf5b.png);
		z-index: 1
	}
	/* 悬停效果 */
.home-header-app:hover {
  background-color: black; /* 黑色背景 */
  color: white; /* 白色文字 */
}

.home-header-app:hover .app-icon img {
	filter: brightness(0) invert(1); /* 让图片变白 */

}
.home-header-app .app-icon img {
  filter: brightness(0) invert(0); /* 让图片变黑 */
}

/* 新增的样式 */
.home-header .app-download-container {
  display: flex;
  flex-direction: row; /* 改为水平排列 */
  gap: 12px; /* 设置按钮之间的间距 */
  margin-top: 0.36rem;
  width: auto; /* 移除宽度限制 */
}

/* 添加以下样式来让 SVG 图片变黑 */
.info_list .app-icon img {
  filter: brightness(0); /* 将图片变成黑色 */
}

/* 如果需要悬停效果，可以添加以下样式 */
.info_list:hover .app-icon img {
  filter: brightness(0) invert(1); /* 悬停时变白色 */
}

/* 只针对 app store 图标 */
.info_list .app-icon img[src*="app_store"] {
  filter: brightness(0); /* 将图片变成黑色 */
}

/* 修改图标和文字之间的间距 */
.info_list .app-icon {
  float: left;
  width: 0.23rem;
  height: 0.28rem;
  margin-right: 15px; /* 增加图标和文字之间的间距，原来是 5px */
}

/* 修改 Android 和 APP Store 之间的间距 */
.info_item .info_list {
  margin-bottom: 16px; /* 增加上下间距 */
}

/* 第一个 info_list 不需要上边距 */
.info_item .info_list:first-child {
  margin-top: 0;
}

/* 最后一个 info_list 不需要下边距 */
.info_item .info_list:last-child {
  margin-bottom: 0;
}
/* 交易界面样式 - 完全对标st5-pc */
.trading-interface {
	width: 100%;
	/* background: #f5f5f5; */
	padding: 0;
	margin: 0;
	min-height: 850px;
	height: auto;
	position: relative;
	z-index: 1;
}

.trading-container {
	display: flex;
	flex-direction: row;
	height: 770px;
	padding: 0;
	margin: 0;
	padding-bottom: 30px;
}

/* 左侧工具栏容器 */
.left-panel-container {
	width: 56px;
	background: var(--toolbar-bg);
	display: flex;
	flex-direction: column;
	height: 770px;
	transition: background-color 0.3s ease;
	position: relative;
	z-index: 10;
}

.klinecharts-pro-content {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.klinecharts-pro-drawing-bar {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 24px 0;
	gap: 6px;
	flex: 1;
}

.klinecharts-pro-drawing-bar .item {
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 6px;
	position: relative;
	transition: all 0.2s ease;
	background: transparent;
}

.klinecharts-pro-drawing-bar .item:hover {
	background: var(--hover-bg);
	transform: translateX(2px);
	transition: background-color 0.3s ease, transform 0.2s ease;
}

.klinecharts-pro-drawing-bar .item:active {
	background: var(--active-bg);
	transition: background-color 0.3s ease;
}

.klinecharts-pro-drawing-bar .item svg {
	width: 26px;
	height: 26px;
}

.klinecharts-pro-drawing-bar .icon-overlay path,
.klinecharts-pro-drawing-bar .icon-overlay ellipse {
	fill: var(--text-secondary);
	transition: fill 0.2s;
}

.klinecharts-pro-drawing-bar .icon-overlay ellipse {
	stroke: var(--text-secondary);
	transition: stroke 0.2s;
}

.klinecharts-pro-drawing-bar .item:hover .icon-overlay path,
.klinecharts-pro-drawing-bar .item:hover .icon-overlay ellipse {
	fill: var(--primary-color);
}

.klinecharts-pro-drawing-bar .item:hover .icon-overlay ellipse {
	stroke: var(--primary-color);
}

.klinecharts-pro-drawing-bar .icon-arrow {
	display: none;
	position: absolute;
	right: -2px;
	top: 50%;
	transform: translateY(-50%);
	width: 10px;
	height: 14px;
}

.klinecharts-pro-drawing-bar .item:hover .icon-arrow {
	display: block;
	animation: arrowBounce 0.4s ease-in-out;
}

@keyframes arrowBounce {
	0%, 100% {
		transform: translateY(-50%) translateX(0);
	}
	50% {
		transform: translateY(-50%) translateX(2px);
	}
}

/* 输入框抖动动画 */
@keyframes shake {
	0%, 100% {
		transform: translateX(0);
	}
	25% {
		transform: translateX(-8px);
	}
	75% {
		transform: translateX(8px);
	}
}

.klinecharts-pro-drawing-bar .icon-arrow svg {
	width: 6px;
	height: 8px;
}

.klinecharts-pro-drawing-bar .icon-arrow path {
	fill: var(--primary-color);
	transition: fill 0.2s;
}

.klinecharts-pro-drawing-bar .split-line {
	width: 28px;
	height: 1px;
	background: linear-gradient(90deg, transparent, var(--border-color), transparent);
	margin: 6px 0;
	transition: background 0.3s ease;
}

/* 绘图工具激活状态 */
.tool-active {
	background: var(--active-bg) !important;
	border-left: 3px solid var(--primary-color) !important;
	transition: background-color 0.3s ease, border-color 0.3s ease;
}

.tool-active .icon-overlay path,
.tool-active .icon-overlay ellipse {
	fill: var(--primary-color) !important;
}

.tool-active .icon-overlay ellipse {
	stroke: var(--primary-color) !important;
}

/* 绘图工具下拉菜单 */
.drawing-tool-item {
	position: relative;
}

.drawing-tool-dropdown {
	position: absolute;
	left: 56px;
	top: 0;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border: 1px solid var(--border-color);
	transition: border-color 0.3s ease;
	border-radius: 8px;
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
	z-index: 1000;
	min-width: 160px;
	max-height: 360px;
	overflow-y: auto;
	animation: dropdownFadeIn 0.2s ease-out;
}

@keyframes dropdownFadeIn {
	from {
		opacity: 0;
		transform: translateX(-10px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

.dropdown-header {
	padding: 10px 14px;
	font-size: 13px;
	font-weight: 600;
	color: var(--text-primary);
	background: var(--popup-header-bg);
	border-bottom: 1px solid var(--border-color);
	border-radius: 8px 8px 0 0;
	position: sticky;
	top: 0;
	z-index: 1;
	transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.dropdown-item {
	padding: 10px 14px;
	font-size: 13px;
	color: var(--text-primary);
	cursor: pointer;
	transition: all 0.2s ease;
	border-bottom: 1px solid var(--border-light);
	display: flex;
	align-items: center;
	gap: 8px;
}
.dropdown-item:hover {
	background: var(--hover-bg);
	color: var(--primary-color, #0156DC);
	padding-left: 18px;
}

.dropdown-item:last-child {
	border-bottom: none;
	border-radius: 0 0 8px 8px;
}

.dropdown-item.selected {
	background: var(--active-bg);
	color: var(--primary-color, #0156DC);
	font-weight: 600;
	border-left: 3px solid var(--primary-color);
	padding-left: 11px;
}

.tool-icon {
	font-size: 16px;
	font-weight: bold;
	min-width: 20px;
	text-align: center;
	color: var(--text-secondary);
	transition: color 0.3s ease;
}

.dropdown-item:hover .tool-icon,
.dropdown-item.selected .tool-icon {
	color: var(--primary-color, #0156DC);
}

.arrow-rotated {
	transform: translateY(-50%) rotate(90deg) !important;
	transition: transform 0.3s ease;
}

/* 绘图覆盖层 */
.drawing-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 10;
}

/* 绘图元素基础样式 */
.drawing-element {
	position: absolute;
	pointer-events: auto;
	cursor: pointer;
	transition: opacity 0.2s ease;
}

.drawing-element:hover {
	opacity: 0.8 !important;
}

/* MA设置弹窗样式 */
.ma-settings-modal {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2000;
}

.ma-settings-content {
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
	width: 400px;
	max-width: 90%;
}

.ma-settings-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	border-bottom: 1px solid #e8e8e8;
	font-size: 16px;
	font-weight: 500;
}

.ma-settings-body {
	padding: 20px;
}

.ma-setting-item {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
}

.ma-setting-item:last-child {
	margin-bottom: 0;
}

.ma-setting-item label {
	width: 80px;
	font-size: 14px;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.ma-setting-item input {
	flex: 1;
	height: 36px;
	padding: 0 12px;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	font-size: 14px;
	outline: none;
	transition: border-color 0.2s;
}

.ma-setting-item input:focus {
	border-color: var(--primary-color, #0156DC);
}

.ma-settings-footer {
	padding: 12px 20px;
	border-top: 1px solid #e8e8e8;
	display: flex;
	justify-content: flex-end;
}

.confirm-btn {
	padding: 8px 32px;
	background: var(--primary-color, #0156DC);
	color: #ffffff;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	cursor: pointer;
	transition: background 0.2s;
}

.indicator-item span {
	font-size: 14px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	user-select: none;
}

/* 订单管理样式 - 完全对标st5-pc */
.scroll-view {
	width: 100%;
	padding: 10px 0;
}

.scroll-item {
	display: inline-block;
	padding: 8px 16px;
	margin-right: 20px;
	cursor: pointer;
	font-size: 16px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	border-bottom: 2px solid transparent;
	/* 移除动画效果 */
}

.scroll-items {
	color: var(--primary-color, #0156DC);
	border-bottom: 2px solid var(--primary-color);
	font-weight: bold;
}

/* 新的标签页样式 - 对标截图 */
.tab-item {
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	border-bottom: 2px solid transparent !important;
}

.tab-item:hover {
	color: var(--text-secondary);
	transition: color 0.3s ease;
}

.tab-active {
	color: #333 !important;
	border-bottom: 2px solid var(--primary-color) !important;
	font-weight: 600 !important;
}

.prtxts {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background: #f8f9fa;
	margin-bottom: 10px;
	border-radius: 4px;
}

.prtxts > div {
	margin-right: 30px;
}

.positive {
	color: var(--primary-color, #0156DC);
}

.negative {
	color: #f23c48;
}

/* Element UI 表格样式覆盖 */
.el-table {
	font-size: 12px;
	width: 100% !important;
	background: transparent !important;
	border: none !important;
}

.el-table th {
	background-color: transparent !important;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-weight: 500;
	border: none !important;
}

.el-table td {
	padding: 12px 8px;
	background: transparent !important;
	border: none !important;
}

.el-table .cell {
	padding: 0 8px;
}

.el-table tr {
	background: transparent !important;
}

.el-table--border {
	border: none !important;
}

.el-table--border::after {
	display: none !important;
}

.el-table::before {
	display: none !important;
}

/* 确保表格头部和内容充满全宽 */
.el-table__header-wrapper,
.el-table__body-wrapper {
	width: 100% !important;
}

.el-table__header,
.el-table__body {
	width: 100% !important;
	table-layout: auto !important;
}

/* 表格列自适应宽度 */
.el-table .el-table__header-wrapper table,
.el-table .el-table__body-wrapper table {
	width: 100% !important;
}

/* 确保表格容器充满父容器 */
.el-table__fixed,
.el-table__fixed-right {
	height: auto !important;
}

/* 表格容器样式优化 */
.el-table {
	border-radius: 4px;
	overflow: hidden;
}

/* 表格内容区域设置 */
.el-table .el-table__body-wrapper {
	background: transparent !important;
}

/* 空数据状态样式 */
.el-table__empty-block {
	min-height: 100px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent !important;
}

/* 表格行样式优化 */
.el-table .el-table__row {
	background: transparent !important;
}

.el-table .el-table__row:hover {
	background: rgba(0, 0, 0, 0.02) !important;
}

.el-table .el-table__row td {
	border-bottom: none !important;
	line-height: 1.4;
}

/* 表格头部样式 */
.el-table .el-table__header-wrapper {
	background: transparent !important;
}

.el-table .el-table__header th {
	border-bottom: none !important;
}

/* 确保表格容器样式 */
.home-pc .el-footer {
	overflow: visible !important;
	background: transparent !important;
}

/* 修复表格容器的overflow问题 */
.home-pc {
	overflow: visible !important;
}

.home-pc .el-container {
	overflow: visible !important;
	background: transparent !important;
}

.home-pc .el-main {
	overflow: visible !important;
}
/* 交易按钮样式 */
button {
	border: none;
	cursor: pointer;
	transition: all 0.3s;
}

button:hover {
	opacity: 0.8;
}

/* 中间图表区域 */
.center-panel {
	flex: 1;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
}

.chart-header {
	padding: 15px 20px;
	border-bottom: 1px solid #eee;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.symbol-info {
	display: flex;
	flex-direction: column;
}

.symbol-name {
	font-size: 18px;
	font-weight: bold;
	color: var(--text-primary);
	transition: color 0.3s ease;
	margin-bottom: 5px;
}

.symbol-details {
	display: flex;
	gap: 15px;
	font-size: 12px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
}

.time-controls {
	display: flex;
	gap: 5px;
}

.time-btn {
	padding: 6px 12px;
	border: 1px solid #ddd;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
	transition: all 0.2s;
}

.time-btn:hover {
	background-color: var(--bg-secondary);
	transition: background-color 0.3s ease;
}

.time-btn.active {
	background-color: #2196f3;
	color: white;
	border-color: #2196f3;
}

.chart-container {
	flex: 1;
	padding: 20px;
}

.chart {
	width: 100%;
	height: 100%;
	background: var(--bg-secondary);
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	font-size: 14px;
}

/* 右侧交易面板 */
.right-panel {
	width: 350px;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.trading-panel {
	height: 100%;
	display: flex;
	flex-direction: column;
}

.panel-header {
	padding: 20px;
	border-bottom: 1px solid #eee;
}

.balance-info {
	margin-bottom: 15px;
}

.uid {
	font-size: 12px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	margin-bottom: 5px;
}

.available-funds {
	font-size: 12px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	margin-bottom: 5px;
}

.balance {
	font-size: 18px;
	font-weight: bold;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.current-price {
	text-align: center;
	padding: 15px;
	background: #f8f9fa;
	border-radius: 6px;
}

.current-price .symbol {
	font-size: 14px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	margin-bottom: 5px;
}

.current-price .price {
	font-size: 24px;
	font-weight: bold;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.trading-form {
	flex: 1;
	padding: 20px;
}

.form-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
}

.form-row label {
	font-size: 14px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-weight: 500;
}

.form-input {
	width: 120px;
	padding: 8px 12px;
	border: 1px solid var(--border-color);
	transition: border-color 0.3s ease;
	border-radius: 4px;
	font-size: 14px;
	text-align: left;
	background: var(--input-bg);
	color: var(--text-primary);
	transition: all 0.3s ease;
}

.trade-info {
	margin: 20px 0;
	padding: 15px;
	background: var(--bg-secondary);
	border-radius: 6px;
	transition: background-color 0.3s ease;
}

.info-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 8px;
	font-size: 12px;
}

.info-row:last-child {
	margin-bottom: 0;
}

.trade-buttons {
	display: flex;
	gap: 10px;
	margin-top: 20px;
}

.buy-up-btn,
.buy-down-btn {
	flex: 1;
	padding: 12px;
	border: none;
	border-radius: 6px;
	font-size: 14px;
	font-weight: bold;
	cursor: pointer;
	transition: all 0.2s;
}

.buy-up-btn {
	background-color: var(--primary-color, #0156DC);
	color: white;
}

.buy-up-btn:hover {
	background-color: #45a049;
}

.buy-down-btn {
	background-color: #f44336;
	color: white;
}

.buy-down-btn:hover {
	background-color: #da190b;
}

/* 订单管理样式 */
.order-management {
	width: 100%;
	max-width: 1200px;
	margin: 20px auto;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	overflow: hidden;
}

.order-tabs {
	display: flex;
	background: #f8f9fa;
	border-bottom: 1px solid #e9ecef;
}

.order-tab {
	flex: 1;
	padding: 15px 20px;
	text-align: center;
	cursor: pointer;
	font-weight: 500;
	color: #6c757d;
	transition: all 0.3s ease;
	border-bottom: 3px solid transparent;
}

.order-tab:hover {
	background: #e9ecef;
	color: #495057;
}

.order-tab.active {
	background: #fff;
	color: var(--primary-color, #0156DC);
	border-bottom-color: var(--primary-color, #0156DC);
}

/* 主选项卡样式 (合约/期权) */
.main-tab-item {
	color: var(--text-secondary);
	transition: color 0.3s ease;
	background: transparent;
	transition: all 0.2s;
}

.main-tab-item:hover {
	color: var(--primary-color, #0156DC);
	background: rgba(1, 102, 252, 0.05);
}

.main-tab-active {
	color: var(--primary-color) !important;
	border-bottom-color: var(--primary-color) !important;
	font-weight: 600 !important;
}

/* 子选项卡样式 (持仓/挂单/历史 或 交易中/已平仓) */
.tab-item {
	color: var(--text-secondary);
	transition: color 0.3s ease;
	transition: all 0.2s;
}

.tab-item:hover {
	color: var(--primary-color, #0156DC);
	background: rgba(1, 102, 252, 0.05);
}

.tab-active {
	color: var(--primary-color) !important;
	border-bottom-color: var(--primary-color) !important;
	font-weight: 600 !important;
}

.order-content {
	padding: 20px;
	min-height: 400px;
}

/* 持仓汇总样式 */
.order-summary {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	gap: 20px;
	margin-bottom: 20px;
	padding: 20px;
	background: #f8f9fa;
	border-radius: 8px;
}

.summary-item {
	text-align: center;
}

.summary-label {
	font-size: 14px;
	color: #6c757d;
	margin-bottom: 8px;
}
.summary-value {
	font-size: 24px;
	font-weight: bold;
	color: #212529;
}

.summary-value.positive {
	color: #28a745;
}

.summary-value.negative {
	color: #dc3545;
}

/* 订单列表样式 */
.order-list {
	max-height: 500px;
	overflow-y: auto;
}

.position-list,
.pending-list,
.history-list {
	display: flex;
	flex-direction: column;
	gap: 15px;
}

.position-item,
.pending-item,
.history-item {
	padding: 20px;
	border: 1px solid #e9ecef;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.position-item:hover,
.pending-item:hover,
.history-item:hover {
	border-color: var(--primary-color, #0156DC);
	box-shadow: 0 2px 8px rgba(1, 102, 252, 0.1);
}

.position-header,
.pending-header,
.history-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
}

.position-symbol,
.pending-symbol,
.history-symbol {
	font-size: 18px;
	font-weight: bold;
	color: #212529;
}

.position-pnl,
.history-pnl {
	font-size: 18px;
	font-weight: bold;
}

.position-pnl.positive,
.history-pnl.positive {
	color: #28a745;
}

.position-pnl.negative,
.history-pnl.negative {
	color: #dc3545;
}

.pending-status {
	padding: 4px 12px;
	background: #ffc107;
	color: #212529;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 500;
}

.position-details,
.pending-details,
.history-details {
	margin-bottom: 15px;
}

.position-info,
.history-info {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.position-price,
.pending-price,
.history-price {
	font-size: 14px;
	color: #6c757d;
}

.position-type,
.pending-type,
.history-type {
	display: flex;
	align-items: center;
	gap: 10px;
}

.buy-type .type-label {
	padding: 4px 8px;
	background: #28a745;
	color: white;
	border-radius: 4px;
	font-size: 12px;
}

.sell-type .type-label {
	padding: 4px 8px;
	background: #dc3545;
	color: white;
	border-radius: 4px;
	font-size: 12px;
}
.rightPC{
	margin-top: 0;
}
.type-quantity {
	font-size: 12px;
	color: #6c757d;
}

.position-footer,
.pending-footer,
.history-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.position-meta,
.pending-meta,
.history-meta {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.position-id,
.pending-id,
.history-id,
.position-time,
.pending-time,
.history-time {
	font-size: 12px;
	color: #6c757d;
}

.cancel-btn {
	padding: 6px 12px;
	background: #dc3545;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
	transition: background 0.3s ease;
}

.cancel-btn:hover {
	background: #c82333;
}

.history-status {
	padding: 4px 12px;
	background: #28a745;
	color: white;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 500;
}

/* 空状态样式 */
.empty-state {
	text-align: center;
	padding: 60px 20px;
	color: #6c757d;
}

.empty-icon {
	font-size: 48px;
	margin-bottom: 16px;
}

.empty-image {
	width: 80px;
	height: 80px;
	margin-bottom: 16px;
}

.empty-text {
	font-size: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
	.order-management {
		margin: 10px;
	}

	.order-summary {
		grid-template-columns: repeat(2, 1fr);
		gap: 15px;
		padding: 15px;
	}

	.order-content {
		padding: 15px;
	}

	.position-item,
	.pending-item,
	.history-item {
		padding: 15px;
	}

	.summary-value {
		font-size: 20px;
	}
}

/* 时间周期按钮样式 */
.period-btn {
	background: #fff !important;
	color: #666 !important;
	border: 1px solid #d9d9d9 !important;
	transition: all 0.3s;
}

.period-btn:hover {
	background: #f5f5f5 !important;
	border-color: var(--primary-color) !important;
}

.period-active {
	background: var(--primary-color) !important;
	color: #fff !important;
	border: 1px solid var(--primary-color) !important;
}

/* Order management styles - matching st5-pc */
.scroll-view {
	width: 100%;
	padding: 10px 0;
}

.scroll-item {
	display: inline-block;
	padding: 8px 16px;
	margin-right: 20px;
	cursor: pointer;
	font-size: 16px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	border-bottom: 2px solid transparent;
	/* 移除动画效果 */
}

.scroll-items {
	color: var(--primary-color, #0156DC);
	border-bottom: 2px solid var(--primary-color);
	font-weight: bold;
}

.prtxts {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background: #f8f9fa;
	margin-bottom: 10px;
	border-radius: 4px;
}

.positive {
	color: var(--primary-color, #0156DC);
}

.negative {
	color: #f23c48;
}

/* 杠杆倍数滑块样式 */
.xiadanheyue .el-slider__runway {
	height: 6px;
	background-color: #e8e8e8;
	margin: 16px 0 28px 0;
}

.xiadanheyue .el-slider__bar {
	height: 6px;
	background-color: var(--primary-color, #0156DC);
}

.xiadanheyue .el-slider__button {
	width: 16px;
	height: 16px;
	border: 2px solid var(--primary-color, #0156DC);
	background-color: var(--card-bg);
	transition: background-color 0.3s ease;
}

.xiadanheyue .el-slider__button:hover {
	transform: scale(1.2);
}

.xiadanheyue .el-slider__marks-text {
	font-size: 10px;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	margin-top: 8px;
}

/* 交易面板样式 */
.trading-panel {
	position: relative;
	top: 0;
	right: 0;
	width: 324px;
	min-height: 770px;
	height: auto;
	z-index: 1000;
	background: transparent;
	padding: 0;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

/* 交易信息容器样式 - 统一三个标签页的样式 */
.trading-info-container {
	width: 100%;
	font-size: 12px;
	font-weight: bold;
	padding: 10px 0;
}

.trading-info-container.pending-info {
	margin-bottom: 15px;
	font-size: 12px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-weight: bold;
	padding: 10px 0;
}

.trading-info-row {
	display: flex;
	line-height: 18px;
	margin-top: 6px;
	justify-content: space-between;
}

.trading-info-row:first-child {
	margin-top: 0;
}

.trading-info-label {
	flex: 1;
	font-weight: bold;
}

.trading-info-value {
	color: inherit;
	font-weight: bold;
}

/* 挂单按钮样式 (保留以供订单管理等其他组件使用) */
.pending-buttons-container {
	width: 100%;
}

.pending-buttons-wrapper {
	display: flex;
	width: 100%;
	gap: 8px;
}

.pending-btn {
	border: 0;
	flex: 1;
	font-size: 12px;
	height: 40px;
	color: #ffffff;
	line-height: 40px;
	border-radius: 20px;
	font-weight: bold;
	cursor: pointer;
	transition: all 0.2s;
}

.pending-btn-buy {
	background: var(--primary-color, #0156DC);
}

.pending-btn-buy:hover {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
}

.pending-btn-sell {
	background: #f23c48;
}

.pending-btn-sell:hover {
	background: #e22c38;
}

/* 未登录状态的pending按钮样式 */
.pending-btn-buy.disabled {
	opacity: 0.5;
	cursor: not-allowed;
	background: #ccc !important;
}

.pending-btn-buy.disabled:hover {
	opacity: 0.5;
	cursor: not-allowed;
	background: #ccc !important;
}

.pending-btn-sell.disabled {
	opacity: 0.5;
	cursor: not-allowed;
	background: #ccc !important;
}

.pending-btn-sell.disabled:hover {
	opacity: 0.5;
	cursor: not-allowed;
	background: #ccc !important;
}

/* 主容器样式 - 合并到上面的定义中 */

/* 表格方向标签样式 */
.direction-tag {
	width: 70px;
	height: 22px;
	color: #ffffff;
	text-align: center;
	line-height: 22px;
	border-radius: 3px;
	font-size: 12px;
	font-weight: 500;
}

.direction-buy {
	background-color: var(--primary-color, #0156DC);
}

.direction-sell {
	background-color: #f23c48;
}

/* 盈亏显示样式 */
.profit-value {
	font-size: 12px;
	font-weight: 500;
}

.profit-positive {
	color: var(--primary-color, #0156DC);
}

.profit-negative {
	color: #F23C48;
}

/* 期权倒计时样式 */
.countdown-display {
	background: #ff4444;
	color: #ffffff;
	padding: 2px 8px;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 500;
	text-align: center;
	display: inline-block;
	min-width: 40px;
}

.countdown-finished {
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	font-size: 12px;
	text-align: left;
}

/* 秒合约样式 */
.options-contract-form {
	margin-top:15px;
	padding: 0 15px 10px;
	width: 100%;
	box-sizing: border-box;
}

/* 合约子标签样式 */
.contract-sub-tabs {
	margin-bottom: 15px;
}

.contract-tab-wrapper {
	display: flex;
	background: #f5f6fa;
	border-radius: 4px;
	overflow: hidden;
}

.contract-sub-tab {
	flex: 1;
	text-align: center;
	padding: 8px 12px;
	cursor: pointer;
	font-size: 14px;
	transition: all 0.2s;
	background: transparent;
	color: var(--text-secondary);
	transition: color 0.3s ease;
}

.contract-sub-tab-active {
	background: var(--primary-color, #0156DC);
	color: white;
}

/* 数量控制样式 */
.quantity-control {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #f5f6fa;
	border-radius: 4px;
	padding: 8px 12px;
}

.quantity-btn {
	width: 30px;
	height: 30px;
	border: none;
	background: var(--primary-color, #0156DC);
	color: white;
	border-radius: 4px;
	cursor: pointer;
	font-size: 16px;
	font-weight: bold;
	transition: all 0.2s;
}

.quantity-btn:hover {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
}

.quantity-value {
	font-size: 16px;
	font-weight: bold;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

/* 时间选择器样式 - 使用Element UI的el-select */

/* 期权弹窗样式 */
.options-popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.options-popup {
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 12px;
	width: 400px;
	max-width: 90%;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
	overflow: hidden;
}

/* 使用更具体的选择器，确保优先级 */
.options-popup-overlay .options-popup .popup-header {
	background: var(--popup-header-bg, #f8f9fa);
	padding: 20px;
	border-bottom: 1px solid var(--border-color, #e9ecef);
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	transition: background-color 0.3s ease, border-color 0.3s ease;
}

.options-popup-overlay .options-popup .header-right {
	display: flex;
	align-items: center;
	gap: 15px;
}
.options-popup-overlay .options-popup .popup-header h3 {
	margin: 0;
	font-size: 20px;
	font-weight: bold;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.options-popup-overlay .options-popup .countdown-circle {
	width: 60px;
	height: 60px;
	border: 3px solid #007bff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	font-weight: bold;
	color: #007bff;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	flex-shrink: 0;
}

.options-popup-overlay .options-popup .result-display {
	width: 60px;
	height: 60px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: bold;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	flex-shrink: 0;
}

.options-popup-overlay .options-popup .result-win {
	color: #28a745;
	text-align: center;
}

.options-popup-overlay .options-popup .result-lose {
	color: #dc3545;
	text-align: center;
}

.options-popup-overlay .options-popup .close-btn {
	background: none;
	border: none;
	font-size: 28px;
	cursor: pointer;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	transition: color 0.3s;
}

.options-popup-overlay .options-popup .close-btn:hover {
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.options-popup-overlay .options-popup .popup-content {
	padding: 20px;
	position: relative !important;
	transform: none !important;
	top: auto !important;
	left: auto !important;
	width: auto !important;
	min-width: auto !important;
	max-width: none !important;
}

.options-popup-overlay .options-popup .popup-actions {
	display: flex;
	gap: 10px;
	padding: 20px;
	justify-content: center;
}

.popup-actions .action-btn {
	padding: 10px 20px;
	border: none;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
	min-width: 80px;
}

.popup-actions .action-btn.secondary {
	background: var(--bg-secondary);
	color: var(--text-secondary);
	border: 1px solid var(--border-color, #ddd);
	transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.popup-actions .action-btn.secondary:hover {
	background: var(--hover-bg, #e9e9e9);
}

.popup-actions .action-btn.primary {
	background: 3A69FA;
	color: white;
}

.popup-actions .action-btn.primary:hover {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
}

.order-info {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.info-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;
	border-bottom: 1px solid var(--border-color, #f0f0f0);
	transition: border-color 0.3s ease;
}

.info-item:last-child {
	border-bottom: none;
}

.info-item .label {
	font-size: 14px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-weight: 500;
}

.info-item .value {
	font-size: 14px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-weight: bold;
}

.price-up {
	color: var(--success-color, #28a745) !important;
}

.price-down {
	color: var(--danger-color, #dc3545) !important;
}

.profit-positive {
	color: var(--primary-color) !important;
}

.profit-negative {
	color: #F23C48 !important;
}

.order-again-btn {
	margin-top: 20px;
	text-align: center;
}

.order-again-btn button {
	background: #007bff;
	color: white;
	border: none;
	padding: 12px 24px;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.2s;
}

.order-again-btn button:hover {
	background: var(--primary-color, #0156DC);
}





/* 时间选择器弹窗样式 */
.time-options {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	padding: 10px 0;
}

.time-option {
	padding: 12px;
	text-align: center;
	border: 2px solid #e5e6ea;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s;
	font-size: 14px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
}

.time-option:hover {
	border-color: var(--primary-color, #0156DC);
	color: var(--primary-color, #0156DC);
}

.time-option-active {
	border-color: var(--primary-color, #0156DC);
	background: var(--primary-color, #0156DC);
	color: white;
}

.time-option-active:hover {
	background: var(--primary-color, #0156DC);
	border-color: var(--primary-color, #0156DC);
	opacity: 0.9;
}

/* 账户弹窗MessageBox样式 - 大尺寸 */
.account-popup-msgbox-large >>> .el-message-box {
	width: 1200px !important;
	max-width: 95vw !important;
	max-height: 90vh !important;
}

.account-popup-msgbox-large /deep/ .el-message-box {
	width: 1200px !important;
	max-width: 95vw !important;
	max-height: 90vh !important;
}

.account-popup-msgbox-large >>> .el-message-box__content {
	padding: 0 !important;
}

.account-popup-msgbox-large /deep/ .el-message-box__content {
	padding: 0 !important;
}

.account-popup-msgbox-large >>> .el-message-box__message {
	padding: 0 !important;
	overflow: visible !important;
}

.account-popup-msgbox-large /deep/ .el-message-box__message {
	padding: 0 !important;
	overflow: visible !important;
}

.account-popup-msgbox-large >>> .el-message-box__header {
	padding: 15px 20px !important;
}

.account-popup-msgbox-large /deep/ .el-message-box__header {
	padding: 15px 20px !important;
}

/* 菜单项悬停效果 */
.menu-item:hover {
	background: #f0f2f5 !important;
}

/* 账户弹窗MessageBox样式（旧版） */
.account-popup-msgbox >>> .el-message-box {
	width: 500px;
}

.account-popup-msgbox >>> .el-message-box__header {
	background: linear-gradient(135deg, var(--primary-color) 0%, #0151d8 100%);
	padding: 20px;
}

.account-popup-msgbox >>> .el-message-box__title {
	color: white;
	font-size: 18px;
	font-weight: 500;
}

.account-popup-msgbox >>> .el-message-box__close {
	color: white;
	font-size: 20px;
}

.account-popup-msgbox >>> .el-message-box__close:hover {
	color: #f0f0f0;
}

.account-popup-msgbox >>> .el-message-box__content {
	padding: 0;
}

.account-popup-msgbox >>> .el-message-box__message {
	padding: 0;
}

/* Element UI Dialog 账户弹窗样式（旧版，已不使用） */
.account-dialog >>> .el-dialog__header {
	background: linear-gradient(135deg, var(--primary-color) 0%, #0151d8 100%);
	padding: 20px;
}

.account-dialog >>> .el-dialog__title {
	color: white;
	font-size: 18px;
	font-weight: 500;
}

.account-dialog >>> .el-dialog__close {
	color: white;
	font-size: 20px;
}

.account-dialog >>> .el-dialog__close:hover {
	color: #f0f0f0;
}

.dialog-account-selector {
	margin-bottom: 20px;
}

.dialog-account-info {
	background: #f5f7fa;
	padding: 20px;
	border-radius: 8px;
	margin-bottom: 20px;
}

.dialog-account-info .info-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
}

.dialog-account-info .info-label {
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-size: 14px;
}
.dialog-account-info .info-value {
	color: var(--primary-color, #0156DC);
	font-size: 16px;
	font-weight: 600;
}

.dialog-footer {
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	flex-wrap: wrap;
}

.dialog-footer .el-button {
	margin-left: 0 !important;
}

/* 简单账户弹窗样式（旧版，已不使用） */
.simple-account-popup {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
}

.popup-mask {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
}

.popup-content {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 8px;
	min-width: 400px;
	max-width: 90vw;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.popup-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	border-bottom: 1px solid #e4e7ed;
}

.popup-header h3 {
	margin: 0;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.close-btn {
	background: none;
	border: none;
	font-size: 24px;
	cursor: pointer;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.close-btn:hover {
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.popup-body {
	padding: 20px;
}

.account-info {
	margin-bottom: 20px;
}

.account-info p {
	margin: 8px 0;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-size: 14px;
}

.popup-actions {
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
}

.action-btn {
	padding: 8px 16px;
	border: 1px solid #dcdfe6;
	/* background: white; */
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
	transition: all 0.3s;
	border-radius: 100px;
}

/* .action-btn:hover { */
	/* border-color: var(--primary-color, #0156DC); */
	/* color: var(--primary-color, #0156DC); */
/* } */

.logout-btn {
	border-color: #f56c6c;
	color: #f56c6c;
}

.logout-btn:hover {
	background: #f56c6c;
	color: white;
}

/* 旧的复杂弹窗样式 - 暂时保留但不使用 */
.account-popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}

.account-popup-container {
	width: 800px;
	max-width: 90vw;
	max-height: 90vh;
	background: #fff;
	border-radius: 10px;
	overflow: hidden;
	position: relative;
	display: flex;
	flex-direction: column;
}

.popup-close {
	position: absolute;
	top: 15px;
	right: 15px;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 10;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-size: 20px;
	transition: color 0.3s;
}

.popup-close:hover {
	color: #000;
}

/* 账户信息头部 */
.account-header {
	background: linear-gradient(135deg, var(--primary-color) 0%, #0151d8 100%);
	color: #fff;
	padding: 20px 30px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.account-selector {
	position: relative;
}

.account-dropdown {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	font-size: 16px;
	font-weight: 500;
}

.account-menu {
	position: absolute;
	top: 100%;
	left: 0;
	margin-top: 10px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
	min-width: 150px;
	overflow: hidden;
	z-index: 100;
}

.menu-item {
	padding: 12px 16px;
	cursor: pointer;
	color: var(--text-primary);
	transition: color 0.3s ease;
	transition: background 0.3s;
}

.menu-item:hover {
	background: #f5f7fa;
}

.menu-item-active {
	background: #e8f4ff;
	color: var(--primary-color, #0156DC);
}

.account-uid {
	font-size: 14px;
	opacity: 0.9;
}

/* 余额显示区域 */
.balance-section {
	padding: 30px;
	background: var(--bg-secondary);
	text-align: center;
}

.balance-label {
	font-size: 14px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	margin-bottom: 8px;
}

.balance-amount {
	font-size: 36px;
	font-weight: bold;
	color: var(--primary-color, #0156DC);
	margin-bottom: 20px;
}

.balance-details {
	display: flex;
	justify-content: center;
	gap: 40px;
}

.detail-item {
	font-size: 12px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
}

.detail-label {
	margin-right: 5px;
}

.detail-value {
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-weight: 500;
}

/* 选项卡样式 */
.account-tabs {
	flex: 1;
	overflow: auto;
	padding: 0 20px 20px;
}

.account-tabs >>> .el-tabs__header {
	margin: 0 0 20px 0;
}

.account-tabs >>> .el-tabs__nav-wrap::after {
	background: #e4e7ed;
}

.account-tabs >>> .el-tabs__item {
	font-size: 14px;
	padding: 0 20px;
}

.account-tabs >>> .el-tabs__item.is-active {
	color: var(--primary-color, #0156DC);
}

.account-tabs >>> .el-tabs__active-bar {
	background-color: var(--primary-color, #0156DC);
}

/* 选项卡内容 */
.tab-content {
	padding: 20px;
	min-height: 300px;
}

.wallet-info {
	display: flex;
	flex-direction: column;
	gap: 15px;
}

.info-row {
	display: flex;
	justify-content: space-between;
	padding: 12px 0;
	border-bottom: 1px solid #f0f0f0;
}

.info-label {
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-size: 14px;
}

.info-value {
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-weight: 500;
	font-size: 14px;
}

.quick-actions {
	display: flex;
	justify-content: center;
	margin-bottom: 20px;
}

.hint-text {
	text-align: center;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	font-size: 13px;
}
.setting-item {
	padding: 15px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #e4e7ed;
	cursor: pointer;
	transition: background 0.3s;
}

.setting-item:hover {
	background: #f5f7fa;
	padding-left: 10px;
	padding-right: 10px;
	border-radius: 4px;
}

.setting-item span {
	font-size: 14px;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.setting-item i {
	color: var(--text-tertiary);
	transition: color 0.3s ease;
}

/* 响应式 */
@media (max-width: 768px) {
	.account-popup-container {
		width: 95vw;
		max-height: 95vh;
	}
	
	.balance-section {
		padding: 20px;
	}
	
	.balance-amount {
		font-size: 28px;
	}
	
	.balance-details {
		flex-direction: column;
		gap: 15px;
		align-items: center;
	}
}

/* 弹窗遮罩层 */
.auth-modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	backdrop-filter: blur(4px);
	transition: background-color 0.3s ease;
}

/* Element UI Message 层级调整 - 确保错误提示显示在弹窗之上 */
.el-message {
	z-index: 99999 !important;
}

.el-message--error {
	z-index: 99999 !important;
}

.el-message--success {
	z-index: 99999 !important;
}

.el-message--warning {
	z-index: 99999 !important;
}

.el-message--info {
	z-index: 99999 !important;
}

/* Element UI MessageBox 层级调整 - 确保错误提示显示在MessageBox之上 */
.el-message-box__wrapper {
	z-index: 99998 !important;
}

.el-message-box {
	z-index: 99998 !important;
}

/* 全局Element UI消息组件层级调整 - 确保所有消息都显示在最顶层 */
.el-message,
.el-message--error,
.el-message--success,
.el-message--warning,
.el-message--info {
	z-index: 99999 !important;
	position: fixed !important;
}

/* 确保消息框的遮罩层也在最顶层 */
.el-message-box__wrapper {
	z-index: 99998 !important;
	position: fixed !important;
}

.el-message-box {
	z-index: 99998 !important;
}

/* 使用更高优先级的选择器确保消息组件在最顶层 */
body .el-message,
body .el-message--error,
body .el-message--success,
body .el-message--warning,
body .el-message--info {
	z-index: 99999 !important;
	position: fixed !important;
}

/* 确保消息框的遮罩层也在最顶层 */
body .el-message-box__wrapper {
	z-index: 99998 !important;
	position: fixed !important;
}

body .el-message-box {
	z-index: 99998 !important;
}

/* 注册方式选择器样式 */
.register-method-selector {
	display: flex;
	gap: 8px;
	margin-top: 8px;
}

.method-btn {
	flex: 1;
	padding: 12px 16px;
	border: 2px solid var(--border-color);
	border-radius: 8px;
	background: var(--bg-secondary);
	color: var(--text-secondary);
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
}

.method-btn:hover {
	border-color: var(--primary-color, #0156DC);
	color: var(--primary-color, #0156DC);
}

.method-btn.active {
	border-color: var(--primary-color, #0156DC);
	background: var(--primary-color, #0156DC);
	color: white;
}

.method-btn.active:hover {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
}

/* 手机号输入组样式 */
.phone-input-group {
	display: flex;
	gap: 10px;
}

.zip-code-select {
	width: 120px;
}

/* Element UI Select 样式覆盖 - 区号选择器 */
.zip-code-select >>> .el-input__inner {
	height: 50px;
	background: var(--bg-secondary);
	border: none;
	border-radius: 8px;
	padding: 0 15px;
	font-size: 15px;
	color: var(--text-primary);
	transition: all 0.3s ease;
}

.zip-code-select >>> .el-input__inner:focus {
	background: var(--input-bg);
	box-shadow: 0 0 0 2px var(--primary-color);
}

.zip-code-select >>> .el-input__suffix {
	right: 10px;
}

.zip-code-select >>> .el-select__caret {
	color: var(--text-secondary);
	font-size: 14px;
	transition: color 0.3s ease;
}

/* Element UI Select 下拉框暗黑模式适配 */
.dark-mode .el-select-dropdown {
	background-color: var(--card-bg) !important;
	border-color: var(--border-color) !important;
}

.dark-mode .el-select-dropdown__item {
	color: var(--text-primary) !important;
}

.dark-mode .el-select-dropdown__item:hover {
	background-color: var(--hover-bg) !important;
}

.dark-mode .el-select-dropdown__item.selected {
	color: var(--primary-color) !important;
}

.phone-input {
	flex: 1;
}

/* 弹窗容器 */
.auth-modal-container {
	background: var(--card-bg);
	border-radius: 16px;
	width: 90%;
	max-width: 480px;
	max-height: 90vh;
	overflow-y: auto;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
	position: relative;
	animation: modalSlideIn 0.3s ease-out;
	transition: background-color 0.3s ease;
}

@keyframes modalSlideIn {
	from {
		opacity: 0;
		transform: translateY(-30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* 关闭按钮 */
.modal-close-btn {
	position: absolute;
	top: 16px;
	right: 16px;
	width: 32px;
	height: 32px;
	border: none;
	background: transparent;
	font-size: 28px;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	cursor: pointer;
	transition: all 0.2s;
	z-index: 10;
}

.modal-close-btn:hover {
	color: var(--text-primary);
	transition: color 0.3s ease;
	transform: rotate(90deg);
}

/* 弹窗标题 */
.modal-title {
	text-align: center;
	font-size: 24px;
	font-weight: 600;
	color: var(--text-primary);
	transition: color 0.3s ease;
	padding: 32px 40px 24px;
}

/* 表单区域 */
.modal-form {
	padding: 0 40px 40px;
}

.form-group {
	margin-bottom: 20px;
}

.form-group label {
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: var(--primary-color, #0156DC);
	margin-bottom: 8px;
	transition: color 0.3s ease;
}

.form-input {
	width: 100%;
	padding: 12px 16px;
	border: 1px solid var(--border-color);
	border-radius: 8px;
	font-size: 14px;
	background: var(--bg-secondary);
	color: var(--text-primary);
	box-sizing: border-box;
	transition: all 0.3s ease;
}

.form-input:focus {
	outline: none;
	border-color: var(--primary-color, #0156DC);
	background: var(--input-bg);
	box-shadow: 0 0 0 3px rgba(1, 102, 252, 0.1);
}

.form-input::placeholder {
	color: var(--text-tertiary);
}

/* 验证码输入组 */
.verification-input-group {
	display: flex;
	gap: 10px;
}

.verification-input-group .form-input {
	flex: 1;
}

.send-code-btn {
	padding: 12px 24px;
	background: var(--primary-color, #0156DC);
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	white-space: nowrap;
	transition: all 0.3s ease;
}

.send-code-btn:hover:not(:disabled) {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
	transform: translateY(-1px);
	box-shadow: 0 4px 8px rgba(1, 102, 252, 0.3);
}

.send-code-btn:disabled {
	background: var(--bg-tertiary);
	color: var(--text-tertiary);
	cursor: not-allowed;
	opacity: 0.6;
}

/* 表单链接 */
.form-links {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
	font-size: 13px;
}

.link-text {
	color: var(--text-secondary);
	cursor: pointer;
	transition: color 0.3s ease;
}

.link-text:hover {
	color: var(--primary-color, #0156DC);
}
.link-highlight {
	color: var(--primary-color, #0156DC);
	font-weight: 500;
	margin-left: 4px;
}
.link-right {
	color: var(--text-tertiary);
	transition: color 0.3s ease;
}

.link-right:hover {
	color: var(--primary-color, #0156DC);
}


/* 退出登录确认弹窗样式 */
.logout-confirm-dialog {
	border-radius: 16px;
	padding: 0;
	overflow: hidden;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
	width: 500px !important;
	max-width: 90vw !important;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border: 1px solid #e5e7eb;
}

.logout-confirm-dialog.el-message-box {
	width: 500px !important;
	max-width: 90vw !important;
}

.logout-confirm-dialog >>> .el-message-box {
	width: 500px !important;
	max-width: 90vw !important;
}

.logout-confirm-dialog /deep/ .el-message-box {
	width: 500px !important;
	max-width: 90vw !important;
}

.logout-confirm-dialog .el-message-box__header {
	padding: 28px 28px 20px;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-bottom: 1px solid #f3f4f6;
	text-align: center;
}

.logout-confirm-dialog .el-message-box__title {
	font-size: 20px;
	font-weight: 700;
	color: #111827;
	text-align: center;
	margin: 0;
	letter-spacing: -0.025em;
}

.logout-confirm-dialog .el-message-box__content {
	padding: 0 28px 28px;
	font-size: 16px;
	color: #6b7280;
	line-height: 1.6;
	text-align: center;
}

.logout-confirm-dialog .el-message-box__message {
	text-align: center;
	margin: 0;
	font-weight: 500;
}

.logout-confirm-dialog .el-message-box__btns {
	padding: 0 28px 28px;
	display: flex;
	gap: 16px;
	justify-content: center;
}

.logout-confirm-dialog .el-message-box__btns button {
	padding: 12px 24px;
	border-radius: 8px;
	font-size: 15px;
	font-weight: 600;
	transition: all 0.3s ease;
	border: none;
	cursor: pointer;
	min-width: 100px;
	height: 44px;
}

.logout-confirm-dialog .el-button--default {
	background: #f8fafc;
	color: #475569;
	border: 1px solid #e2e8f0;
}

.logout-confirm-dialog .el-button--default:hover {
	background: #f1f5f9;
	border-color: #cbd5e1;
	color: #334155;
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.logout-confirm-dialog .el-button--primary {
	background: 3A69FA;
	color: #ffffff;
	border: 1px solid 3A69FA;
}

.logout-confirm-dialog .el-button--primary:hover {
	background: var(--primary-color, #0156DC);
	border-color: var(--primary-color, #0156DC);
	opacity: 0.9;
	transform: translateY(-1px);
	box-shadow: 0 6px 20px rgba(77, 109, 248, 0.3);
}

.logout-confirm-dialog .el-message-box__close {
	font-size: 18px;
	color: #9ca3af;
	top: 20px;
	right: 20px;
	width: 32px;
	height: 32px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
}

.logout-confirm-dialog .el-message-box__close:hover {
	color: #6b7280;
	background: #f3f4f6;
	transform: scale(1.05);
}

/* 提交按钮 */
.modal-submit-btn {
	width: 100%;
	padding: 14px;
	background: var(--primary-color, #0156DC);
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	margin-bottom: 12px;
}

.modal-submit-btn:hover {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
	transform: translateY(-2px);
	box-shadow: 0 6px 16px rgba(1, 102, 252, 0.4);
}

/* Demo账户按钮 */
.modal-demo-btn {
	width: 100%;
	padding: 14px;
	background: var(--primary-color, #0156DC);
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
}

.modal-demo-btn:hover {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
	transform: translateY(-2px);
	box-shadow: 0 6px 16px rgba(1, 102, 252, 0.4);
}

/* 按钮禁用状态 */
.trade-btn.disabled,
.action-btn.disabled {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transition: background-color 0.3s ease, color 0.3s ease;
	cursor: not-allowed;
	opacity: 0.8;
}

.trade-btn.disabled:hover,
.action-btn.disabled:hover {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transform: none;
	box-shadow: none;
}

/* Loading Spinner Animation for KYC Upload */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 截图预览弹窗样式 */
.screenshot-modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	backdrop-filter: blur(4px);
}

.screenshot-modal-container {
	background: var(--card-bg);
	border-radius: 12px;
	max-width: 900px;
	width: 90%;
	max-height: 600px;
	display: flex;
	flex-direction: column;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
	overflow: hidden;
}

.screenshot-modal-header {
	padding: 20px 24px;
	border-bottom: 1px solid var(--border-color);
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.screenshot-modal-header h3 {
	margin: 0;
	font-size: 18px;
	font-weight: 600;
	color: var(--text-primary);
}

.screenshot-close-btn {
	width: 32px;
	height: 32px;
	border: none;
	background: transparent;
	color: var(--text-secondary);
	font-size: 28px;
	line-height: 1;
	cursor: pointer;
	border-radius: 6px;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	justify-content: center;
}

.screenshot-close-btn:hover {
	background: var(--hover-bg);
	color: var(--text-primary);
}

.screenshot-modal-body {
	padding: 20px;
	overflow: auto;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--bg-secondary);
	min-height: 0;
}

.screenshot-preview {
	max-width: 100%;
	max-height: 100%;
	height: auto;
	width: auto;
	object-fit: contain;
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.screenshot-modal-footer {
	padding: 16px 24px;
	border-top: 1px solid var(--border-color);
	display: flex;
	justify-content: flex-end;
}

.screenshot-save-btn {
	padding: 10px 32px;
	border: none;
	border-radius: 8px;
	background: var(--primary-color, #0156DC);
	color: white;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
}

.screenshot-save-btn:hover {
	background: var(--primary-color, #0156DC);
	opacity: 0.9;
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(1, 102, 252, 0.3);
}

.screenshot-save-btn:active {
	transform: translateY(0);
}

/* 移动端响应式调整 */
@media screen and (max-width: 768px) {
	.screenshot-modal-container {
		max-width: 95%;
		width: 95%;
		max-height: 70vh;
	}
	
	.screenshot-modal-header {
		padding: 16px 20px;
	}
	
	.screenshot-modal-header h3 {
		font-size: 16px;
	}
	
	.screenshot-modal-body {
		padding: 16px;
	}
	
	.screenshot-modal-footer {
		padding: 12px 20px;
	}
	
	.screenshot-save-btn {
		padding: 10px 24px;
		font-size: 14px;
	}
}

</style>